import "./style.css";
import { effectScope as js, ref as We, markRaw as Yt, toRaw as Bi, getCurrentInstance as Zt, inject as $o, watch as No, unref as J, reactive as vm, isRef as ro, isReactive as Ys, toRef as fr, nextTick as rl, computed as Oe, getCurrentScope as ym, onScopeDispose as wm, toRefs as sl, defineComponent as It, h as Wo, shallowRef as bd, onMounted as Gs, openBlock as $t, createBlock as no, withCtx as re, createVNode as he, createTextVNode as Ue, toDisplayString as He, createElementBlock as _i, Fragment as Lo, renderList as Jr, onUpdated as km, onUnmounted as xm, onBeforeMount as _m, Text as Em } from "vue";
import "vue-router";
var vd = !1;
function Jo(e, t, n) {
  return Array.isArray(e) ? (e.length = Math.max(e.length, t), e.splice(t, 1, n), n) : (e[t] = n, n);
}
function hr(e, t) {
  if (Array.isArray(e)) {
    e.splice(t, 1);
    return;
  }
  delete e[t];
}
function Tm() {
  return yd().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function yd() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Im = typeof Proxy == "function", Sm = "devtools-plugin:setup", Om = "plugin:settings:set";
let jn, Qr;
function Cm() {
  var e;
  return jn !== void 0 || (typeof window < "u" && window.performance ? (jn = !0, Qr = window.performance) : typeof global < "u" && (!((e = global.perf_hooks) === null || e === void 0) && e.performance) ? (jn = !0, Qr = global.perf_hooks.performance) : jn = !1), jn;
}
function Am() {
  return Cm() ? Qr.now() : Date.now();
}
class Dm {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const o = {};
    if (t.settings)
      for (const s in t.settings) {
        const a = t.settings[s];
        o[s] = a.defaultValue;
      }
    const i = `__vue-devtools-plugin-settings__${t.id}`;
    let r = Object.assign({}, o);
    try {
      const s = localStorage.getItem(i), a = JSON.parse(s);
      Object.assign(r, a);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return r;
      },
      setSettings(s) {
        try {
          localStorage.setItem(i, JSON.stringify(s));
        } catch {
        }
        r = s;
      },
      now() {
        return Am();
      }
    }, n && n.on(Om, (s, a) => {
      s === this.plugin.id && this.fallbacks.setSettings(a);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, a) => this.target ? this.target.on[a] : (...l) => {
        this.onQueue.push({
          method: a,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, a) => this.target ? this.target[a] : a === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(a) ? (...l) => (this.targetQueue.push({
        method: a,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[a](...l)) : (...l) => new Promise((c) => {
        this.targetQueue.push({
          method: a,
          args: l,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function qs(e, t) {
  const n = e, o = yd(), i = Tm(), r = Im && n.enableEarlyProxy;
  if (i && (o.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !r))
    i.emit(Sm, e, t);
  else {
    const s = r ? new Dm(n, i) : null;
    (o.__VUE_DEVTOOLS_PLUGINS__ = o.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: s
    }), s && t(s.proxiedTarget);
  }
}
/*!
  * pinia v2.0.36
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
let _o;
const Po = (e) => _o = e, wd = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function Cn(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var Lt;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(Lt || (Lt = {}));
const Wi = typeof window < "u", So = (process.env.NODE_ENV !== "production" || !1) && process.env.NODE_ENV !== "test" && Wi, al = /* @__PURE__ */ (() => typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null })();
function $m(e, { autoBom: t = !1 } = {}) {
  return t && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([String.fromCharCode(65279), e], { type: e.type }) : e;
}
function Ks(e, t, n) {
  const o = new XMLHttpRequest();
  o.open("GET", e), o.responseType = "blob", o.onload = function() {
    _d(o.response, t, n);
  }, o.onerror = function() {
    console.error("could not download file");
  }, o.send();
}
function kd(e) {
  const t = new XMLHttpRequest();
  t.open("HEAD", e, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function gi(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    const n = document.createEvent("MouseEvents");
    n.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(n);
  }
}
const bi = typeof navigator == "object" ? navigator : { userAgent: "" }, xd = /* @__PURE__ */ (() => /Macintosh/.test(bi.userAgent) && /AppleWebKit/.test(bi.userAgent) && !/Safari/.test(bi.userAgent))(), _d = Wi ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !xd ? Nm : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in bi ? Lm : (
      // Fallback to using FileReader and a popup
      Pm
    )
  )
) : () => {
};
function Nm(e, t = "download", n) {
  const o = document.createElement("a");
  o.download = t, o.rel = "noopener", typeof e == "string" ? (o.href = e, o.origin !== location.origin ? kd(o.href) ? Ks(e, t, n) : (o.target = "_blank", gi(o)) : gi(o)) : (o.href = URL.createObjectURL(e), setTimeout(function() {
    URL.revokeObjectURL(o.href);
  }, 4e4), setTimeout(function() {
    gi(o);
  }, 0));
}
function Lm(e, t = "download", n) {
  if (typeof e == "string")
    if (kd(e))
      Ks(e, t, n);
    else {
      const o = document.createElement("a");
      o.href = e, o.target = "_blank", setTimeout(function() {
        gi(o);
      });
    }
  else
    navigator.msSaveOrOpenBlob($m(e, n), t);
}
function Pm(e, t, n, o) {
  if (o = o || open("", "_blank"), o && (o.document.title = o.document.body.innerText = "downloading..."), typeof e == "string")
    return Ks(e, t, n);
  const i = e.type === "application/octet-stream", r = /constructor/i.test(String(al.HTMLElement)) || "safari" in al, s = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((s || i && r || xd) && typeof FileReader < "u") {
    const a = new FileReader();
    a.onloadend = function() {
      let l = a.result;
      if (typeof l != "string")
        throw o = null, new Error("Wrong reader.result type");
      l = s ? l : l.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = l : location.assign(l), o = null;
    }, a.readAsDataURL(e);
  } else {
    const a = URL.createObjectURL(e);
    o ? o.location.assign(a) : location.href = a, o = null, setTimeout(function() {
      URL.revokeObjectURL(a);
    }, 4e4);
  }
}
function Se(e, t) {
  const n = "🍍 " + e;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(n, t) : t === "error" ? console.error(n) : t === "warn" ? console.warn(n) : console.log(n);
}
function Xs(e) {
  return "_a" in e && "install" in e;
}
function Ed() {
  if (!("clipboard" in navigator))
    return Se("Your browser doesn't support the Clipboard API", "error"), !0;
}
function Td(e) {
  return e instanceof Error && e.message.toLowerCase().includes("document is not focused") ? (Se('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function Mm(e) {
  if (!Ed())
    try {
      await navigator.clipboard.writeText(JSON.stringify(e.state.value)), Se("Global state copied to clipboard.");
    } catch (t) {
      if (Td(t))
        return;
      Se("Failed to serialize the state. Check the console for more details.", "error"), console.error(t);
    }
}
async function Fm(e) {
  if (!Ed())
    try {
      e.state.value = JSON.parse(await navigator.clipboard.readText()), Se("Global state pasted from clipboard.");
    } catch (t) {
      if (Td(t))
        return;
      Se("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(t);
    }
}
async function Rm(e) {
  try {
    _d(new Blob([JSON.stringify(e.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (t) {
    Se("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(t);
  }
}
let Bt;
function Vm() {
  Bt || (Bt = document.createElement("input"), Bt.type = "file", Bt.accept = ".json");
  function e() {
    return new Promise((t, n) => {
      Bt.onchange = async () => {
        const o = Bt.files;
        if (!o)
          return t(null);
        const i = o.item(0);
        return t(i ? { text: await i.text(), file: i } : null);
      }, Bt.oncancel = () => t(null), Bt.onerror = n, Bt.click();
    });
  }
  return e;
}
async function zm(e) {
  try {
    const n = await (await Vm())();
    if (!n)
      return;
    const { text: o, file: i } = n;
    e.state.value = JSON.parse(o), Se(`Global state imported from "${i.name}".`);
  } catch (t) {
    Se("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(t);
  }
}
function yt(e) {
  return {
    _custom: {
      display: e
    }
  };
}
const Id = "🍍 Pinia (root)", es = "_root";
function Um(e) {
  return Xs(e) ? {
    id: es,
    label: Id
  } : {
    id: e.$id,
    label: e.$id
  };
}
function Hm(e) {
  if (Xs(e)) {
    const n = Array.from(e._s.keys()), o = e._s;
    return {
      state: n.map((r) => ({
        editable: !0,
        key: r,
        value: e.state.value[r]
      })),
      getters: n.filter((r) => o.get(r)._getters).map((r) => {
        const s = o.get(r);
        return {
          editable: !1,
          key: r,
          value: s._getters.reduce((a, l) => (a[l] = s[l], a), {})
        };
      })
    };
  }
  const t = {
    state: Object.keys(e.$state).map((n) => ({
      editable: !0,
      key: n,
      value: e.$state[n]
    }))
  };
  return e._getters && e._getters.length && (t.getters = e._getters.map((n) => ({
    editable: !1,
    key: n,
    value: e[n]
  }))), e._customProperties.size && (t.customProperties = Array.from(e._customProperties).map((n) => ({
    editable: !0,
    key: n,
    value: e[n]
  }))), t;
}
function Bm(e) {
  return e ? Array.isArray(e) ? e.reduce((t, n) => (t.keys.push(n.key), t.operations.push(n.type), t.oldValue[n.key] = n.oldValue, t.newValue[n.key] = n.newValue, t), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: yt(e.type),
    key: yt(e.key),
    oldValue: e.oldValue,
    newValue: e.newValue
  } : {};
}
function Wm(e) {
  switch (e) {
    case Lt.direct:
      return "mutation";
    case Lt.patchFunction:
      return "$patch";
    case Lt.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let eo = !0;
const vi = [], wn = "pinia:mutations", Me = "pinia", { assign: jm } = Object, Ei = (e) => "🍍 " + e;
function Ym(e, t) {
  qs({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: vi,
    app: e
  }, (n) => {
    typeof n.now != "function" && Se("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), n.addTimelineLayer({
      id: wn,
      label: "Pinia 🍍",
      color: 15064968
    }), n.addInspector({
      id: Me,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            Mm(t);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await Fm(t), n.sendInspectorTree(Me), n.sendInspectorState(Me);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            Rm(t);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await zm(t), n.sendInspectorTree(Me), n.sendInspectorState(Me);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: "Reset the state (option store only)",
          action: (o) => {
            const i = t._s.get(o);
            i ? i._isOptionsAPI ? (i.$reset(), Se(`Store "${o}" reset.`)) : Se(`Cannot reset "${o}" store because it's a setup store.`, "warn") : Se(`Cannot reset "${o}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), n.on.inspectComponent((o, i) => {
      const r = o.componentInstance && o.componentInstance.proxy;
      if (r && r._pStores) {
        const s = o.componentInstance.proxy._pStores;
        Object.values(s).forEach((a) => {
          o.instanceData.state.push({
            type: Ei(a.$id),
            key: "state",
            editable: !0,
            value: a._isOptionsAPI ? {
              _custom: {
                value: Bi(a.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => a.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(a.$state).reduce((l, c) => (l[c] = a.$state[c], l), {})
            )
          }), a._getters && a._getters.length && o.instanceData.state.push({
            type: Ei(a.$id),
            key: "getters",
            editable: !1,
            value: a._getters.reduce((l, c) => {
              try {
                l[c] = a[c];
              } catch (d) {
                l[c] = d;
              }
              return l;
            }, {})
          });
        });
      }
    }), n.on.getInspectorTree((o) => {
      if (o.app === e && o.inspectorId === Me) {
        let i = [t];
        i = i.concat(Array.from(t._s.values())), o.rootNodes = (o.filter ? i.filter((r) => "$id" in r ? r.$id.toLowerCase().includes(o.filter.toLowerCase()) : Id.toLowerCase().includes(o.filter.toLowerCase())) : i).map(Um);
      }
    }), n.on.getInspectorState((o) => {
      if (o.app === e && o.inspectorId === Me) {
        const i = o.nodeId === es ? t : t._s.get(o.nodeId);
        if (!i)
          return;
        i && (o.state = Hm(i));
      }
    }), n.on.editInspectorState((o, i) => {
      if (o.app === e && o.inspectorId === Me) {
        const r = o.nodeId === es ? t : t._s.get(o.nodeId);
        if (!r)
          return Se(`store "${o.nodeId}" not found`, "error");
        const { path: s } = o;
        Xs(r) ? s.unshift("state") : (s.length !== 1 || !r._customProperties.has(s[0]) || s[0] in r.$state) && s.unshift("$state"), eo = !1, o.set(r, s, o.state.value), eo = !0;
      }
    }), n.on.editComponentState((o) => {
      if (o.type.startsWith("🍍")) {
        const i = o.type.replace(/^🍍\s*/, ""), r = t._s.get(i);
        if (!r)
          return Se(`store "${i}" not found`, "error");
        const { path: s } = o;
        if (s[0] !== "state")
          return Se(`Invalid path for store "${i}":
${s}
Only state can be modified.`);
        s[0] = "$state", eo = !1, o.set(r, s, o.state.value), eo = !0;
      }
    });
  });
}
function Gm(e, t) {
  vi.includes(Ei(t.$id)) || vi.push(Ei(t.$id)), qs({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: vi,
    app: e,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (n) => {
    const o = typeof n.now == "function" ? n.now.bind(n) : Date.now;
    t.$onAction(({ after: s, onError: a, name: l, args: c }) => {
      const d = Sd++;
      n.addTimelineEvent({
        layerId: wn,
        event: {
          time: o(),
          title: "🛫 " + l,
          subtitle: "start",
          data: {
            store: yt(t.$id),
            action: yt(l),
            args: c
          },
          groupId: d
        }
      }), s((u) => {
        xn = void 0, n.addTimelineEvent({
          layerId: wn,
          event: {
            time: o(),
            title: "🛬 " + l,
            subtitle: "end",
            data: {
              store: yt(t.$id),
              action: yt(l),
              args: c,
              result: u
            },
            groupId: d
          }
        });
      }), a((u) => {
        xn = void 0, n.addTimelineEvent({
          layerId: wn,
          event: {
            time: o(),
            logType: "error",
            title: "💥 " + l,
            subtitle: "end",
            data: {
              store: yt(t.$id),
              action: yt(l),
              args: c,
              error: u
            },
            groupId: d
          }
        });
      });
    }, !0), t._customProperties.forEach((s) => {
      No(() => J(t[s]), (a, l) => {
        n.notifyComponentUpdate(), n.sendInspectorState(Me), eo && n.addTimelineEvent({
          layerId: wn,
          event: {
            time: o(),
            title: "Change",
            subtitle: s,
            data: {
              newValue: a,
              oldValue: l
            },
            groupId: xn
          }
        });
      }, { deep: !0 });
    }), t.$subscribe(({ events: s, type: a }, l) => {
      if (n.notifyComponentUpdate(), n.sendInspectorState(Me), !eo)
        return;
      const c = {
        time: o(),
        title: Wm(a),
        data: jm({ store: yt(t.$id) }, Bm(s)),
        groupId: xn
      };
      xn = void 0, a === Lt.patchFunction ? c.subtitle = "⤵️" : a === Lt.patchObject ? c.subtitle = "🧩" : s && !Array.isArray(s) && (c.subtitle = s.type), s && (c.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: s
        }
      }), n.addTimelineEvent({
        layerId: wn,
        event: c
      });
    }, { detached: !0, flush: "sync" });
    const i = t._hotUpdate;
    t._hotUpdate = Yt((s) => {
      i(s), n.addTimelineEvent({
        layerId: wn,
        event: {
          time: o(),
          title: "🔥 " + t.$id,
          subtitle: "HMR update",
          data: {
            store: yt(t.$id),
            info: yt("HMR update")
          }
        }
      }), n.notifyComponentUpdate(), n.sendInspectorTree(Me), n.sendInspectorState(Me);
    });
    const { $dispose: r } = t;
    t.$dispose = () => {
      r(), n.notifyComponentUpdate(), n.sendInspectorTree(Me), n.sendInspectorState(Me), n.getSettings().logStoreChanges && Se(`Disposed "${t.$id}" store 🗑`);
    }, n.notifyComponentUpdate(), n.sendInspectorTree(Me), n.sendInspectorState(Me), n.getSettings().logStoreChanges && Se(`"${t.$id}" store installed 🆕`);
  });
}
let Sd = 0, xn;
function ll(e, t) {
  const n = t.reduce((o, i) => (o[i] = Bi(e)[i], o), {});
  for (const o in n)
    e[o] = function() {
      const i = Sd, r = new Proxy(e, {
        get(...s) {
          return xn = i, Reflect.get(...s);
        },
        set(...s) {
          return xn = i, Reflect.set(...s);
        }
      });
      return n[o].apply(r, arguments);
    };
}
function qm({ app: e, store: t, options: n }) {
  if (!t.$id.startsWith("__hot:")) {
    if (n.state && (t._isOptionsAPI = !0), typeof n.state == "function") {
      ll(
        // @ts-expect-error: can cast the store...
        t,
        Object.keys(n.actions)
      );
      const o = t._hotUpdate;
      Bi(t)._hotUpdate = function(i) {
        o.apply(this, arguments), ll(t, Object.keys(i._hmrPayload.actions));
      };
    }
    Gm(
      e,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      t
    );
  }
}
function Km() {
  const e = js(!0), t = e.run(() => We({}));
  let n = [], o = [];
  const i = Yt({
    install(r) {
      Po(i), i._a = r, r.provide(wd, i), r.config.globalProperties.$pinia = i, So && Ym(r, i), o.forEach((s) => n.push(s)), o = [];
    },
    use(r) {
      return !this._a && !vd ? o.push(r) : n.push(r), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return So && typeof Proxy < "u" && i.use(qm), i;
}
function Od(e, t) {
  for (const n in t) {
    const o = t[n];
    if (!(n in e))
      continue;
    const i = e[n];
    Cn(i) && Cn(o) && !ro(o) && !Ys(o) ? e[n] = Od(i, o) : e[n] = o;
  }
  return e;
}
const Cd = () => {
};
function cl(e, t, n, o = Cd) {
  e.push(t);
  const i = () => {
    const r = e.indexOf(t);
    r > -1 && (e.splice(r, 1), o());
  };
  return !n && ym() && wm(i), i;
}
function Yn(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
function ts(e, t) {
  e instanceof Map && t instanceof Map && t.forEach((n, o) => e.set(o, n)), e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n))
      continue;
    const o = t[n], i = e[n];
    Cn(i) && Cn(o) && e.hasOwnProperty(n) && !ro(o) && !Ys(o) ? e[n] = ts(i, o) : e[n] = o;
  }
  return e;
}
const Xm = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function Zm(e) {
  return !Cn(e) || !e.hasOwnProperty(Xm);
}
const { assign: st } = Object;
function dl(e) {
  return !!(ro(e) && e.effect);
}
function ul(e, t, n, o) {
  const { state: i, actions: r, getters: s } = t, a = n.state.value[e];
  let l;
  function c() {
    !a && (process.env.NODE_ENV === "production" || !o) && (n.state.value[e] = i ? i() : {});
    const d = process.env.NODE_ENV !== "production" && o ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      sl(We(i ? i() : {}).value)
    ) : sl(n.state.value[e]);
    return st(d, r, Object.keys(s || {}).reduce((u, f) => (process.env.NODE_ENV !== "production" && f in d && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${f}" in store "${e}".`), u[f] = Yt(Oe(() => {
      Po(n);
      const g = n._s.get(e);
      return s[f].call(g, g);
    })), u), {}));
  }
  return l = ns(e, c, t, n, o, !0), l;
}
function ns(e, t, n = {}, o, i, r) {
  let s;
  const a = st({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !o._e.active)
    throw new Error("Pinia destroyed");
  const l = {
    deep: !0
    // flush: 'post',
  };
  process.env.NODE_ENV !== "production" && !vd && (l.onTrigger = (C) => {
    c ? g = C : c == !1 && !y._hotUpdating && (Array.isArray(g) ? g.push(C) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let c, d, u = Yt([]), f = Yt([]), g;
  const E = o.state.value[e];
  !r && !E && (process.env.NODE_ENV === "production" || !i) && (o.state.value[e] = {});
  const k = We({});
  let S;
  function m(C) {
    let D;
    c = d = !1, process.env.NODE_ENV !== "production" && (g = []), typeof C == "function" ? (C(o.state.value[e]), D = {
      type: Lt.patchFunction,
      storeId: e,
      events: g
    }) : (ts(o.state.value[e], C), D = {
      type: Lt.patchObject,
      payload: C,
      storeId: e,
      events: g
    });
    const N = S = Symbol();
    rl().then(() => {
      S === N && (c = !0);
    }), d = !0, Yn(u, D, o.state.value[e]);
  }
  const v = r ? function() {
    const { state: D } = n, N = D ? D() : {};
    this.$patch((z) => {
      st(z, N);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : Cd
  );
  function I() {
    s.stop(), u = [], f = [], o._s.delete(e);
  }
  function w(C, D) {
    return function() {
      Po(o);
      const N = Array.from(arguments), z = [], oe = [];
      function ke(K) {
        z.push(K);
      }
      function Ye(K) {
        oe.push(K);
      }
      Yn(f, {
        args: N,
        name: C,
        store: y,
        after: ke,
        onError: Ye
      });
      let q;
      try {
        q = D.apply(this && this.$id === e ? this : y, N);
      } catch (K) {
        throw Yn(oe, K), K;
      }
      return q instanceof Promise ? q.then((K) => (Yn(z, K), K)).catch((K) => (Yn(oe, K), Promise.reject(K))) : (Yn(z, q), q);
    };
  }
  const A = /* @__PURE__ */ Yt({
    actions: {},
    getters: {},
    state: [],
    hotState: k
  }), b = {
    _p: o,
    // _s: scope,
    $id: e,
    $onAction: cl.bind(null, f),
    $patch: m,
    $reset: v,
    $subscribe(C, D = {}) {
      const N = cl(u, C, D.detached, () => z()), z = s.run(() => No(() => o.state.value[e], (oe) => {
        (D.flush === "sync" ? d : c) && C({
          storeId: e,
          type: Lt.direct,
          events: g
        }, oe);
      }, st({}, l, D)));
      return N;
    },
    $dispose: I
  }, y = vm(process.env.NODE_ENV !== "production" || So ? st(
    {
      _hmrPayload: A,
      _customProperties: Yt(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    b
    // must be added later
    // setupStore
  ) : b);
  o._s.set(e, y);
  const L = o._e.run(() => (s = js(), s.run(() => t())));
  for (const C in L) {
    const D = L[C];
    if (ro(D) && !dl(D) || Ys(D))
      process.env.NODE_ENV !== "production" && i ? Jo(k.value, C, fr(L, C)) : r || (E && Zm(D) && (ro(D) ? D.value = E[C] : ts(D, E[C])), o.state.value[e][C] = D), process.env.NODE_ENV !== "production" && A.state.push(C);
    else if (typeof D == "function") {
      const N = process.env.NODE_ENV !== "production" && i ? D : w(C, D);
      L[C] = N, process.env.NODE_ENV !== "production" && (A.actions[C] = D), a.actions[C] = D;
    } else
      process.env.NODE_ENV !== "production" && dl(D) && (A.getters[C] = r ? (
        // @ts-expect-error
        n.getters[C]
      ) : D, Wi && (L._getters || // @ts-expect-error: same
      (L._getters = Yt([]))).push(C));
  }
  if (st(y, L), st(Bi(y), L), Object.defineProperty(y, "$state", {
    get: () => process.env.NODE_ENV !== "production" && i ? k.value : o.state.value[e],
    set: (C) => {
      if (process.env.NODE_ENV !== "production" && i)
        throw new Error("cannot set hotState");
      m((D) => {
        st(D, C);
      });
    }
  }), process.env.NODE_ENV !== "production" && (y._hotUpdate = Yt((C) => {
    y._hotUpdating = !0, C._hmrPayload.state.forEach((D) => {
      if (D in y.$state) {
        const N = C.$state[D], z = y.$state[D];
        typeof N == "object" && Cn(N) && Cn(z) ? Od(N, z) : C.$state[D] = z;
      }
      Jo(y, D, fr(C.$state, D));
    }), Object.keys(y.$state).forEach((D) => {
      D in C.$state || hr(y, D);
    }), c = !1, d = !1, o.state.value[e] = fr(C._hmrPayload, "hotState"), d = !0, rl().then(() => {
      c = !0;
    });
    for (const D in C._hmrPayload.actions) {
      const N = C[D];
      Jo(y, D, w(D, N));
    }
    for (const D in C._hmrPayload.getters) {
      const N = C._hmrPayload.getters[D], z = r ? (
        // special handling of options api
        Oe(() => (Po(o), N.call(y, y)))
      ) : N;
      Jo(y, D, z);
    }
    Object.keys(y._hmrPayload.getters).forEach((D) => {
      D in C._hmrPayload.getters || hr(y, D);
    }), Object.keys(y._hmrPayload.actions).forEach((D) => {
      D in C._hmrPayload.actions || hr(y, D);
    }), y._hmrPayload = C._hmrPayload, y._getters = C._getters, y._hotUpdating = !1;
  })), So) {
    const C = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((D) => {
      Object.defineProperty(y, D, st({ value: y[D] }, C));
    });
  }
  return o._p.forEach((C) => {
    if (So) {
      const D = s.run(() => C({
        store: y,
        app: o._a,
        pinia: o,
        options: a
      }));
      Object.keys(D || {}).forEach((N) => y._customProperties.add(N)), st(y, D);
    } else
      st(y, s.run(() => C({
        store: y,
        app: o._a,
        pinia: o,
        options: a
      })));
  }), process.env.NODE_ENV !== "production" && y.$state && typeof y.$state == "object" && typeof y.$state.constructor == "function" && !y.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${y.$id}".`), E && r && n.hydrate && n.hydrate(y.$state, E), c = !0, d = !0, y;
}
function Zs(e, t, n) {
  let o, i;
  const r = typeof t == "function";
  if (typeof e == "string")
    o = e, i = r ? n : t;
  else if (i = e, o = e.id, process.env.NODE_ENV !== "production" && typeof o != "string")
    throw new Error('[🍍]: "defineStore()" must be passed a store id as its first argument.');
  function s(a, l) {
    const c = Zt();
    if (a = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && _o && _o._testing ? null : a) || c && $o(wd, null), a && Po(a), process.env.NODE_ENV !== "production" && !_o)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Did you forget to install pinia?
	const pinia = createPinia()
	app.use(pinia)
This will fail in production.`);
    a = _o, a._s.has(o) || (r ? ns(o, t, i, a) : ul(o, i, a), process.env.NODE_ENV !== "production" && (s._pinia = a));
    const d = a._s.get(o);
    if (process.env.NODE_ENV !== "production" && l) {
      const u = "__hot:" + o, f = r ? ns(u, t, i, a, !0) : ul(u, st({}, i), a, !0);
      l._hotUpdate(f), delete a.state.value[u], a._s.delete(u);
    }
    if (process.env.NODE_ENV !== "production" && Wi && c && c.proxy && // avoid adding stores that are just built for hot module replacement
    !l) {
      const u = c.proxy, f = "_pStores" in u ? u._pStores : u._pStores = {};
      f[o] = d;
    }
    return d;
  }
  return s.$id = o, s;
}
const Jm = Zs("productIdentification", {
  state: () => ({
    productIdentificationPref: {
      primaryId: "",
      secondaryId: ""
    },
    productIdentificationOptions: ["productId", "groupId", "groupName", "internalName", "parentProductName", "primaryProductCategoryName", "productId", "sku", "title", "SHOPIFY_PROD_SKU"]
  }),
  getters: {
    getProductIdentificationPref: (e) => e.productIdentificationPref,
    getProductIdentificationOptions: (e) => e.productIdentificationOptions
  },
  actions: {
    async setProductIdentificationPref(e, t, n) {
      const o = JSON.parse(JSON.stringify(this.getProductIdentificationPref));
      if (!n) {
        this.productIdentificationPref = o;
        return;
      }
      o[e] = t;
      try {
        this.productIdentificationPref = await Hi.setProductIdentificationPref(n, o);
      } catch (i) {
        console.log("error", i);
      }
    },
    async getIdentificationPref(e) {
      if (!e)
        return this.productIdentificationPref = {
          primaryId: "productId",
          secondaryId: ""
        };
      this.productIdentificationPref = await Hi.getProductIdentificationPref(e);
    }
  }
});
class Un extends Error {
}
class Qm extends Un {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class ep extends Un {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class tp extends Un {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class Eo extends Un {
}
class Ad extends Un {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class at extends Un {
}
class tn extends Un {
  constructor() {
    super("Zone is an abstract class");
  }
}
const F = "numeric", Tt = "short", Qe = "long", Ti = {
  year: F,
  month: F,
  day: F
}, Dd = {
  year: F,
  month: Tt,
  day: F
}, np = {
  year: F,
  month: Tt,
  day: F,
  weekday: Tt
}, $d = {
  year: F,
  month: Qe,
  day: F
}, Nd = {
  year: F,
  month: Qe,
  day: F,
  weekday: Qe
}, Ld = {
  hour: F,
  minute: F
}, Pd = {
  hour: F,
  minute: F,
  second: F
}, Md = {
  hour: F,
  minute: F,
  second: F,
  timeZoneName: Tt
}, Fd = {
  hour: F,
  minute: F,
  second: F,
  timeZoneName: Qe
}, Rd = {
  hour: F,
  minute: F,
  hourCycle: "h23"
}, Vd = {
  hour: F,
  minute: F,
  second: F,
  hourCycle: "h23"
}, zd = {
  hour: F,
  minute: F,
  second: F,
  hourCycle: "h23",
  timeZoneName: Tt
}, Ud = {
  hour: F,
  minute: F,
  second: F,
  hourCycle: "h23",
  timeZoneName: Qe
}, Hd = {
  year: F,
  month: F,
  day: F,
  hour: F,
  minute: F
}, Bd = {
  year: F,
  month: F,
  day: F,
  hour: F,
  minute: F,
  second: F
}, Wd = {
  year: F,
  month: Tt,
  day: F,
  hour: F,
  minute: F
}, jd = {
  year: F,
  month: Tt,
  day: F,
  hour: F,
  minute: F,
  second: F
}, op = {
  year: F,
  month: Tt,
  day: F,
  weekday: Tt,
  hour: F,
  minute: F
}, Yd = {
  year: F,
  month: Qe,
  day: F,
  hour: F,
  minute: F,
  timeZoneName: Tt
}, Gd = {
  year: F,
  month: Qe,
  day: F,
  hour: F,
  minute: F,
  second: F,
  timeZoneName: Tt
}, qd = {
  year: F,
  month: Qe,
  day: F,
  weekday: Qe,
  hour: F,
  minute: F,
  timeZoneName: Qe
}, Kd = {
  year: F,
  month: Qe,
  day: F,
  weekday: Qe,
  hour: F,
  minute: F,
  second: F,
  timeZoneName: Qe
};
class jo {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new tn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new tn();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new tn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new tn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new tn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new tn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new tn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new tn();
  }
}
let mr = null;
class ji extends jo {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return mr === null && (mr = new ji()), mr;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: o }) {
    return Zd(t, n, o);
  }
  /** @override **/
  formatOffset(t, n) {
    return Co(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let yi = {};
function ip(e) {
  return yi[e] || (yi[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), yi[e];
}
const rp = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function sp(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), o = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, i, r, s, a, l, c, d] = o;
  return [s, i, r, a, l, c, d];
}
function ap(e, t) {
  const n = e.formatToParts(t), o = [];
  for (let i = 0; i < n.length; i++) {
    const { type: r, value: s } = n[i], a = rp[r];
    r === "era" ? o[a] = s : X(a) || (o[a] = parseInt(s, 10));
  }
  return o;
}
let Qo = {};
class Jt extends jo {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return Qo[t] || (Qo[t] = new Jt(t)), Qo[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Qo = {}, yi = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = Jt.isValidZone(t);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: o }) {
    return Zd(t, n, o, this.name);
  }
  /** @override **/
  formatOffset(t, n) {
    return Co(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    const n = new Date(t);
    if (isNaN(n))
      return NaN;
    const o = ip(this.name);
    let [i, r, s, a, l, c, d] = o.formatToParts ? ap(o, n) : sp(o, n);
    a === "BC" && (i = -Math.abs(i) + 1);
    const f = Gi({
      year: i,
      month: r,
      day: s,
      hour: l === 24 ? 0 : l,
      minute: c,
      second: d,
      millisecond: 0
    });
    let g = +n;
    const E = g % 1e3;
    return g -= E >= 0 ? E : 1e3 + E, (f - g) / (60 * 1e3);
  }
  /** @override **/
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let fl = {};
function lp(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let o = fl[n];
  return o || (o = new Intl.ListFormat(e, t), fl[n] = o), o;
}
let os = {};
function is(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let o = os[n];
  return o || (o = new Intl.DateTimeFormat(e, t), os[n] = o), o;
}
let rs = {};
function cp(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let o = rs[n];
  return o || (o = new Intl.NumberFormat(e, t), rs[n] = o), o;
}
let ss = {};
function dp(e, t = {}) {
  const { base: n, ...o } = t, i = JSON.stringify([e, o]);
  let r = ss[i];
  return r || (r = new Intl.RelativeTimeFormat(e, t), ss[i] = r), r;
}
let To = null;
function up() {
  return To || (To = new Intl.DateTimeFormat().resolvedOptions().locale, To);
}
function fp(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let o, i;
    try {
      o = is(e).resolvedOptions(), i = e;
    } catch {
      const l = e.substring(0, n);
      o = is(l).resolvedOptions(), i = l;
    }
    const { numberingSystem: r, calendar: s } = o;
    return [i, r, s];
  }
}
function hp(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function mp(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const o = W.utc(2009, n, 1);
    t.push(e(o));
  }
  return t;
}
function pp(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const o = W.utc(2016, 11, 13 + n);
    t.push(e(o));
  }
  return t;
}
function ei(e, t, n, o) {
  const i = e.listingMode();
  return i === "error" ? null : i === "en" ? n(t) : o(t);
}
function gp(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class bp {
  constructor(t, n, o) {
    this.padTo = o.padTo || 0, this.floor = o.floor || !1;
    const { padTo: i, floor: r, ...s } = o;
    if (!n || Object.keys(s).length > 0) {
      const a = { useGrouping: !1, ...o };
      o.padTo > 0 && (a.minimumIntegerDigits = o.padTo), this.inf = cp(t, a);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : Qs(t, 3);
      return ye(n, this.padTo);
    }
  }
}
class vp {
  constructor(t, n, o) {
    this.opts = o, this.originalZone = void 0;
    let i;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const s = -1 * (t.offset / 60), a = s >= 0 ? `Etc/GMT+${s}` : `Etc/GMT${s}`;
      t.offset !== 0 && Jt.create(a).valid ? (i = a, this.dt = t) : (i = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else
      t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, i = t.zone.name) : (i = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const r = { ...this.opts };
    r.timeZone = r.timeZone || i, this.dtf = is(n, r);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const o = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: o
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class yp {
  constructor(t, n, o) {
    this.opts = { style: "long", ...o }, !n && Xd() && (this.rtf = dp(t, o));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : Mp(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
class ce {
  static fromOpts(t) {
    return ce.create(t.locale, t.numberingSystem, t.outputCalendar, t.defaultToEN);
  }
  static create(t, n, o, i = !1) {
    const r = t || ve.defaultLocale, s = r || (i ? "en-US" : up()), a = n || ve.defaultNumberingSystem, l = o || ve.defaultOutputCalendar;
    return new ce(s, a, l, r);
  }
  static resetCache() {
    To = null, os = {}, rs = {}, ss = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: o } = {}) {
    return ce.create(t, n, o);
  }
  constructor(t, n, o, i) {
    const [r, s, a] = fp(t);
    this.locale = r, this.numberingSystem = n || s || null, this.outputCalendar = o || a || null, this.intl = hp(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = i, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = gp(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : ce.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return ei(this, t, eu, () => {
      const o = n ? { month: t, day: "numeric" } : { month: t }, i = n ? "format" : "standalone";
      return this.monthsCache[i][t] || (this.monthsCache[i][t] = mp((r) => this.extract(r, o, "month"))), this.monthsCache[i][t];
    });
  }
  weekdays(t, n = !1) {
    return ei(this, t, ou, () => {
      const o = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, i = n ? "format" : "standalone";
      return this.weekdaysCache[i][t] || (this.weekdaysCache[i][t] = pp(
        (r) => this.extract(r, o, "weekday")
      )), this.weekdaysCache[i][t];
    });
  }
  meridiems() {
    return ei(
      this,
      void 0,
      () => iu,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [W.utc(2016, 11, 13, 9), W.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return ei(this, t, ru, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [W.utc(-40, 1, 1), W.utc(2017, 1, 1)].map(
        (o) => this.extract(o, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, o) {
    const i = this.dtFormatter(t, n), r = i.formatToParts(), s = r.find((a) => a.type.toLowerCase() === o);
    return s ? s.value : null;
  }
  numberFormatter(t = {}) {
    return new bp(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new vp(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new yp(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return lp(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
}
let pr = null;
class je extends jo {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return pr === null && (pr = new je(0)), pr;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? je.utcInstance : new je(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new je(qi(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Co(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Co(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(t, n) {
    return Co(this.fixed, n);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class wp extends jo {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function an(e, t) {
  if (X(e) || e === null)
    return t;
  if (e instanceof jo)
    return e;
  if (kp(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? ji.instance : n === "utc" || n === "gmt" ? je.utcInstance : je.parseSpecifier(n) || Jt.create(e);
  } else
    return On(e) ? je.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new wp(e);
}
let hl = () => Date.now(), ml = "system", pl = null, gl = null, bl = null, vl = 60, yl;
class ve {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return hl;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    hl = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    ml = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return an(ml, ji.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return pl;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    pl = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return gl;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    gl = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return bl;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    bl = t;
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return vl;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    vl = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return yl;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    yl = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    ce.resetCache(), Jt.resetCache();
  }
}
function X(e) {
  return typeof e > "u";
}
function On(e) {
  return typeof e == "number";
}
function Yi(e) {
  return typeof e == "number" && e % 1 === 0;
}
function kp(e) {
  return typeof e == "string";
}
function xp(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function Xd() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function _p(e) {
  return Array.isArray(e) ? e : [e];
}
function wl(e, t, n) {
  if (e.length !== 0)
    return e.reduce((o, i) => {
      const r = [t(i), i];
      return o && n(o[0], r[0]) === o[0] ? o : r;
    }, null)[1];
}
function Ep(e, t) {
  return t.reduce((n, o) => (n[o] = e[o], n), {});
}
function so(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Kt(e, t, n) {
  return Yi(e) && e >= t && e <= n;
}
function Tp(e, t) {
  return e - t * Math.floor(e / t);
}
function ye(e, t = 2) {
  const n = e < 0;
  let o;
  return n ? o = "-" + ("" + -e).padStart(t, "0") : o = ("" + e).padStart(t, "0"), o;
}
function sn(e) {
  if (!(X(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function bn(e) {
  if (!(X(e) || e === null || e === ""))
    return parseFloat(e);
}
function Js(e) {
  if (!(X(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function Qs(e, t, n = !1) {
  const o = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * o) / o;
}
function Yo(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Oo(e) {
  return Yo(e) ? 366 : 365;
}
function Ii(e, t) {
  const n = Tp(t - 1, 12) + 1, o = e + (t - n) / 12;
  return n === 2 ? Yo(o) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Gi(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function Si(e) {
  const t = (e + Math.floor(e / 4) - Math.floor(e / 100) + Math.floor(e / 400)) % 7, n = e - 1, o = (n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400)) % 7;
  return t === 4 || o === 3 ? 53 : 52;
}
function as(e) {
  return e > 99 ? e : e > ve.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function Zd(e, t, n, o = null) {
  const i = new Date(e), r = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  o && (r.timeZone = o);
  const s = { timeZoneName: t, ...r }, a = new Intl.DateTimeFormat(n, s).formatToParts(i).find((l) => l.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function qi(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const o = parseInt(t, 10) || 0, i = n < 0 || Object.is(n, -0) ? -o : o;
  return n * 60 + i;
}
function Jd(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new at(`Invalid unit value ${e}`);
  return t;
}
function Oi(e, t) {
  const n = {};
  for (const o in e)
    if (so(e, o)) {
      const i = e[o];
      if (i == null)
        continue;
      n[t(o)] = Jd(i);
    }
  return n;
}
function Co(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), o = Math.trunc(Math.abs(e % 60)), i = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${i}${ye(n, 2)}:${ye(o, 2)}`;
    case "narrow":
      return `${i}${n}${o > 0 ? `:${o}` : ""}`;
    case "techie":
      return `${i}${ye(n, 2)}${ye(o, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function Ki(e) {
  return Ep(e, ["hour", "minute", "second", "millisecond"]);
}
const Ip = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Qd = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Sp = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function eu(e) {
  switch (e) {
    case "narrow":
      return [...Sp];
    case "short":
      return [...Qd];
    case "long":
      return [...Ip];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const tu = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], nu = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], Op = ["M", "T", "W", "T", "F", "S", "S"];
function ou(e) {
  switch (e) {
    case "narrow":
      return [...Op];
    case "short":
      return [...nu];
    case "long":
      return [...tu];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const iu = ["AM", "PM"], Cp = ["Before Christ", "Anno Domini"], Ap = ["BC", "AD"], Dp = ["B", "A"];
function ru(e) {
  switch (e) {
    case "narrow":
      return [...Dp];
    case "short":
      return [...Ap];
    case "long":
      return [...Cp];
    default:
      return null;
  }
}
function $p(e) {
  return iu[e.hour < 12 ? 0 : 1];
}
function Np(e, t) {
  return ou(t)[e.weekday - 1];
}
function Lp(e, t) {
  return eu(t)[e.month - 1];
}
function Pp(e, t) {
  return ru(t)[e.year < 0 ? 0 : 1];
}
function Mp(e, t, n = "always", o = !1) {
  const i = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, r = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && r) {
    const u = e === "days";
    switch (t) {
      case 1:
        return u ? "tomorrow" : `next ${i[e][0]}`;
      case -1:
        return u ? "yesterday" : `last ${i[e][0]}`;
      case 0:
        return u ? "today" : `this ${i[e][0]}`;
    }
  }
  const s = Object.is(t, -0) || t < 0, a = Math.abs(t), l = a === 1, c = i[e], d = o ? l ? c[1] : c[2] || c[1] : l ? i[e][0] : e;
  return s ? `${a} ${d} ago` : `in ${a} ${d}`;
}
function kl(e, t) {
  let n = "";
  for (const o of e)
    o.literal ? n += o.val : n += t(o.val);
  return n;
}
const Fp = {
  D: Ti,
  DD: Dd,
  DDD: $d,
  DDDD: Nd,
  t: Ld,
  tt: Pd,
  ttt: Md,
  tttt: Fd,
  T: Rd,
  TT: Vd,
  TTT: zd,
  TTTT: Ud,
  f: Hd,
  ff: Wd,
  fff: Yd,
  ffff: qd,
  F: Bd,
  FF: jd,
  FFF: Gd,
  FFFF: Kd
};
class Re {
  static create(t, n = {}) {
    return new Re(t, n);
  }
  static parseFormat(t) {
    let n = null, o = "", i = !1;
    const r = [];
    for (let s = 0; s < t.length; s++) {
      const a = t.charAt(s);
      a === "'" ? (o.length > 0 && r.push({ literal: i || /^\s+$/.test(o), val: o }), n = null, o = "", i = !i) : i || a === n ? o += a : (o.length > 0 && r.push({ literal: /^\s+$/.test(o), val: o }), o = a, n = a);
    }
    return o.length > 0 && r.push({ literal: i || /^\s+$/.test(o), val: o }), r;
  }
  static macroTokenToFormatOpts(t) {
    return Fp[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return ye(t, n);
    const o = { ...this.opts };
    return n > 0 && (o.padTo = n), this.loc.numberFormatter(o).format(t);
  }
  formatDateTimeFromString(t, n) {
    const o = this.loc.listingMode() === "en", i = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", r = (g, E) => this.loc.extract(t, g, E), s = (g) => t.isOffsetFixed && t.offset === 0 && g.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, g.format) : "", a = () => o ? $p(t) : r({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), l = (g, E) => o ? Lp(t, g) : r(E ? { month: g } : { month: g, day: "numeric" }, "month"), c = (g, E) => o ? Np(t, g) : r(
      E ? { weekday: g } : { weekday: g, month: "long", day: "numeric" },
      "weekday"
    ), d = (g) => {
      const E = Re.macroTokenToFormatOpts(g);
      return E ? this.formatWithSystemDefault(t, E) : g;
    }, u = (g) => o ? Pp(t, g) : r({ era: g }, "era"), f = (g) => {
      switch (g) {
        case "S":
          return this.num(t.millisecond);
        case "u":
        case "SSS":
          return this.num(t.millisecond, 3);
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        case "Z":
          return s({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return s({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return s({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return t.zoneName;
        case "a":
          return a();
        case "d":
          return i ? r({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return i ? r({ day: "2-digit" }, "day") : this.num(t.day, 2);
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return c("short", !0);
        case "cccc":
          return c("long", !0);
        case "ccccc":
          return c("narrow", !0);
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return c("short", !1);
        case "EEEE":
          return c("long", !1);
        case "EEEEE":
          return c("narrow", !1);
        case "L":
          return i ? r({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return i ? r({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return l("short", !0);
        case "LLLL":
          return l("long", !0);
        case "LLLLL":
          return l("narrow", !0);
        case "M":
          return i ? r({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return i ? r({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return l("short", !1);
        case "MMMM":
          return l("long", !1);
        case "MMMMM":
          return l("narrow", !1);
        case "y":
          return i ? r({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return i ? r({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return i ? r({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return i ? r({ year: "numeric" }, "year") : this.num(t.year, 6);
        case "G":
          return u("short");
        case "GG":
          return u("long");
        case "GGGGG":
          return u("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return d(g);
      }
    };
    return kl(Re.parseFormat(n), f);
  }
  formatDurationFromString(t, n) {
    const o = (l) => {
      switch (l[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, i = (l) => (c) => {
      const d = o(c);
      return d ? this.num(l.get(d), c.length) : c;
    }, r = Re.parseFormat(n), s = r.reduce(
      (l, { literal: c, val: d }) => c ? l : l.concat(d),
      []
    ), a = t.shiftTo(...s.map(o).filter((l) => l));
    return kl(r, i(a));
  }
}
class xt {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const su = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function uo(...e) {
  const t = e.reduce((n, o) => n + o.source, "");
  return RegExp(`^${t}$`);
}
function fo(...e) {
  return (t) => e.reduce(
    ([n, o, i], r) => {
      const [s, a, l] = r(t, i);
      return [{ ...n, ...s }, a || o, l];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function ho(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, o] of t) {
    const i = n.exec(e);
    if (i)
      return o(i);
  }
  return [null, null];
}
function au(...e) {
  return (t, n) => {
    const o = {};
    let i;
    for (i = 0; i < e.length; i++)
      o[e[i]] = sn(t[n + i]);
    return [o, null, n + i];
  };
}
const lu = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, Rp = `(?:${lu.source}?(?:\\[(${su.source})\\])?)?`, ea = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, cu = RegExp(`${ea.source}${Rp}`), ta = RegExp(`(?:T${cu.source})?`), Vp = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, zp = /(\d{4})-?W(\d\d)(?:-?(\d))?/, Up = /(\d{4})-?(\d{3})/, Hp = au("weekYear", "weekNumber", "weekDay"), Bp = au("year", "ordinal"), Wp = /(\d{4})-(\d\d)-(\d\d)/, du = RegExp(
  `${ea.source} ?(?:${lu.source}|(${su.source}))?`
), jp = RegExp(`(?: ${du.source})?`);
function oo(e, t, n) {
  const o = e[t];
  return X(o) ? n : sn(o);
}
function Yp(e, t) {
  return [{
    year: oo(e, t),
    month: oo(e, t + 1, 1),
    day: oo(e, t + 2, 1)
  }, null, t + 3];
}
function mo(e, t) {
  return [{
    hours: oo(e, t, 0),
    minutes: oo(e, t + 1, 0),
    seconds: oo(e, t + 2, 0),
    milliseconds: Js(e[t + 3])
  }, null, t + 4];
}
function Go(e, t) {
  const n = !e[t] && !e[t + 1], o = qi(e[t + 1], e[t + 2]), i = n ? null : je.instance(o);
  return [{}, i, t + 3];
}
function qo(e, t) {
  const n = e[t] ? Jt.create(e[t]) : null;
  return [{}, n, t + 1];
}
const Gp = RegExp(`^T?${ea.source}$`), qp = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Kp(e) {
  const [t, n, o, i, r, s, a, l, c] = e, d = t[0] === "-", u = l && l[0] === "-", f = (g, E = !1) => g !== void 0 && (E || g && d) ? -g : g;
  return [
    {
      years: f(bn(n)),
      months: f(bn(o)),
      weeks: f(bn(i)),
      days: f(bn(r)),
      hours: f(bn(s)),
      minutes: f(bn(a)),
      seconds: f(bn(l), l === "-0"),
      milliseconds: f(Js(c), u)
    }
  ];
}
const Xp = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function na(e, t, n, o, i, r, s) {
  const a = {
    year: t.length === 2 ? as(sn(t)) : sn(t),
    month: Qd.indexOf(n) + 1,
    day: sn(o),
    hour: sn(i),
    minute: sn(r)
  };
  return s && (a.second = sn(s)), e && (a.weekday = e.length > 3 ? tu.indexOf(e) + 1 : nu.indexOf(e) + 1), a;
}
const Zp = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Jp(e) {
  const [
    ,
    t,
    n,
    o,
    i,
    r,
    s,
    a,
    l,
    c,
    d,
    u
  ] = e, f = na(t, i, o, n, r, s, a);
  let g;
  return l ? g = Xp[l] : c ? g = 0 : g = qi(d, u), [f, new je(g)];
}
function Qp(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const eg = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, tg = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ng = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function xl(e) {
  const [, t, n, o, i, r, s, a] = e;
  return [na(t, i, o, n, r, s, a), je.utcInstance];
}
function og(e) {
  const [, t, n, o, i, r, s, a] = e;
  return [na(t, a, n, o, i, r, s), je.utcInstance];
}
const ig = uo(Vp, ta), rg = uo(zp, ta), sg = uo(Up, ta), ag = uo(cu), uu = fo(
  Yp,
  mo,
  Go,
  qo
), lg = fo(
  Hp,
  mo,
  Go,
  qo
), cg = fo(
  Bp,
  mo,
  Go,
  qo
), dg = fo(
  mo,
  Go,
  qo
);
function ug(e) {
  return ho(
    e,
    [ig, uu],
    [rg, lg],
    [sg, cg],
    [ag, dg]
  );
}
function fg(e) {
  return ho(Qp(e), [Zp, Jp]);
}
function hg(e) {
  return ho(
    e,
    [eg, xl],
    [tg, xl],
    [ng, og]
  );
}
function mg(e) {
  return ho(e, [qp, Kp]);
}
const pg = fo(mo);
function gg(e) {
  return ho(e, [Gp, pg]);
}
const bg = uo(Wp, jp), vg = uo(du), yg = fo(
  mo,
  Go,
  qo
);
function wg(e) {
  return ho(
    e,
    [bg, uu],
    [vg, yg]
  );
}
const _l = "Invalid Duration", fu = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, kg = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...fu
}, rt = 146097 / 400, Gn = 146097 / 4800, xg = {
  years: {
    quarters: 4,
    months: 12,
    weeks: rt / 7,
    days: rt,
    hours: rt * 24,
    minutes: rt * 24 * 60,
    seconds: rt * 24 * 60 * 60,
    milliseconds: rt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: rt / 28,
    days: rt / 4,
    hours: rt * 24 / 4,
    minutes: rt * 24 * 60 / 4,
    seconds: rt * 24 * 60 * 60 / 4,
    milliseconds: rt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Gn / 7,
    days: Gn,
    hours: Gn * 24,
    minutes: Gn * 24 * 60,
    seconds: Gn * 24 * 60 * 60,
    milliseconds: Gn * 24 * 60 * 60 * 1e3
  },
  ...fu
}, _n = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], _g = _n.slice(0).reverse();
function nn(e, t, n = !1) {
  const o = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new ee(o);
}
function hu(e, t) {
  let n = t.milliseconds ?? 0;
  for (const o of _g.slice(1))
    t[o] && (n += t[o] * e[o].milliseconds);
  return n;
}
function El(e, t) {
  const n = hu(e, t) < 0 ? -1 : 1;
  _n.reduceRight((o, i) => {
    if (X(t[i]))
      return o;
    if (o) {
      const r = t[o] * n, s = e[i][o], a = Math.floor(r / s);
      t[i] += a * n, t[o] -= a * s * n;
    }
    return i;
  }, null), _n.reduce((o, i) => {
    if (X(t[i]))
      return o;
    if (o) {
      const r = t[o] % 1;
      t[o] -= r, t[i] += r * e[o][i];
    }
    return i;
  }, null);
}
function Eg(e) {
  const t = {};
  for (const [n, o] of Object.entries(e))
    o !== 0 && (t[n] = o);
  return t;
}
class ee {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let o = n ? xg : kg;
    t.matrix && (o = t.matrix), this.values = t.values, this.loc = t.loc || ce.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = o, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return ee.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new at(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new ee({
      values: Oi(t, ee.normalizeUnit),
      loc: ce.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (On(t))
      return ee.fromMillis(t);
    if (ee.isDuration(t))
      return t;
    if (typeof t == "object")
      return ee.fromObject(t);
    throw new at(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [o] = mg(t);
    return o ? ee.fromObject(o, n) : ee.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [o] = gg(t);
    return o ? ee.fromObject(o, n) : ee.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new at("need to specify a reason the Duration is invalid");
    const o = t instanceof xt ? t : new xt(t, n);
    if (ve.throwOnInvalid)
      throw new tp(o);
    return new ee({ invalid: o });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n)
      throw new Ad(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const o = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? Re.create(this.loc, o).formatDurationFromString(this, t) : _l;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid)
      return _l;
    const n = _n.map((o) => {
      const i = this.values[o];
      return X(i) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: o.slice(0, -1) }).format(i);
    }).filter((o) => o);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += Qs(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid)
      return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, W.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? hu(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid)
      return this;
    const n = ee.fromDurationLike(t), o = {};
    for (const i of _n)
      (so(n.values, i) || so(this.values, i)) && (o[i] = n.get(i) + this.get(i));
    return nn(this, { values: o }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid)
      return this;
    const n = ee.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid)
      return this;
    const n = {};
    for (const o of Object.keys(this.values))
      n[o] = Jd(t(this.values[o], o));
    return nn(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[ee.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid)
      return this;
    const n = { ...this.values, ...Oi(t, ee.normalizeUnit) };
    return nn(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: o, matrix: i } = {}) {
    const s = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: i, conversionAccuracy: o };
    return nn(this, s);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see second example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const t = this.toObject();
    return El(this.matrix, t), nn(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const t = Eg(this.normalize().shiftToAll().toObject());
    return nn(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid)
      return this;
    if (t.length === 0)
      return this;
    t = t.map((s) => ee.normalizeUnit(s));
    const n = {}, o = {}, i = this.toObject();
    let r;
    for (const s of _n)
      if (t.indexOf(s) >= 0) {
        r = s;
        let a = 0;
        for (const c in o)
          a += this.matrix[c][s] * o[c], o[c] = 0;
        On(i[s]) && (a += i[s]);
        const l = Math.trunc(a);
        n[s] = l, o[s] = (a * 1e3 - l * 1e3) / 1e3;
      } else
        On(i[s]) && (o[s] = i[s]);
    for (const s in o)
      o[s] !== 0 && (n[r] += s === r ? o[s] : o[s] / this.matrix[r][s]);
    return El(this.matrix, n), nn(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return nn(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(o, i) {
      return o === void 0 || o === 0 ? i === void 0 || i === 0 : o === i;
    }
    for (const o of _n)
      if (!n(this.values[o], t.values[o]))
        return !1;
    return !0;
  }
}
const qn = "Invalid Interval";
function Tg(e, t) {
  return !e || !e.isValid ? pe.invalid("missing or invalid start") : !t || !t.isValid ? pe.invalid("missing or invalid end") : t < e ? pe.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class pe {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new at("need to specify a reason the Interval is invalid");
    const o = t instanceof xt ? t : new xt(t, n);
    if (ve.throwOnInvalid)
      throw new ep(o);
    return new pe({ invalid: o });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const o = ko(t), i = ko(n), r = Tg(o, i);
    return r ?? new pe({
      start: o,
      end: i
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const o = ee.fromDurationLike(n), i = ko(t);
    return pe.fromDateTimes(i, i.plus(o));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const o = ee.fromDurationLike(n), i = ko(t);
    return pe.fromDateTimes(i.minus(o), i);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [o, i] = (t || "").split("/", 2);
    if (o && i) {
      let r, s;
      try {
        r = W.fromISO(o, n), s = r.isValid;
      } catch {
        s = !1;
      }
      let a, l;
      try {
        a = W.fromISO(i, n), l = a.isValid;
      } catch {
        l = !1;
      }
      if (s && l)
        return pe.fromDateTimes(r, a);
      if (s) {
        const c = ee.fromISO(i, n);
        if (c.isValid)
          return pe.after(r, c);
      } else if (l) {
        const c = ee.fromISO(o, n);
        if (c.isValid)
          return pe.before(a, c);
      }
    }
    return pe.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(t = "milliseconds") {
    if (!this.isValid)
      return NaN;
    const n = this.start.startOf(t), o = this.end.startOf(t);
    return Math.floor(o.diff(n, t).get(t)) + (o.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? pe.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid)
      return [];
    const n = t.map(ko).filter((s) => this.contains(s)).sort(), o = [];
    let { s: i } = this, r = 0;
    for (; i < this.e; ) {
      const s = n[r] || this.e, a = +s > +this.e ? this.e : s;
      o.push(pe.fromDateTimes(i, a)), i = a, r += 1;
    }
    return o;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = ee.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: o } = this, i = 1, r;
    const s = [];
    for (; o < this.e; ) {
      const a = this.start.plus(n.mapUnits((l) => l * i));
      r = +a > +this.e ? this.e : a, s.push(pe.fromDateTimes(o, r)), o = r, i += 1;
    }
    return s;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid)
      return this;
    const n = this.s > t.s ? this.s : t.s, o = this.e < t.e ? this.e : t.e;
    return n >= o ? null : pe.fromDateTimes(n, o);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid)
      return this;
    const n = this.s < t.s ? this.s : t.s, o = this.e > t.e ? this.e : t.e;
    return pe.fromDateTimes(n, o);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, o] = t.sort((i, r) => i.s - r.s).reduce(
      ([i, r], s) => r ? r.overlaps(s) || r.abutsStart(s) ? [i, r.union(s)] : [i.concat([r]), s] : [i, s],
      [[], null]
    );
    return o && n.push(o), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, o = 0;
    const i = [], r = t.map((l) => [
      { time: l.s, type: "s" },
      { time: l.e, type: "e" }
    ]), s = Array.prototype.concat(...r), a = s.sort((l, c) => l.time - c.time);
    for (const l of a)
      o += l.type === "s" ? 1 : -1, o === 1 ? n = l.time : (n && +n != +l.time && i.push(pe.fromDateTimes(n, l.time)), n = null);
    return pe.merge(i);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return pe.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : qn;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = Ti, n = {}) {
    return this.isValid ? Re.create(this.s.loc.clone(n), t).formatInterval(this) : qn;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : qn;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : qn;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : qn;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : qn;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : ee.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return pe.fromDateTimes(t(this.s), t(this.e));
  }
}
class ti {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = ve.defaultZone) {
    const n = W.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return Jt.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return an(t, ve.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: o = null, locObj: i = null, outputCalendar: r = "gregory" } = {}) {
    return (i || ce.create(n, o, r)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: o = null, locObj: i = null, outputCalendar: r = "gregory" } = {}) {
    return (i || ce.create(n, o, r)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: o = null, locObj: i = null } = {}) {
    return (i || ce.create(n, o, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: o = null, locObj: i = null } = {}) {
    return (i || ce.create(n, o, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return ce.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return ce.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: Xd() };
  }
}
function Tl(e, t) {
  const n = (i) => i.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), o = n(t) - n(e);
  return Math.floor(ee.fromMillis(o).as("days"));
}
function Ig(e, t, n) {
  const o = [
    ["years", (l, c) => c.year - l.year],
    ["quarters", (l, c) => c.quarter - l.quarter + (c.year - l.year) * 4],
    ["months", (l, c) => c.month - l.month + (c.year - l.year) * 12],
    [
      "weeks",
      (l, c) => {
        const d = Tl(l, c);
        return (d - d % 7) / 7;
      }
    ],
    ["days", Tl]
  ], i = {}, r = e;
  let s, a;
  for (const [l, c] of o)
    n.indexOf(l) >= 0 && (s = l, i[l] = c(e, t), a = r.plus(i), a > t ? (i[l]--, e = r.plus(i), e > t && (a = e, i[l]--, e = r.plus(i))) : e = a);
  return [e, i, a, s];
}
function Sg(e, t, n, o) {
  let [i, r, s, a] = Ig(e, t, n);
  const l = t - i, c = n.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  c.length === 0 && (s < t && (s = i.plus({ [a]: 1 })), s !== i && (r[a] = (r[a] || 0) + l / (s - i)));
  const d = ee.fromObject(r, o);
  return c.length > 0 ? ee.fromMillis(l, o).shiftTo(...c).plus(d) : d;
}
const oa = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Il = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Og = oa.hanidec.replace(/[\[|\]]/g, "").split("");
function Cg(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const o = e.charCodeAt(n);
      if (e[n].search(oa.hanidec) !== -1)
        t += Og.indexOf(e[n]);
      else
        for (const i in Il) {
          const [r, s] = Il[i];
          o >= r && o <= s && (t += o - r);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
function gt({ numberingSystem: e }, t = "") {
  return new RegExp(`${oa[e || "latn"]}${t}`);
}
const Ag = "missing Intl.DateTimeFormat.formatToParts support";
function ie(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(Cg(n)) };
}
const Dg = String.fromCharCode(160), mu = `[ ${Dg}]`, pu = new RegExp(mu, "g");
function $g(e) {
  return e.replace(/\./g, "\\.?").replace(pu, mu);
}
function Sl(e) {
  return e.replace(/\./g, "").replace(pu, " ").toLowerCase();
}
function bt(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map($g).join("|")),
    deser: ([n]) => e.findIndex((o) => Sl(n) === Sl(o)) + t
  };
}
function Ol(e, t) {
  return { regex: e, deser: ([, n, o]) => qi(n, o), groups: t };
}
function ni(e) {
  return { regex: e, deser: ([t]) => t };
}
function Ng(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Lg(e, t) {
  const n = gt(t), o = gt(t, "{2}"), i = gt(t, "{3}"), r = gt(t, "{4}"), s = gt(t, "{6}"), a = gt(t, "{1,2}"), l = gt(t, "{1,3}"), c = gt(t, "{1,6}"), d = gt(t, "{1,9}"), u = gt(t, "{2,4}"), f = gt(t, "{4,6}"), g = (S) => ({ regex: RegExp(Ng(S.val)), deser: ([m]) => m, literal: !0 }), k = ((S) => {
    if (e.literal)
      return g(S);
    switch (S.val) {
      case "G":
        return bt(t.eras("short"), 0);
      case "GG":
        return bt(t.eras("long"), 0);
      case "y":
        return ie(c);
      case "yy":
        return ie(u, as);
      case "yyyy":
        return ie(r);
      case "yyyyy":
        return ie(f);
      case "yyyyyy":
        return ie(s);
      case "M":
        return ie(a);
      case "MM":
        return ie(o);
      case "MMM":
        return bt(t.months("short", !0), 1);
      case "MMMM":
        return bt(t.months("long", !0), 1);
      case "L":
        return ie(a);
      case "LL":
        return ie(o);
      case "LLL":
        return bt(t.months("short", !1), 1);
      case "LLLL":
        return bt(t.months("long", !1), 1);
      case "d":
        return ie(a);
      case "dd":
        return ie(o);
      case "o":
        return ie(l);
      case "ooo":
        return ie(i);
      case "HH":
        return ie(o);
      case "H":
        return ie(a);
      case "hh":
        return ie(o);
      case "h":
        return ie(a);
      case "mm":
        return ie(o);
      case "m":
        return ie(a);
      case "q":
        return ie(a);
      case "qq":
        return ie(o);
      case "s":
        return ie(a);
      case "ss":
        return ie(o);
      case "S":
        return ie(l);
      case "SSS":
        return ie(i);
      case "u":
        return ni(d);
      case "uu":
        return ni(a);
      case "uuu":
        return ie(n);
      case "a":
        return bt(t.meridiems(), 0);
      case "kkkk":
        return ie(r);
      case "kk":
        return ie(u, as);
      case "W":
        return ie(a);
      case "WW":
        return ie(o);
      case "E":
      case "c":
        return ie(n);
      case "EEE":
        return bt(t.weekdays("short", !1), 1);
      case "EEEE":
        return bt(t.weekdays("long", !1), 1);
      case "ccc":
        return bt(t.weekdays("short", !0), 1);
      case "cccc":
        return bt(t.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return Ol(new RegExp(`([+-]${a.source})(?::(${o.source}))?`), 2);
      case "ZZZ":
        return Ol(new RegExp(`([+-]${a.source})(${o.source})?`), 2);
      case "z":
        return ni(/[a-z_+-/]{1,256}?/i);
      case " ":
        return ni(/[^\S\n\r]/);
      default:
        return g(S);
    }
  })(e) || {
    invalidReason: Ag
  };
  return k.token = e, k;
}
const Pg = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function Mg(e, t, n) {
  const { type: o, value: i } = e;
  if (o === "literal") {
    const l = /^\s+$/.test(i);
    return {
      literal: !l,
      val: l ? " " : i
    };
  }
  const r = t[o];
  let s = o;
  o === "hour" && (t.hour12 != null ? s = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? s = "hour12" : s = "hour24" : s = n.hour12 ? "hour12" : "hour24");
  let a = Pg[s];
  if (typeof a == "object" && (a = a[r]), a)
    return {
      literal: !1,
      val: a
    };
}
function Fg(e) {
  return [`^${e.map((n) => n.regex).reduce((n, o) => `${n}(${o.source})`, "")}$`, e];
}
function Rg(e, t, n) {
  const o = e.match(t);
  if (o) {
    const i = {};
    let r = 1;
    for (const s in n)
      if (so(n, s)) {
        const a = n[s], l = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (i[a.token.val[0]] = a.deser(o.slice(r, r + l))), r += l;
      }
    return [o, i];
  } else
    return [o, {}];
}
function Vg(e) {
  const t = (r) => {
    switch (r) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, o;
  return X(e.z) || (n = Jt.create(e.z)), X(e.Z) || (n || (n = new je(e.Z)), o = e.Z), X(e.q) || (e.M = (e.q - 1) * 3 + 1), X(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), X(e.u) || (e.S = Js(e.u)), [Object.keys(e).reduce((r, s) => {
    const a = t(s);
    return a && (r[a] = e[s]), r;
  }, {}), n, o];
}
let gr = null;
function zg() {
  return gr || (gr = W.fromMillis(1555555555555)), gr;
}
function Ug(e, t) {
  if (e.literal)
    return e;
  const n = Re.macroTokenToFormatOpts(e.val), o = vu(n, t);
  return o == null || o.includes(void 0) ? e : o;
}
function gu(e, t) {
  return Array.prototype.concat(...e.map((n) => Ug(n, t)));
}
function bu(e, t, n) {
  const o = gu(Re.parseFormat(n), e), i = o.map((s) => Lg(s, e)), r = i.find((s) => s.invalidReason);
  if (r)
    return { input: t, tokens: o, invalidReason: r.invalidReason };
  {
    const [s, a] = Fg(i), l = RegExp(s, "i"), [c, d] = Rg(t, l, a), [u, f, g] = d ? Vg(d) : [null, null, void 0];
    if (so(d, "a") && so(d, "H"))
      throw new Eo(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: t, tokens: o, regex: l, rawMatches: c, matches: d, result: u, zone: f, specificOffset: g };
  }
}
function Hg(e, t, n) {
  const { result: o, zone: i, specificOffset: r, invalidReason: s } = bu(e, t, n);
  return [o, i, r, s];
}
function vu(e, t) {
  if (!e)
    return null;
  const o = Re.create(t, e).dtFormatter(zg()), i = o.formatToParts(), r = o.resolvedOptions();
  return i.map((s) => Mg(s, e, r));
}
const yu = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], wu = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function lt(e, t) {
  return new xt(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function ku(e, t, n) {
  const o = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && o.setUTCFullYear(o.getUTCFullYear() - 1900);
  const i = o.getUTCDay();
  return i === 0 ? 7 : i;
}
function xu(e, t, n) {
  return n + (Yo(e) ? wu : yu)[t - 1];
}
function _u(e, t) {
  const n = Yo(e) ? wu : yu, o = n.findIndex((r) => r < t), i = t - n[o];
  return { month: o + 1, day: i };
}
function ls(e) {
  const { year: t, month: n, day: o } = e, i = xu(t, n, o), r = ku(t, n, o);
  let s = Math.floor((i - r + 10) / 7), a;
  return s < 1 ? (a = t - 1, s = Si(a)) : s > Si(t) ? (a = t + 1, s = 1) : a = t, { weekYear: a, weekNumber: s, weekday: r, ...Ki(e) };
}
function Cl(e) {
  const { weekYear: t, weekNumber: n, weekday: o } = e, i = ku(t, 1, 4), r = Oo(t);
  let s = n * 7 + o - i - 3, a;
  s < 1 ? (a = t - 1, s += Oo(a)) : s > r ? (a = t + 1, s -= Oo(t)) : a = t;
  const { month: l, day: c } = _u(a, s);
  return { year: a, month: l, day: c, ...Ki(e) };
}
function br(e) {
  const { year: t, month: n, day: o } = e, i = xu(t, n, o);
  return { year: t, ordinal: i, ...Ki(e) };
}
function Al(e) {
  const { year: t, ordinal: n } = e, { month: o, day: i } = _u(t, n);
  return { year: t, month: o, day: i, ...Ki(e) };
}
function Bg(e) {
  const t = Yi(e.weekYear), n = Kt(e.weekNumber, 1, Si(e.weekYear)), o = Kt(e.weekday, 1, 7);
  return t ? n ? o ? !1 : lt("weekday", e.weekday) : lt("week", e.week) : lt("weekYear", e.weekYear);
}
function Wg(e) {
  const t = Yi(e.year), n = Kt(e.ordinal, 1, Oo(e.year));
  return t ? n ? !1 : lt("ordinal", e.ordinal) : lt("year", e.year);
}
function Eu(e) {
  const t = Yi(e.year), n = Kt(e.month, 1, 12), o = Kt(e.day, 1, Ii(e.year, e.month));
  return t ? n ? o ? !1 : lt("day", e.day) : lt("month", e.month) : lt("year", e.year);
}
function Tu(e) {
  const { hour: t, minute: n, second: o, millisecond: i } = e, r = Kt(t, 0, 23) || t === 24 && n === 0 && o === 0 && i === 0, s = Kt(n, 0, 59), a = Kt(o, 0, 59), l = Kt(i, 0, 999);
  return r ? s ? a ? l ? !1 : lt("millisecond", i) : lt("second", o) : lt("minute", n) : lt("hour", t);
}
const vr = "Invalid DateTime", Dl = 864e13;
function oi(e) {
  return new xt("unsupported zone", `the zone "${e.name}" is not supported`);
}
function yr(e) {
  return e.weekData === null && (e.weekData = ls(e.c)), e.weekData;
}
function vn(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new W({ ...n, ...t, old: n });
}
function Iu(e, t, n) {
  let o = e - t * 60 * 1e3;
  const i = n.offset(o);
  if (t === i)
    return [o, t];
  o -= (i - t) * 60 * 1e3;
  const r = n.offset(o);
  return i === r ? [o, i] : [e - Math.min(i, r) * 60 * 1e3, Math.max(i, r)];
}
function ii(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function wi(e, t, n) {
  return Iu(Gi(e), t, n);
}
function $l(e, t) {
  const n = e.o, o = e.c.year + Math.trunc(t.years), i = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, r = {
    ...e.c,
    year: o,
    month: i,
    day: Math.min(e.c.day, Ii(o, i)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, s = ee.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), a = Gi(r);
  let [l, c] = Iu(a, n, e.zone);
  return s !== 0 && (l += s, c = e.zone.offset(l)), { ts: l, o: c };
}
function wo(e, t, n, o, i, r) {
  const { setZone: s, zone: a } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const l = t || a, c = W.fromObject(e, {
      ...n,
      zone: l,
      specificOffset: r
    });
    return s ? c : c.setZone(a);
  } else
    return W.invalid(
      new xt("unparsable", `the input "${i}" can't be parsed as ${o}`)
    );
}
function ri(e, t, n = !0) {
  return e.isValid ? Re.create(ce.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function wr(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let o = "";
  return n && e.c.year >= 0 && (o += "+"), o += ye(e.c.year, n ? 6 : 4), t ? (o += "-", o += ye(e.c.month), o += "-", o += ye(e.c.day)) : (o += ye(e.c.month), o += ye(e.c.day)), o;
}
function Nl(e, t, n, o, i, r) {
  let s = ye(e.c.hour);
  return t ? (s += ":", s += ye(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (s += ":")) : s += ye(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (s += ye(e.c.second), (e.c.millisecond !== 0 || !o) && (s += ".", s += ye(e.c.millisecond, 3))), i && (e.isOffsetFixed && e.offset === 0 && !r ? s += "Z" : e.o < 0 ? (s += "-", s += ye(Math.trunc(-e.o / 60)), s += ":", s += ye(Math.trunc(-e.o % 60))) : (s += "+", s += ye(Math.trunc(e.o / 60)), s += ":", s += ye(Math.trunc(e.o % 60)))), r && (s += "[" + e.zone.ianaName + "]"), s;
}
const Su = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, jg = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Yg = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Ou = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Gg = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], qg = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Ll(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t)
    throw new Ad(e);
  return t;
}
function Pl(e, t) {
  const n = an(t.zone, ve.defaultZone), o = ce.fromObject(t), i = ve.now();
  let r, s;
  if (X(e.year))
    r = i;
  else {
    for (const c of Ou)
      X(e[c]) && (e[c] = Su[c]);
    const a = Eu(e) || Tu(e);
    if (a)
      return W.invalid(a);
    const l = n.offset(i);
    [r, s] = wi(e, l, n);
  }
  return new W({ ts: r, zone: n, loc: o, o: s });
}
function Ml(e, t, n) {
  const o = X(n.round) ? !0 : n.round, i = (s, a) => (s = Qs(s, o || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(s, a)), r = (s) => n.calendary ? t.hasSame(e, s) ? 0 : t.startOf(s).diff(e.startOf(s), s).get(s) : t.diff(e, s).get(s);
  if (n.unit)
    return i(r(n.unit), n.unit);
  for (const s of n.units) {
    const a = r(s);
    if (Math.abs(a) >= 1)
      return i(a, s);
  }
  return i(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function Fl(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
class W {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || ve.defaultZone;
    let o = t.invalid || (Number.isNaN(t.ts) ? new xt("invalid input") : null) || (n.isValid ? null : oi(n));
    this.ts = X(t.ts) ? ve.now() : t.ts;
    let i = null, r = null;
    if (!o)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [i, r] = [t.old.c, t.old.o];
      else {
        const a = n.offset(this.ts);
        i = ii(this.ts, a), o = Number.isNaN(i.year) ? new xt("invalid input") : null, i = o ? null : i, r = o ? null : a;
      }
    this._zone = n, this.loc = t.loc || ce.create(), this.invalid = o, this.weekData = null, this.c = i, this.o = r, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new W({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = Fl(arguments), [o, i, r, s, a, l, c] = n;
    return Pl({ year: o, month: i, day: r, hour: s, minute: a, second: l, millisecond: c }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = Fl(arguments), [o, i, r, s, a, l, c] = n;
    return t.zone = je.utcInstance, Pl({ year: o, month: i, day: r, hour: s, minute: a, second: l, millisecond: c }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const o = xp(t) ? t.valueOf() : NaN;
    if (Number.isNaN(o))
      return W.invalid("invalid input");
    const i = an(n.zone, ve.defaultZone);
    return i.isValid ? new W({
      ts: o,
      zone: i,
      loc: ce.fromObject(n)
    }) : W.invalid(oi(i));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (On(t))
      return t < -Dl || t > Dl ? W.invalid("Timestamp out of range") : new W({
        ts: t,
        zone: an(n.zone, ve.defaultZone),
        loc: ce.fromObject(n)
      });
    throw new at(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (On(t))
      return new W({
        ts: t * 1e3,
        zone: an(n.zone, ve.defaultZone),
        loc: ce.fromObject(n)
      });
    throw new at("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const o = an(n.zone, ve.defaultZone);
    if (!o.isValid)
      return W.invalid(oi(o));
    const i = ve.now(), r = X(n.specificOffset) ? o.offset(i) : n.specificOffset, s = Oi(t, Ll), a = !X(s.ordinal), l = !X(s.year), c = !X(s.month) || !X(s.day), d = l || c, u = s.weekYear || s.weekNumber, f = ce.fromObject(n);
    if ((d || a) && u)
      throw new Eo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (c && a)
      throw new Eo("Can't mix ordinal dates with month/day");
    const g = u || s.weekday && !d;
    let E, k, S = ii(i, r);
    g ? (E = Gg, k = jg, S = ls(S)) : a ? (E = qg, k = Yg, S = br(S)) : (E = Ou, k = Su);
    let m = !1;
    for (const L of E) {
      const C = s[L];
      X(C) ? m ? s[L] = k[L] : s[L] = S[L] : m = !0;
    }
    const v = g ? Bg(s) : a ? Wg(s) : Eu(s), I = v || Tu(s);
    if (I)
      return W.invalid(I);
    const w = g ? Cl(s) : a ? Al(s) : s, [A, b] = wi(w, r, o), y = new W({
      ts: A,
      zone: o,
      o: b,
      loc: f
    });
    return s.weekday && d && t.weekday !== y.weekday ? W.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${s.weekday} and a date of ${y.toISO()}`
    ) : y;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [o, i] = ug(t);
    return wo(o, i, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [o, i] = fg(t);
    return wo(o, i, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [o, i] = hg(t);
    return wo(o, i, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, o = {}) {
    if (X(t) || X(n))
      throw new at("fromFormat requires an input string and a format");
    const { locale: i = null, numberingSystem: r = null } = o, s = ce.fromOpts({
      locale: i,
      numberingSystem: r,
      defaultToEN: !0
    }), [a, l, c, d] = Hg(s, t, n);
    return d ? W.invalid(d) : wo(a, l, o, `format ${n}`, t, c);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, o = {}) {
    return W.fromFormat(t, n, o);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [o, i] = wg(t);
    return wo(o, i, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new at("need to specify a reason the DateTime is invalid");
    const o = t instanceof xt ? t : new xt(t, n);
    if (ve.throwOnInvalid)
      throw new Qm(o);
    return new W({ invalid: o });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const o = vu(t, ce.fromObject(n));
    return o ? o.map((i) => i ? i.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return gu(Re.parseFormat(t), ce.fromObject(n)).map((i) => i.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? yr(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? yr(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? yr(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? br(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? ti.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? ti.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? ti.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? ti.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, o = Gi(this.c), i = this.zone.offset(o - t), r = this.zone.offset(o + t), s = this.zone.offset(o - i * n), a = this.zone.offset(o - r * n);
    if (s === a)
      return [this];
    const l = o - s * n, c = o - a * n, d = ii(l, s), u = ii(c, a);
    return d.hour === u.hour && d.minute === u.minute && d.second === u.second && d.millisecond === u.millisecond ? [vn(this, { ts: l }), vn(this, { ts: c })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Yo(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Ii(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Oo(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Si(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: o, calendar: i } = Re.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: o, outputCalendar: i };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(je.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(ve.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: o = !1 } = {}) {
    if (t = an(t, ve.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let i = this.ts;
      if (n || o) {
        const r = t.offset(this.ts), s = this.toObject();
        [i] = wi(s, r, t);
      }
      return vn(this, { ts: i, zone: t });
    } else
      return W.invalid(oi(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: o } = {}) {
    const i = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: o });
    return vn(this, { loc: i });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid)
      return this;
    const n = Oi(t, Ll), o = !X(n.weekYear) || !X(n.weekNumber) || !X(n.weekday), i = !X(n.ordinal), r = !X(n.year), s = !X(n.month) || !X(n.day), a = r || s, l = n.weekYear || n.weekNumber;
    if ((a || i) && l)
      throw new Eo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (s && i)
      throw new Eo("Can't mix ordinal dates with month/day");
    let c;
    o ? c = Cl({ ...ls(this.c), ...n }) : X(n.ordinal) ? (c = { ...this.toObject(), ...n }, X(n.day) && (c.day = Math.min(Ii(c.year, c.month), c.day))) : c = Al({ ...br(this.c), ...n });
    const [d, u] = wi(c, this.o, this.zone);
    return vn(this, { ts: d, o: u });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid)
      return this;
    const n = ee.fromDurationLike(t);
    return vn(this, $l(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid)
      return this;
    const n = ee.fromDurationLike(t).negate();
    return vn(this, $l(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t) {
    if (!this.isValid)
      return this;
    const n = {}, o = ee.normalizeUnit(t);
    switch (o) {
      case "years":
        n.month = 1;
      case "quarters":
      case "months":
        n.day = 1;
      case "weeks":
      case "days":
        n.hour = 0;
      case "hours":
        n.minute = 0;
      case "minutes":
        n.second = 0;
      case "seconds":
        n.millisecond = 0;
        break;
    }
    if (o === "weeks" && (n.weekday = 1), o === "quarters") {
      const i = Math.ceil(this.month / 3);
      n.month = (i - 1) * 3 + 1;
    }
    return this.set(n);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? Re.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : vr;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = Ti, n = {}) {
    return this.isValid ? Re.create(this.loc.clone(n), t).formatDateTime(this) : vr;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? Re.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: o = !1,
    includeOffset: i = !0,
    extendedZone: r = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const s = t === "extended";
    let a = wr(this, s);
    return a += "T", a += Nl(this, s, n, o, i, r), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? wr(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return ri(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: o = !0,
    includePrefix: i = !1,
    extendedZone: r = !1,
    format: s = "extended"
  } = {}) {
    return this.isValid ? (i ? "T" : "") + Nl(
      this,
      s === "extended",
      n,
      t,
      o,
      r
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return ri(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return ri(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? wr(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: o = !0 } = {}) {
    let i = "HH:mm:ss.SSS";
    return (n || t) && (o && (i += " "), n ? i += "z" : t && (i += "ZZ")), ri(this, i, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : vr;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid)
      return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", o = {}) {
    if (!this.isValid || !t.isValid)
      return ee.invalid("created by diffing an invalid DateTime");
    const i = { locale: this.locale, numberingSystem: this.numberingSystem, ...o }, r = _p(n).map(ee.normalizeUnit), s = t.valueOf() > this.valueOf(), a = s ? this : t, l = s ? t : this, c = Sg(a, l, r, i);
    return s ? c.negate() : c;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(W.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? pe.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n) {
    if (!this.isValid)
      return !1;
    const o = t.valueOf(), i = this.setZone(t.zone, { keepLocalTime: !0 });
    return i.startOf(n) <= o && o <= i.endOf(n);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid)
      return null;
    const n = t.base || W.fromObject({}, { zone: this.zone }), o = t.padding ? this < n ? -t.padding : t.padding : 0;
    let i = ["years", "months", "days", "hours", "minutes", "seconds"], r = t.unit;
    return Array.isArray(t.unit) && (i = t.unit, r = void 0), Ml(n, this.plus(o), {
      ...t,
      numeric: "always",
      units: i,
      unit: r
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? Ml(t.base || W.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(W.isDateTime))
      throw new at("min requires all arguments be DateTimes");
    return wl(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(W.isDateTime))
      throw new at("max requires all arguments be DateTimes");
    return wl(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, o = {}) {
    const { locale: i = null, numberingSystem: r = null } = o, s = ce.fromOpts({
      locale: i,
      numberingSystem: r,
      defaultToEN: !0
    });
    return bu(s, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, o = {}) {
    return W.fromFormatExplain(t, n, o);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Ti;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Dd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return np;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return $d;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return Nd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Ld;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Pd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Md;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Fd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Rd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Vd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return zd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Ud;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Hd;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return Bd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Wd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return jd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return op;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Yd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Gd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return qd;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Kd;
  }
}
function ko(e) {
  if (W.isDateTime(e))
    return e;
  if (e && e.valueOf && On(e.valueOf()))
    return W.fromJSDate(e);
  if (e && typeof e == "object")
    return W.fromObject(e);
  throw new at(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const Cu = Zs("userAuth", {
  state: () => ({
    token: {
      value: "",
      expiration: void 0
    },
    oms: ""
  }),
  getters: {
    getToken: (e) => e.token,
    getOms: (e) => e.oms,
    isAuthenticated: (e) => {
      let t = !1;
      if (e.token.expiration) {
        const n = W.now().toMillis();
        t = e.token.expiration < n;
      }
      return e.token.value && !t;
    }
  },
  persist: !0
});
const Kn = {
  allRenderFn: !1,
  cmpDidLoad: !0,
  cmpDidUnload: !1,
  cmpDidUpdate: !0,
  cmpDidRender: !0,
  cmpWillLoad: !0,
  cmpWillUpdate: !0,
  cmpWillRender: !0,
  connectedCallback: !0,
  disconnectedCallback: !0,
  element: !0,
  event: !0,
  hasRenderFn: !0,
  lifecycle: !0,
  hostListener: !0,
  hostListenerTargetWindow: !0,
  hostListenerTargetDocument: !0,
  hostListenerTargetBody: !0,
  hostListenerTargetParent: !1,
  hostListenerTarget: !0,
  member: !0,
  method: !0,
  mode: !0,
  observeAttribute: !0,
  prop: !0,
  propMutable: !0,
  reflect: !0,
  scoped: !0,
  shadowDom: !0,
  slot: !0,
  cssAnnotations: !0,
  state: !0,
  style: !0,
  svg: !0,
  updatable: !0,
  vdomAttribute: !0,
  vdomXlink: !0,
  vdomClass: !0,
  vdomFunctional: !0,
  vdomKey: !0,
  vdomListener: !0,
  vdomRef: !0,
  vdomPropOrAttr: !0,
  vdomRender: !0,
  vdomStyle: !0,
  vdomText: !0,
  watchCallback: !0,
  taskQueue: !0,
  hotModuleReplacement: !1,
  isDebug: !1,
  isDev: !1,
  isTesting: !1,
  hydrateServerSide: !1,
  hydrateClientSide: !1,
  lifecycleDOMEvents: !1,
  lazyLoad: !1,
  profile: !1,
  slotRelocation: !0,
  appendChildSlotFix: !1,
  cloneNodeFix: !1,
  hydratedAttribute: !1,
  hydratedClass: !0,
  safari10: !1,
  scriptDataOpts: !1,
  scopedSlotTextContentFix: !1,
  shadowDomShim: !1,
  slotChildNodesFix: !1,
  invisiblePrehydration: !0,
  propBoolean: !0,
  propNumber: !0,
  propString: !0,
  cssVarShim: !1,
  constructableCSS: !0,
  cmpShouldUpdate: !0,
  devTools: !1,
  dynamicImportShim: !1,
  shadowDelegatesFocus: !0,
  initializeNextTick: !1,
  asyncLoading: !1,
  asyncQueue: !1,
  transformTagName: !1,
  attachStyles: !0
};
let Xn, Au, Xi, Du = !1, Ci = !1, ia = !1, Xe = !1, Rl = null, cs = !1;
const $u = (e) => {
  const t = new URL(e, Ne.$resourcesUrl$);
  return t.origin !== Xo.location.origin ? t.href : t.pathname;
}, An = (e, t = "") => () => {
}, Vl = "http://www.w3.org/1999/xlink", zl = {}, Kg = "http://www.w3.org/2000/svg", Xg = "http://www.w3.org/1999/xhtml", Zg = (e) => e != null, ra = (e) => (e = typeof e, e === "object" || e === "function");
function Jg(e) {
  var t, n, o;
  return (o = (n = (t = e.head) === null || t === void 0 ? void 0 : t.querySelector('meta[name="csp-nonce"]')) === null || n === void 0 ? void 0 : n.getAttribute("content")) !== null && o !== void 0 ? o : void 0;
}
const x = (e, t, ...n) => {
  let o = null, i = null, r = null, s = !1, a = !1;
  const l = [], c = (u) => {
    for (let f = 0; f < u.length; f++)
      o = u[f], Array.isArray(o) ? c(o) : o != null && typeof o != "boolean" && ((s = typeof e != "function" && !ra(o)) && (o = String(o)), s && a ? l[l.length - 1].$text$ += o : l.push(s ? Ai(null, o) : o), a = s);
  };
  if (c(n), t) {
    t.key && (i = t.key), t.name && (r = t.name);
    {
      const u = t.className || t.class;
      u && (t.class = typeof u != "object" ? u : Object.keys(u).filter((f) => u[f]).join(" "));
    }
  }
  if (typeof e == "function")
    return e(t === null ? {} : t, l, eb);
  const d = Ai(e, null);
  return d.$attrs$ = t, l.length > 0 && (d.$children$ = l), d.$key$ = i, d.$name$ = r, d;
}, Ai = (e, t) => {
  const n = {
    $flags$: 0,
    $tag$: e,
    $text$: t,
    $elm$: null,
    $children$: null
  };
  return n.$attrs$ = null, n.$key$ = null, n.$name$ = null, n;
}, ae = {}, Qg = (e) => e && e.$tag$ === ae, eb = {
  forEach: (e, t) => e.map(Ul).forEach(t),
  map: (e, t) => e.map(Ul).map(t).map(tb)
}, Ul = (e) => ({
  vattrs: e.$attrs$,
  vchildren: e.$children$,
  vkey: e.$key$,
  vname: e.$name$,
  vtag: e.$tag$,
  vtext: e.$text$
}), tb = (e) => {
  if (typeof e.vtag == "function") {
    const n = Object.assign({}, e.vattrs);
    return e.vkey && (n.key = e.vkey), e.vname && (n.name = e.vname), x(e.vtag, n, ...e.vchildren || []);
  }
  const t = Ai(e.vtag, e.vtext);
  return t.$attrs$ = e.vattrs, t.$children$ = e.vchildren, t.$key$ = e.vkey, t.$name$ = e.vname, t;
}, nb = (e) => Ab.map((t) => t(e)).find((t) => !!t), ob = (e) => po(e).$modeName$, ib = (e, t) => e != null && !ra(e) ? t & 4 ? e === "false" ? !1 : e === "" || !!e : t & 2 ? parseFloat(e) : t & 1 ? String(e) : e : e, rb = (e) => e, G = (e, t, n) => {
  const o = rb(e);
  return {
    emit: (i) => sb(o, t, {
      bubbles: !!(n & 4),
      composed: !!(n & 2),
      cancelable: !!(n & 1),
      detail: i
    })
  };
}, sb = (e, t, n) => {
  const o = Ne.ce(t, n);
  return e.dispatchEvent(o), o;
}, Hl = /* @__PURE__ */ new WeakMap(), ab = (e, t, n) => {
  let o = Ni.get(e);
  Nb && n ? (o = o || new CSSStyleSheet(), typeof o == "string" ? o = t : o.replaceSync(t)) : o = t, Ni.set(e, o);
}, lb = (e, t, n, o) => {
  var i;
  let r = Nu(t, n);
  const s = Ni.get(r);
  if (e = e.nodeType === 11 ? e : _t, s)
    if (typeof s == "string") {
      e = e.head || e;
      let a = Hl.get(e), l;
      if (a || Hl.set(e, a = /* @__PURE__ */ new Set()), !a.has(r)) {
        {
          l = _t.createElement("style"), l.innerHTML = s;
          const c = (i = Ne.$nonce$) !== null && i !== void 0 ? i : Jg(_t);
          c != null && l.setAttribute("nonce", c), e.insertBefore(l, e.querySelector("link"));
        }
        a && a.add(r);
      }
    } else
      e.adoptedStyleSheets.includes(s) || (e.adoptedStyleSheets = [...e.adoptedStyleSheets, s]);
  return r;
}, cb = (e) => {
  const t = e.$cmpMeta$, n = e.$hostElement$, o = t.$flags$, i = An("attachStyles", t.$tagName$), r = lb(n.shadowRoot ? n.shadowRoot : n.getRootNode(), t, e.$modeName$);
  o & 10 && (n["s-sc"] = r, n.classList.add(r + "-h"), o & 2 && n.classList.add(r + "-s")), i();
}, Nu = (e, t) => "sc-" + (t && e.$flags$ & 32 ? e.$tagName$ + "-" + t : e.$tagName$), Bl = (e, t, n, o, i, r) => {
  if (n !== o) {
    let s = Gl(e, t), a = t.toLowerCase();
    if (t === "class") {
      const l = e.classList, c = Wl(n), d = Wl(o);
      l.remove(...c.filter((u) => u && !d.includes(u))), l.add(...d.filter((u) => u && !c.includes(u)));
    } else if (t === "style") {
      for (const l in n)
        (!o || o[l] == null) && (l.includes("-") ? e.style.removeProperty(l) : e.style[l] = "");
      for (const l in o)
        (!n || o[l] !== n[l]) && (l.includes("-") ? e.style.setProperty(l, o[l]) : e.style[l] = o[l]);
    } else if (t !== "key")
      if (t === "ref")
        o && o(e);
      else if (!e.__lookupSetter__(t) && t[0] === "o" && t[1] === "n")
        t[2] === "-" ? t = t.slice(3) : Gl(Xo, a) ? t = a.slice(2) : t = a[2] + t.slice(3), n && Ne.rel(e, t, n, !1), o && Ne.ael(e, t, o, !1);
      else {
        const l = ra(o);
        if ((s || l && o !== null) && !i)
          try {
            if (e.tagName.includes("-"))
              e[t] = o;
            else {
              const d = o ?? "";
              t === "list" ? s = !1 : (n == null || e[t] != d) && (e[t] = d);
            }
          } catch {
          }
        let c = !1;
        a !== (a = a.replace(/^xlink\:?/, "")) && (t = a, c = !0), o == null || o === !1 ? (o !== !1 || e.getAttribute(t) === "") && (c ? e.removeAttributeNS(Vl, t) : e.removeAttribute(t)) : (!s || r & 4 || i) && !l && (o = o === !0 ? "" : o, c ? e.setAttributeNS(Vl, t, o) : e.setAttribute(t, o));
      }
  }
}, db = /\s/, Wl = (e) => e ? e.split(db) : [], Lu = (e, t, n, o) => {
  const i = t.$elm$.nodeType === 11 && t.$elm$.host ? t.$elm$.host : t.$elm$, r = e && e.$attrs$ || zl, s = t.$attrs$ || zl;
  for (o in r)
    o in s || Bl(i, o, r[o], void 0, n, t.$flags$);
  for (o in s)
    Bl(i, o, r[o], s[o], n, t.$flags$);
}, Di = (e, t, n, o) => {
  const i = t.$children$[n];
  let r = 0, s, a, l;
  if (Du || (ia = !0, i.$tag$ === "slot" && (Xn && o.classList.add(Xn + "-s"), i.$flags$ |= i.$children$ ? (
    // slot element has fallback content
    2
  ) : (
    // slot element does not have fallback content
    1
  ))), i.$text$ !== null)
    s = i.$elm$ = _t.createTextNode(i.$text$);
  else if (i.$flags$ & 1)
    s = i.$elm$ = _t.createTextNode("");
  else {
    if (Xe || (Xe = i.$tag$ === "svg"), s = i.$elm$ = _t.createElementNS(Xe ? Kg : Xg, i.$flags$ & 2 ? "slot-fb" : i.$tag$), Xe && i.$tag$ === "foreignObject" && (Xe = !1), Lu(null, i, Xe), Zg(Xn) && s["s-si"] !== Xn && s.classList.add(s["s-si"] = Xn), i.$children$)
      for (r = 0; r < i.$children$.length; ++r)
        a = Di(e, i, r, s), a && s.appendChild(a);
    i.$tag$ === "svg" ? Xe = !1 : s.tagName === "foreignObject" && (Xe = !0);
  }
  return s["s-hn"] = Xi, i.$flags$ & 3 && (s["s-sr"] = !0, s["s-cr"] = Au, s["s-sn"] = i.$name$ || "", l = e && e.$children$ && e.$children$[n], l && l.$tag$ === i.$tag$ && e.$elm$ && Mo(e.$elm$, !1)), s;
}, Mo = (e, t) => {
  Ne.$flags$ |= 1;
  const n = e.childNodes;
  for (let o = n.length - 1; o >= 0; o--) {
    const i = n[o];
    i["s-hn"] !== Xi && i["s-ol"] && (Fu(i).insertBefore(i, sa(i)), i["s-ol"].remove(), i["s-ol"] = void 0, ia = !0), t && Mo(i, t);
  }
  Ne.$flags$ &= -2;
}, Pu = (e, t, n, o, i, r) => {
  let s = e["s-cr"] && e["s-cr"].parentNode || e, a;
  for (s.shadowRoot && s.tagName === Xi && (s = s.shadowRoot); i <= r; ++i)
    o[i] && (a = Di(null, n, i, e), a && (o[i].$elm$ = a, s.insertBefore(a, sa(t))));
}, Mu = (e, t, n, o, i) => {
  for (; t <= n; ++t)
    (o = e[t]) && (i = o.$elm$, zu(o), Ci = !0, i["s-ol"] ? i["s-ol"].remove() : Mo(i, !0), i.remove());
}, ub = (e, t, n, o) => {
  let i = 0, r = 0, s = 0, a = 0, l = t.length - 1, c = t[0], d = t[l], u = o.length - 1, f = o[0], g = o[u], E, k;
  for (; i <= l && r <= u; )
    if (c == null)
      c = t[++i];
    else if (d == null)
      d = t[--l];
    else if (f == null)
      f = o[++r];
    else if (g == null)
      g = o[--u];
    else if (si(c, f))
      Zn(c, f), c = t[++i], f = o[++r];
    else if (si(d, g))
      Zn(d, g), d = t[--l], g = o[--u];
    else if (si(c, g))
      (c.$tag$ === "slot" || g.$tag$ === "slot") && Mo(c.$elm$.parentNode, !1), Zn(c, g), e.insertBefore(c.$elm$, d.$elm$.nextSibling), c = t[++i], g = o[--u];
    else if (si(d, f))
      (c.$tag$ === "slot" || g.$tag$ === "slot") && Mo(d.$elm$.parentNode, !1), Zn(d, f), e.insertBefore(d.$elm$, c.$elm$), d = t[--l], f = o[++r];
    else {
      for (s = -1, a = i; a <= l; ++a)
        if (t[a] && t[a].$key$ !== null && t[a].$key$ === f.$key$) {
          s = a;
          break;
        }
      s >= 0 ? (k = t[s], k.$tag$ !== f.$tag$ ? E = Di(t && t[r], n, s, e) : (Zn(k, f), t[s] = void 0, E = k.$elm$), f = o[++r]) : (E = Di(t && t[r], n, r, e), f = o[++r]), E && Fu(c.$elm$).insertBefore(E, sa(c.$elm$));
    }
  i > l ? Pu(e, o[u + 1] == null ? null : o[u + 1].$elm$, n, o, r, u) : r > u && Mu(t, i, l);
}, si = (e, t) => e.$tag$ === t.$tag$ ? e.$tag$ === "slot" ? e.$name$ === t.$name$ : e.$key$ === t.$key$ : !1, sa = (e) => e && e["s-ol"] || e, Fu = (e) => (e["s-ol"] ? e["s-ol"] : e).parentNode, Zn = (e, t) => {
  const n = t.$elm$ = e.$elm$, o = e.$children$, i = t.$children$, r = t.$tag$, s = t.$text$;
  let a;
  s === null ? (Xe = r === "svg" ? !0 : r === "foreignObject" ? !1 : Xe, r === "slot" || Lu(e, t, Xe), o !== null && i !== null ? ub(n, o, t, i) : i !== null ? (e.$text$ !== null && (n.textContent = ""), Pu(n, null, t, i, 0, i.length - 1)) : o !== null && Mu(o, 0, o.length - 1), Xe && r === "svg" && (Xe = !1)) : (a = n["s-cr"]) ? a.parentNode.textContent = s : e.$text$ !== s && (n.data = s);
}, Ru = (e) => {
  const t = e.childNodes;
  let n, o, i, r, s, a;
  for (o = 0, i = t.length; o < i; o++)
    if (n = t[o], n.nodeType === 1) {
      if (n["s-sr"]) {
        for (s = n["s-sn"], n.hidden = !1, r = 0; r < i; r++)
          if (a = t[r].nodeType, t[r]["s-hn"] !== n["s-hn"] || s !== "") {
            if (a === 1 && s === t[r].getAttribute("slot")) {
              n.hidden = !0;
              break;
            }
          } else if (a === 1 || a === 3 && t[r].textContent.trim() !== "") {
            n.hidden = !0;
            break;
          }
      }
      Ru(n);
    }
}, wt = [], Vu = (e) => {
  let t, n, o, i, r, s, a = 0;
  const l = e.childNodes, c = l.length;
  for (; a < c; a++) {
    if (t = l[a], t["s-sr"] && (n = t["s-cr"]) && n.parentNode)
      for (o = n.parentNode.childNodes, i = t["s-sn"], s = o.length - 1; s >= 0; s--)
        n = o[s], !n["s-cn"] && !n["s-nr"] && n["s-hn"] !== t["s-hn"] && (jl(n, i) ? (r = wt.find((d) => d.$nodeToRelocate$ === n), Ci = !0, n["s-sn"] = n["s-sn"] || i, r ? r.$slotRefNode$ = t : wt.push({
          $slotRefNode$: t,
          $nodeToRelocate$: n
        }), n["s-sr"] && wt.map((d) => {
          jl(d.$nodeToRelocate$, n["s-sn"]) && (r = wt.find((u) => u.$nodeToRelocate$ === n), r && !d.$slotRefNode$ && (d.$slotRefNode$ = r.$slotRefNode$));
        })) : wt.some((d) => d.$nodeToRelocate$ === n) || wt.push({
          $nodeToRelocate$: n
        }));
    t.nodeType === 1 && Vu(t);
  }
}, jl = (e, t) => e.nodeType === 1 ? e.getAttribute("slot") === null && t === "" || e.getAttribute("slot") === t : e["s-sn"] === t ? !0 : t === "", zu = (e) => {
  e.$attrs$ && e.$attrs$.ref && e.$attrs$.ref(null), e.$children$ && e.$children$.map(zu);
}, fb = (e, t) => {
  const n = e.$hostElement$, o = e.$cmpMeta$, i = e.$vnode$ || Ai(null, null), r = Qg(t) ? t : x(null, null, t);
  Xi = n.tagName, o.$attrsToReflect$ && (r.$attrs$ = r.$attrs$ || {}, o.$attrsToReflect$.map(([s, a]) => r.$attrs$[a] = n[s])), r.$tag$ = null, r.$flags$ |= 4, e.$vnode$ = r, r.$elm$ = i.$elm$ = n.shadowRoot || n, Xn = n["s-sc"], Au = n["s-cr"], Du = (o.$flags$ & 1) !== 0, Ci = !1, Zn(i, r);
  {
    if (Ne.$flags$ |= 1, ia) {
      Vu(r.$elm$);
      let s, a, l, c, d, u, f = 0;
      for (; f < wt.length; f++)
        s = wt[f], a = s.$nodeToRelocate$, a["s-ol"] || (l = _t.createTextNode(""), l["s-nr"] = a, a.parentNode.insertBefore(a["s-ol"] = l, a));
      for (f = 0; f < wt.length; f++)
        if (s = wt[f], a = s.$nodeToRelocate$, s.$slotRefNode$) {
          for (c = s.$slotRefNode$.parentNode, d = s.$slotRefNode$.nextSibling, l = a["s-ol"]; l = l.previousSibling; )
            if (u = l["s-nr"], u && u["s-sn"] === a["s-sn"] && c === u.parentNode && (u = u.nextSibling, !u || !u["s-nr"])) {
              d = u;
              break;
            }
          (!d && c !== a.parentNode || a.nextSibling !== d) && a !== d && (!a["s-hn"] && a["s-ol"] && (a["s-hn"] = a["s-ol"].parentNode.nodeName), c.insertBefore(a, d));
        } else
          a.nodeType === 1 && (a.hidden = !0);
    }
    Ci && Ru(r.$elm$), Ne.$flags$ &= -2, wt.length = 0;
  }
}, hb = (e, t) => {
}, aa = (e, t) => (e.$flags$ |= 16, hb(e, e.$ancestorComponent$), Li(() => mb(e, t))), mb = (e, t) => {
  const n = e.$hostElement$, o = An("scheduleUpdate", e.$cmpMeta$.$tagName$), i = n;
  let r;
  return t ? r = io(i, "componentWillLoad") : r = io(i, "componentWillUpdate"), r = Yl(r, () => io(i, "componentWillRender")), o(), Yl(r, () => pb(e, i, t));
}, pb = async (e, t, n) => {
  const o = e.$hostElement$, i = An("update", e.$cmpMeta$.$tagName$);
  o["s-rc"], n && cb(e);
  const r = An("render", e.$cmpMeta$.$tagName$);
  gb(e, t, o), r(), i(), bb(e);
}, gb = (e, t, n) => {
  try {
    Rl = t, t = t.render && t.render(), e.$flags$ &= -17, e.$flags$ |= 2, (Kn.hasRenderFn || Kn.reflect) && (Kn.vdomRender || Kn.reflect) && (Kn.hydrateServerSide || fb(e, t));
  } catch (a) {
    Ko(a, e.$hostElement$);
  }
  return Rl = null, null;
}, bb = (e) => {
  const t = e.$cmpMeta$.$tagName$, n = e.$hostElement$, o = An("postUpdate", t), i = n;
  e.$ancestorComponent$, io(i, "componentDidRender"), e.$flags$ & 64 ? (io(i, "componentDidUpdate"), o()) : (e.$flags$ |= 64, io(i, "componentDidLoad"), o());
}, $i = (e) => {
  {
    const t = po(e), n = t.$hostElement$.isConnected;
    return n && (t.$flags$ & 18) === 2 && aa(t, !1), n;
  }
}, io = (e, t, n) => {
  if (e && e[t])
    try {
      return e[t](n);
    } catch (o) {
      Ko(o);
    }
}, Yl = (e, t) => e && e.then ? e.then(t) : t(), vb = (e, t) => po(e).$instanceValues$.get(t), yb = (e, t, n, o) => {
  const i = po(e), r = e, s = i.$instanceValues$.get(t), a = i.$flags$, l = r;
  n = ib(n, o.$members$[t][0]);
  const c = Number.isNaN(s) && Number.isNaN(n);
  if (n !== s && !c) {
    i.$instanceValues$.set(t, n);
    {
      if (o.$watchers$ && a & 128) {
        const u = o.$watchers$[t];
        u && u.map((f) => {
          try {
            l[f](n, s, t);
          } catch (g) {
            Ko(g, r);
          }
        });
      }
      if ((a & 18) === 2) {
        if (l.componentShouldUpdate && l.componentShouldUpdate(n, s, t) === !1)
          return;
        aa(i, !1);
      }
    }
  }
}, wb = (e, t, n) => {
  if (t.$members$) {
    e.watchers && (t.$watchers$ = e.watchers);
    const o = Object.entries(t.$members$), i = e.prototype;
    o.map(([r, [s]]) => {
      (s & 31 || s & 32) && Object.defineProperty(i, r, {
        get() {
          return vb(this, r);
        },
        set(a) {
          yb(this, r, a, t);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const r = /* @__PURE__ */ new Map();
      i.attributeChangedCallback = function(s, a, l) {
        Ne.jmp(() => {
          const c = r.get(s);
          if (this.hasOwnProperty(c))
            l = this[c], delete this[c];
          else if (i.hasOwnProperty(c) && typeof this[c] == "number" && this[c] == l)
            return;
          this[c] = l === null && typeof this[c] == "boolean" ? !1 : l;
        });
      }, e.observedAttributes = o.filter(
        ([s, a]) => a[0] & 15
        /* MEMBER_FLAGS.HasAttribute */
      ).map(([s, a]) => {
        const l = a[1] || s;
        return r.set(l, s), a[0] & 512 && t.$attrsToReflect$.push([s, l]), l;
      });
    }
  }
  return e;
}, kb = async (e, t, n, o, i) => {
  if (!(t.$flags$ & 32) && (i = e.constructor, t.$flags$ |= 32, customElements.whenDefined(n.$tagName$).then(() => t.$flags$ |= 128), i.style)) {
    let s = i.style;
    typeof s != "string" && (s = s[t.$modeName$ = nb(e)]);
    const a = Nu(n, t.$modeName$);
    if (!Ni.has(a)) {
      const l = An("registerStyles", n.$tagName$);
      ab(a, s, !!(n.$flags$ & 1)), l();
    }
  }
  t.$ancestorComponent$, (() => aa(t, !0))();
}, xb = (e) => {
}, _b = (e) => {
  if (!(Ne.$flags$ & 1)) {
    const t = po(e), n = t.$cmpMeta$, o = An("connectedCallback", n.$tagName$);
    t.$flags$ & 1 ? (Uu(e, t, n.$listeners$), xb(t.$lazyInstance$)) : (t.$flags$ |= 1, n.$flags$ & 12 && Eb(e), n.$members$ && Object.entries(n.$members$).map(([i, [r]]) => {
      if (r & 31 && e.hasOwnProperty(i)) {
        const s = e[i];
        delete e[i], e[i] = s;
      }
    }), kb(e, t, n)), o();
  }
}, Eb = (e) => {
  const t = e["s-cr"] = _t.createComment("");
  t["s-cn"] = !0, e.insertBefore(t, e.firstChild);
}, Tb = (e) => {
  if (!(Ne.$flags$ & 1)) {
    const t = po(e);
    t.$rmListeners$ && (t.$rmListeners$.map((n) => n()), t.$rmListeners$ = void 0);
  }
}, de = (e, t) => {
  const n = {
    $flags$: t[0],
    $tagName$: t[1]
  };
  n.$members$ = t[2], n.$listeners$ = t[3], n.$watchers$ = e.$watchers$, n.$attrsToReflect$ = [];
  const o = e.prototype.connectedCallback, i = e.prototype.disconnectedCallback;
  return Object.assign(e.prototype, {
    __registerHost() {
      Cb(this, n);
    },
    connectedCallback() {
      _b(this), o && o.call(this);
    },
    disconnectedCallback() {
      Tb(this), i && i.call(this);
    },
    __attachShadow() {
      this.attachShadow({
        mode: "open",
        delegatesFocus: !!(n.$flags$ & 16)
      });
    }
  }), e.is = n.$tagName$, wb(e, n);
}, Uu = (e, t, n, o) => {
  n && n.map(([i, r, s]) => {
    const a = Sb(e, i), l = Ib(t, s), c = Ob(i);
    Ne.ael(a, r, l, c), (t.$rmListeners$ = t.$rmListeners$ || []).push(() => Ne.rel(a, r, l, c));
  });
}, Ib = (e, t) => (n) => {
  try {
    Kn.lazyLoad || e.$hostElement$[t](n);
  } catch (o) {
    Ko(o);
  }
}, Sb = (e, t) => t & 4 ? _t : t & 8 ? Xo : t & 16 ? _t.body : e, Ob = (e) => Db ? {
  passive: (e & 1) !== 0,
  capture: (e & 2) !== 0
} : (e & 2) !== 0, Hu = /* @__PURE__ */ new WeakMap(), po = (e) => Hu.get(e), Cb = (e, t) => {
  const n = {
    $flags$: 0,
    $hostElement$: e,
    $cmpMeta$: t,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return Uu(e, n, t.$listeners$), Hu.set(e, n);
}, Gl = (e, t) => t in e, Ko = (e, t) => (0, console.error)(e, t), Ni = /* @__PURE__ */ new Map(), Ab = [], Xo = typeof window < "u" ? window : {}, _t = Xo.document || { head: {} }, ue = Xo.HTMLElement || class {
}, Ne = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (e) => e(),
  raf: (e) => requestAnimationFrame(e),
  ael: (e, t, n, o) => e.addEventListener(t, n, o),
  rel: (e, t, n, o) => e.removeEventListener(t, n, o),
  ce: (e, t) => new CustomEvent(e, t)
}, Db = /* @__PURE__ */ (() => {
  let e = !1;
  try {
    _t.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        e = !0;
      }
    }));
  } catch {
  }
  return e;
})(), $b = (e) => Promise.resolve(e), Nb = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), ds = [], Bu = [], Wu = (e, t) => (n) => {
  e.push(n), cs || (cs = !0, t && Ne.$flags$ & 4 ? Lb(us) : Ne.raf(us));
}, ql = (e) => {
  for (let t = 0; t < e.length; t++)
    try {
      e[t](performance.now());
    } catch (n) {
      Ko(n);
    }
  e.length = 0;
}, us = () => {
  ql(ds), ql(Bu), (cs = ds.length > 0) && Ne.raf(us);
}, Lb = (e) => $b().then(e), ju = /* @__PURE__ */ Wu(ds, !1), Li = /* @__PURE__ */ Wu(Bu, !0);
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Kl = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M184 112l144 144-144 144' class='ionicon-fill-none'/></svg>";
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
class Pb {
  constructor() {
    this.m = /* @__PURE__ */ new Map();
  }
  reset(t) {
    this.m = new Map(Object.entries(t));
  }
  get(t, n) {
    const o = this.m.get(t);
    return o !== void 0 ? o : n;
  }
  getBoolean(t, n = !1) {
    const o = this.m.get(t);
    return o === void 0 ? n : typeof o == "string" ? o === "true" : !!o;
  }
  getNumber(t, n) {
    const o = parseFloat(this.m.get(t));
    return isNaN(o) ? n !== void 0 ? n : NaN : o;
  }
  set(t, n) {
    this.m.set(t, n);
  }
}
const go = /* @__PURE__ */ new Pb(), Mb = (e) => Rb(e), Fb = (e, t) => (typeof e == "string" && (t = e, e = void 0), Mb(e).includes(t)), Rb = (e = window) => {
  if (typeof e > "u")
    return [];
  e.Ionic = e.Ionic || {};
  let t = e.Ionic.platforms;
  return t == null && (t = e.Ionic.platforms = Vb(e), t.forEach((n) => e.document.documentElement.classList.add(`plt-${n}`))), t;
}, Vb = (e) => {
  const t = go.get("platform");
  return Object.keys(Xl).filter((n) => {
    const o = t == null ? void 0 : t[n];
    return typeof o == "function" ? o(e) : Xl[n](e);
  });
}, zb = (e) => Zi(e) && !Gu(e), la = (e) => !!(Dn(e, /iPad/i) || Dn(e, /Macintosh/i) && Zi(e)), Ub = (e) => Dn(e, /iPhone/i), Hb = (e) => Dn(e, /iPhone|iPod/i) || la(e), Yu = (e) => Dn(e, /android|sink/i), Bb = (e) => Yu(e) && !Dn(e, /mobile/i), Wb = (e) => {
  const t = e.innerWidth, n = e.innerHeight, o = Math.min(t, n), i = Math.max(t, n);
  return o > 390 && o < 520 && i > 620 && i < 800;
}, jb = (e) => {
  const t = e.innerWidth, n = e.innerHeight, o = Math.min(t, n), i = Math.max(t, n);
  return la(e) || Bb(e) || o > 460 && o < 820 && i > 780 && i < 1400;
}, Zi = (e) => Kb(e, "(any-pointer:coarse)"), Yb = (e) => !Zi(e), Gu = (e) => qu(e) || Ku(e), qu = (e) => !!(e.cordova || e.phonegap || e.PhoneGap), Ku = (e) => {
  const t = e.Capacitor;
  return !!(t != null && t.isNative);
}, Gb = (e) => Dn(e, /electron/i), qb = (e) => {
  var t;
  return !!(!((t = e.matchMedia) === null || t === void 0) && t.call(e, "(display-mode: standalone)").matches || e.navigator.standalone);
}, Dn = (e, t) => t.test(e.navigator.userAgent), Kb = (e, t) => {
  var n;
  return (n = e.matchMedia) === null || n === void 0 ? void 0 : n.call(e, t).matches;
}, Xl = {
  ipad: la,
  iphone: Ub,
  ios: Hb,
  android: Yu,
  phablet: Wb,
  tablet: jb,
  cordova: qu,
  capacitor: Ku,
  electron: Gb,
  pwa: qb,
  mobile: Zi,
  mobileweb: zb,
  desktop: Yb,
  hybrid: Gu
};
let Xb;
const te = (e) => e && ob(e) || Xb;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const ca = (e, t) => {
  e.componentOnReady ? e.componentOnReady().then((n) => t(n)) : Fe(() => t(e));
}, da = (e, t = []) => {
  const n = {};
  return t.forEach((o) => {
    e.hasAttribute(o) && (e.getAttribute(o) !== null && (n[o] = e.getAttribute(o)), e.removeAttribute(o));
  }), n;
}, Zb = [
  "role",
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-braillelabel",
  "aria-brailleroledescription",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colindextext",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-description",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowindextext",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext"
], Jb = (e, t) => {
  let n = Zb;
  return t && t.length > 0 && (n = n.filter((o) => !t.includes(o))), da(e, n);
}, ua = (e, t, n, o) => {
  var i;
  if (typeof window < "u") {
    const r = window, s = (i = r == null ? void 0 : r.Ionic) === null || i === void 0 ? void 0 : i.config;
    if (s) {
      const a = s.get("_ael");
      if (a)
        return a(e, t, n, o);
      if (s._ael)
        return s._ael(e, t, n, o);
    }
  }
  return e.addEventListener(t, n, o);
}, Xu = (e, t, n, o) => {
  var i;
  if (typeof window < "u") {
    const r = window, s = (i = r == null ? void 0 : r.Ionic) === null || i === void 0 ? void 0 : i.config;
    if (s) {
      const a = s.get("_rel");
      if (a)
        return a(e, t, n, o);
      if (s._rel)
        return s._rel(e, t, n, o);
    }
  }
  return e.removeEventListener(t, n, o);
}, Hn = (e, t = e) => e.shadowRoot || t, Fe = (e) => typeof __zone_symbol__requestAnimationFrame == "function" ? __zone_symbol__requestAnimationFrame(e) : typeof requestAnimationFrame == "function" ? requestAnimationFrame(e) : setTimeout(e), Zu = (e) => !!e.shadowRoot && !!e.attachShadow, Ju = (e) => {
  const t = e.closest("ion-item");
  return t ? t.querySelector("ion-label") : null;
}, Qu = (e) => {
  if (e.focus(), e.classList.contains("ion-focusable")) {
    const t = e.closest("ion-app");
    t && t.setFocus([e]);
  }
}, fa = (e, t) => {
  let n;
  const o = e.getAttribute("aria-labelledby"), i = e.id;
  let r = o !== null && o.trim() !== "" ? o : t + "-lbl", s = o !== null && o.trim() !== "" ? document.getElementById(o) : Ju(e);
  return s ? (o === null && (s.id = r), n = s.textContent, s.setAttribute("aria-hidden", "true")) : i.trim() !== "" && (s = document.querySelector(`label[for="${i}"]`), s && (s.id !== "" ? r = s.id : s.id = r = `${i}-lbl`, n = s.textContent)), { label: s, labelId: r, labelText: n };
}, ha = (e, t, n, o, i) => {
  if (e || Zu(t)) {
    let r = t.querySelector("input.aux-input");
    r || (r = t.ownerDocument.createElement("input"), r.type = "hidden", r.classList.add("aux-input"), t.appendChild(r)), r.disabled = i, r.name = n, r.value = o || "";
  }
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
let kr;
const Qb = () => {
  if (typeof window > "u")
    return /* @__PURE__ */ new Map();
  if (!kr) {
    const e = window;
    e.Ionicons = e.Ionicons || {}, kr = e.Ionicons.map = e.Ionicons.map || /* @__PURE__ */ new Map();
  }
  return kr;
}, e0 = (e) => {
  let t = xr(e.src);
  return t || (t = ef(e.name, e.icon, e.mode, e.ios, e.md), t ? t0(t) : e.icon && (t = xr(e.icon), t || (t = xr(e.icon[e.mode]), t)) ? t : null);
}, t0 = (e) => {
  const t = Qb().get(e);
  return t || $u(`svg/${e}.svg`);
}, ef = (e, t, n, o, i) => (n = (n && ai(n)) === "ios" ? "ios" : "md", o && n === "ios" ? e = ai(o) : i && n === "md" ? e = ai(i) : (!e && t && !tf(t) && (e = t), Pi(e) && (e = ai(e))), !Pi(e) || e.trim() === "" || e.replace(/[a-z]|-|\d/gi, "") !== "" ? null : e), xr = (e) => Pi(e) && (e = e.trim(), tf(e)) ? e : null, tf = (e) => e.length > 0 && /(\/|\.)/.test(e), Pi = (e) => typeof e == "string", ai = (e) => e.toLowerCase(), n0 = (e, t = []) => {
  const n = {};
  return t.forEach((o) => {
    e.hasAttribute(o) && (e.getAttribute(o) !== null && (n[o] = e.getAttribute(o)), e.removeAttribute(o));
  }), n;
}, o0 = (e) => e && e.dir !== "" ? e.dir.toLowerCase() === "rtl" : (document == null ? void 0 : document.dir.toLowerCase()) === "rtl", i0 = (e) => {
  const t = document.createElement("div");
  t.innerHTML = e;
  for (let o = t.childNodes.length - 1; o >= 0; o--)
    t.childNodes[o].nodeName.toLowerCase() !== "svg" && t.removeChild(t.childNodes[o]);
  const n = t.firstElementChild;
  if (n && n.nodeName.toLowerCase() === "svg") {
    const o = n.getAttribute("class") || "";
    if (n.setAttribute("class", (o + " s-ion-icon").trim()), nf(n))
      return t.innerHTML;
  }
  return "";
}, nf = (e) => {
  if (e.nodeType === 1) {
    if (e.nodeName.toLowerCase() === "script")
      return !1;
    for (let t = 0; t < e.attributes.length; t++) {
      const n = e.attributes[t].name;
      if (Pi(n) && n.toLowerCase().indexOf("on") === 0)
        return !1;
    }
    for (let t = 0; t < e.childNodes.length; t++)
      if (!nf(e.childNodes[t]))
        return !1;
  }
  return !0;
}, r0 = (e) => e.startsWith("data:image/svg+xml"), s0 = (e) => e.indexOf(";utf8,") !== -1, En = /* @__PURE__ */ new Map(), Zl = /* @__PURE__ */ new Map();
let _r;
const a0 = (e, t) => {
  let n = Zl.get(e);
  if (!n)
    if (typeof fetch < "u" && typeof document < "u")
      if (r0(e) && s0(e)) {
        _r || (_r = new DOMParser());
        const i = _r.parseFromString(e, "text/html").querySelector("svg");
        return i && En.set(e, i.outerHTML), Promise.resolve();
      } else
        n = fetch(e).then((o) => {
          if (o.ok)
            return o.text().then((i) => {
              i && t !== !1 && (i = i0(i)), En.set(e, i || "");
            });
          En.set(e, "");
        }), Zl.set(e, n);
    else
      return En.set(e, ""), Promise.resolve();
  return n;
}, l0 = ":host{display:inline-block;width:1em;height:1em;contain:strict;fill:currentColor;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host .ionicon{stroke:currentColor}.ionicon-fill-none{fill:none}.ionicon-stroke-width{stroke-width:32px;stroke-width:var(--ionicon-stroke-width, 32px)}.icon-inner,.ionicon,svg{display:block;height:100%;width:100%}:host(.flip-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}:host(.icon-small){font-size:18px !important}:host(.icon-large){font-size:32px !important}:host(.ion-color){color:var(--ion-color-base) !important}:host(.ion-color-primary){--ion-color-base:var(--ion-color-primary, #3880ff)}:host(.ion-color-secondary){--ion-color-base:var(--ion-color-secondary, #0cd1e8)}:host(.ion-color-tertiary){--ion-color-base:var(--ion-color-tertiary, #f4a942)}:host(.ion-color-success){--ion-color-base:var(--ion-color-success, #10dc60)}:host(.ion-color-warning){--ion-color-base:var(--ion-color-warning, #ffce00)}:host(.ion-color-danger){--ion-color-base:var(--ion-color-danger, #f14141)}:host(.ion-color-light){--ion-color-base:var(--ion-color-light, #f4f5f8)}:host(.ion-color-medium){--ion-color-base:var(--ion-color-medium, #989aa2)}:host(.ion-color-dark){--ion-color-base:var(--ion-color-dark, #222428)}", c0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.iconName = null, this.inheritedAttributes = {}, this.isVisible = !1, this.mode = d0(), this.lazy = !1, this.sanitize = !0, this.hasAriaHidden = () => {
      const { el: e } = this;
      return e.hasAttribute("aria-hidden") && e.getAttribute("aria-hidden") === "true";
    };
  }
  componentWillLoad() {
    this.inheritedAttributes = n0(this.el, ["aria-label"]);
  }
  connectedCallback() {
    this.waitUntilVisible(this.el, "50px", () => {
      this.isVisible = !0, this.loadIcon();
    });
  }
  disconnectedCallback() {
    this.io && (this.io.disconnect(), this.io = void 0);
  }
  waitUntilVisible(e, t, n) {
    if (this.lazy && typeof window < "u" && window.IntersectionObserver) {
      const o = this.io = new window.IntersectionObserver((i) => {
        i[0].isIntersecting && (o.disconnect(), this.io = void 0, n());
      }, { rootMargin: t });
      o.observe(e);
    } else
      n();
  }
  loadIcon() {
    if (this.isVisible) {
      const t = e0(this);
      t && (En.has(t) ? this.svgContent = En.get(t) : a0(t, this.sanitize).then(() => this.svgContent = En.get(t)));
    }
    const e = this.iconName = ef(this.name, this.icon, this.mode, this.ios, this.md);
    e && (this.ariaLabel = e.replace(/\-/g, " "));
  }
  render() {
    const { iconName: e, ariaLabel: t, el: n, inheritedAttributes: o } = this, i = this.mode || "md", r = this.flipRtl || e && (e.indexOf("arrow") > -1 || e.indexOf("chevron") > -1) && this.flipRtl !== !1;
    return x(ae, Object.assign({ "aria-label": t !== void 0 && !this.hasAriaHidden() ? t : null, role: "img", class: Object.assign(Object.assign({ [i]: !0 }, u0(this.color)), { [`icon-${this.size}`]: !!this.size, "flip-rtl": !!r && o0(n) }) }, o), this.svgContent ? x("div", { class: "icon-inner", innerHTML: this.svgContent }) : x("div", { class: "icon-inner" }));
  }
  static get assetsDirs() {
    return ["svg"];
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      name: ["loadIcon"],
      src: ["loadIcon"],
      icon: ["loadIcon"],
      ios: ["loadIcon"],
      md: ["loadIcon"]
    };
  }
  static get style() {
    return l0;
  }
}, [1, "ion-icon", {
  mode: [1025],
  color: [1],
  ios: [1],
  md: [1],
  flipRtl: [4, "flip-rtl"],
  name: [513],
  src: [1],
  icon: [8],
  size: [1],
  lazy: [4],
  sanitize: [4],
  svgContent: [32],
  isVisible: [32],
  ariaLabel: [32]
}]), d0 = () => typeof document < "u" && document.documentElement.getAttribute("mode") || "md", u0 = (e) => e ? {
  "ion-color": !0,
  [`ion-color-${e}`]: !0
} : null;
function Ji() {
  if (typeof customElements > "u")
    return;
  ["ion-icon"].forEach((t) => {
    switch (t) {
      case "ion-icon":
        customElements.get(t) || customElements.define(t, c0);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
class f0 {
  constructor() {
    this.gestureId = 0, this.requestedStart = /* @__PURE__ */ new Map(), this.disabledGestures = /* @__PURE__ */ new Map(), this.disabledScroll = /* @__PURE__ */ new Set();
  }
  /**
   * Creates a gesture delegate based on the GestureConfig passed
   */
  createGesture(t) {
    var n;
    return new h0(this, this.newID(), t.name, (n = t.priority) !== null && n !== void 0 ? n : 0, !!t.disableScroll);
  }
  /**
   * Creates a blocker that will block any other gesture events from firing. Set in the ion-gesture component.
   */
  createBlocker(t = {}) {
    return new m0(this, this.newID(), t.disable, !!t.disableScroll);
  }
  start(t, n, o) {
    return this.canStart(t) ? (this.requestedStart.set(n, o), !0) : (this.requestedStart.delete(n), !1);
  }
  capture(t, n, o) {
    if (!this.start(t, n, o))
      return !1;
    const i = this.requestedStart;
    let r = -1e4;
    if (i.forEach((s) => {
      r = Math.max(r, s);
    }), r === o) {
      this.capturedId = n, i.clear();
      const s = new CustomEvent("ionGestureCaptured", { detail: { gestureName: t } });
      return document.dispatchEvent(s), !0;
    }
    return i.delete(n), !1;
  }
  release(t) {
    this.requestedStart.delete(t), this.capturedId === t && (this.capturedId = void 0);
  }
  disableGesture(t, n) {
    let o = this.disabledGestures.get(t);
    o === void 0 && (o = /* @__PURE__ */ new Set(), this.disabledGestures.set(t, o)), o.add(n);
  }
  enableGesture(t, n) {
    const o = this.disabledGestures.get(t);
    o !== void 0 && o.delete(n);
  }
  disableScroll(t) {
    this.disabledScroll.add(t), this.disabledScroll.size === 1 && document.body.classList.add(Jl);
  }
  enableScroll(t) {
    this.disabledScroll.delete(t), this.disabledScroll.size === 0 && document.body.classList.remove(Jl);
  }
  canStart(t) {
    return !(this.capturedId !== void 0 || this.isDisabled(t));
  }
  isCaptured() {
    return this.capturedId !== void 0;
  }
  isScrollDisabled() {
    return this.disabledScroll.size > 0;
  }
  isDisabled(t) {
    const n = this.disabledGestures.get(t);
    return !!(n && n.size > 0);
  }
  newID() {
    return this.gestureId++, this.gestureId;
  }
}
class h0 {
  constructor(t, n, o, i, r) {
    this.id = n, this.name = o, this.disableScroll = r, this.priority = i * 1e6 + n, this.ctrl = t;
  }
  canStart() {
    return this.ctrl ? this.ctrl.canStart(this.name) : !1;
  }
  start() {
    return this.ctrl ? this.ctrl.start(this.name, this.id, this.priority) : !1;
  }
  capture() {
    if (!this.ctrl)
      return !1;
    const t = this.ctrl.capture(this.name, this.id, this.priority);
    return t && this.disableScroll && this.ctrl.disableScroll(this.id), t;
  }
  release() {
    this.ctrl && (this.ctrl.release(this.id), this.disableScroll && this.ctrl.enableScroll(this.id));
  }
  destroy() {
    this.release(), this.ctrl = void 0;
  }
}
class m0 {
  constructor(t, n, o, i) {
    this.id = n, this.disable = o, this.disableScroll = i, this.ctrl = t;
  }
  block() {
    if (this.ctrl) {
      if (this.disable)
        for (const t of this.disable)
          this.ctrl.disableGesture(t, this.id);
      this.disableScroll && this.ctrl.disableScroll(this.id);
    }
  }
  unblock() {
    if (this.ctrl) {
      if (this.disable)
        for (const t of this.disable)
          this.ctrl.enableGesture(t, this.id);
      this.disableScroll && this.ctrl.enableScroll(this.id);
    }
  }
  destroy() {
    this.unblock(), this.ctrl = void 0;
  }
}
const Jl = "backdrop-no-scroll", of = new f0();
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const p0 = ":host{left:0;right:0;top:0;bottom:0;display:block;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);contain:strict;cursor:pointer;opacity:0.01;-ms-touch-action:none;touch-action:none;z-index:2}:host(.backdrop-hide){background:transparent}:host(.backdrop-no-tappable){cursor:auto}:host{background-color:var(--ion-backdrop-color, #000)}", g0 = ":host{left:0;right:0;top:0;bottom:0;display:block;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);contain:strict;cursor:pointer;opacity:0.01;-ms-touch-action:none;touch-action:none;z-index:2}:host(.backdrop-hide){background:transparent}:host(.backdrop-no-tappable){cursor:auto}:host{background-color:var(--ion-backdrop-color, #000)}", b0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionBackdropTap = G(this, "ionBackdropTap", 7), this.blocker = of.createBlocker({
      disableScroll: !0
    }), this.visible = !0, this.tappable = !0, this.stopPropagation = !0;
  }
  connectedCallback() {
    this.stopPropagation && this.blocker.block();
  }
  disconnectedCallback() {
    this.blocker.unblock();
  }
  onMouseDown(e) {
    this.emitTap(e);
  }
  emitTap(e) {
    this.stopPropagation && (e.preventDefault(), e.stopPropagation()), this.tappable && this.ionBackdropTap.emit();
  }
  render() {
    const e = te(this);
    return x(ae, { tabindex: "-1", "aria-hidden": "true", class: {
      [e]: !0,
      "backdrop-hide": !this.visible,
      "backdrop-no-tappable": !this.tappable
    } });
  }
  static get style() {
    return {
      ios: p0,
      md: g0
    };
  }
}, [33, "ion-backdrop", {
  visible: [4],
  tappable: [4],
  stopPropagation: [4, "stop-propagation"]
}, [[2, "click", "onMouseDown"]]]);
function Qi() {
  if (typeof customElements > "u")
    return;
  ["ion-backdrop"].forEach((t) => {
    switch (t) {
      case "ion-backdrop":
        customElements.get(t) || customElements.define(t, b0);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const ln = (e, t) => t.closest(e) !== null, dt = (e, t) => typeof e == "string" && e.length > 0 ? Object.assign({ "ion-color": !0, [`ion-color-${e}`]: !0 }, t) : t, v0 = (e) => e !== void 0 ? (Array.isArray(e) ? e : e.split(" ")).filter((n) => n != null).map((n) => n.trim()).filter((n) => n !== "") : [], Et = (e) => {
  const t = {};
  return v0(e).forEach((n) => t[n] = !0), t;
}, y0 = /^[a-z][a-z0-9+\-.]*:/, ma = async (e, t, n, o) => {
  if (e != null && e[0] !== "#" && !y0.test(e)) {
    const i = document.querySelector("ion-router");
    if (i)
      return t != null && t.preventDefault(), i.push(e, n, o);
  }
  return !1;
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const fs = (e, ...t) => console.warn(`[Ionic Warning]: ${e}`, ...t), w0 = (e, ...t) => console.error(`[Ionic Error]: ${e}`, ...t);
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const k0 = ":host{left:0;right:0;top:0;bottom:0;position:absolute;contain:strict;pointer-events:none}:host(.unbounded){contain:layout size style}.ripple-effect{border-radius:50%;position:absolute;background-color:currentColor;color:inherit;contain:strict;opacity:0;-webkit-animation:225ms rippleAnimation forwards, 75ms fadeInAnimation forwards;animation:225ms rippleAnimation forwards, 75ms fadeInAnimation forwards;will-change:transform, opacity;pointer-events:none}.fade-out{-webkit-transform:translate(var(--translate-end)) scale(var(--final-scale, 1));transform:translate(var(--translate-end)) scale(var(--final-scale, 1));-webkit-animation:150ms fadeOutAnimation forwards;animation:150ms fadeOutAnimation forwards}@-webkit-keyframes rippleAnimation{from{-webkit-animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:translate(var(--translate-end)) scale(var(--final-scale, 1));transform:translate(var(--translate-end)) scale(var(--final-scale, 1))}}@keyframes rippleAnimation{from{-webkit-animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:translate(var(--translate-end)) scale(var(--final-scale, 1));transform:translate(var(--translate-end)) scale(var(--final-scale, 1))}}@-webkit-keyframes fadeInAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0}to{opacity:0.16}}@keyframes fadeInAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0}to{opacity:0.16}}@-webkit-keyframes fadeOutAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0.16}to{opacity:0}}@keyframes fadeOutAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0.16}to{opacity:0}}", x0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.type = "bounded";
  }
  /**
   * Adds the ripple effect to the parent element.
   *
   * @param x The horizontal coordinate of where the ripple should start.
   * @param y The vertical coordinate of where the ripple should start.
   */
  async addRipple(e, t) {
    return new Promise((n) => {
      ju(() => {
        const o = this.el.getBoundingClientRect(), i = o.width, r = o.height, s = Math.sqrt(i * i + r * r), a = Math.max(r, i), l = this.unbounded ? a : s + E0, c = Math.floor(a * T0), d = l / c;
        let u = e - o.left, f = t - o.top;
        this.unbounded && (u = i * 0.5, f = r * 0.5);
        const g = u - c * 0.5, E = f - c * 0.5, k = i * 0.5 - u, S = r * 0.5 - f;
        Li(() => {
          const m = document.createElement("div");
          m.classList.add("ripple-effect");
          const v = m.style;
          v.top = E + "px", v.left = g + "px", v.width = v.height = c + "px", v.setProperty("--final-scale", `${d}`), v.setProperty("--translate-end", `${k}px, ${S}px`), (this.el.shadowRoot || this.el).appendChild(m), setTimeout(() => {
            n(() => {
              _0(m);
            });
          }, 225 + 100);
        });
      });
    });
  }
  get unbounded() {
    return this.type === "unbounded";
  }
  render() {
    const e = te(this);
    return x(ae, { role: "presentation", class: {
      [e]: !0,
      unbounded: this.unbounded
    } });
  }
  get el() {
    return this;
  }
  static get style() {
    return k0;
  }
}, [1, "ion-ripple-effect", {
  type: [1],
  addRipple: [64]
}]), _0 = (e) => {
  e.classList.add("fade-out"), setTimeout(() => {
    e.remove();
  }, 200);
}, E0 = 10, T0 = 0.5;
function Bn() {
  if (typeof customElements > "u")
    return;
  ["ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-ripple-effect":
        customElements.get(t) || customElements.define(t, x0);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const I0 = ':host{--overflow:hidden;--ripple-color:currentColor;--border-width:initial;--border-color:initial;--border-style:initial;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--box-shadow:none;display:inline-block;width:auto;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:center;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:top;vertical-align:-webkit-baseline-middle;-webkit-font-kerning:none;font-kerning:none}:host(.button-disabled){cursor:default;opacity:0.5;pointer-events:none}:host(.button-solid){--background:var(--ion-color-primary, #3880ff);--color:var(--ion-color-primary-contrast, #fff)}:host(.button-outline){--border-color:var(--ion-color-primary, #3880ff);--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-clear){--border-width:0;--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-block){display:block}:host(.button-block) .button-native{margin-left:0;margin-right:0;display:block;width:100%;clear:both;contain:content}:host(.button-block) .button-native::after{clear:both}:host(.button-full){display:block}:host(.button-full) .button-native{margin-left:0;margin-right:0;display:block;width:100%;contain:content}:host(.button-full:not(.button-round)) .button-native{border-radius:0;border-right-width:0;border-left-width:0}.button-native{border-radius:var(--border-radius);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:var(--padding-start);padding-right:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:block;position:relative;width:100%;height:100%;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);line-height:1;-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);contain:layout style;cursor:pointer;opacity:var(--opacity);overflow:var(--overflow);z-index:0;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.button-native{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end)}}.button-native::-moz-focus-inner{border:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}::slotted(ion-icon){font-size:1.4em;pointer-events:none}::slotted(ion-icon[slot=start]){margin-left:-0.3em;margin-right:0.3em;margin-top:0;margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-icon[slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:-0.3em;margin-inline-start:-0.3em;-webkit-margin-end:0.3em;margin-inline-end:0.3em}}::slotted(ion-icon[slot=end]){margin-left:0.3em;margin-right:-0.2em;margin-top:0;margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-icon[slot=end]){margin-left:unset;margin-right:unset;-webkit-margin-start:0.3em;margin-inline-start:0.3em;-webkit-margin-end:-0.2em;margin-inline-end:-0.2em}}::slotted(ion-icon[slot=icon-only]){font-size:1.8em}ion-ripple-effect{color:var(--ripple-color)}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}:host(.ion-focused){color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}@media (any-hover: hover){:host(:hover){color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-activated){color:var(--color-activated)}:host(.ion-activated) .button-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.button-solid.ion-color) .button-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.button-outline.ion-color) .button-native{border-color:var(--ion-color-base);background:transparent;color:var(--ion-color-base)}:host(.button-clear.ion-color) .button-native{background:transparent;color:var(--ion-color-base)}:host(.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{color:var(--ion-toolbar-color, var(--color))}:host(.button-outline.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{border-color:var(--ion-toolbar-color, var(--color, var(--border-color)))}:host(.button-solid.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--background));color:var(--ion-toolbar-background, var(--color))}:host(.button-outline.ion-activated.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--color));color:var(--ion-toolbar-background, var(--background), var(--ion-color-primary-contrast, #fff))}:host{--border-radius:10px;--padding-top:0;--padding-bottom:0;--padding-start:1em;--padding-end:1em;--transition:background-color, opacity 100ms linear;margin-left:2px;margin-right:2px;margin-top:4px;margin-bottom:4px;height:2.8em;font-size:16px;font-weight:500;letter-spacing:-0.03em}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{margin-left:unset;margin-right:unset;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:2px;margin-inline-end:2px}}:host(.in-buttons){font-size:17px;font-weight:400}:host(.button-solid){--background-activated:var(--ion-color-primary-shade, #3171e0);--background-focused:var(--ion-color-primary-shade, #3171e0);--background-hover:var(--ion-color-primary-tint, #4c8dff);--background-activated-opacity:1;--background-focused-opacity:1;--background-hover-opacity:1}:host(.button-outline){--border-radius:10px;--border-width:1px;--border-style:solid;--background-activated:var(--ion-color-primary, #3880ff);--background-focused:var(--ion-color-primary, #3880ff);--background-hover:transparent;--background-focused-opacity:.1;--color-activated:var(--ion-color-primary-contrast, #fff)}:host(.button-clear){--background-activated:transparent;--background-activated-opacity:0;--background-focused:var(--ion-color-primary, #3880ff);--background-hover:transparent;--background-focused-opacity:.1;font-size:17px;font-weight:normal;letter-spacing:0}:host(.button-large){--border-radius:12px;--padding-top:0;--padding-start:1em;--padding-end:1em;--padding-bottom:0;height:2.8em;font-size:20px}:host(.button-small){--border-radius:6px;--padding-top:0;--padding-start:0.9em;--padding-end:0.9em;--padding-bottom:0;height:2.1em;font-size:13px}:host(.button-round){--border-radius:64px;--padding-top:0;--padding-start:26px;--padding-end:26px;--padding-bottom:0}:host(.button-strong){font-weight:600}:host(.button-outline.ion-focused.ion-color) .button-native,:host(.button-clear.ion-focused.ion-color) .button-native{color:var(--ion-color-base)}:host(.button-outline.ion-focused.ion-color) .button-native::after,:host(.button-clear.ion-focused.ion-color) .button-native::after{background:var(--ion-color-base)}:host(.button-solid.ion-color.ion-focused) .button-native::after{background:var(--ion-color-shade)}@media (any-hover: hover){:host(.button-clear:not(.ion-activated):hover),:host(.button-outline:not(.ion-activated):hover){opacity:0.6}:host(.button-clear.ion-color:hover) .button-native,:host(.button-outline.ion-color:hover) .button-native{color:var(--ion-color-base)}:host(.button-clear.ion-color:hover) .button-native::after,:host(.button-outline.ion-color:hover) .button-native::after{background:transparent}:host(.button-solid.ion-color:hover) .button-native::after{background:var(--ion-color-tint)}:host(:hover.button-solid.in-toolbar:not(.ion-color):not(.in-toolbar-color):not(.ion-activated)) .button-native::after{background:#fff;opacity:0.1}}:host(.button-clear.ion-activated){opacity:0.4}:host(.button-outline.ion-activated.ion-color) .button-native{color:var(--ion-color-contrast)}:host(.button-outline.ion-activated.ion-color) .button-native::after{background:var(--ion-color-base)}:host(.button-solid.ion-color.ion-activated) .button-native::after{background:var(--ion-color-shade)}', S0 = `:host{--overflow:hidden;--ripple-color:currentColor;--border-width:initial;--border-color:initial;--border-style:initial;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--box-shadow:none;display:inline-block;width:auto;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:center;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:top;vertical-align:-webkit-baseline-middle;-webkit-font-kerning:none;font-kerning:none}:host(.button-disabled){cursor:default;opacity:0.5;pointer-events:none}:host(.button-solid){--background:var(--ion-color-primary, #3880ff);--color:var(--ion-color-primary-contrast, #fff)}:host(.button-outline){--border-color:var(--ion-color-primary, #3880ff);--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-clear){--border-width:0;--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-block){display:block}:host(.button-block) .button-native{margin-left:0;margin-right:0;display:block;width:100%;clear:both;contain:content}:host(.button-block) .button-native::after{clear:both}:host(.button-full){display:block}:host(.button-full) .button-native{margin-left:0;margin-right:0;display:block;width:100%;contain:content}:host(.button-full:not(.button-round)) .button-native{border-radius:0;border-right-width:0;border-left-width:0}.button-native{border-radius:var(--border-radius);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:var(--padding-start);padding-right:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:block;position:relative;width:100%;height:100%;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);line-height:1;-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);contain:layout style;cursor:pointer;opacity:var(--opacity);overflow:var(--overflow);z-index:0;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.button-native{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end)}}.button-native::-moz-focus-inner{border:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}::slotted(ion-icon){font-size:1.4em;pointer-events:none}::slotted(ion-icon[slot=start]){margin-left:-0.3em;margin-right:0.3em;margin-top:0;margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-icon[slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:-0.3em;margin-inline-start:-0.3em;-webkit-margin-end:0.3em;margin-inline-end:0.3em}}::slotted(ion-icon[slot=end]){margin-left:0.3em;margin-right:-0.2em;margin-top:0;margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-icon[slot=end]){margin-left:unset;margin-right:unset;-webkit-margin-start:0.3em;margin-inline-start:0.3em;-webkit-margin-end:-0.2em;margin-inline-end:-0.2em}}::slotted(ion-icon[slot=icon-only]){font-size:1.8em}ion-ripple-effect{color:var(--ripple-color)}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}:host(.ion-focused){color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}@media (any-hover: hover){:host(:hover){color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-activated){color:var(--color-activated)}:host(.ion-activated) .button-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.button-solid.ion-color) .button-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.button-outline.ion-color) .button-native{border-color:var(--ion-color-base);background:transparent;color:var(--ion-color-base)}:host(.button-clear.ion-color) .button-native{background:transparent;color:var(--ion-color-base)}:host(.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{color:var(--ion-toolbar-color, var(--color))}:host(.button-outline.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{border-color:var(--ion-toolbar-color, var(--color, var(--border-color)))}:host(.button-solid.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--background));color:var(--ion-toolbar-background, var(--color))}:host(.button-outline.ion-activated.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--color));color:var(--ion-toolbar-background, var(--background), var(--ion-color-primary-contrast, #fff))}:host{--border-radius:4px;--padding-top:0;--padding-bottom:0;--padding-start:1.1em;--padding-end:1.1em;--transition:box-shadow 280ms cubic-bezier(.4, 0, .2, 1),
                background-color 15ms linear,
                color 15ms linear;margin-left:2px;margin-right:2px;margin-top:4px;margin-bottom:4px;height:36px;font-size:14px;font-weight:500;letter-spacing:0.06em;text-transform:uppercase}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{margin-left:unset;margin-right:unset;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:2px;margin-inline-end:2px}}:host(.button-solid){--background-activated:transparent;--background-hover:var(--ion-color-primary-contrast, #fff);--background-focused:var(--ion-color-primary-contrast, #fff);--background-activated-opacity:0;--background-focused-opacity:.24;--background-hover-opacity:.08;--box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}:host(.button-solid.ion-activated){--box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)}:host(.button-outline){--border-width:2px;--border-style:solid;--box-shadow:none;--background-activated:transparent;--background-focused:var(--ion-color-primary, #3880ff);--background-hover:var(--ion-color-primary, #3880ff);--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04}:host(.button-outline.ion-activated.ion-color) .button-native{background:transparent}:host(.button-clear){--background-activated:transparent;--background-focused:var(--ion-color-primary, #3880ff);--background-hover:var(--ion-color-primary, #3880ff);--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04}:host(.button-round){--border-radius:64px;--padding-top:0;--padding-start:26px;--padding-end:26px;--padding-bottom:0}:host(.button-large){--padding-top:0;--padding-start:1em;--padding-end:1em;--padding-bottom:0;height:2.8em;font-size:20px}:host(.button-small){--padding-top:0;--padding-start:0.9em;--padding-end:0.9em;--padding-bottom:0;height:2.1em;font-size:13px}:host(.button-strong){font-weight:bold}::slotted(ion-icon[slot=icon-only]){padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}:host(.button-solid.ion-color.ion-focused) .button-native::after{background:var(--ion-color-contrast)}:host(.button-clear.ion-color.ion-focused) .button-native::after,:host(.button-outline.ion-color.ion-focused) .button-native::after{background:var(--ion-color-base)}@media (any-hover: hover){:host(.button-solid.ion-color:hover) .button-native::after{background:var(--ion-color-contrast)}:host(.button-clear.ion-color:hover) .button-native::after,:host(.button-outline.ion-color:hover) .button-native::after{background:var(--ion-color-base)}}`, O0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionFocus = G(this, "ionFocus", 7), this.ionBlur = G(this, "ionBlur", 7), this.inItem = !1, this.inListHeader = !1, this.inToolbar = !1, this.inheritedAttributes = {}, this.buttonType = "button", this.disabled = !1, this.routerDirection = "forward", this.strong = !1, this.type = "button", this.handleClick = (e) => {
      const { el: t } = this;
      if (this.type === "button")
        ma(this.href, e, this.routerDirection, this.routerAnimation);
      else if (Zu(t)) {
        let n = this.findForm();
        const { form: o } = this;
        if (!n && o !== void 0) {
          fs(typeof o == "string" ? `Form with selector: "#${o}" could not be found. Verify that the id is correct and the form is rendered in the DOM.` : 'The provided "form" element is invalid. Verify that the form is a HTMLFormElement and rendered in the DOM.', t);
          return;
        }
        if (n || (n = t.closest("form")), n) {
          e.preventDefault();
          const i = document.createElement("button");
          i.type = this.type, i.style.display = "none", n.appendChild(i), i.click(), i.remove();
        }
      }
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    };
  }
  componentWillLoad() {
    this.inToolbar = !!this.el.closest("ion-buttons"), this.inListHeader = !!this.el.closest("ion-list-header"), this.inItem = !!this.el.closest("ion-item") || !!this.el.closest("ion-item-divider"), this.inheritedAttributes = Jb(this.el);
  }
  get hasIconOnly() {
    return !!this.el.querySelector('[slot="icon-only"]');
  }
  get rippleType() {
    return (this.fill === void 0 || this.fill === "clear") && this.hasIconOnly && this.inToolbar ? "unbounded" : "bounded";
  }
  /**
   * Finds the form element based on the provided `form` selector
   * or element reference provided.
   */
  findForm() {
    const { form: e } = this;
    if (e instanceof HTMLFormElement)
      return e;
    if (typeof e == "string") {
      const t = document.getElementById(e);
      if (t instanceof HTMLFormElement)
        return t;
    }
    return null;
  }
  render() {
    const e = te(this), { buttonType: t, type: n, disabled: o, rel: i, target: r, size: s, href: a, color: l, expand: c, hasIconOnly: d, shape: u, strong: f, inheritedAttributes: g } = this, E = s === void 0 && this.inItem ? "small" : s, k = a === void 0 ? "button" : "a", S = k === "button" ? { type: n } : {
      download: this.download,
      href: a,
      rel: i,
      target: r
    };
    let m = this.fill;
    return m == null && (m = this.inToolbar || this.inListHeader ? "clear" : "solid"), x(ae, { onClick: this.handleClick, "aria-disabled": o ? "true" : null, class: dt(l, {
      [e]: !0,
      [t]: !0,
      [`${t}-${c}`]: c !== void 0,
      [`${t}-${E}`]: E !== void 0,
      [`${t}-${u}`]: u !== void 0,
      [`${t}-${m}`]: !0,
      [`${t}-strong`]: f,
      "in-toolbar": ln("ion-toolbar", this.el),
      "in-toolbar-color": ln("ion-toolbar[color]", this.el),
      "in-buttons": ln("ion-buttons", this.el),
      "button-has-icon-only": d,
      "button-disabled": o,
      "ion-activatable": !0,
      "ion-focusable": !0
    }) }, x(k, Object.assign({}, S, { class: "button-native", part: "native", disabled: o, onFocus: this.onFocus, onBlur: this.onBlur }, g), x("span", { class: "button-inner" }, x("slot", { name: "icon-only" }), x("slot", { name: "start" }), x("slot", null), x("slot", { name: "end" })), e === "md" && x("ion-ripple-effect", { type: this.rippleType })));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: I0,
      md: S0
    };
  }
}, [33, "ion-button", {
  color: [513],
  buttonType: [1025, "button-type"],
  disabled: [516],
  expand: [513],
  fill: [1537],
  routerDirection: [1, "router-direction"],
  routerAnimation: [16],
  download: [1],
  href: [1],
  rel: [1],
  shape: [513],
  size: [513],
  strong: [4],
  target: [1],
  type: [1],
  form: [1]
}]);
function C0() {
  if (typeof customElements > "u")
    return;
  ["ion-button", "ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-button":
        customElements.get(t) || customElements.define(t, O0);
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const A0 = C0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const D0 = ":host{--ion-safe-area-left:0px;--ion-safe-area-right:0px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;background:var(--background);color:var(--color);font-family:var(--ion-font-family, inherit);contain:content;overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.card-disabled){cursor:default;opacity:0.3;pointer-events:none}.card-native{font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:inherit}.card-native::-moz-focus-inner{border:0}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}ion-ripple-effect{color:var(--ripple-color)}:host{--background:var(--ion-card-background, var(--ion-item-background, var(--ion-background-color, #fff)));--color:var(--ion-card-color, var(--ion-item-color, var(--ion-color-step-600, #666666)));margin-left:16px;margin-right:16px;margin-top:24px;margin-bottom:24px;border-radius:8px;-webkit-transition:-webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);transition:-webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);transition:transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);transition:transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1), -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);font-size:14px;-webkit-box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);box-shadow:0 4px 16px rgba(0, 0, 0, 0.12)}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{margin-left:unset;margin-right:unset;-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:16px;margin-inline-end:16px}}:host(.ion-activated){-webkit-transform:scale3d(0.97, 0.97, 1);transform:scale3d(0.97, 0.97, 1)}", $0 = ":host{--ion-safe-area-left:0px;--ion-safe-area-right:0px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;background:var(--background);color:var(--color);font-family:var(--ion-font-family, inherit);contain:content;overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.card-disabled){cursor:default;opacity:0.3;pointer-events:none}.card-native{font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:inherit}.card-native::-moz-focus-inner{border:0}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}ion-ripple-effect{color:var(--ripple-color)}:host{--background:var(--ion-card-background, var(--ion-item-background, var(--ion-background-color, #fff)));--color:var(--ion-card-color, var(--ion-item-color, var(--ion-color-step-550, #737373)));margin-left:10px;margin-right:10px;margin-top:10px;margin-bottom:10px;border-radius:4px;font-size:14px;-webkit-box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{margin-left:unset;margin-right:unset;-webkit-margin-start:10px;margin-inline-start:10px;-webkit-margin-end:10px;margin-inline-end:10px}}", N0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inheritedAriaAttributes = {}, this.button = !1, this.type = "button", this.disabled = !1, this.routerDirection = "forward";
  }
  componentWillLoad() {
    this.inheritedAriaAttributes = da(this.el, ["aria-label"]);
  }
  isClickable() {
    return this.href !== void 0 || this.button;
  }
  renderCard(e) {
    const t = this.isClickable();
    if (!t)
      return [x("slot", null)];
    const { href: n, routerAnimation: o, routerDirection: i, inheritedAriaAttributes: r } = this, s = t ? n === void 0 ? "button" : "a" : "div", a = s === "button" ? { type: this.type } : {
      download: this.download,
      href: this.href,
      rel: this.rel,
      target: this.target
    };
    return x(s, Object.assign({}, a, r, { class: "card-native", part: "native", disabled: this.disabled, onClick: (l) => ma(n, l, i, o) }), x("slot", null), t && e === "md" && x("ion-ripple-effect", null));
  }
  render() {
    const e = te(this);
    return x(ae, { class: dt(this.color, {
      [e]: !0,
      "card-disabled": this.disabled,
      "ion-activatable": this.isClickable()
    }) }, this.renderCard(e));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: D0,
      md: $0
    };
  }
}, [33, "ion-card", {
  color: [513],
  button: [4],
  type: [1],
  disabled: [4],
  download: [1],
  href: [1],
  rel: [1],
  routerDirection: [1, "router-direction"],
  routerAnimation: [16],
  target: [1]
}]);
function L0() {
  if (typeof customElements > "u")
    return;
  ["ion-card", "ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-card":
        customElements.get(t) || customElements.define(t, N0);
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
    }
  });
}
const P0 = L0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const M0 = "ion-card-content{display:block;position:relative}.card-content-ios{padding-left:20px;padding-right:20px;padding-top:20px;padding-bottom:20px;font-size:16px;line-height:1.4}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.card-content-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:20px;padding-inline-start:20px;-webkit-padding-end:20px;padding-inline-end:20px}}.card-content-ios h1{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:24px;font-weight:normal}.card-content-ios h2{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:16px;font-weight:normal}.card-content-ios h3,.card-content-ios h4,.card-content-ios h5,.card-content-ios h6{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:14px;font-weight:normal}.card-content-ios p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:14px}ion-card-header+.card-content-ios{padding-top:0}", F0 = "ion-card-content{display:block;position:relative}.card-content-md{padding-left:16px;padding-right:16px;padding-top:13px;padding-bottom:13px;font-size:14px;line-height:1.5}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.card-content-md{padding-left:unset;padding-right:unset;-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px}}.card-content-md h1{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:24px;font-weight:normal}.card-content-md h2{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:16px;font-weight:normal}.card-content-md h3,.card-content-md h4,.card-content-md h5,.card-content-md h6{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:14px;font-weight:normal}.card-content-md p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:14px;font-weight:normal;line-height:1.5}ion-card-header+.card-content-md{padding-top:0}", R0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost();
  }
  render() {
    const e = te(this);
    return x(ae, { class: {
      [e]: !0,
      // Used internally for styling
      [`card-content-${e}`]: !0
    } });
  }
  static get style() {
    return {
      ios: M0,
      md: F0
    };
  }
}, [32, "ion-card-content"]);
function V0() {
  if (typeof customElements > "u")
    return;
  ["ion-card-content"].forEach((t) => {
    switch (t) {
      case "ion-card-content":
        customElements.get(t) || customElements.define(t, R0);
        break;
    }
  });
}
const z0 = V0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const U0 = ":host{--background:transparent;--color:inherit;display:block;position:relative;background:var(--background);color:var(--color)}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host{padding-left:20px;padding-right:20px;padding-top:20px;padding-bottom:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;padding-right:unset;-webkit-padding-start:20px;padding-inline-start:20px;-webkit-padding-end:20px;padding-inline-end:20px}}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.card-header-translucent){background-color:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.9);-webkit-backdrop-filter:saturate(180%) blur(30px);backdrop-filter:saturate(180%) blur(30px)}}", H0 = ":host{--background:transparent;--color:inherit;display:block;position:relative;background:var(--background);color:var(--color)}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host{padding-left:16px;padding-right:16px;padding-top:16px;padding-bottom:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;padding-right:unset;-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px}}::slotted(ion-card-title:not(:first-child)),::slotted(ion-card-subtitle:not(:first-child)){margin-top:8px}", B0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.translucent = !1;
  }
  render() {
    const e = te(this);
    return x(ae, { class: dt(this.color, {
      "card-header-translucent": this.translucent,
      "ion-inherit-color": !0,
      [e]: !0
    }) }, x("slot", null));
  }
  static get style() {
    return {
      ios: U0,
      md: H0
    };
  }
}, [33, "ion-card-header", {
  color: [513],
  translucent: [4]
}]);
function W0() {
  if (typeof customElements > "u")
    return;
  ["ion-card-header"].forEach((t) => {
    switch (t) {
      case "ion-card-header":
        customElements.get(t) || customElements.define(t, B0);
        break;
    }
  });
}
const j0 = W0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Y0 = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-600, #666666);margin-left:0;margin-right:0;margin-top:0;margin-bottom:4px;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:12px;font-weight:700;letter-spacing:0.4px;text-transform:uppercase}", G0 = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-550, #737373);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:14px;font-weight:500}", q0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  render() {
    const e = te(this);
    return x(ae, { role: "heading", "aria-level": "3", class: dt(this.color, {
      "ion-inherit-color": !0,
      [e]: !0
    }) }, x("slot", null));
  }
  static get style() {
    return {
      ios: Y0,
      md: G0
    };
  }
}, [33, "ion-card-subtitle", {
  color: [513]
}]);
function K0() {
  if (typeof customElements > "u")
    return;
  ["ion-card-subtitle"].forEach((t) => {
    switch (t) {
      case "ion-card-subtitle":
        customElements.get(t) || customElements.define(t, q0);
        break;
    }
  });
}
const X0 = K0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Z0 = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-text-color, #000);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:28px;font-weight:700;line-height:1.2}", J0 = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-850, #262626);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:20px;font-weight:500;line-height:1.2}", Q0 = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  render() {
    const e = te(this);
    return x(ae, { role: "heading", "aria-level": "2", class: dt(this.color, {
      "ion-inherit-color": !0,
      [e]: !0
    }) }, x("slot", null));
  }
  static get style() {
    return {
      ios: Z0,
      md: J0
    };
  }
}, [33, "ion-card-title", {
  color: [513]
}]);
function ev() {
  if (typeof customElements > "u")
    return;
  ["ion-card-title"].forEach((t) => {
    switch (t) {
      case "ion-card-title":
        customElements.get(t) || customElements.define(t, Q0);
        break;
    }
  });
}
const tv = ev;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const nv = ":host{--background-checked:var(--ion-color-primary, #3880ff);--border-color-checked:var(--ion-color-primary, #3880ff);--checkmark-color:var(--ion-color-primary-contrast, #fff);--checkmark-width:1;--transition:none;display:inline-block;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(.ion-color){--background-checked:var(--ion-color-base);--border-color-checked:var(--ion-color-base);--checkmark-color:var(--ion-color-contrast)}label{left:0;top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}[dir=rtl] label,:host-context([dir=rtl]) label{left:unset;right:unset;right:0}label::-moz-focus-inner{border:0}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.checkbox-icon{border-radius:var(--border-radius);display:block;position:relative;width:100%;height:100%;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);-webkit-box-sizing:border-box;box-sizing:border-box}.checkbox-icon path{fill:none;stroke:var(--checkmark-color);stroke-width:var(--checkmark-width);opacity:0}:host(.checkbox-checked) .checkbox-icon,:host(.checkbox-indeterminate) .checkbox-icon{border-color:var(--border-color-checked);background:var(--background-checked)}:host(.checkbox-checked) .checkbox-icon path,:host(.checkbox-indeterminate) .checkbox-icon path{opacity:1}:host(.checkbox-disabled){pointer-events:none}:host{--border-radius:50%;--border-width:1px;--border-style:solid;--border-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.23);--background:var(--ion-item-background, var(--ion-background-color, #fff));--size:26px;width:var(--size);height:var(--size)}:host(.checkbox-disabled){opacity:0.3}:host(.in-item){margin-left:0;margin-right:8px;margin-top:10px;margin-bottom:9px;display:block;position:static}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.in-item){margin-left:unset;margin-right:unset;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px}}:host(.in-item[slot=start]){margin-left:2px;margin-right:20px;margin-top:8px;margin-bottom:8px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.in-item[slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:20px;margin-inline-end:20px}}", ov = ":host{--background-checked:var(--ion-color-primary, #3880ff);--border-color-checked:var(--ion-color-primary, #3880ff);--checkmark-color:var(--ion-color-primary-contrast, #fff);--checkmark-width:1;--transition:none;display:inline-block;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(.ion-color){--background-checked:var(--ion-color-base);--border-color-checked:var(--ion-color-base);--checkmark-color:var(--ion-color-contrast)}label{left:0;top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}[dir=rtl] label,:host-context([dir=rtl]) label{left:unset;right:unset;right:0}label::-moz-focus-inner{border:0}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.checkbox-icon{border-radius:var(--border-radius);display:block;position:relative;width:100%;height:100%;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);-webkit-box-sizing:border-box;box-sizing:border-box}.checkbox-icon path{fill:none;stroke:var(--checkmark-color);stroke-width:var(--checkmark-width);opacity:0}:host(.checkbox-checked) .checkbox-icon,:host(.checkbox-indeterminate) .checkbox-icon{border-color:var(--border-color-checked);background:var(--background-checked)}:host(.checkbox-checked) .checkbox-icon path,:host(.checkbox-indeterminate) .checkbox-icon path{opacity:1}:host(.checkbox-disabled){pointer-events:none}:host{--border-radius:calc(var(--size) * .125);--border-width:2px;--border-style:solid;--border-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.51);--checkmark-width:3;--background:var(--ion-item-background, var(--ion-background-color, #fff));--transition:background 180ms cubic-bezier(0.4, 0, 0.2, 1);--size:18px;width:var(--size);height:var(--size)}.checkbox-icon path{stroke-dasharray:30;stroke-dashoffset:30}:host(.checkbox-checked) .checkbox-icon path,:host(.checkbox-indeterminate) .checkbox-icon path{stroke-dashoffset:0;-webkit-transition:stroke-dashoffset 90ms linear 90ms;transition:stroke-dashoffset 90ms linear 90ms}:host(.checkbox-disabled){opacity:0.3}:host(.in-item){margin-left:0;margin-right:0;margin-top:18px;margin-bottom:18px;display:block;position:static}:host(.in-item[slot=start]){margin-left:4px;margin-right:36px;margin-top:18px;margin-bottom:18px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.in-item[slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:36px;margin-inline-end:36px}}", iv = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionChange = G(this, "ionChange", 7), this.ionFocus = G(this, "ionFocus", 7), this.ionBlur = G(this, "ionBlur", 7), this.ionStyle = G(this, "ionStyle", 7), this.inputId = `ion-cb-${rv++}`, this.name = this.inputId, this.checked = !1, this.indeterminate = !1, this.disabled = !1, this.value = "on", this.onClick = (e) => {
      e.preventDefault(), this.setFocus(), this.checked = !this.checked, this.indeterminate = !1;
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    };
  }
  componentWillLoad() {
    this.emitStyle();
  }
  checkedChanged(e) {
    this.ionChange.emit({
      checked: e,
      value: this.value
    }), this.emitStyle();
  }
  disabledChanged() {
    this.emitStyle();
  }
  emitStyle() {
    this.ionStyle.emit({
      "checkbox-checked": this.checked,
      "interactive-disabled": this.disabled
    });
  }
  setFocus() {
    this.focusEl && this.focusEl.focus();
  }
  render() {
    const { color: e, checked: t, disabled: n, el: o, indeterminate: i, inputId: r, name: s, value: a } = this, l = te(this), { label: c, labelId: d, labelText: u } = fa(o, r);
    ha(!0, o, s, t ? a : "", n);
    let f = i ? x("path", { d: "M6 12L18 12", part: "mark" }) : x("path", { d: "M5.9,12.5l3.8,3.8l8.8-8.8", part: "mark" });
    return l === "md" && (f = i ? x("path", { d: "M2 12H22", part: "mark" }) : x("path", { d: "M1.73,12.91 8.1,19.28 22.79,4.59", part: "mark" })), x(ae, { onClick: this.onClick, "aria-labelledby": c ? d : null, "aria-checked": `${t}`, "aria-hidden": n ? "true" : null, role: "checkbox", class: dt(e, {
      [l]: !0,
      "in-item": ln("ion-item", o),
      "checkbox-checked": t,
      "checkbox-disabled": n,
      "checkbox-indeterminate": i,
      interactive: !0
    }) }, x("svg", { class: "checkbox-icon", viewBox: "0 0 24 24", part: "container" }, f), x("label", { htmlFor: r }, u), x("input", { type: "checkbox", "aria-checked": `${t}`, disabled: n, id: r, onFocus: () => this.onFocus(), onBlur: () => this.onBlur(), ref: (g) => this.focusEl = g }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      checked: ["checkedChanged"],
      disabled: ["disabledChanged"]
    };
  }
  static get style() {
    return {
      ios: nv,
      md: ov
    };
  }
}, [33, "ion-checkbox", {
  color: [513],
  name: [1],
  checked: [1028],
  indeterminate: [1028],
  disabled: [4],
  value: [8]
}]);
let rv = 0;
function rf() {
  if (typeof customElements > "u")
    return;
  ["ion-checkbox"].forEach((t) => {
    switch (t) {
      case "ion-checkbox":
        customElements.get(t) || customElements.define(t, iv);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const li = typeof window < "u" ? window : void 0;
li && (li.CSS && li.CSS.supports && li.CSS.supports("--a: 0"));
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const sv = ":host{color:var(--color);font-family:var(--ion-font-family, inherit);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-350, #a6a6a6)}", av = ":host{color:var(--color);font-family:var(--ion-font-family, inherit);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-600, #666666);font-size:14px}", lv = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  render() {
    const e = te(this);
    return x(ae, { class: dt(this.color, {
      [e]: !0
    }) }, x("slot", null));
  }
  static get style() {
    return {
      ios: sv,
      md: av
    };
  }
}, [33, "ion-note", {
  color: [513]
}]);
function pa() {
  if (typeof customElements > "u")
    return;
  ["ion-note"].forEach((t) => {
    switch (t) {
      case "ion-note":
        customElements.get(t) || customElements.define(t, lv);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const cv = ':host{--border-radius:0px;--border-width:0px;--border-style:solid;--padding-top:0px;--padding-bottom:0px;--padding-end:0px;--padding-start:0px;--inner-border-width:0px;--inner-padding-top:0px;--inner-padding-bottom:0px;--inner-padding-start:0px;--inner-padding-end:0px;--inner-box-shadow:none;--show-full-highlight:0;--show-inset-highlight:0;--detail-icon-color:initial;--detail-icon-font-size:20px;--detail-icon-opacity:0.25;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--ripple-color:currentColor;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;outline:none;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:initial;text-decoration:none;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native,:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-inner{border-color:var(--ion-color-shade)}:host(.ion-activated) .item-native{color:var(--color-activated)}:host(.ion-activated) .item-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.ion-color.ion-activated) .item-native{color:var(--ion-color-contrast)}:host(.ion-focused) .item-native{color:var(--color-focused)}:host(.ion-focused) .item-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(.ion-color.ion-focused) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-focused) .item-native::after{background:var(--ion-color-contrast)}@media (any-hover: hover){:host(.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--color-hover)}:host(.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--ion-color-contrast)}}:host(.item-interactive-disabled:not(.item-multiple-inputs)){cursor:default;pointer-events:none}:host(.item-disabled){cursor:default;opacity:0.3;pointer-events:none}.item-native{border-radius:var(--border-radius);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-right:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-native{padding-left:unset;padding-right:unset;-webkit-padding-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-inline-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end)}}.item-native::-moz-focus-inner{border:0}.item-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0;-webkit-transition:var(--transition);transition:var(--transition);z-index:-1}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.item-inner{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:var(--inner-padding-start);padding-right:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end));padding-top:var(--inner-padding-top);padding-bottom:var(--inner-padding-bottom);display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);-webkit-box-shadow:var(--inner-box-shadow);box-shadow:var(--inner-box-shadow);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-inner{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--inner-padding-start);padding-inline-start:var(--inner-padding-start);-webkit-padding-end:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end));padding-inline-end:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end))}}.item-bottom{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-right:var(--inner-padding-end);padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-bottom{padding-left:unset;padding-right:unset;-webkit-padding-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-inline-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));-webkit-padding-end:var(--inner-padding-end);padding-inline-end:var(--inner-padding-end)}}.item-detail-icon{color:var(--detail-icon-color);font-size:var(--detail-icon-font-size);opacity:var(--detail-icon-opacity)}::slotted(ion-icon){font-size:1.6em}::slotted(ion-button){--margin-top:0;--margin-bottom:0;--margin-start:0;--margin-end:0;z-index:1}::slotted(ion-label:not([slot=end])){-ms-flex:1;flex:1}:host(.item-input){-ms-flex-align:center;align-items:center}.input-wrapper{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;text-overflow:ellipsis;overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.item-label-stacked),:host(.item-label-floating){-ms-flex-align:start;align-items:start}:host(.item-label-stacked) .input-wrapper,:host(.item-label-floating) .input-wrapper{-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column}.item-highlight,.item-inner-highlight{left:0;right:0;top:0;bottom:0;border-radius:inherit;position:absolute;width:100%;height:100%;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:transform 200ms, border-bottom-width 200ms;transition:transform 200ms, border-bottom-width 200ms, -webkit-transform 200ms;z-index:2;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus),:host(.item-interactive.ion-touched.ion-invalid){--full-highlight-height:calc(var(--highlight-height) * var(--show-full-highlight));--inset-highlight-height:calc(var(--highlight-height) * var(--show-inset-highlight))}:host(.ion-focused) .item-highlight,:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-highlight,:host(.item-has-focus) .item-inner-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-style:var(--border-style);border-color:var(--highlight-background)}:host(.ion-focused) .item-highlight,:host(.item-has-focus) .item-highlight{border-width:var(--full-highlight-height);opacity:var(--show-full-highlight)}:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-inner-highlight{border-bottom-width:var(--inset-highlight-height);opacity:var(--show-inset-highlight)}:host(.ion-focused.item-fill-solid) .item-highlight,:host(.item-has-focus.item-fill-solid) .item-highlight{border-width:calc(var(--full-highlight-height) - 1px)}:host(.ion-focused) .item-inner-highlight,:host(.ion-focused:not(.item-fill-outline)) .item-highlight,:host(.item-has-focus) .item-inner-highlight,:host(.item-has-focus:not(.item-fill-outline)) .item-highlight{border-top:none;border-right:none;border-left:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus){--highlight-background:var(--highlight-color-focused)}:host(.item-interactive.ion-valid){--highlight-background:var(--highlight-color-valid)}:host(.item-interactive.ion-invalid){--highlight-background:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=helper]){display:none}::slotted([slot=error]){display:none;color:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=error]){display:block}:host(:not(.item-label)) ::slotted(ion-select){--padding-start:0;max-width:none}:host(.item-label-stacked) ::slotted(ion-select),:host(.item-label-floating) ::slotted(ion-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0;-ms-flex-item-align:stretch;align-self:stretch;width:100%;max-width:100%}:host(:not(.item-label)) ::slotted(ion-datetime){--padding-start:0}:host(.item-label-stacked) ::slotted(ion-datetime),:host(.item-label-floating) ::slotted(ion-datetime){--padding-start:0;width:100%}:host(.item-multiple-inputs) ::slotted(ion-checkbox),:host(.item-multiple-inputs) ::slotted(ion-datetime),:host(.item-multiple-inputs) ::slotted(ion-radio),:host(.item-multiple-inputs) ::slotted(ion-select){position:relative}:host(.item-textarea){-ms-flex-align:stretch;align-items:stretch}::slotted(ion-reorder[slot]){margin-top:0;margin-bottom:0}ion-ripple-effect{color:var(--ripple-color)}:host(.item-fill-solid) ::slotted([slot=start]),:host(.item-fill-solid) ::slotted([slot=end]),:host(.item-fill-outline) ::slotted([slot=start]),:host(.item-fill-outline) ::slotted([slot=end]){-ms-flex-item-align:center;align-self:center}::slotted([slot=helper]),::slotted([slot=error]),.item-counter{padding-top:5px;font-size:12px;z-index:1}.item-counter{margin-left:auto;color:var(--ion-color-step-550, #737373);white-space:nowrap;-webkit-padding-start:16px;padding-inline-start:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-counter{margin-left:unset;-webkit-margin-start:auto;margin-inline-start:auto}}@media (prefers-reduced-motion: reduce){.item-highlight,.item-inner-highlight{-webkit-transition:none;transition:none}}:host{--min-height:44px;--transition:background-color 200ms linear, opacity 200ms linear;--padding-start:20px;--inner-padding-end:10px;--inner-border-width:0px 0px 0.55px 0px;--background:var(--ion-item-background, var(--ion-background-color, #fff));--background-activated:#000;--background-focused:#000;--background-hover:currentColor;--background-activated-opacity:.12;--background-focused-opacity:.15;--background-hover-opacity:.04;--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-250, #c8c7cc)));--color:var(--ion-item-color, var(--ion-text-color, #000));--highlight-height:0px;--highlight-color-focused:var(--ion-color-primary, #3880ff);--highlight-color-valid:var(--ion-color-success, #2dd36f);--highlight-color-invalid:var(--ion-color-danger, #eb445a);--bottom-padding-start:0px;font-size:17px}:host(.ion-activated){--transition:none}:host(.ion-color.ion-focused) .item-native::after{background:#000;opacity:0.15}:host(.ion-color.ion-activated) .item-native::after{background:#000;opacity:0.12}:host(.item-interactive){--show-full-highlight:0;--show-inset-highlight:1}:host(.item-lines-full){--border-width:0px 0px 0.55px 0px;--show-full-highlight:1;--show-inset-highlight:0}:host(.item-lines-inset){--inner-border-width:0px 0px 0.55px 0px;--show-full-highlight:0;--show-inset-highlight:1}:host(.item-lines-inset),:host(.item-lines-none){--border-width:0px;--show-full-highlight:0}:host(.item-lines-full),:host(.item-lines-none){--inner-border-width:0px;--show-inset-highlight:0}.item-highlight,.item-inner-highlight{-webkit-transition:none;transition:none}:host(.item-has-focus) .item-inner-highlight,:host(.item-has-focus) .item-highlight{border-top:none;border-right:none;border-left:none}::slotted([slot=start]){margin-left:0;margin-right:20px;margin-top:2px;margin-bottom:2px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted([slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:20px;margin-inline-end:20px}}::slotted([slot=end]){margin-left:10px;margin-right:10px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted([slot=end]){margin-left:unset;margin-right:unset;-webkit-margin-start:10px;margin-inline-start:10px;-webkit-margin-end:10px;margin-inline-end:10px}}::slotted(ion-icon[slot=start]),::slotted(ion-icon[slot=end]){margin-top:7px;margin-bottom:7px}::slotted(ion-toggle[slot=start]),::slotted(ion-toggle[slot=end]){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}:host(.item-label-stacked) ::slotted([slot=end]),:host(.item-label-floating) ::slotted([slot=end]){margin-top:7px;margin-bottom:7px}::slotted(.button-small){--padding-top:0px;--padding-bottom:0px;--padding-start:.5em;--padding-end:.5em;height:24px;font-size:13px}::slotted(ion-avatar){width:36px;height:36px}::slotted(ion-thumbnail){--size:56px}::slotted(ion-avatar[slot=end]),::slotted(ion-thumbnail[slot=end]){margin-left:10px;margin-right:10px;margin-top:10px;margin-bottom:10px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-avatar[slot=end]),::slotted(ion-thumbnail[slot=end]){margin-left:unset;margin-right:unset;-webkit-margin-start:10px;margin-inline-start:10px;-webkit-margin-end:10px;margin-inline-end:10px}}:host(.item-radio) ::slotted(ion-label),:host(.item-toggle) ::slotted(ion-label){margin-left:0px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.item-radio) ::slotted(ion-label),:host(.item-toggle) ::slotted(ion-label){margin-left:unset;-webkit-margin-start:0px;margin-inline-start:0px}}::slotted(ion-label){margin-left:0;margin-right:8px;margin-top:10px;margin-bottom:10px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-label){margin-left:unset;margin-right:unset;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px}}:host(.item-label-floating),:host(.item-label-stacked){--min-height:68px}:host(.item-label-stacked) ::slotted(ion-select),:host(.item-label-floating) ::slotted(ion-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0px}:host(.item-label-fixed) ::slotted(ion-select),:host(.item-label-fixed) ::slotted(ion-datetime){--padding-start:0}', dv = ':host{--border-radius:0px;--border-width:0px;--border-style:solid;--padding-top:0px;--padding-bottom:0px;--padding-end:0px;--padding-start:0px;--inner-border-width:0px;--inner-padding-top:0px;--inner-padding-bottom:0px;--inner-padding-start:0px;--inner-padding-end:0px;--inner-box-shadow:none;--show-full-highlight:0;--show-inset-highlight:0;--detail-icon-color:initial;--detail-icon-font-size:20px;--detail-icon-opacity:0.25;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--ripple-color:currentColor;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;outline:none;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:initial;text-decoration:none;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native,:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-inner{border-color:var(--ion-color-shade)}:host(.ion-activated) .item-native{color:var(--color-activated)}:host(.ion-activated) .item-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.ion-color.ion-activated) .item-native{color:var(--ion-color-contrast)}:host(.ion-focused) .item-native{color:var(--color-focused)}:host(.ion-focused) .item-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(.ion-color.ion-focused) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-focused) .item-native::after{background:var(--ion-color-contrast)}@media (any-hover: hover){:host(.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--color-hover)}:host(.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--ion-color-contrast)}}:host(.item-interactive-disabled:not(.item-multiple-inputs)){cursor:default;pointer-events:none}:host(.item-disabled){cursor:default;opacity:0.3;pointer-events:none}.item-native{border-radius:var(--border-radius);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-right:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-native{padding-left:unset;padding-right:unset;-webkit-padding-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-inline-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end)}}.item-native::-moz-focus-inner{border:0}.item-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0;-webkit-transition:var(--transition);transition:var(--transition);z-index:-1}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.item-inner{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:var(--inner-padding-start);padding-right:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end));padding-top:var(--inner-padding-top);padding-bottom:var(--inner-padding-bottom);display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);-webkit-box-shadow:var(--inner-box-shadow);box-shadow:var(--inner-box-shadow);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-inner{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--inner-padding-start);padding-inline-start:var(--inner-padding-start);-webkit-padding-end:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end));padding-inline-end:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end))}}.item-bottom{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-right:var(--inner-padding-end);padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-bottom{padding-left:unset;padding-right:unset;-webkit-padding-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-inline-start:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));-webkit-padding-end:var(--inner-padding-end);padding-inline-end:var(--inner-padding-end)}}.item-detail-icon{color:var(--detail-icon-color);font-size:var(--detail-icon-font-size);opacity:var(--detail-icon-opacity)}::slotted(ion-icon){font-size:1.6em}::slotted(ion-button){--margin-top:0;--margin-bottom:0;--margin-start:0;--margin-end:0;z-index:1}::slotted(ion-label:not([slot=end])){-ms-flex:1;flex:1}:host(.item-input){-ms-flex-align:center;align-items:center}.input-wrapper{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;text-overflow:ellipsis;overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.item-label-stacked),:host(.item-label-floating){-ms-flex-align:start;align-items:start}:host(.item-label-stacked) .input-wrapper,:host(.item-label-floating) .input-wrapper{-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column}.item-highlight,.item-inner-highlight{left:0;right:0;top:0;bottom:0;border-radius:inherit;position:absolute;width:100%;height:100%;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:transform 200ms, border-bottom-width 200ms;transition:transform 200ms, border-bottom-width 200ms, -webkit-transform 200ms;z-index:2;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus),:host(.item-interactive.ion-touched.ion-invalid){--full-highlight-height:calc(var(--highlight-height) * var(--show-full-highlight));--inset-highlight-height:calc(var(--highlight-height) * var(--show-inset-highlight))}:host(.ion-focused) .item-highlight,:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-highlight,:host(.item-has-focus) .item-inner-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-style:var(--border-style);border-color:var(--highlight-background)}:host(.ion-focused) .item-highlight,:host(.item-has-focus) .item-highlight{border-width:var(--full-highlight-height);opacity:var(--show-full-highlight)}:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-inner-highlight{border-bottom-width:var(--inset-highlight-height);opacity:var(--show-inset-highlight)}:host(.ion-focused.item-fill-solid) .item-highlight,:host(.item-has-focus.item-fill-solid) .item-highlight{border-width:calc(var(--full-highlight-height) - 1px)}:host(.ion-focused) .item-inner-highlight,:host(.ion-focused:not(.item-fill-outline)) .item-highlight,:host(.item-has-focus) .item-inner-highlight,:host(.item-has-focus:not(.item-fill-outline)) .item-highlight{border-top:none;border-right:none;border-left:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus){--highlight-background:var(--highlight-color-focused)}:host(.item-interactive.ion-valid){--highlight-background:var(--highlight-color-valid)}:host(.item-interactive.ion-invalid){--highlight-background:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=helper]){display:none}::slotted([slot=error]){display:none;color:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=error]){display:block}:host(:not(.item-label)) ::slotted(ion-select){--padding-start:0;max-width:none}:host(.item-label-stacked) ::slotted(ion-select),:host(.item-label-floating) ::slotted(ion-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0;-ms-flex-item-align:stretch;align-self:stretch;width:100%;max-width:100%}:host(:not(.item-label)) ::slotted(ion-datetime){--padding-start:0}:host(.item-label-stacked) ::slotted(ion-datetime),:host(.item-label-floating) ::slotted(ion-datetime){--padding-start:0;width:100%}:host(.item-multiple-inputs) ::slotted(ion-checkbox),:host(.item-multiple-inputs) ::slotted(ion-datetime),:host(.item-multiple-inputs) ::slotted(ion-radio),:host(.item-multiple-inputs) ::slotted(ion-select){position:relative}:host(.item-textarea){-ms-flex-align:stretch;align-items:stretch}::slotted(ion-reorder[slot]){margin-top:0;margin-bottom:0}ion-ripple-effect{color:var(--ripple-color)}:host(.item-fill-solid) ::slotted([slot=start]),:host(.item-fill-solid) ::slotted([slot=end]),:host(.item-fill-outline) ::slotted([slot=start]),:host(.item-fill-outline) ::slotted([slot=end]){-ms-flex-item-align:center;align-self:center}::slotted([slot=helper]),::slotted([slot=error]),.item-counter{padding-top:5px;font-size:12px;z-index:1}.item-counter{margin-left:auto;color:var(--ion-color-step-550, #737373);white-space:nowrap;-webkit-padding-start:16px;padding-inline-start:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-counter{margin-left:unset;-webkit-margin-start:auto;margin-inline-start:auto}}@media (prefers-reduced-motion: reduce){.item-highlight,.item-inner-highlight{-webkit-transition:none;transition:none}}:host{--min-height:48px;--background:var(--ion-item-background, var(--ion-background-color, #fff));--background-activated:transparent;--background-focused:currentColor;--background-hover:currentColor;--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04;--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))));--color:var(--ion-item-color, var(--ion-text-color, #000));--transition:opacity 15ms linear, background-color 15ms linear;--padding-start:16px;--inner-padding-end:16px;--inner-border-width:0 0 1px 0;--highlight-height:1px;--highlight-color-focused:var(--ion-color-primary, #3880ff);--highlight-color-valid:var(--ion-color-success, #2dd36f);--highlight-color-invalid:var(--ion-color-danger, #eb445a);font-size:16px;font-weight:normal;text-transform:none}:host(.item-fill-outline){--highlight-height:2px}:host(.item-fill-none.item-interactive.ion-focus) .item-highlight,:host(.item-fill-none.item-interactive.item-has-focus) .item-highlight,:host(.item-fill-none.item-interactive.ion-touched.ion-invalid) .item-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-width:0 0 var(--full-highlight-height) 0;border-style:var(--border-style);border-color:var(--highlight-background)}:host(.item-fill-none.item-interactive.ion-focus) .item-native,:host(.item-fill-none.item-interactive.item-has-focus) .item-native,:host(.item-fill-none.item-interactive.ion-touched.ion-invalid) .item-native{border-bottom-color:var(--highlight-background)}:host(.item-fill-outline.item-interactive.ion-focus) .item-highlight,:host(.item-fill-outline.item-interactive.item-has-focus) .item-highlight{-webkit-transform:scaleX(1);transform:scaleX(1)}:host(.item-fill-outline.item-interactive.ion-focus) .item-highlight,:host(.item-fill-outline.item-interactive.item-has-focus) .item-highlight,:host(.item-fill-outline.item-interactive.ion-touched.ion-invalid) .item-highlight{border-width:var(--full-highlight-height);border-style:var(--border-style);border-color:var(--highlight-background)}:host(.item-fill-outline.item-interactive.ion-touched.ion-invalid) .item-native{border-color:var(--highlight-background)}:host(.item-fill-solid.item-interactive.ion-focus) .item-highlight,:host(.item-fill-solid.item-interactive.item-has-focus) .item-highlight,:host(.item-fill-solid.item-interactive.ion-touched.ion-invalid) .item-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-width:0 0 var(--full-highlight-height) 0;border-style:var(--border-style);border-color:var(--highlight-background)}:host(.item-fill-solid.item-interactive.ion-focus) .item-native,:host(.item-fill-solid.item-interactive.item-has-focus) .item-native,:host(.item-fill-solid.item-interactive.ion-touched.ion-invalid) .item-native{border-bottom-color:var(--highlight-background)}:host(.ion-color.ion-activated) .item-native::after{background:transparent}:host(.item-has-focus) .item-native{caret-color:var(--highlight-background)}:host(.item-interactive){--border-width:0 0 1px 0;--inner-border-width:0;--show-full-highlight:1;--show-inset-highlight:0}:host(.item-lines-full){--border-width:0 0 1px 0;--show-full-highlight:1;--show-inset-highlight:0}:host(.item-lines-inset){--inner-border-width:0 0 1px 0;--show-full-highlight:0;--show-inset-highlight:1}:host(.item-lines-inset),:host(.item-lines-none){--border-width:0;--show-full-highlight:0}:host(.item-lines-full),:host(.item-lines-none){--inner-border-width:0;--show-inset-highlight:0}:host(.item-fill-outline) .item-highlight{--position-offset:calc(-1 * var(--border-width));left:var(--position-offset);top:var(--position-offset);width:calc(100% + 2 * var(--border-width));height:calc(100% + 2 * var(--border-width));-webkit-transition:none;transition:none}:host-context([dir=rtl]):host(.item-fill-outline) .item-highlight,:host-context([dir=rtl]).item-fill-outline .item-highlight{left:unset;right:unset;right:var(--position-offset)}:host(.item-fill-outline.ion-focused) .item-native,:host(.item-fill-outline.item-has-focus) .item-native{border-color:transparent}:host(.item-multi-line) ::slotted([slot=start]),:host(.item-multi-line) ::slotted([slot=end]){margin-top:16px;margin-bottom:16px;-ms-flex-item-align:start;align-self:flex-start}::slotted([slot=start]){margin-right:32px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted([slot=start]){margin-right:unset;-webkit-margin-end:32px;margin-inline-end:32px}}::slotted([slot=end]){margin-left:32px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted([slot=end]){margin-left:unset;-webkit-margin-start:32px;margin-inline-start:32px}}:host(.item-fill-solid) ::slotted([slot=start]),:host(.item-fill-solid) ::slotted([slot=end]),:host(.item-fill-outline) ::slotted([slot=start]),:host(.item-fill-outline) ::slotted([slot=end]){-ms-flex-item-align:center;align-self:center}::slotted(ion-icon){color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54);font-size:24px}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) ::slotted(ion-icon){color:var(--ion-color-contrast)}::slotted(ion-icon[slot]){margin-top:12px;margin-bottom:12px}::slotted(ion-icon[slot=start]){margin-right:32px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-icon[slot=start]){margin-right:unset;-webkit-margin-end:32px;margin-inline-end:32px}}::slotted(ion-icon[slot=end]){margin-left:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-icon[slot=end]){margin-left:unset;-webkit-margin-start:16px;margin-inline-start:16px}}:host(.item-fill-solid) ::slotted(ion-icon[slot=start]),:host(.item-fill-outline) ::slotted(ion-icon[slot=start]){margin-right:8px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.item-fill-solid) ::slotted(ion-icon[slot=start]),:host(.item-fill-outline) ::slotted(ion-icon[slot=start]){margin-right:unset;-webkit-margin-end:8px;margin-inline-end:8px}}::slotted(ion-toggle[slot=start]),::slotted(ion-toggle[slot=end]){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}::slotted(ion-note){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-ms-flex-item-align:start;align-self:flex-start;font-size:11px}::slotted(ion-note[slot]:not([slot=helper]):not([slot=error])){padding-left:0;padding-right:0;padding-top:18px;padding-bottom:10px}::slotted(ion-note[slot=start]){padding-right:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-note[slot=start]){padding-right:unset;-webkit-padding-end:16px;padding-inline-end:16px}}::slotted(ion-note[slot=end]){padding-left:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-note[slot=end]){padding-left:unset;-webkit-padding-start:16px;padding-inline-start:16px}}::slotted(ion-avatar){width:40px;height:40px}::slotted(ion-thumbnail){--size:56px}::slotted(ion-avatar),::slotted(ion-thumbnail){margin-top:8px;margin-bottom:8px}::slotted(ion-avatar[slot=start]),::slotted(ion-thumbnail[slot=start]){margin-right:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-avatar[slot=start]),::slotted(ion-thumbnail[slot=start]){margin-right:unset;-webkit-margin-end:16px;margin-inline-end:16px}}::slotted(ion-avatar[slot=end]),::slotted(ion-thumbnail[slot=end]){margin-left:16px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-avatar[slot=end]),::slotted(ion-thumbnail[slot=end]){margin-left:unset;-webkit-margin-start:16px;margin-inline-start:16px}}::slotted(ion-label){margin-left:0;margin-right:0;margin-top:10px;margin-bottom:10px}:host(.item-label-stacked) ::slotted([slot=end]),:host(.item-label-floating) ::slotted([slot=end]){margin-top:7px;margin-bottom:7px}:host(.item-label-fixed) ::slotted(ion-select),:host(.item-label-fixed) ::slotted(ion-datetime){--padding-start:8px}:host(.item-toggle) ::slotted(ion-label),:host(.item-radio) ::slotted(ion-label){margin-left:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.item-toggle) ::slotted(ion-label),:host(.item-radio) ::slotted(ion-label){margin-left:unset;-webkit-margin-start:0;margin-inline-start:0}}::slotted(.button-small){--padding-top:0;--padding-bottom:0;--padding-start:.6em;--padding-end:.6em;height:25px;font-size:12px}:host(.item-label-floating),:host(.item-label-stacked){--min-height:55px}:host(.item-label-stacked) ::slotted(ion-select),:host(.item-label-floating) ::slotted(ion-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0}:host(.ion-focused:not(.ion-color)) ::slotted(.label-stacked),:host(.ion-focused:not(.ion-color)) ::slotted(.label-floating),:host(.item-has-focus:not(.ion-color)) ::slotted(.label-stacked),:host(.item-has-focus:not(.ion-color)) ::slotted(.label-floating){color:var(--ion-color-primary, #3880ff)}:host(.ion-color){--highlight-color-focused:var(--ion-color-contrast)}:host(.item-label-color){--highlight-color-focused:var(--ion-color-base)}:host(.item-fill-solid.ion-color),:host(.item-fill-outline.ion-color){--highlight-color-focused:var(--ion-color-base)}:host(.item-fill-solid){--background:var(--ion-color-step-50, #f2f2f2);--background-hover:var(--ion-color-step-100, #e6e6e6);--background-focused:var(--ion-color-step-150, #d9d9d9);--border-width:0 0 1px 0;--inner-border-width:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl]):host(.item-fill-solid),:host-context([dir=rtl]).item-fill-solid{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}:host(.item-fill-solid) .item-native{--border-color:var(--ion-color-step-500, gray)}:host(.item-fill-solid.ion-focused) .item-native,:host(.item-fill-solid.item-has-focus) .item-native{--background:var(--background-focused)}:host(.item-fill-solid.item-shape-round){border-top-left-radius:16px;border-top-right-radius:16px;border-bottom-right-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl]):host(.item-fill-solid.item-shape-round),:host-context([dir=rtl]).item-fill-solid.item-shape-round{border-top-left-radius:16px;border-top-right-radius:16px;border-bottom-right-radius:0;border-bottom-left-radius:0}@media (any-hover: hover){:host(.item-fill-solid:hover) .item-native{--background:var(--background-hover);--border-color:var(--ion-color-step-750, #404040)}}:host(.item-fill-outline){--ripple-color:transparent;--background-focused:transparent;--background-hover:transparent;--border-color:var(--ion-color-step-500, gray);--border-width:1px;border:none;overflow:visible}:host(.item-fill-outline) .item-native{--native-padding-left:16px;border-radius:4px}:host(.item-fill-outline.item-shape-round) .item-native{--inner-padding-start:16px;border-radius:28px}:host(.item-fill-outline.item-shape-round) .item-bottom{padding-left:32px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.item-fill-outline.item-shape-round) .item-bottom{padding-left:unset;-webkit-padding-start:32px;padding-inline-start:32px}}:host(.item-fill-outline.item-label-floating.ion-focused) .item-native ::slotted(ion-input:not(:first-child)),:host(.item-fill-outline.item-label-floating.ion-focused) .item-native ::slotted(ion-textarea:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-focus) .item-native ::slotted(ion-input:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-focus) .item-native ::slotted(ion-textarea:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-value) .item-native ::slotted(ion-input:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-value) .item-native ::slotted(ion-textarea:not(:first-child)){-webkit-transform:translateY(-14px);transform:translateY(-14px)}@media (any-hover: hover){:host(.item-fill-outline:hover) .item-native{--border-color:var(--ion-color-step-750, #404040)}}.item-counter{letter-spacing:0.0333333333em}', uv = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.labelColorStyles = {}, this.itemStyles = /* @__PURE__ */ new Map(), this.inheritedAriaAttributes = {}, this.multipleInputs = !1, this.focusable = !0, this.button = !1, this.detailIcon = Kl, this.disabled = !1, this.counter = !1, this.routerDirection = "forward", this.type = "button";
  }
  counterFormatterChanged() {
    this.updateCounterOutput(this.getFirstInput());
  }
  handleIonChange(e) {
    this.counter && e.target === this.getFirstInput() && this.updateCounterOutput(e.target);
  }
  labelColorChanged(e) {
    const { color: t } = this;
    t === void 0 && (this.labelColorStyles = e.detail);
  }
  itemStyle(e) {
    e.stopPropagation();
    const t = e.target.tagName, n = e.detail, o = {}, i = this.itemStyles.get(t) || {};
    let r = !1;
    Object.keys(n).forEach((s) => {
      if (n[s]) {
        const a = `item-${s}`;
        i[a] || (r = !0), o[a] = !0;
      }
    }), !r && Object.keys(o).length !== Object.keys(i).length && (r = !0), r && (this.itemStyles.set(t, o), $i(this));
  }
  connectedCallback() {
    this.counter && this.updateCounterOutput(this.getFirstInput()), this.hasStartEl();
  }
  componentDidUpdate() {
    const e = this.getFirstInput();
    e !== void 0 && !this.clickListener && (this.clickListener = (t) => this.delegateFocus(t, e), this.el.addEventListener("click", this.clickListener));
  }
  disconnectedCallback() {
    this.getFirstInput() !== void 0 && this.clickListener && (this.el.removeEventListener("click", this.clickListener), this.clickListener = void 0);
  }
  componentWillLoad() {
    this.inheritedAriaAttributes = da(this.el, ["aria-label"]);
  }
  componentDidLoad() {
    Fe(() => {
      this.setMultipleInputs(), this.focusable = this.isFocusable();
    });
  }
  // If the item contains multiple clickable elements and/or inputs, then the item
  // should not have a clickable input cover over the entire item to prevent
  // interfering with their individual click events
  setMultipleInputs() {
    const e = this.el.querySelectorAll("ion-checkbox, ion-datetime, ion-select, ion-radio"), t = this.el.querySelectorAll("ion-input, ion-range, ion-searchbar, ion-segment, ion-textarea, ion-toggle"), n = this.el.querySelectorAll("ion-anchor, ion-button, a, button");
    this.multipleInputs = e.length + t.length > 1 || e.length + n.length > 1 || e.length > 0 && this.isClickable();
  }
  // If the item contains an input including a checkbox, datetime, select, or radio
  // then the item will have a clickable input cover that covers the item
  // that should get the hover, focused and activated states UNLESS it has multiple
  // inputs, then those need to individually get each click
  hasCover() {
    return this.el.querySelectorAll("ion-checkbox, ion-datetime, ion-select, ion-radio").length === 1 && !this.multipleInputs;
  }
  // If the item has an href or button property it will render a native
  // anchor or button that is clickable
  isClickable() {
    return this.href !== void 0 || this.button;
  }
  canActivate() {
    return this.isClickable() || this.hasCover();
  }
  isFocusable() {
    const e = this.el.querySelector(".ion-focusable");
    return this.canActivate() || e !== null;
  }
  getFirstInput() {
    return this.el.querySelectorAll("ion-input, ion-textarea")[0];
  }
  // This is needed for WebKit due to a delegatesFocus bug where
  // clicking on the left padding of an item is not focusing the input
  // but is opening the keyboard. It will no longer be needed with
  // iOS 14.
  delegateFocus(e, t) {
    const n = e.target.tagName === "ION-ITEM";
    let o = !1;
    document.activeElement && (o = t.querySelector("input, textarea") === document.activeElement), n && (o || !this.multipleInputs) && (t.fireFocusEvents = !1, t.setBlur(), t.setFocus(), Fe(() => {
      t.fireFocusEvents = !0;
    }));
  }
  updateCounterOutput(e) {
    var t, n;
    const { counter: o, counterFormatter: i, defaultCounterFormatter: r } = this;
    if (o && !this.multipleInputs && (e == null ? void 0 : e.maxlength) !== void 0) {
      const s = (n = (t = e == null ? void 0 : e.value) === null || t === void 0 ? void 0 : t.toString().length) !== null && n !== void 0 ? n : 0;
      if (i === void 0)
        this.counterString = r(s, e.maxlength);
      else
        try {
          this.counterString = i(s, e.maxlength);
        } catch (a) {
          w0("Exception in provided `counterFormatter`.", a), this.counterString = r(s, e.maxlength);
        }
    }
  }
  defaultCounterFormatter(e, t) {
    return `${e} / ${t}`;
  }
  hasStartEl() {
    this.el.querySelector('[slot="start"]') !== null && this.el.classList.add("item-has-start-slot");
  }
  render() {
    const { counterString: e, detail: t, detailIcon: n, download: o, fill: i, labelColorStyles: r, lines: s, disabled: a, href: l, rel: c, shape: d, target: u, routerAnimation: f, routerDirection: g, inheritedAriaAttributes: E } = this, k = {}, S = te(this), m = this.isClickable(), v = this.canActivate(), I = m ? l === void 0 ? "button" : "a" : "div", w = I === "button" ? { type: this.type } : {
      download: o,
      href: l,
      rel: c,
      target: u
    }, A = m ? {
      onClick: (D) => {
        ma(l, D, g, f);
      }
    } : {}, b = t !== void 0 ? t : S === "ios" && m;
    this.itemStyles.forEach((D) => {
      Object.assign(k, D);
    });
    const y = a || k["item-interactive-disabled"] ? "true" : null, L = i || "none", C = ln("ion-list", this.el);
    return x(ae, { "aria-disabled": y, class: Object.assign(Object.assign(Object.assign({}, k), r), dt(this.color, {
      item: !0,
      [S]: !0,
      "item-lines-default": s === void 0,
      [`item-lines-${s}`]: s !== void 0,
      [`item-fill-${L}`]: !0,
      [`item-shape-${d}`]: d !== void 0,
      "item-disabled": a,
      "in-list": C,
      "item-multiple-inputs": this.multipleInputs,
      "ion-activatable": v,
      "ion-focusable": this.focusable,
      "item-rtl": document.dir === "rtl"
    })), role: C ? "listitem" : null }, x(I, Object.assign({}, w, E, { class: "item-native", part: "native", disabled: a }, A), x("slot", { name: "start" }), x("div", { class: "item-inner" }, x("div", { class: "input-wrapper" }, x("slot", null)), x("slot", { name: "end" }), b && x("ion-icon", { icon: n, lazy: !1, class: "item-detail-icon", part: "detail-icon", "aria-hidden": "true", "flip-rtl": n === Kl }), x("div", { class: "item-inner-highlight" })), v && S === "md" && x("ion-ripple-effect", null), x("div", { class: "item-highlight" })), x("div", { class: "item-bottom" }, x("slot", { name: "error" }), x("slot", { name: "helper" }), e && x("ion-note", { class: "item-counter" }, e)));
  }
  static get delegatesFocus() {
    return !0;
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      counterFormatter: ["counterFormatterChanged"]
    };
  }
  static get style() {
    return {
      ios: cv,
      md: dv
    };
  }
}, [49, "ion-item", {
  color: [513],
  button: [4],
  detail: [4],
  detailIcon: [1, "detail-icon"],
  disabled: [4],
  download: [1],
  fill: [1],
  shape: [1],
  href: [1],
  rel: [1],
  lines: [1],
  counter: [4],
  routerAnimation: [16],
  routerDirection: [1, "router-direction"],
  target: [1],
  type: [1],
  counterFormatter: [16],
  multipleInputs: [32],
  focusable: [32],
  counterString: [32]
}, [[0, "ionChange", "handleIonChange"], [0, "ionColor", "labelColorChanged"], [0, "ionStyle", "itemStyle"]]]);
function ga() {
  if (typeof customElements > "u")
    return;
  ["ion-item", "ion-icon", "ion-note", "ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-item":
        customElements.get(t) || customElements.define(t, uv);
        break;
      case "ion-icon":
        customElements.get(t) || Ji();
        break;
      case "ion-note":
        customElements.get(t) || pa();
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const fv = ".item.sc-ion-label-ios-h,.item .sc-ion-label-ios-h{--color:initial;display:block;color:var(--color);font-family:var(--ion-font-family, inherit);font-size:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}.ion-color.sc-ion-label-ios-h{color:var(--ion-color-base)}.ion-text-wrap.sc-ion-label-ios-h,[text-wrap].sc-ion-label-ios-h{white-space:normal}.item-interactive-disabled.sc-ion-label-ios-h:not(.item-multiple-inputs),.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-ios-h{cursor:default;opacity:0.3;pointer-events:none}.item-input.sc-ion-label-ios-h,.item-input .sc-ion-label-ios-h{-ms-flex:initial;flex:initial;max-width:200px;pointer-events:none}.item-textarea.sc-ion-label-ios-h,.item-textarea .sc-ion-label-ios-h{-ms-flex-item-align:baseline;align-self:baseline}.label-fixed.sc-ion-label-ios-h{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}.label-stacked.sc-ion-label-ios-h,.label-floating.sc-ion-label-ios-h{margin-bottom:0;-ms-flex-item-align:stretch;align-self:stretch;width:auto;max-width:100%}.label-no-animate.label-floating.sc-ion-label-ios-h{-webkit-transition:none;transition:none}.sc-ion-label-ios-s h1,.sc-ion-label-ios-s h2,.sc-ion-label-ios-s h3,.sc-ion-label-ios-s h4,.sc-ion-label-ios-s h5,.sc-ion-label-ios-s h6{text-overflow:inherit;overflow:inherit}.ion-text-wrap.sc-ion-label-ios-h,[text-wrap].sc-ion-label-ios-h{font-size:14px;line-height:1.5}.label-stacked.sc-ion-label-ios-h{margin-bottom:4px;font-size:14px}.label-floating.sc-ion-label-ios-h{margin-bottom:0;-webkit-transform:translate(0, 29px);transform:translate(0, 29px);-webkit-transform-origin:left top;transform-origin:left top;-webkit-transition:-webkit-transform 150ms ease-in-out;transition:-webkit-transform 150ms ease-in-out;transition:transform 150ms ease-in-out;transition:transform 150ms ease-in-out, -webkit-transform 150ms ease-in-out}[dir=rtl].sc-ion-label-ios-h -no-combinator.label-floating.sc-ion-label-ios-h,[dir=rtl] .sc-ion-label-ios-h -no-combinator.label-floating.sc-ion-label-ios-h,[dir=rtl].label-floating.sc-ion-label-ios-h,[dir=rtl] .label-floating.sc-ion-label-ios-h{-webkit-transform-origin:right top;transform-origin:right top}.item-textarea.label-floating.sc-ion-label-ios-h,.item-textarea .label-floating.sc-ion-label-ios-h{-webkit-transform:translate(0, 28px);transform:translate(0, 28px)}.item-has-focus.label-floating.sc-ion-label-ios-h,.item-has-focus .label-floating.sc-ion-label-ios-h,.item-has-placeholder.sc-ion-label-ios-h:not(.item-input).label-floating,.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-ios-h,.item-has-value.label-floating.sc-ion-label-ios-h,.item-has-value .label-floating.sc-ion-label-ios-h{-webkit-transform:scale(0.82);transform:scale(0.82)}.sc-ion-label-ios-s h1{margin-left:0;margin-right:0;margin-top:3px;margin-bottom:2px;font-size:22px;font-weight:normal}.sc-ion-label-ios-s h2{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:17px;font-weight:normal}.sc-ion-label-ios-s h3,.sc-ion-label-ios-s h4,.sc-ion-label-ios-s h5,.sc-ion-label-ios-s h6{margin-left:0;margin-right:0;margin-top:0;margin-bottom:3px;font-size:14px;font-weight:normal;line-height:normal}.sc-ion-label-ios-s p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:14px;line-height:normal;text-overflow:inherit;overflow:inherit}.sc-ion-label-ios-s>p{color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.4)}.sc-ion-label-ios-h.in-item-color.sc-ion-label-ios-s>p{color:inherit}.sc-ion-label-ios-s h2:last-child,.sc-ion-label-ios-s h3:last-child,.sc-ion-label-ios-s h4:last-child,.sc-ion-label-ios-s h5:last-child,.sc-ion-label-ios-s h6:last-child,.sc-ion-label-ios-s p:last-child{margin-bottom:0}", hv = '.item.sc-ion-label-md-h,.item .sc-ion-label-md-h{--color:initial;display:block;color:var(--color);font-family:var(--ion-font-family, inherit);font-size:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}.ion-color.sc-ion-label-md-h{color:var(--ion-color-base)}.ion-text-wrap.sc-ion-label-md-h,[text-wrap].sc-ion-label-md-h{white-space:normal}.item-interactive-disabled.sc-ion-label-md-h:not(.item-multiple-inputs),.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-md-h{cursor:default;opacity:0.3;pointer-events:none}.item-input.sc-ion-label-md-h,.item-input .sc-ion-label-md-h{-ms-flex:initial;flex:initial;max-width:200px;pointer-events:none}.item-textarea.sc-ion-label-md-h,.item-textarea .sc-ion-label-md-h{-ms-flex-item-align:baseline;align-self:baseline}.label-fixed.sc-ion-label-md-h{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}.label-stacked.sc-ion-label-md-h,.label-floating.sc-ion-label-md-h{margin-bottom:0;-ms-flex-item-align:stretch;align-self:stretch;width:auto;max-width:100%}.label-no-animate.label-floating.sc-ion-label-md-h{-webkit-transition:none;transition:none}.sc-ion-label-md-s h1,.sc-ion-label-md-s h2,.sc-ion-label-md-s h3,.sc-ion-label-md-s h4,.sc-ion-label-md-s h5,.sc-ion-label-md-s h6{text-overflow:inherit;overflow:inherit}.ion-text-wrap.sc-ion-label-md-h,[text-wrap].sc-ion-label-md-h{line-height:1.5}.label-stacked.sc-ion-label-md-h,.label-floating.sc-ion-label-md-h{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-transform-origin:top left;transform-origin:top left}.label-stacked.label-rtl.sc-ion-label-md-h,.label-floating.label-rtl.sc-ion-label-md-h{-webkit-transform-origin:top right;transform-origin:top right}.label-stacked.sc-ion-label-md-h{-webkit-transform:translateY(50%) scale(0.75);transform:translateY(50%) scale(0.75);-webkit-transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1)}.label-floating.sc-ion-label-md-h{-webkit-transform:translateY(96%);transform:translateY(96%);-webkit-transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1)}.ion-focused.label-floating.sc-ion-label-md-h,.ion-focused .label-floating.sc-ion-label-md-h,.item-has-focus.label-floating.sc-ion-label-md-h,.item-has-focus .label-floating.sc-ion-label-md-h,.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating,.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h,.item-has-value.label-floating.sc-ion-label-md-h,.item-has-value .label-floating.sc-ion-label-md-h{-webkit-transform:translateY(50%) scale(0.75);transform:translateY(50%) scale(0.75)}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h{-webkit-transform:translateY(-6px) scale(0.75);transform:translateY(-6px) scale(0.75);position:relative;max-width:-webkit-min-content;max-width:-moz-min-content;max-width:min-content;background-color:var(--ion-item-background, var(--ion-background-color, #fff));overflow:visible;z-index:3}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::before,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::before,.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::after,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::before,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::after,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::after{position:absolute;width:4px;height:100%;background-color:var(--ion-item-background, var(--ion-background-color, #fff));content:""}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::before,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::before,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::before{left:calc(-1 * 4px)}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::after,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::after,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::after{right:calc(-1 * 4px)}.item-fill-outline.ion-focused.item-has-start-slot.label-floating.sc-ion-label-md-h,.item-fill-outline.ion-focused.item-has-start-slot .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).item-has-start-slot.label-floating,.item-fill-outline.item-has-placeholder:not(.item-input).item-has-start-slot .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot .label-floating.sc-ion-label-md-h{-webkit-transform:translateX(-32px) translateY(-6px) scale(0.75);transform:translateX(-32px) translateY(-6px) scale(0.75)}.item-fill-outline.ion-focused.item-has-start-slot.label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.ion-focused.item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot.label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).item-has-start-slot.label-floating.label-rtl,.item-fill-outline.item-has-placeholder:not(.item-input).item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot.label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h{-webkit-transform:translateX(calc(-1 * -32px)) translateY(-6px) scale(0.75);transform:translateX(calc(-1 * -32px)) translateY(-6px) scale(0.75)}.ion-focused.label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused .label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused.label-floating.sc-ion-label-md-h:not(.ion-color),.ion-focused .label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus.label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--ion-color-primary, #3880ff)}.ion-focused.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.ion-focused.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--ion-color-contrast)}.item-fill-solid.ion-focused.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.ion-focused.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.ion-focused.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.ion-focused.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--ion-color-base)}.ion-invalid.ion-touched.label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-invalid.ion-touched .label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-invalid.ion-touched.label-floating.sc-ion-label-md-h:not(.ion-color),.ion-invalid.ion-touched .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--highlight-color-invalid)}.sc-ion-label-md-s h1{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:24px;font-weight:normal}.sc-ion-label-md-s h2{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:16px;font-weight:normal}.sc-ion-label-md-s h3,.sc-ion-label-md-s h4,.sc-ion-label-md-s h5,.sc-ion-label-md-s h6{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:14px;font-weight:normal;line-height:normal}.sc-ion-label-md-s p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:14px;line-height:20px;text-overflow:inherit;overflow:inherit}.sc-ion-label-md-s>p{color:var(--ion-color-step-600, #666666)}.sc-ion-label-md-h.in-item-color.sc-ion-label-md-s>p{color:inherit}', mv = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.ionColor = G(this, "ionColor", 7), this.ionStyle = G(this, "ionStyle", 7), this.inRange = !1, this.noAnimate = !1;
  }
  componentWillLoad() {
    this.inRange = !!this.el.closest("ion-range"), this.noAnimate = this.position === "floating", this.emitStyle(), this.emitColor();
  }
  componentDidLoad() {
    this.noAnimate && setTimeout(() => {
      this.noAnimate = !1;
    }, 1e3);
  }
  colorChanged() {
    this.emitColor();
  }
  positionChanged() {
    this.emitStyle();
  }
  emitColor() {
    const { color: e } = this;
    this.ionColor.emit({
      "item-label-color": e !== void 0,
      [`ion-color-${e}`]: e !== void 0
    });
  }
  emitStyle() {
    const { inRange: e, position: t } = this;
    e || this.ionStyle.emit({
      label: !0,
      [`label-${t}`]: t !== void 0
    });
  }
  render() {
    const e = this.position, t = te(this);
    return x(ae, { class: dt(this.color, {
      [t]: !0,
      "in-item-color": ln("ion-item.ion-color", this.el),
      [`label-${e}`]: e !== void 0,
      "label-no-animate": this.noAnimate,
      "label-rtl": document.dir === "rtl"
    }) });
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      color: ["colorChanged"],
      position: ["positionChanged"]
    };
  }
  static get style() {
    return {
      ios: fv,
      md: hv
    };
  }
}, [34, "ion-label", {
  color: [513],
  position: [1],
  noAnimate: [32]
}]);
function ba() {
  if (typeof customElements > "u")
    return;
  ["ion-label"].forEach((t) => {
    switch (t) {
      case "ion-label":
        customElements.get(t) || customElements.define(t, mv);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const er = {
  getEngine() {
    var e;
    const t = window;
    return t.TapticEngine || ((e = t.Capacitor) === null || e === void 0 ? void 0 : e.isPluginAvailable("Haptics")) && t.Capacitor.Plugins.Haptics;
  },
  available() {
    var e;
    const t = window;
    return this.getEngine() ? ((e = t.Capacitor) === null || e === void 0 ? void 0 : e.getPlatform()) === "web" ? typeof navigator < "u" && navigator.vibrate !== void 0 : !0 : !1;
  },
  isCordova() {
    return !!window.TapticEngine;
  },
  isCapacitor() {
    return !!window.Capacitor;
  },
  impact(e) {
    const t = this.getEngine();
    if (!t)
      return;
    const n = this.isCapacitor() ? e.style.toUpperCase() : e.style;
    t.impact({ style: n });
  },
  notification(e) {
    const t = this.getEngine();
    if (!t)
      return;
    const n = this.isCapacitor() ? e.style.toUpperCase() : e.style;
    t.notification({ style: n });
  },
  selection() {
    this.impact({ style: "light" });
  },
  selectionStart() {
    const e = this.getEngine();
    e && (this.isCapacitor() ? e.selectionStart() : e.gestureSelectionStart());
  },
  selectionChanged() {
    const e = this.getEngine();
    e && (this.isCapacitor() ? e.selectionChanged() : e.gestureSelectionChanged());
  },
  selectionEnd() {
    const e = this.getEngine();
    e && (this.isCapacitor() ? e.selectionEnd() : e.gestureSelectionEnd());
  }
}, va = () => er.available(), pv = () => {
  va() && er.selectionStart();
}, gv = () => {
  va() && er.selectionChanged();
}, bv = () => {
  va() && er.selectionEnd();
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const vv = async (e, t, n, o, i, r) => {
  var s;
  if (e)
    return e.attachViewToDom(t, n, i, o);
  if (!r && typeof n != "string" && !(n instanceof HTMLElement))
    throw new Error("framework delegate is missing");
  const a = typeof n == "string" ? (s = t.ownerDocument) === null || s === void 0 ? void 0 : s.createElement(n) : n;
  return o && o.forEach((l) => a.classList.add(l)), i && Object.assign(a, i), t.appendChild(a), await new Promise((l) => ca(a, l)), a;
}, yv = (e, t) => {
  if (t) {
    if (e) {
      const n = t.parentElement;
      return e.removeViewFromDom(n, t);
    }
    t.remove();
  }
  return Promise.resolve();
}, wv = () => {
  let e, t;
  return { attachViewToDom: async (i, r, s = {}, a = []) => {
    var l, c;
    if (e = i, r) {
      const u = typeof r == "string" ? (l = e.ownerDocument) === null || l === void 0 ? void 0 : l.createElement(r) : r;
      a.forEach((f) => u.classList.add(f)), Object.assign(u, s), e.appendChild(u), await new Promise((f) => ca(u, f));
    } else if (e.children.length > 0 && !e.children[0].classList.contains("ion-delegate-host")) {
      const f = (c = e.ownerDocument) === null || c === void 0 ? void 0 : c.createElement("div");
      f.classList.add("ion-delegate-host"), a.forEach((g) => f.classList.add(g)), f.append(...e.children), e.appendChild(f);
    }
    const d = document.querySelector("ion-app") || document.body;
    return t = document.createComment("ionic teleport"), e.parentNode.insertBefore(t, e), d.appendChild(e), e;
  }, removeViewFromDom: () => (e && t && (t.parentNode.insertBefore(e, t), t.remove()), Promise.resolve()) };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const kv = 100;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
let hs = 0;
const ms = /* @__PURE__ */ new WeakMap(), ya = (e) => ({
  create(t) {
    return Tv(e, t);
  },
  dismiss(t, n, o) {
    return Cv(document, t, n, e, o);
  },
  async getTop() {
    return Ro(document, e);
  }
}), xv = /* @__PURE__ */ ya("ion-alert"), _v = /* @__PURE__ */ ya("ion-action-sheet"), Ev = /* @__PURE__ */ ya("ion-popover"), wa = (e) => {
  typeof document < "u" && Ov(document);
  const t = hs++;
  e.overlayIndex = t, e.hasAttribute("id") || (e.id = `ion-overlay-${t}`);
}, Tv = (e, t) => typeof window < "u" && typeof window.customElements < "u" ? window.customElements.whenDefined(e).then(() => {
  const n = document.createElement(e);
  return n.classList.add("overlay-hidden"), Object.assign(n, Object.assign(Object.assign({}, t), { hasController: !0 })), af(document).appendChild(n), new Promise((o) => ca(n, o));
}) : Promise.resolve(), Fo = '[tabindex]:not([tabindex^="-"]):not([hidden]):not([disabled]), input:not([type=hidden]):not([tabindex^="-"]):not([hidden]):not([disabled]), textarea:not([tabindex^="-"]):not([hidden]):not([disabled]), button:not([tabindex^="-"]):not([hidden]):not([disabled]), select:not([tabindex^="-"]):not([hidden]):not([disabled]), .ion-focusable:not([tabindex^="-"]):not([hidden]):not([disabled]), .ion-focusable[disabled="false"]:not([tabindex^="-"]):not([hidden])', ps = (e, t) => {
  let n = e.querySelector(Fo);
  const o = n == null ? void 0 : n.shadowRoot;
  o && (n = o.querySelector(Fo) || n), n ? Qu(n) : t.focus();
}, Iv = (e) => e.classList.contains("overlay-hidden"), Ql = (e, t) => {
  const n = Array.from(e.querySelectorAll(Fo));
  let o = n.length > 0 ? n[n.length - 1] : null;
  const i = o == null ? void 0 : o.shadowRoot;
  i && (o = i.querySelector(Fo) || o), o ? o.focus() : t.focus();
}, Sv = (e, t) => {
  const n = Ro(t, "ion-alert,ion-action-sheet,ion-loading,ion-modal,ion-picker,ion-popover"), o = e.target;
  if (!n || !o || n.classList.contains("ion-disable-focus-trap"))
    return;
  const i = () => {
    if (n === o)
      n.lastFocus = void 0;
    else {
      const s = Hn(n);
      if (!s.contains(o))
        return;
      const a = s.querySelector(".ion-overlay-wrapper");
      if (!a)
        return;
      if (a.contains(o))
        n.lastFocus = o;
      else {
        const l = n.lastFocus;
        ps(a, n), l === t.activeElement && Ql(a, n), n.lastFocus = t.activeElement;
      }
    }
  }, r = () => {
    if (n.contains(o))
      n.lastFocus = o;
    else {
      const s = n.lastFocus;
      ps(n, n), s === t.activeElement && Ql(n, n), n.lastFocus = t.activeElement;
    }
  };
  n.shadowRoot ? r() : i();
}, Ov = (e) => {
  hs === 0 && (hs = 1, e.addEventListener("focus", (t) => {
    Sv(t, e);
  }, !0), e.addEventListener("ionBackButton", (t) => {
    const n = Ro(e);
    n != null && n.backdropDismiss && t.detail.register(kv, () => n.dismiss(void 0, lo));
  }), e.addEventListener("keyup", (t) => {
    if (t.key === "Escape") {
      const n = Ro(e);
      n != null && n.backdropDismiss && n.dismiss(void 0, lo);
    }
  }));
}, Cv = (e, t, n, o, i) => {
  const r = Ro(e, o, i);
  return r ? r.dismiss(t, n) : Promise.reject("overlay does not exist");
}, Av = (e, t) => (t === void 0 && (t = "ion-alert,ion-action-sheet,ion-loading,ion-modal,ion-picker,ion-popover,ion-toast"), Array.from(e.querySelectorAll(t)).filter((n) => n.overlayIndex > 0)), Ro = (e, t, n) => {
  const o = Av(e, t).filter((i) => !Iv(i));
  return n === void 0 ? o[o.length - 1] : o.find((i) => i.id === n);
}, sf = (e = !1) => {
  const n = af(document).querySelector("ion-router-outlet, ion-nav, #ion-view-container-root");
  n && (e ? n.setAttribute("aria-hidden", "true") : n.removeAttribute("aria-hidden"));
}, ka = async (e, t, n, o, i) => {
  var r, s;
  if (e.presented)
    return;
  sf(!0), e.presented = !0, e.willPresent.emit(), (r = e.willPresentShorthand) === null || r === void 0 || r.emit();
  const a = te(e), l = e.enterAnimation ? e.enterAnimation : go.get(t, a === "ios" ? n : o);
  await lf(e, l, e.el, i) && (e.didPresent.emit(), (s = e.didPresentShorthand) === null || s === void 0 || s.emit()), e.el.tagName !== "ION-TOAST" && Dv(e.el), e.keyboardClose && (document.activeElement === null || !e.el.contains(document.activeElement)) && e.el.focus();
}, Dv = async (e) => {
  let t = document.activeElement;
  if (!t)
    return;
  const n = t == null ? void 0 : t.shadowRoot;
  n && (t = n.querySelector(Fo) || t), await e.onDidDismiss(), t.focus();
}, xa = async (e, t, n, o, i, r, s) => {
  var a, l;
  if (!e.presented)
    return !1;
  sf(!1), e.presented = !1;
  try {
    e.el.style.setProperty("pointer-events", "none"), e.willDismiss.emit({ data: t, role: n }), (a = e.willDismissShorthand) === null || a === void 0 || a.emit({ data: t, role: n });
    const c = te(e), d = e.leaveAnimation ? e.leaveAnimation : go.get(o, c === "ios" ? i : r);
    n !== Lv && await lf(e, d, e.el, s), e.didDismiss.emit({ data: t, role: n }), (l = e.didDismissShorthand) === null || l === void 0 || l.emit({ data: t, role: n }), ms.delete(e), e.el.classList.add("overlay-hidden"), e.el.style.removeProperty("pointer-events"), e.el.lastFocus !== void 0 && (e.el.lastFocus = void 0);
  } catch (c) {
    console.error(c);
  }
  return e.el.remove(), !0;
}, af = (e) => e.querySelector("ion-app") || e.body, lf = async (e, t, n, o) => {
  n.classList.remove("overlay-hidden");
  const i = e.el, r = t(i, o);
  (!e.animated || !go.getBoolean("animated", !0)) && r.duration(0), e.keyboardClose && r.beforeAddWrite(() => {
    const a = n.ownerDocument.activeElement;
    a != null && a.matches("input,ion-input, ion-textarea") && a.blur();
  });
  const s = ms.get(e) || [];
  return ms.set(e, [...s, r]), await r.play(), !0;
}, ao = (e, t) => {
  let n;
  const o = new Promise((i) => n = i);
  return $v(e, t, (i) => {
    n(i.detail);
  }), o;
}, $v = (e, t, n) => {
  const o = (i) => {
    Xu(e, t, o), n(i);
  };
  ua(e, t, o);
}, Mi = (e) => e === "cancel" || e === lo, Nv = (e) => e(), Ao = (e, t) => {
  if (typeof e == "function")
    return go.get("_zoneGate", Nv)(() => {
      try {
        return e(t);
      } catch (o) {
        throw o;
      }
    });
}, lo = "backdrop", Lv = "gesture";
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Pv = "ionViewWillEnter", Mv = "ionViewDidEnter", Fv = "ionViewWillLeave", Rv = "ionViewDidLeave", cf = async (e) => {
  const t = e;
  if (t) {
    if (t.componentOnReady != null) {
      if (await t.componentOnReady() != null)
        return;
    } else if (t.__registerHost != null) {
      await new Promise((o) => Fe(o));
      return;
    }
    await Promise.all(Array.from(t.children).map(cf));
  }
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const qe = typeof window < "u" ? window : void 0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
let Er;
const Vv = (e) => (e.forEach((t) => {
  for (const n in t)
    if (t.hasOwnProperty(n)) {
      const o = t[n];
      if (n === "easing") {
        const i = "animation-timing-function";
        t[i] = o, delete t[n];
      } else {
        const i = zv(n);
        i !== n && (t[i] = o, delete t[n]);
      }
    }
}), e), zv = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), _a = (e) => {
  if (Er === void 0) {
    const t = e.style.animationName !== void 0, n = e.style.webkitAnimationName !== void 0;
    Er = !t && n ? "-webkit-" : "";
  }
  return Er;
}, fe = (e, t, n) => {
  const o = t.startsWith("animation") ? _a(e) : "";
  e.style.setProperty(o + t, n);
}, vt = (e, t) => {
  const n = t.startsWith("animation") ? _a(e) : "";
  e.style.removeProperty(n + t);
}, Uv = (e, t) => {
  let n;
  const o = { passive: !0 }, i = () => {
    n && n();
  }, r = (s) => {
    e === s.target && (i(), t(s));
  };
  return e && (e.addEventListener("webkitAnimationEnd", r, o), e.addEventListener("animationend", r, o), n = () => {
    e.removeEventListener("webkitAnimationEnd", r, o), e.removeEventListener("animationend", r, o);
  }), i;
}, Hv = (e = []) => e.map((t) => {
  const n = t.offset, o = [];
  for (const i in t)
    t.hasOwnProperty(i) && i !== "offset" && o.push(`${i}: ${t[i]};`);
  return `${n * 100}% { ${o.join(" ")} }`;
}).join(" "), ec = [], Bv = (e) => {
  let t = ec.indexOf(e);
  return t < 0 && (t = ec.push(e) - 1), `ion-animation-${t}`;
}, Wv = (e) => {
  const t = e.getRootNode !== void 0 ? e.getRootNode() : e;
  return t.head || t;
}, jv = (e, t, n) => {
  var o;
  const i = Wv(n), r = _a(n), s = i.querySelector("#" + e);
  if (s)
    return s;
  const a = ((o = n.ownerDocument) !== null && o !== void 0 ? o : document).createElement("style");
  return a.id = e, a.textContent = `@${r}keyframes ${e} { ${t} } @${r}keyframes ${e}-alt { ${t} }`, i.appendChild(a), a;
}, ci = (e = [], t) => {
  if (t !== void 0) {
    const n = Array.isArray(t) ? t : [t];
    return [...e, ...n];
  }
  return e;
}, Y = (e) => {
  let t, n, o, i, r, s, a = [], l = [], c = [], d = !1, u, f = {}, g = [], E = [], k = {}, S = 0, m = !1, v = !1, I, w, A, b, y = !0, L = !1, C = !0, D, N, z = !1;
  const oe = e, ke = [], Ye = [], q = [], K = [], ut = [], Le = [], et = [], ft = [], St = [], Te = [], tt = typeof AnimationEffect == "function" || qe !== void 0 && typeof qe.AnimationEffect == "function", Ie = typeof Element == "function" && typeof Element.prototype.animate == "function" && tt, Qt = 100, en = () => Te, Rt = (_) => (K.forEach((P) => {
    P.destroy(_);
  }), Vt(_), q.length = 0, K.length = 0, a.length = 0, p(), d = !1, C = !0, N), Vt = (_) => {
    h(), _ && T();
  }, Ot = () => {
    m = !1, v = !1, C = !0, w = void 0, A = void 0, b = void 0, S = 0, L = !1, y = !0, z = !1;
  }, zt = () => S !== 0 && !z, Ct = (_, P) => ((P != null && P.oneTimeCallback ? Ye : ke).push({ c: _, o: P }), N), p = () => (ke.length = 0, Ye.length = 0, N), h = () => {
    if (Ie)
      Te.forEach((_) => {
        _.cancel();
      }), Te.length = 0;
    else {
      const _ = q.slice();
      Fe(() => {
        _.forEach((P) => {
          vt(P, "animation-name"), vt(P, "animation-duration"), vt(P, "animation-timing-function"), vt(P, "animation-iteration-count"), vt(P, "animation-delay"), vt(P, "animation-play-state"), vt(P, "animation-fill-mode"), vt(P, "animation-direction");
        });
      });
    }
  }, T = () => {
    ut.forEach((_) => {
      _ != null && _.parentNode && _.parentNode.removeChild(_);
    }), ut.length = 0;
  }, R = (_) => (Le.push(_), N), H = (_) => (et.push(_), N), Q = (_) => (ft.push(_), N), nt = (_) => (St.push(_), N), ht = (_) => (l = ci(l, _), N), cr = (_) => (c = ci(c, _), N), dr = (_ = {}) => (f = _, N), me = (_ = []) => {
    for (const P of _)
      f[P] = "";
    return N;
  }, O = (_) => (g = ci(g, _), N), $ = (_) => (E = ci(E, _), N), Pe = (_ = {}) => (k = _, N), Ae = (_ = []) => {
    for (const P of _)
      k[P] = "";
    return N;
  }, Ut = () => r !== void 0 ? r : u ? u.getFill() : "both", mt = () => w !== void 0 ? w : s !== void 0 ? s : u ? u.getDirection() : "normal", pt = () => m ? "linear" : o !== void 0 ? o : u ? u.getEasing() : "linear", xe = () => v ? 0 : A !== void 0 ? A : n !== void 0 ? n : u ? u.getDuration() : 0, At = () => i !== void 0 ? i : u ? u.getIterations() : 1, Ht = () => b !== void 0 ? b : t !== void 0 ? t : u ? u.getDelay() : 0, Gh = () => a, qh = (_) => (s = _, ot(!0), N), Kh = (_) => (r = _, ot(!0), N), Xh = (_) => (t = _, ot(!0), N), Zh = (_) => (o = _, ot(!0), N), Jh = (_) => (!Ie && _ === 0 && (_ = 1), n = _, ot(!0), N), Qh = (_) => (i = _, ot(!0), N), em = (_) => (u = _, N), tm = (_) => {
    if (_ != null)
      if (_.nodeType === 1)
        q.push(_);
      else if (_.length >= 0)
        for (let P = 0; P < _.length; P++)
          q.push(_[P]);
      else
        console.error("Invalid addElement value");
    return N;
  }, nm = (_) => {
    if (_ != null)
      if (Array.isArray(_))
        for (const P of _)
          P.parent(N), K.push(P);
      else
        _.parent(N), K.push(_);
    return N;
  }, om = (_) => {
    const P = a !== _;
    return a = _, P && im(a), N;
  }, im = (_) => {
    Ie ? en().forEach((P) => {
      if (P.effect.setKeyframes)
        P.effect.setKeyframes(_);
      else {
        const V = new KeyframeEffect(P.effect.target, _, P.effect.getTiming());
        P.effect = V;
      }
    }) : Ja();
  }, rm = () => {
    Le.forEach((_e) => _e()), et.forEach((_e) => _e());
    const _ = l, P = c, V = f;
    q.forEach((_e) => {
      const De = _e.classList;
      _.forEach((it) => De.add(it)), P.forEach((it) => De.remove(it));
      for (const it in V)
        V.hasOwnProperty(it) && fe(_e, it, V[it]);
    });
  }, sm = () => {
    ur(), ft.forEach((De) => De()), St.forEach((De) => De());
    const _ = y ? 1 : 0, P = g, V = E, _e = k;
    q.forEach((De) => {
      const it = De.classList;
      P.forEach((gn) => it.add(gn)), V.forEach((gn) => it.remove(gn));
      for (const gn in _e)
        _e.hasOwnProperty(gn) && fe(De, gn, _e[gn]);
    }), ke.forEach((De) => De.c(_, N)), Ye.forEach((De) => De.c(_, N)), Ye.length = 0, C = !0, y && (L = !0), y = !0;
  }, Wn = () => {
    S !== 0 && (S--, S === 0 && (sm(), u && u.animationFinish()));
  }, Ja = (_ = !0) => {
    T();
    const P = Vv(a);
    q.forEach((V) => {
      if (P.length > 0) {
        const _e = Hv(P);
        D = e !== void 0 ? e : Bv(_e);
        const De = jv(D, _e, V);
        ut.push(De), fe(V, "animation-duration", `${xe()}ms`), fe(V, "animation-timing-function", pt()), fe(V, "animation-delay", `${Ht()}ms`), fe(V, "animation-fill-mode", Ut()), fe(V, "animation-direction", mt());
        const it = At() === 1 / 0 ? "infinite" : At().toString();
        fe(V, "animation-iteration-count", it), fe(V, "animation-play-state", "paused"), _ && fe(V, "animation-name", `${De.id}-alt`), Fe(() => {
          fe(V, "animation-name", De.id || null);
        });
      }
    });
  }, am = () => {
    q.forEach((_) => {
      const P = _.animate(a, {
        id: oe,
        delay: Ht(),
        duration: xe(),
        easing: pt(),
        iterations: At(),
        fill: Ut(),
        direction: mt()
      });
      P.pause(), Te.push(P);
    }), Te.length > 0 && (Te[0].onfinish = () => {
      Wn();
    });
  }, Qa = (_ = !0) => {
    rm(), a.length > 0 && (Ie ? am() : Ja(_)), d = !0;
  }, yo = (_) => {
    if (_ = Math.min(Math.max(_, 0), 0.9999), Ie)
      Te.forEach((P) => {
        P.currentTime = P.effect.getComputedTiming().delay + xe() * _, P.pause();
      });
    else {
      const P = `-${xe() * _}ms`;
      q.forEach((V) => {
        a.length > 0 && (fe(V, "animation-delay", P), fe(V, "animation-play-state", "paused"));
      });
    }
  }, el = (_) => {
    Te.forEach((P) => {
      P.effect.updateTiming({
        delay: Ht(),
        duration: xe(),
        easing: pt(),
        iterations: At(),
        fill: Ut(),
        direction: mt()
      });
    }), _ !== void 0 && yo(_);
  }, tl = (_ = !0, P) => {
    Fe(() => {
      q.forEach((V) => {
        fe(V, "animation-name", D || null), fe(V, "animation-duration", `${xe()}ms`), fe(V, "animation-timing-function", pt()), fe(V, "animation-delay", P !== void 0 ? `-${P * xe()}ms` : `${Ht()}ms`), fe(V, "animation-fill-mode", Ut() || null), fe(V, "animation-direction", mt() || null);
        const _e = At() === 1 / 0 ? "infinite" : At().toString();
        fe(V, "animation-iteration-count", _e), _ && fe(V, "animation-name", `${D}-alt`), Fe(() => {
          fe(V, "animation-name", D || null);
        });
      });
    });
  }, ot = (_ = !1, P = !0, V) => (_ && K.forEach((_e) => {
    _e.update(_, P, V);
  }), Ie ? el(V) : tl(P, V), N), lm = (_ = !1, P) => (K.forEach((V) => {
    V.progressStart(_, P);
  }), nl(), m = _, d || Qa(), ot(!1, !0, P), N), cm = (_) => (K.forEach((P) => {
    P.progressStep(_);
  }), yo(_), N), dm = (_, P, V) => (m = !1, K.forEach((_e) => {
    _e.progressEnd(_, P, V);
  }), V !== void 0 && (A = V), L = !1, y = !0, _ === 0 ? (w = mt() === "reverse" ? "normal" : "reverse", w === "reverse" && (y = !1), Ie ? (ot(), yo(1 - P)) : (b = (1 - P) * xe() * -1, ot(!1, !1))) : _ === 1 && (Ie ? (ot(), yo(P)) : (b = P * xe() * -1, ot(!1, !1))), _ !== void 0 && (Ct(() => {
    A = void 0, w = void 0, b = void 0;
  }, {
    oneTimeCallback: !0
  }), u || ol()), N), nl = () => {
    d && (Ie ? Te.forEach((_) => {
      _.pause();
    }) : q.forEach((_) => {
      fe(_, "animation-play-state", "paused");
    }), z = !0);
  }, um = () => (K.forEach((_) => {
    _.pause();
  }), nl(), N), fm = () => {
    I = void 0, Wn();
  }, ur = () => {
    I && clearTimeout(I);
  }, hm = () => {
    if (ur(), Fe(() => {
      q.forEach((_) => {
        a.length > 0 && fe(_, "animation-play-state", "running");
      });
    }), a.length === 0 || q.length === 0)
      Wn();
    else {
      const _ = Ht() || 0, P = xe() || 0, V = At() || 1;
      isFinite(V) && (I = setTimeout(fm, _ + P * V + Qt)), Uv(q[0], () => {
        ur(), Fe(() => {
          mm(), Fe(Wn);
        });
      });
    }
  }, mm = () => {
    q.forEach((_) => {
      vt(_, "animation-duration"), vt(_, "animation-delay"), vt(_, "animation-play-state");
    });
  }, pm = () => {
    Te.forEach((_) => {
      _.play();
    }), (a.length === 0 || q.length === 0) && Wn();
  }, gm = () => {
    Ie ? (yo(0), el()) : tl();
  }, ol = (_) => new Promise((P) => {
    _ != null && _.sync && (v = !0, Ct(() => v = !1, { oneTimeCallback: !0 })), d || Qa(), L && (gm(), L = !1), C && (S = K.length + 1, C = !1), Ct(() => P(), { oneTimeCallback: !0 }), K.forEach((V) => {
      V.play();
    }), Ie ? pm() : hm(), z = !1;
  }), bm = () => {
    K.forEach((_) => {
      _.stop();
    }), d && (h(), d = !1), Ot();
  }, il = (_, P) => {
    const V = a[0];
    return V !== void 0 && (V.offset === void 0 || V.offset === 0) ? V[_] = P : a = [{ offset: 0, [_]: P }, ...a], N;
  };
  return N = {
    parentAnimation: u,
    elements: q,
    childAnimations: K,
    id: oe,
    animationFinish: Wn,
    from: il,
    to: (_, P) => {
      const V = a[a.length - 1];
      return V !== void 0 && (V.offset === void 0 || V.offset === 1) ? V[_] = P : a = [...a, { offset: 1, [_]: P }], N;
    },
    fromTo: (_, P, V) => il(_, P).to(_, V),
    parent: em,
    play: ol,
    pause: um,
    stop: bm,
    destroy: Rt,
    keyframes: om,
    addAnimation: nm,
    addElement: tm,
    update: ot,
    fill: Kh,
    direction: qh,
    iterations: Qh,
    duration: Jh,
    easing: Zh,
    delay: Xh,
    getWebAnimations: en,
    getKeyframes: Gh,
    getFill: Ut,
    getDirection: mt,
    getDelay: Ht,
    getIterations: At,
    getEasing: pt,
    getDuration: xe,
    afterAddRead: Q,
    afterAddWrite: nt,
    afterClearStyles: Ae,
    afterStyles: Pe,
    afterRemoveClass: $,
    afterAddClass: O,
    beforeAddRead: R,
    beforeAddWrite: H,
    beforeClearStyles: me,
    beforeStyles: dr,
    beforeRemoveClass: cr,
    beforeAddClass: ht,
    onFinish: Ct,
    isRunning: zt,
    progressStart: lm,
    progressStep: cm,
    progressEnd: dm
  };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Yv = (e) => {
  if (!e)
    return { arrowWidth: 0, arrowHeight: 0 };
  const { width: t, height: n } = e.getBoundingClientRect();
  return { arrowWidth: t, arrowHeight: n };
}, df = (e, t, n) => {
  const o = t.getBoundingClientRect(), i = o.height;
  let r = o.width;
  return e === "cover" && n && (r = n.getBoundingClientRect().width), {
    contentWidth: r,
    contentHeight: i
  };
}, Gv = (e, t, n, o) => {
  let i = [];
  const s = Hn(o).querySelector(".popover-content");
  switch (t) {
    case "hover":
      i = [
        {
          /**
           * Do not use mouseover here
           * as this will causes the event to
           * be dispatched on each underlying
           * element rather than on the popover
           * content as a whole.
           */
          eventName: "mouseenter",
          callback: (a) => {
            document.elementFromPoint(a.clientX, a.clientY) !== e && n.dismiss(void 0, void 0, !1);
          }
        }
      ];
      break;
    case "context-menu":
    case "click":
    default:
      i = [
        {
          eventName: "click",
          callback: (a) => {
            if (a.target.closest("[data-ion-popover-trigger]") === e) {
              a.stopPropagation();
              return;
            }
            n.dismiss(void 0, void 0, !1);
          }
        }
      ];
      break;
  }
  return i.forEach(({ eventName: a, callback: l }) => s.addEventListener(a, l)), () => {
    i.forEach(({ eventName: a, callback: l }) => s.removeEventListener(a, l));
  };
}, qv = (e, t, n) => {
  let o = [];
  switch (t) {
    case "hover":
      let i;
      o = [
        {
          eventName: "mouseenter",
          callback: async (r) => {
            r.stopPropagation(), i && clearTimeout(i), i = setTimeout(() => {
              Fe(() => {
                n.presentFromTrigger(r), i = void 0;
              });
            }, 100);
          }
        },
        {
          eventName: "mouseleave",
          callback: (r) => {
            i && clearTimeout(i);
            const s = r.relatedTarget;
            s && s.closest("ion-popover") !== n && n.dismiss(void 0, void 0, !1);
          }
        },
        {
          /**
           * stopPropagation here prevents the popover
           * from dismissing when dismiss-on-select="true".
           */
          eventName: "click",
          callback: (r) => r.stopPropagation()
        },
        {
          eventName: "ionPopoverActivateTrigger",
          callback: (r) => n.presentFromTrigger(r, !0)
        }
      ];
      break;
    case "context-menu":
      o = [
        {
          eventName: "contextmenu",
          callback: (r) => {
            r.preventDefault(), n.presentFromTrigger(r);
          }
        },
        {
          eventName: "click",
          callback: (r) => r.stopPropagation()
        },
        {
          eventName: "ionPopoverActivateTrigger",
          callback: (r) => n.presentFromTrigger(r, !0)
        }
      ];
      break;
    case "click":
    default:
      o = [
        {
          /**
           * Do not do a stopPropagation() here
           * because if you had two click triggers
           * then clicking the first trigger and then
           * clicking the second trigger would not cause
           * the first popover to dismiss.
           */
          eventName: "click",
          callback: (r) => n.presentFromTrigger(r)
        },
        {
          eventName: "ionPopoverActivateTrigger",
          callback: (r) => n.presentFromTrigger(r, !0)
        }
      ];
      break;
  }
  return o.forEach(({ eventName: i, callback: r }) => e.addEventListener(i, r)), e.setAttribute("data-ion-popover-trigger", "true"), () => {
    o.forEach(({ eventName: i, callback: r }) => e.removeEventListener(i, r)), e.removeAttribute("data-ion-popover-trigger");
  };
}, uf = (e, t) => !t || t.tagName !== "ION-ITEM" ? -1 : e.findIndex((n) => n === t), Kv = (e, t) => {
  const n = uf(e, t);
  return e[n + 1];
}, Xv = (e, t) => {
  const n = uf(e, t);
  return e[n - 1];
}, di = (e) => {
  const n = Hn(e).querySelector("button");
  n && Fe(() => n.focus());
}, Zv = (e) => e.hasAttribute("data-ion-popover-trigger"), Jv = (e) => {
  const t = async (n) => {
    var o;
    const i = document.activeElement;
    let r = [];
    const s = (o = n.target) === null || o === void 0 ? void 0 : o.tagName;
    if (!(s !== "ION-POPOVER" && s !== "ION-ITEM")) {
      try {
        r = Array.from(e.querySelectorAll("ion-item:not(ion-popover ion-popover *):not([disabled])"));
      } catch {
      }
      switch (n.key) {
        case "ArrowLeft":
          await e.getParentPopover() && e.dismiss(void 0, void 0, !1);
          break;
        case "ArrowDown":
          n.preventDefault();
          const l = Kv(r, i);
          l !== void 0 && di(l);
          break;
        case "ArrowUp":
          n.preventDefault();
          const c = Xv(r, i);
          c !== void 0 && di(c);
          break;
        case "Home":
          n.preventDefault();
          const d = r[0];
          d !== void 0 && di(d);
          break;
        case "End":
          n.preventDefault();
          const u = r[r.length - 1];
          u !== void 0 && di(u);
          break;
        case "ArrowRight":
        case " ":
        case "Enter":
          if (i && Zv(i)) {
            const f = new CustomEvent("ionPopoverActivateTrigger");
            i.dispatchEvent(f);
          }
          break;
      }
    }
  };
  return e.addEventListener("keydown", t), () => e.removeEventListener("keydown", t);
}, ff = (e, t, n, o, i, r, s, a, l, c, d) => {
  var u;
  let f = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  };
  switch (r) {
    case "event":
      if (!d)
        return l;
      const A = d;
      f = {
        top: A.clientY,
        left: A.clientX,
        width: 1,
        height: 1
      };
      break;
    case "trigger":
    default:
      const b = d, y = c || ((u = b == null ? void 0 : b.detail) === null || u === void 0 ? void 0 : u.ionShadowTarget) || (b == null ? void 0 : b.target);
      if (!y)
        return l;
      const L = y.getBoundingClientRect();
      f = {
        top: L.top,
        left: L.left,
        width: L.width,
        height: L.height
      };
      break;
  }
  const g = ty(s, f, t, n, o, i, e), E = ny(a, s, f, t, n), k = g.top + E.top, S = g.left + E.left, { arrowTop: m, arrowLeft: v } = ey(s, o, i, k, S, t, n, e), { originX: I, originY: w } = Qv(s, a, e);
  return { top: k, left: S, referenceCoordinates: f, arrowTop: m, arrowLeft: v, originX: I, originY: w };
}, Qv = (e, t, n) => {
  switch (e) {
    case "top":
      return { originX: tc(t), originY: "bottom" };
    case "bottom":
      return { originX: tc(t), originY: "top" };
    case "left":
      return { originX: "right", originY: ui(t) };
    case "right":
      return { originX: "left", originY: ui(t) };
    case "start":
      return { originX: n ? "left" : "right", originY: ui(t) };
    case "end":
      return { originX: n ? "right" : "left", originY: ui(t) };
  }
}, tc = (e) => {
  switch (e) {
    case "start":
      return "left";
    case "center":
      return "center";
    case "end":
      return "right";
  }
}, ui = (e) => {
  switch (e) {
    case "start":
      return "top";
    case "center":
      return "center";
    case "end":
      return "bottom";
  }
}, ey = (e, t, n, o, i, r, s, a) => {
  const l = {
    arrowTop: o + s / 2 - t / 2,
    arrowLeft: i + r - t / 2
  }, c = { arrowTop: o + s / 2 - t / 2, arrowLeft: i - t * 1.5 };
  switch (e) {
    case "top":
      return { arrowTop: o + s, arrowLeft: i + r / 2 - t / 2 };
    case "bottom":
      return { arrowTop: o - n, arrowLeft: i + r / 2 - t / 2 };
    case "left":
      return l;
    case "right":
      return c;
    case "start":
      return a ? c : l;
    case "end":
      return a ? l : c;
    default:
      return { arrowTop: 0, arrowLeft: 0 };
  }
}, ty = (e, t, n, o, i, r, s) => {
  const a = {
    top: t.top,
    left: t.left - n - i
  }, l = {
    top: t.top,
    left: t.left + t.width + i
  };
  switch (e) {
    case "top":
      return {
        top: t.top - o - r,
        left: t.left
      };
    case "right":
      return l;
    case "bottom":
      return {
        top: t.top + t.height + r,
        left: t.left
      };
    case "left":
      return a;
    case "start":
      return s ? l : a;
    case "end":
      return s ? a : l;
  }
}, ny = (e, t, n, o, i) => {
  switch (e) {
    case "center":
      return iy(t, n, o, i);
    case "end":
      return oy(t, n, o, i);
    case "start":
    default:
      return { top: 0, left: 0 };
  }
}, oy = (e, t, n, o) => {
  switch (e) {
    case "start":
    case "end":
    case "left":
    case "right":
      return {
        top: -(o - t.height),
        left: 0
      };
    case "top":
    case "bottom":
    default:
      return {
        top: 0,
        left: -(n - t.width)
      };
  }
}, iy = (e, t, n, o) => {
  switch (e) {
    case "start":
    case "end":
    case "left":
    case "right":
      return {
        top: -(o / 2 - t.height / 2),
        left: 0
      };
    case "top":
    case "bottom":
    default:
      return {
        top: 0,
        left: -(n / 2 - t.width / 2)
      };
  }
}, hf = (e, t, n, o, i, r, s, a, l, c, d, u, f = 0, g = 0, E = 0) => {
  let k = f;
  const S = g;
  let m = n, v = t, I, w = c, A = d, b = !1, y = !1;
  const L = u ? u.top + u.height : r / 2 - a / 2, C = u ? u.height : 0;
  let D = !1;
  return m < o + l ? (m = o, b = !0, w = "left") : s + o + m + l > i && (y = !0, m = i - s - o, w = "right"), L + C + a > r && (e === "top" || e === "bottom") && (L - a > 0 ? (v = Math.max(12, L - a - C - (E - 1)), k = v + a, A = "bottom", D = !0) : I = o), {
    top: v,
    left: m,
    bottom: I,
    originX: w,
    originY: A,
    checkSafeAreaLeft: b,
    checkSafeAreaRight: y,
    arrowTop: k,
    arrowLeft: S,
    addPopoverBottomClass: D
  };
}, ry = (e, t = !1, n, o) => !(!n && !o || e !== "top" && e !== "bottom" && t), sy = 5, ay = (e, t) => {
  var n;
  const { event: o, size: i, trigger: r, reference: s, side: a, align: l } = t, c = e.ownerDocument, d = c.dir === "rtl", u = c.defaultView.innerWidth, f = c.defaultView.innerHeight, g = Hn(e), E = g.querySelector(".popover-content"), k = g.querySelector(".popover-arrow"), S = r || ((n = o == null ? void 0 : o.detail) === null || n === void 0 ? void 0 : n.ionShadowTarget) || (o == null ? void 0 : o.target), { contentWidth: m, contentHeight: v } = df(i, E, S), { arrowWidth: I, arrowHeight: w } = Yv(k), A = {
    top: f / 2 - v / 2,
    left: u / 2 - m / 2,
    originX: d ? "right" : "left",
    originY: "top"
  }, b = ff(d, m, v, I, w, s, a, l, A, r, o), y = i === "cover" ? 0 : sy, L = i === "cover" ? 0 : 25, { originX: C, originY: D, top: N, left: z, bottom: oe, checkSafeAreaLeft: ke, checkSafeAreaRight: Ye, arrowTop: q, arrowLeft: K, addPopoverBottomClass: ut } = hf(a, b.top, b.left, y, u, f, m, v, L, b.originX, b.originY, b.referenceCoordinates, b.arrowTop, b.arrowLeft, w), Le = Y(), et = Y(), ft = Y();
  return et.addElement(g.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), ft.addElement(g.querySelector(".popover-wrapper")).fromTo("opacity", 0.01, 1), Le.easing("ease").duration(100).beforeAddWrite(() => {
    i === "cover" && e.style.setProperty("--width", `${m}px`), ut && e.classList.add("popover-bottom"), oe !== void 0 && E.style.setProperty("bottom", `${oe}px`);
    const St = " + var(--ion-safe-area-left, 0)", Te = " - var(--ion-safe-area-right, 0)";
    let tt = `${z}px`;
    if (ke && (tt = `${z}px${St}`), Ye && (tt = `${z}px${Te}`), E.style.setProperty("top", `calc(${N}px + var(--offset-y, 0))`), E.style.setProperty("left", `calc(${tt} + var(--offset-x, 0))`), E.style.setProperty("transform-origin", `${D} ${C}`), k !== null) {
      const Ie = b.top !== N || b.left !== z;
      ry(a, Ie, o, r) ? (k.style.setProperty("top", `calc(${q}px + var(--offset-y, 0))`), k.style.setProperty("left", `calc(${K}px + var(--offset-x, 0))`)) : k.style.setProperty("display", "none");
    }
  }).addAnimation([et, ft]);
}, ly = (e) => {
  const t = Hn(e), n = t.querySelector(".popover-content"), o = t.querySelector(".popover-arrow"), i = Y(), r = Y(), s = Y();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), s.addElement(t.querySelector(".popover-wrapper")).fromTo("opacity", 0.99, 0), i.easing("ease").afterAddWrite(() => {
    e.style.removeProperty("--width"), e.classList.remove("popover-bottom"), n.style.removeProperty("top"), n.style.removeProperty("left"), n.style.removeProperty("bottom"), n.style.removeProperty("transform-origin"), o && (o.style.removeProperty("top"), o.style.removeProperty("left"), o.style.removeProperty("display"));
  }).duration(300).addAnimation([r, s]);
}, cy = 12, dy = (e, t) => {
  var n;
  const { event: o, size: i, trigger: r, reference: s, side: a, align: l } = t, c = e.ownerDocument, d = c.dir === "rtl", u = c.defaultView.innerWidth, f = c.defaultView.innerHeight, g = Hn(e), E = g.querySelector(".popover-content"), k = r || ((n = o == null ? void 0 : o.detail) === null || n === void 0 ? void 0 : n.ionShadowTarget) || (o == null ? void 0 : o.target), { contentWidth: S, contentHeight: m } = df(i, E, k), v = {
    top: f / 2 - m / 2,
    left: u / 2 - S / 2,
    originX: d ? "right" : "left",
    originY: "top"
  }, I = ff(d, S, m, 0, 0, s, a, l, v, r, o), w = i === "cover" ? 0 : cy, { originX: A, originY: b, top: y, left: L, bottom: C } = hf(a, I.top, I.left, w, u, f, S, m, 0, I.originX, I.originY, I.referenceCoordinates), D = Y(), N = Y(), z = Y(), oe = Y(), ke = Y();
  return N.addElement(g.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), z.addElement(g.querySelector(".popover-wrapper")).duration(150).fromTo("opacity", 0.01, 1), oe.addElement(E).beforeStyles({
    top: `calc(${y}px + var(--offset-y, 0px))`,
    left: `calc(${L}px + var(--offset-x, 0px))`,
    "transform-origin": `${b} ${A}`
  }).beforeAddWrite(() => {
    C !== void 0 && E.style.setProperty("bottom", `${C}px`);
  }).fromTo("transform", "scale(0.8)", "scale(1)"), ke.addElement(g.querySelector(".popover-viewport")).fromTo("opacity", 0.01, 1), D.easing("cubic-bezier(0.36,0.66,0.04,1)").duration(300).beforeAddWrite(() => {
    i === "cover" && e.style.setProperty("--width", `${S}px`), b === "bottom" && e.classList.add("popover-bottom");
  }).addAnimation([N, z, oe, ke]);
}, uy = (e) => {
  const t = Hn(e), n = t.querySelector(".popover-content"), o = Y(), i = Y(), r = Y();
  return i.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), r.addElement(t.querySelector(".popover-wrapper")).fromTo("opacity", 0.99, 0), o.easing("ease").afterAddWrite(() => {
    e.style.removeProperty("--width"), e.classList.remove("popover-bottom"), n.style.removeProperty("top"), n.style.removeProperty("left"), n.style.removeProperty("bottom"), n.style.removeProperty("transform-origin");
  }).duration(150).addAnimation([i, r]);
}, fy = ':host{--background:var(--ion-background-color, #fff);--min-width:0;--min-height:0;--max-width:auto;--height:auto;--offset-x:0px;--offset-y:0px;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:fixed;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;color:var(--ion-text-color, #000);z-index:1001}:host(.popover-nested){pointer-events:none}:host(.popover-nested) .popover-wrapper{pointer-events:auto}:host(.overlay-hidden){display:none}.popover-wrapper{opacity:0;z-index:10}.popover-content{display:-ms-flexbox;display:flex;position:absolute;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);overflow:auto;z-index:10}.popover-viewport{--ion-safe-area-top:0px;--ion-safe-area-right:0px;--ion-safe-area-bottom:0px;--ion-safe-area-left:0px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden}:host(.popover-nested.popover-side-left){--offset-x:5px}:host(.popover-nested.popover-side-right){--offset-x:-5px}:host(.popover-nested.popover-side-start){--offset-x:5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-start),:host-context([dir=rtl]).popover-nested.popover-side-start{--offset-x:-5px}:host(.popover-nested.popover-side-end){--offset-x:-5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-end),:host-context([dir=rtl]).popover-nested.popover-side-end{--offset-x:5px}:host{--width:200px;--max-height:90%;--box-shadow:none;--backdrop-opacity:var(--ion-backdrop-opacity, 0.08)}:host(.popover-desktop){--box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.12)}.popover-content{border-radius:10px}:host(.popover-desktop) .popover-content{border:0.5px solid var(--ion-color-step-100, #e6e6e6)}.popover-arrow{display:block;position:absolute;width:20px;height:10px;overflow:hidden}.popover-arrow::after{left:3px;top:3px;border-radius:3px;position:absolute;width:14px;height:14px;-webkit-transform:rotate(45deg);transform:rotate(45deg);background:var(--background);content:"";z-index:10}[dir=rtl] .popover-arrow::after,:host-context([dir=rtl]) .popover-arrow::after{left:unset;right:unset;right:3px}:host(.popover-bottom) .popover-arrow{top:auto;bottom:-10px}:host(.popover-bottom) .popover-arrow::after{top:-6px}:host(.popover-side-left) .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}:host(.popover-side-right) .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}:host(.popover-side-top) .popover-arrow{-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host(.popover-side-start) .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}:host-context([dir=rtl]):host(.popover-side-start) .popover-arrow,:host-context([dir=rtl]).popover-side-start .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}:host(.popover-side-end) .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}:host-context([dir=rtl]):host(.popover-side-end) .popover-arrow,:host-context([dir=rtl]).popover-side-end .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.popover-translucent) .popover-content,:host(.popover-translucent) .popover-arrow::after{background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8);-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}}', hy = ":host{--background:var(--ion-background-color, #fff);--min-width:0;--min-height:0;--max-width:auto;--height:auto;--offset-x:0px;--offset-y:0px;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:fixed;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;color:var(--ion-text-color, #000);z-index:1001}:host(.popover-nested){pointer-events:none}:host(.popover-nested) .popover-wrapper{pointer-events:auto}:host(.overlay-hidden){display:none}.popover-wrapper{opacity:0;z-index:10}.popover-content{display:-ms-flexbox;display:flex;position:absolute;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);overflow:auto;z-index:10}.popover-viewport{--ion-safe-area-top:0px;--ion-safe-area-right:0px;--ion-safe-area-bottom:0px;--ion-safe-area-left:0px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden}:host(.popover-nested.popover-side-left){--offset-x:5px}:host(.popover-nested.popover-side-right){--offset-x:-5px}:host(.popover-nested.popover-side-start){--offset-x:5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-start),:host-context([dir=rtl]).popover-nested.popover-side-start{--offset-x:-5px}:host(.popover-nested.popover-side-end){--offset-x:-5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-end),:host-context([dir=rtl]).popover-nested.popover-side-end{--offset-x:5px}:host{--width:250px;--max-height:90%;--box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);--backdrop-opacity:var(--ion-backdrop-opacity, 0.32)}.popover-content{border-radius:4px;-webkit-transform-origin:left top;transform-origin:left top}[dir=rtl] .popover-content,:host-context([dir=rtl]) .popover-content{-webkit-transform-origin:right top;transform-origin:right top}.popover-viewport{-webkit-transition-delay:100ms;transition-delay:100ms}", my = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.didPresent = G(this, "ionPopoverDidPresent", 7), this.willPresent = G(this, "ionPopoverWillPresent", 7), this.willDismiss = G(this, "ionPopoverWillDismiss", 7), this.didDismiss = G(this, "ionPopoverDidDismiss", 7), this.didPresentShorthand = G(this, "didPresent", 7), this.willPresentShorthand = G(this, "willPresent", 7), this.willDismissShorthand = G(this, "willDismiss", 7), this.didDismissShorthand = G(this, "didDismiss", 7), this.ionMount = G(this, "ionMount", 7), this.parentPopover = null, this.popoverIndex = gy++, this.coreDelegate = wv(), this.inline = !1, this.focusDescendantOnPresent = !1, this.presented = !1, this.hasController = !1, this.keyboardClose = !0, this.backdropDismiss = !0, this.showBackdrop = !0, this.translucent = !1, this.animated = !0, this.triggerAction = "click", this.size = "auto", this.dismissOnSelect = !1, this.reference = "trigger", this.side = "bottom", this.arrow = !0, this.isOpen = !1, this.keyboardEvents = !1, this.keepContentsMounted = !1, this.onBackdropTap = () => {
      this.dismiss(void 0, lo);
    }, this.onLifecycle = (e) => {
      const t = this.usersElement, n = py[e.type];
      if (t && n) {
        const o = new CustomEvent(n, {
          bubbles: !1,
          cancelable: !1,
          detail: e.detail
        });
        t.dispatchEvent(o);
      }
    }, this.configureTriggerInteraction = () => {
      const { trigger: e, triggerAction: t, el: n, destroyTriggerInteraction: o } = this;
      if (o && o(), e === void 0)
        return;
      const i = this.triggerEl = e !== void 0 ? document.getElementById(e) : null;
      if (!i) {
        fs(`A trigger element with the ID "${e}" was not found in the DOM. The trigger element must be in the DOM when the "trigger" property is set on ion-popover.`, this.el);
        return;
      }
      this.destroyTriggerInteraction = qv(i, t, n);
    }, this.configureKeyboardInteraction = () => {
      const { destroyKeyboardInteraction: e, el: t } = this;
      e && e(), this.destroyKeyboardInteraction = Jv(t);
    }, this.configureDismissInteraction = () => {
      const { destroyDismissInteraction: e, parentPopover: t, triggerAction: n, triggerEl: o, el: i } = this;
      !t || !o || (e && e(), this.destroyDismissInteraction = Gv(o, n, i, t));
    };
  }
  onTriggerChange() {
    this.configureTriggerInteraction();
  }
  onIsOpenChange(e, t) {
    e === !0 && t === !1 ? this.present() : e === !1 && t === !0 && this.dismiss();
  }
  connectedCallback() {
    const { configureTriggerInteraction: e, el: t } = this;
    wa(t), e();
  }
  disconnectedCallback() {
    const { destroyTriggerInteraction: e } = this;
    e && e();
  }
  componentWillLoad() {
    this.popoverId = this.el.hasAttribute("id") ? this.el.getAttribute("id") : `ion-popover-${this.popoverIndex}`, this.parentPopover = this.el.closest(`ion-popover:not(#${this.popoverId})`), this.alignment === void 0 && (this.alignment = te(this) === "ios" ? "center" : "start");
  }
  componentDidLoad() {
    const { parentPopover: e, isOpen: t } = this;
    t === !0 && Fe(() => this.present()), e && ua(e, "ionPopoverWillDismiss", () => {
      this.dismiss(void 0, void 0, !1);
    });
  }
  /**
   * When opening a popover from a trigger, we should not be
   * modifying the `event` prop from inside the component.
   * Additionally, when pressing the "Right" arrow key, we need
   * to shift focus to the first descendant in the newly presented
   * popover.
   *
   * @internal
   */
  async presentFromTrigger(e, t = !1) {
    this.focusDescendantOnPresent = t, await this.present(e), this.focusDescendantOnPresent = !1;
  }
  /**
   * Determines whether or not an overlay
   * is being used inline or via a controller/JS
   * and returns the correct delegate.
   * By default, subsequent calls to getDelegate
   * will use a cached version of the delegate.
   * This is useful for calling dismiss after
   * present so that the correct delegate is given.
   */
  getDelegate(e = !1) {
    if (this.workingDelegate && !e)
      return {
        delegate: this.workingDelegate,
        inline: this.inline
      };
    const t = this.el.parentNode, n = this.inline = t !== null && !this.hasController, o = this.workingDelegate = n ? this.delegate || this.coreDelegate : this.delegate;
    return { inline: n, delegate: o };
  }
  /**
   * Present the popover overlay after it has been created.
   * Developers can pass a mouse, touch, or pointer event
   * to position the popover relative to where that event
   * was dispatched.
   */
  async present(e) {
    if (this.presented)
      return;
    this.currentTransition !== void 0 && await this.currentTransition;
    const { inline: t, delegate: n } = this.getDelegate(!0);
    return this.usersElement = await vv(n, this.el, this.component, ["popover-viewport"], this.componentProps, t), await cf(this.usersElement), this.keyboardEvents || this.configureKeyboardInteraction(), this.configureDismissInteraction(), this.ionMount.emit(), new Promise((o) => {
      Fe(() => {
        Fe(async () => {
          this.currentTransition = ka(this, "popoverEnter", ay, dy, {
            event: e || this.event,
            size: this.size,
            trigger: this.triggerEl,
            reference: this.reference,
            side: this.side,
            align: this.alignment
          }), await this.currentTransition, this.currentTransition = void 0, this.focusDescendantOnPresent && ps(this.el, this.el), o();
        });
      });
    });
  }
  /**
   * Dismiss the popover overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the popover. For example, 'cancel' or 'backdrop'.
   * @param dismissParentPopover If `true`, dismissing this popover will also dismiss
   * a parent popover if this popover is nested. Defaults to `true`.
   */
  async dismiss(e, t, n = !0) {
    this.currentTransition !== void 0 && await this.currentTransition;
    const { destroyKeyboardInteraction: o, destroyDismissInteraction: i } = this;
    n && this.parentPopover && this.parentPopover.dismiss(e, t, n), this.currentTransition = xa(this, e, t, "popoverLeave", ly, uy, this.event);
    const r = await this.currentTransition;
    if (r) {
      o && (o(), this.destroyKeyboardInteraction = void 0), i && (i(), this.destroyDismissInteraction = void 0);
      const { delegate: s } = this.getDelegate();
      await yv(s, this.usersElement);
    }
    return this.currentTransition = void 0, r;
  }
  /**
   * @internal
   */
  async getParentPopover() {
    return this.parentPopover;
  }
  /**
   * Returns a promise that resolves when the popover did dismiss.
   */
  onDidDismiss() {
    return ao(this.el, "ionPopoverDidDismiss");
  }
  /**
   * Returns a promise that resolves when the popover will dismiss.
   */
  onWillDismiss() {
    return ao(this.el, "ionPopoverWillDismiss");
  }
  render() {
    const e = te(this), { onLifecycle: t, popoverId: n, parentPopover: o, dismissOnSelect: i, side: r, arrow: s, htmlAttributes: a } = this, l = Fb("desktop"), c = s && !o;
    return x(ae, Object.assign({ "aria-modal": "true", "no-router": !0, tabindex: "-1" }, a, { style: {
      zIndex: `${2e4 + this.overlayIndex}`
    }, id: n, class: Object.assign(Object.assign({}, Et(this.cssClass)), { [e]: !0, "popover-translucent": this.translucent, "overlay-hidden": !0, "popover-desktop": l, [`popover-side-${r}`]: !0, "popover-nested": !!o }), onIonPopoverDidPresent: t, onIonPopoverWillPresent: t, onIonPopoverWillDismiss: t, onIonPopoverDidDismiss: t, onIonBackdropTap: this.onBackdropTap }), !o && x("ion-backdrop", { tappable: this.backdropDismiss, visible: this.showBackdrop, part: "backdrop" }), x("div", { class: "popover-wrapper ion-overlay-wrapper", onClick: i ? () => this.dismiss() : void 0 }, c && x("div", { class: "popover-arrow", part: "arrow" }), x("div", { class: "popover-content", part: "content" }, x("slot", null))));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      trigger: ["onTriggerChange"],
      triggerAction: ["onTriggerChange"],
      isOpen: ["onIsOpenChange"]
    };
  }
  static get style() {
    return {
      ios: fy,
      md: hy
    };
  }
}, [33, "ion-popover", {
  hasController: [4, "has-controller"],
  delegate: [16],
  overlayIndex: [2, "overlay-index"],
  enterAnimation: [16],
  leaveAnimation: [16],
  component: [1],
  componentProps: [16],
  keyboardClose: [4, "keyboard-close"],
  cssClass: [1, "css-class"],
  backdropDismiss: [4, "backdrop-dismiss"],
  event: [8],
  showBackdrop: [4, "show-backdrop"],
  translucent: [4],
  animated: [4],
  htmlAttributes: [16],
  triggerAction: [1, "trigger-action"],
  trigger: [1],
  size: [1],
  dismissOnSelect: [4, "dismiss-on-select"],
  reference: [1],
  side: [1],
  alignment: [1025],
  arrow: [4],
  isOpen: [4, "is-open"],
  keyboardEvents: [4, "keyboard-events"],
  keepContentsMounted: [4, "keep-contents-mounted"],
  presented: [32],
  presentFromTrigger: [64],
  present: [64],
  dismiss: [64],
  getParentPopover: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}]), py = {
  ionPopoverDidPresent: "ionViewDidEnter",
  ionPopoverWillPresent: "ionViewWillEnter",
  ionPopoverWillDismiss: "ionViewWillLeave",
  ionPopoverDidDismiss: "ionViewDidLeave"
};
let gy = 0;
function by() {
  if (typeof customElements > "u")
    return;
  ["ion-popover", "ion-backdrop"].forEach((t) => {
    switch (t) {
      case "ion-popover":
        customElements.get(t) || customElements.define(t, my);
        break;
      case "ion-backdrop":
        customElements.get(t) || Qi();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const vy = (e) => {
  let t, n, o;
  const i = () => {
    t = () => {
      o = !0, e && e(!0);
    }, n = () => {
      o = !1, e && e(!1);
    }, qe == null || qe.addEventListener("keyboardWillShow", t), qe == null || qe.addEventListener("keyboardWillHide", n);
  }, r = () => {
    qe == null || qe.removeEventListener("keyboardWillShow", t), qe == null || qe.removeEventListener("keyboardWillHide", n), t = n = void 0;
  }, s = () => o;
  return i(), { init: i, destroy: r, isKeyboardVisible: s };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const yy = (e) => {
  try {
    if (e instanceof _y)
      return e.value;
    if (!wy() || typeof e != "string" || e === "")
      return e;
    if (e.includes("onload="))
      return "";
    const t = document.createDocumentFragment(), n = document.createElement("div");
    t.appendChild(n), n.innerHTML = e, xy.forEach((s) => {
      const a = t.querySelectorAll(s);
      for (let l = a.length - 1; l >= 0; l--) {
        const c = a[l];
        c.parentNode ? c.parentNode.removeChild(c) : t.removeChild(c);
        const d = bs(c);
        for (let u = 0; u < d.length; u++)
          gs(d[u]);
      }
    });
    const o = bs(t);
    for (let s = 0; s < o.length; s++)
      gs(o[s]);
    const i = document.createElement("div");
    i.appendChild(t);
    const r = i.querySelector("div");
    return r !== null ? r.innerHTML : i.innerHTML;
  } catch (t) {
    return console.error(t), "";
  }
}, gs = (e) => {
  if (e.nodeType && e.nodeType !== 1)
    return;
  if (typeof NamedNodeMap < "u" && !(e.attributes instanceof NamedNodeMap)) {
    e.remove();
    return;
  }
  for (let n = e.attributes.length - 1; n >= 0; n--) {
    const o = e.attributes.item(n), i = o.name;
    if (!ky.includes(i.toLowerCase())) {
      e.removeAttribute(i);
      continue;
    }
    const r = o.value, s = e[i];
    (r != null && r.toLowerCase().includes("javascript:") || s != null && s.toLowerCase().includes("javascript:")) && e.removeAttribute(i);
  }
  const t = bs(e);
  for (let n = 0; n < t.length; n++)
    gs(t[n]);
}, bs = (e) => e.children != null ? e.children : e.childNodes, wy = () => {
  var e;
  const t = window, n = (e = t == null ? void 0 : t.Ionic) === null || e === void 0 ? void 0 : e.config;
  return n ? n.get ? n.get("sanitizerEnabled", !0) : n.sanitizerEnabled === !0 || n.sanitizerEnabled === void 0 : !0;
}, ky = ["class", "id", "href", "src", "name", "slot"], xy = ["script", "style", "iframe", "meta", "link", "object", "embed"];
class _y {
  constructor(t) {
    this.value = t;
  }
}
const Ey = !0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Ty = ga;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Iy = ba;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Sy = "ion-list{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:block;contain:content;list-style-type:none}ion-list.list-inset{-webkit-transform:translateZ(0);transform:translateZ(0);overflow:hidden}.list-ios{background:var(--ion-item-background, var(--ion-background-color, #fff))}.list-ios.list-inset{margin-left:16px;margin-right:16px;margin-top:16px;margin-bottom:16px;border-radius:10px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.list-ios.list-inset{margin-left:unset;margin-right:unset;-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:16px;margin-inline-end:16px}}.list-ios.list-inset ion-item:last-child{--border-width:0;--inner-border-width:0}.list-ios.list-inset+ion-list.list-inset{margin-top:0}.list-ios-lines-none .item-lines-default{--inner-border-width:0px;--border-width:0px}.list-ios-lines-full .item-lines-default{--inner-border-width:0px;--border-width:0 0 0.55px 0}.list-ios-lines-inset .item-lines-default{--inner-border-width:0 0 0.55px 0;--border-width:0px}ion-card .list-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}", Oy = "ion-list{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:block;contain:content;list-style-type:none}ion-list.list-inset{-webkit-transform:translateZ(0);transform:translateZ(0);overflow:hidden}.list-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:8px;padding-bottom:8px;background:var(--ion-item-background, var(--ion-background-color, #fff))}.list-md>.input:last-child::after{left:0}[dir=rtl] .list-md>.input:last-child::after,:host-context([dir=rtl]) .list-md>.input:last-child::after{left:unset;right:unset;right:0}.list-md.list-inset{margin-left:16px;margin-right:16px;margin-top:16px;margin-bottom:16px;border-radius:2px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.list-md.list-inset{margin-left:unset;margin-right:unset;-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:16px;margin-inline-end:16px}}.list-md.list-inset ion-item:first-child{--border-radius:2px 2px 0 0}.list-md.list-inset ion-item:last-child{--border-radius:0 0 2px, 2px;--border-width:0;--inner-border-width:0}.list-md.list-inset+ion-list.list-inset{margin-top:0}.list-md-lines-none .item-lines-default{--inner-border-width:0px;--border-width:0px}.list-md-lines-full .item-lines-default{--inner-border-width:0px;--border-width:0 0 1px 0}.list-md-lines-inset .item-lines-default{--inner-border-width:0 0 1px 0;--border-width:0px}ion-card .list-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}", Cy = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.inset = !1;
  }
  /**
   * If `ion-item-sliding` are used inside the list, this method closes
   * any open sliding item.
   *
   * Returns `true` if an actual `ion-item-sliding` is closed.
   */
  async closeSlidingItems() {
    const e = this.el.querySelector("ion-item-sliding");
    return e != null && e.closeOpened ? e.closeOpened() : !1;
  }
  render() {
    const e = te(this), { lines: t, inset: n } = this;
    return x(ae, { role: "list", class: {
      [e]: !0,
      // Used internally for styling
      [`list-${e}`]: !0,
      "list-inset": n,
      [`list-lines-${t}`]: t !== void 0,
      [`list-${e}-lines-${t}`]: t !== void 0
    } });
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: Sy,
      md: Oy
    };
  }
}, [32, "ion-list", {
  lines: [1],
  inset: [4],
  closeSlidingItems: [64]
}]);
function mf() {
  if (typeof customElements > "u")
    return;
  ["ion-list"].forEach((t) => {
    switch (t) {
      case "ion-list":
        customElements.get(t) || customElements.define(t, Cy);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Ay = ":host{--border-style:solid;--border-width:0;--inner-border-width:0;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;min-height:40px;border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);color:var(--color);overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}.list-header-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-label){-ms-flex:1 1 auto;flex:1 1 auto}:host(.list-header-lines-inset),:host(.list-header-lines-none){--border-width:0}:host(.list-header-lines-full),:host(.list-header-lines-none){--inner-border-width:0}:host{--background:transparent;--color:var(--ion-color-step-850, #262626);--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-250, #c8c7cc)));padding-left:calc(var(--ion-safe-area-left, 0px) + 20px);position:relative;-ms-flex-align:end;align-items:flex-end;font-size:22px;font-weight:700;letter-spacing:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;-webkit-padding-start:calc(var(--ion-safe-area-left, 0px) + 20px);padding-inline-start:calc(var(--ion-safe-area-left, 0px) + 20px)}}::slotted(ion-button),::slotted(ion-label){margin-top:29px;margin-bottom:6px}::slotted(ion-button){margin-left:3px;margin-right:3px;height:1.4em}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){::slotted(ion-button){margin-left:unset;margin-right:unset;-webkit-margin-start:3px;margin-inline-start:3px;-webkit-margin-end:3px;margin-inline-end:3px}}:host(.list-header-lines-full){--border-width:0 0 0.55px 0}:host(.list-header-lines-inset){--inner-border-width:0 0 0.55px 0}", Dy = ":host{--border-style:solid;--border-width:0;--inner-border-width:0;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;min-height:40px;border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);color:var(--color);overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}.list-header-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-label){-ms-flex:1 1 auto;flex:1 1 auto}:host(.list-header-lines-inset),:host(.list-header-lines-none){--border-width:0}:host(.list-header-lines-full),:host(.list-header-lines-none){--inner-border-width:0}:host{--background:transparent;--color:var(--ion-text-color, #000);--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))));padding-left:calc(var(--ion-safe-area-left, 0) + 16px);min-height:45px;font-size:14px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;-webkit-padding-start:calc(var(--ion-safe-area-left, 0) + 16px);padding-inline-start:calc(var(--ion-safe-area-left, 0) + 16px)}}:host(.list-header-lines-full){--border-width:0 0 1px 0}:host(.list-header-lines-inset){--inner-border-width:0 0 1px 0}", $y = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  render() {
    const { lines: e } = this, t = te(this);
    return x(ae, { class: dt(this.color, {
      [t]: !0,
      [`list-header-lines-${e}`]: e !== void 0
    }) }, x("div", { class: "list-header-inner" }, x("slot", null)));
  }
  static get style() {
    return {
      ios: Ay,
      md: Dy
    };
  }
}, [33, "ion-list-header", {
  color: [513],
  lines: [1]
}]);
function pf() {
  if (typeof customElements > "u")
    return;
  ["ion-list-header"].forEach((t) => {
    switch (t) {
      case "ion-list-header":
        customElements.get(t) || customElements.define(t, $y);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Ny = ':host{--inner-border-radius:50%;display:inline-block;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(.radio-disabled){pointer-events:none}.radio-icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;contain:layout size style}.radio-icon,.radio-inner{-webkit-box-sizing:border-box;box-sizing:border-box}label{left:0;top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}[dir=rtl] label,:host-context([dir=rtl]) label{left:unset;right:unset;right:0}label::-moz-focus-inner{border:0}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}:host(:focus){outline:none}:host{--color-checked:var(--ion-color-primary, #3880ff);width:15px;height:24px}:host(.ion-color.radio-checked) .radio-inner{border-color:var(--ion-color-base)}.item-radio.item-ios ion-label{margin-left:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.item-radio.item-ios ion-label{margin-left:unset;-webkit-margin-start:0;margin-inline-start:0}}.radio-inner{width:33%;height:50%}:host(.radio-checked) .radio-inner{-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:2px;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--color-checked)}:host(.radio-disabled){opacity:0.3}:host(.ion-focused) .radio-icon::after{border-radius:var(--inner-border-radius);left:-9px;top:-8px;display:block;position:absolute;width:36px;height:36px;background:var(--ion-color-primary-tint, #4c8dff);content:"";opacity:0.2}:host-context([dir=rtl]):host(.ion-focused) .radio-icon::after,:host-context([dir=rtl]).ion-focused .radio-icon::after{left:unset;right:unset;right:-9px}:host(.in-item){margin-left:10px;margin-right:11px;margin-top:8px;margin-bottom:8px;display:block;position:static}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.in-item){margin-left:unset;margin-right:unset;-webkit-margin-start:10px;margin-inline-start:10px;-webkit-margin-end:11px;margin-inline-end:11px}}:host(.in-item[slot=start]){margin-left:3px;margin-right:21px;margin-top:8px;margin-bottom:8px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.in-item[slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:3px;margin-inline-start:3px;-webkit-margin-end:21px;margin-inline-end:21px}}', Ly = ':host{--inner-border-radius:50%;display:inline-block;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(.radio-disabled){pointer-events:none}.radio-icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;contain:layout size style}.radio-icon,.radio-inner{-webkit-box-sizing:border-box;box-sizing:border-box}label{left:0;top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}[dir=rtl] label,:host-context([dir=rtl]) label{left:unset;right:unset;right:0}label::-moz-focus-inner{border:0}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}:host(:focus){outline:none}:host{--color:var(--ion-color-step-400, #999999);--color-checked:var(--ion-color-primary, #3880ff);--border-width:2px;--border-style:solid;--border-radius:50%;width:20px;height:20px}:host(.ion-color) .radio-inner{background:var(--ion-color-base)}:host(.ion-color.radio-checked) .radio-icon{border-color:var(--ion-color-base)}.radio-icon{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;border-radius:var(--border-radius);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--color)}.radio-inner{border-radius:var(--inner-border-radius);width:calc(50% + var(--border-width));height:calc(50% + var(--border-width));-webkit-transform:scale3d(0, 0, 0);transform:scale3d(0, 0, 0);-webkit-transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);background:var(--color-checked)}:host(.radio-checked) .radio-icon{border-color:var(--color-checked)}:host(.radio-checked) .radio-inner{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}:host(.radio-disabled){opacity:0.3}:host(.ion-focused) .radio-icon::after{border-radius:var(--inner-border-radius);left:-12px;top:-12px;display:block;position:absolute;width:36px;height:36px;background:var(--ion-color-primary-tint, #4c8dff);content:"";opacity:0.2}:host-context([dir=rtl]):host(.ion-focused) .radio-icon::after,:host-context([dir=rtl]).ion-focused .radio-icon::after{left:unset;right:unset;right:-12px}:host(.in-item){margin-left:0;margin-right:0;margin-top:9px;margin-bottom:9px;display:block;position:static}:host(.in-item[slot=start]){margin-left:4px;margin-right:36px;margin-top:11px;margin-bottom:10px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.in-item[slot=start]){margin-left:unset;margin-right:unset;-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:36px;margin-inline-end:36px}}', Py = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionStyle = G(this, "ionStyle", 7), this.ionFocus = G(this, "ionFocus", 7), this.ionBlur = G(this, "ionBlur", 7), this.inputId = `ion-rb-${My++}`, this.radioGroup = null, this.checked = !1, this.buttonTabindex = -1, this.name = this.inputId, this.disabled = !1, this.updateState = () => {
      this.radioGroup && (this.checked = this.radioGroup.value === this.value);
    }, this.onClick = () => {
      this.checked = this.nativeInput.checked;
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    };
  }
  valueChanged() {
    this.updateState();
  }
  /** @internal */
  async setFocus(e) {
    e.stopPropagation(), e.preventDefault(), this.el.focus();
  }
  /** @internal */
  async setButtonTabindex(e) {
    this.buttonTabindex = e;
  }
  connectedCallback() {
    this.value === void 0 && (this.value = this.inputId);
    const e = this.radioGroup = this.el.closest("ion-radio-group");
    e && (this.updateState(), ua(e, "ionChange", this.updateState));
  }
  disconnectedCallback() {
    const e = this.radioGroup;
    e && (Xu(e, "ionChange", this.updateState), this.radioGroup = null);
  }
  componentWillLoad() {
    this.emitStyle();
  }
  emitStyle() {
    this.ionStyle.emit({
      "radio-checked": this.checked,
      "interactive-disabled": this.disabled
    });
  }
  render() {
    const { inputId: e, disabled: t, checked: n, color: o, el: i, buttonTabindex: r } = this, s = te(this), { label: a, labelId: l, labelText: c } = fa(i, e);
    return x(ae, { "aria-checked": `${n}`, "aria-hidden": t ? "true" : null, "aria-labelledby": a ? l : null, role: "radio", tabindex: r, onFocus: this.onFocus, onBlur: this.onBlur, onClick: this.onClick, class: dt(o, {
      [s]: !0,
      "in-item": ln("ion-item", i),
      interactive: !0,
      "radio-checked": n,
      "radio-disabled": t
    }) }, x("div", { class: "radio-icon", part: "container" }, x("div", { class: "radio-inner", part: "mark" }), x("div", { class: "radio-ripple" })), x("label", { htmlFor: e }, c), x("input", { type: "radio", checked: n, disabled: t, tabindex: "-1", id: e, ref: (d) => this.nativeInput = d }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      value: ["valueChanged"],
      color: ["emitStyle"],
      checked: ["emitStyle"],
      disabled: ["emitStyle"]
    };
  }
  static get style() {
    return {
      ios: Ny,
      md: Ly
    };
  }
}, [33, "ion-radio", {
  color: [513],
  name: [1],
  disabled: [4],
  value: [8],
  checked: [32],
  buttonTabindex: [32],
  setFocus: [64],
  setButtonTabindex: [64]
}]);
let My = 0;
function gf() {
  if (typeof customElements > "u")
    return;
  ["ion-radio"].forEach((t) => {
    switch (t) {
      case "ion-radio":
        customElements.get(t) || customElements.define(t, Py);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Fy = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.ionChange = G(this, "ionChange", 7), this.inputId = `ion-rg-${Ry++}`, this.labelId = `${this.inputId}-lbl`, this.allowEmptySelection = !1, this.name = this.inputId, this.setRadioTabindex = (e) => {
      const t = this.getRadios(), n = t.find((r) => !r.disabled), o = t.find((r) => r.value === e && !r.disabled);
      if (!n && !o)
        return;
      const i = o || n;
      for (const r of t) {
        const s = r === i ? 0 : -1;
        r.setButtonTabindex(s);
      }
    }, this.onClick = (e) => {
      e.preventDefault();
      const t = e.target && e.target.closest("ion-radio");
      if (t) {
        const n = this.value, o = t.value;
        o !== n ? this.value = o : this.allowEmptySelection && (this.value = void 0);
      }
    };
  }
  valueChanged(e) {
    this.setRadioTabindex(e), this.ionChange.emit({ value: e });
  }
  componentDidLoad() {
    this.setRadioTabindex(this.value);
  }
  async connectedCallback() {
    const e = this.el.querySelector("ion-list-header") || this.el.querySelector("ion-item-divider");
    if (e) {
      const t = this.label = e.querySelector("ion-label");
      t && (this.labelId = t.id = this.name + "-lbl");
    }
  }
  getRadios() {
    return Array.from(this.el.querySelectorAll("ion-radio"));
  }
  onKeydown(e) {
    const t = !!this.el.closest("ion-select-popover");
    if (e.target && !this.el.contains(e.target))
      return;
    const n = this.getRadios().filter((o) => !o.disabled);
    if (e.target && n.includes(e.target)) {
      const o = n.findIndex((s) => s === e.target), i = n[o];
      let r;
      ["ArrowDown", "ArrowRight"].includes(e.key) && (r = o === n.length - 1 ? n[0] : n[o + 1]), ["ArrowUp", "ArrowLeft"].includes(e.key) && (r = o === 0 ? n[n.length - 1] : n[o - 1]), r && n.includes(r) && (r.setFocus(e), t || (this.value = r.value)), [" "].includes(e.key) && (this.value = this.allowEmptySelection && this.value !== void 0 ? void 0 : i.value, e.preventDefault());
    }
  }
  render() {
    const { label: e, labelId: t, el: n, name: o, value: i } = this, r = te(this);
    return ha(!0, n, o, i, !1), x(ae, { role: "radiogroup", "aria-labelledby": e ? t : null, onClick: this.onClick, class: r });
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      value: ["valueChanged"]
    };
  }
}, [0, "ion-radio-group", {
  allowEmptySelection: [4, "allow-empty-selection"],
  name: [1],
  value: [1032]
}, [[4, "keydown", "onKeydown"]]]);
let Ry = 0;
function bf() {
  if (typeof customElements > "u")
    return;
  ["ion-radio-group"].forEach((t) => {
    switch (t) {
      case "ion-radio-group":
        customElements.get(t) || customElements.define(t, Fy);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const yn = (e, t, n, o) => {
  const i = Vy(e) ? {
    capture: !!o.capture,
    passive: !!o.passive
  } : !!o.capture;
  let r, s;
  return e.__zone_symbol__addEventListener ? (r = "__zone_symbol__addEventListener", s = "__zone_symbol__removeEventListener") : (r = "addEventListener", s = "removeEventListener"), e[r](t, n, i), () => {
    e[s](t, n, i);
  };
}, Vy = (e) => {
  if (fi === void 0)
    try {
      const t = Object.defineProperty({}, "passive", {
        get: () => {
          fi = !0;
        }
      });
      e.addEventListener("optsTest", () => {
      }, t);
    } catch {
      fi = !1;
    }
  return !!fi;
};
let fi;
const zy = 2e3, Uy = (e, t, n, o, i) => {
  let r, s, a, l, c, d, u, f = 0;
  const g = (b) => {
    f = Date.now() + zy, t(b) && (!s && n && (s = yn(e, "touchmove", n, i)), a || (a = yn(b.target, "touchend", k, i)), l || (l = yn(b.target, "touchcancel", k, i)));
  }, E = (b) => {
    f > Date.now() || t(b) && (!d && n && (d = yn(nc(e), "mousemove", n, i)), u || (u = yn(nc(e), "mouseup", S, i)));
  }, k = (b) => {
    m(), o && o(b);
  }, S = (b) => {
    v(), o && o(b);
  }, m = () => {
    s && s(), a && a(), l && l(), s = a = l = void 0;
  }, v = () => {
    d && d(), u && u(), d = u = void 0;
  }, I = () => {
    m(), v();
  }, w = (b = !0) => {
    b ? (r || (r = yn(e, "touchstart", g, i)), c || (c = yn(e, "mousedown", E, i))) : (r && r(), c && c(), r = c = void 0, I());
  };
  return {
    enable: w,
    stop: I,
    destroy: () => {
      w(!1), o = n = t = void 0;
    }
  };
}, nc = (e) => e instanceof Document ? e : e.ownerDocument, Hy = (e, t, n) => {
  const o = n * (Math.PI / 180), i = e === "x", r = Math.cos(o), s = t * t;
  let a = 0, l = 0, c = !1, d = 0;
  return {
    start(u, f) {
      a = u, l = f, d = 0, c = !0;
    },
    detect(u, f) {
      if (!c)
        return !1;
      const g = u - a, E = f - l, k = g * g + E * E;
      if (k < s)
        return !1;
      const S = Math.sqrt(k), m = (i ? g : E) / S;
      return m > r ? d = 1 : m < -r ? d = -1 : d = 0, c = !1, !0;
    },
    isGesture() {
      return d !== 0;
    },
    getDirection() {
      return d;
    }
  };
}, By = (e) => {
  let t = !1, n = !1, o = !0, i = !1;
  const r = Object.assign({ disableScroll: !1, direction: "x", gesturePriority: 0, passive: !0, maxAngle: 40, threshold: 10 }, e), s = r.canStart, a = r.onWillStart, l = r.onStart, c = r.onEnd, d = r.notCaptured, u = r.onMove, f = r.threshold, g = r.passive, E = r.blurOnStart, k = {
    type: "pan",
    startX: 0,
    startY: 0,
    startTime: 0,
    currentX: 0,
    currentY: 0,
    velocityX: 0,
    velocityY: 0,
    deltaX: 0,
    deltaY: 0,
    currentTime: 0,
    event: void 0,
    data: void 0
  }, S = Hy(r.direction, r.threshold, r.maxAngle), m = of.createGesture({
    name: e.gestureName,
    priority: e.gesturePriority,
    disableScroll: e.disableScroll
  }), v = (z) => {
    const oe = yf(z);
    return n || !o || (vf(z, k), k.startX = k.currentX, k.startY = k.currentY, k.startTime = k.currentTime = oe, k.velocityX = k.velocityY = k.deltaX = k.deltaY = 0, k.event = z, s && s(k) === !1) || (m.release(), !m.start()) ? !1 : (n = !0, f === 0 ? A() : (S.start(k.startX, k.startY), !0));
  }, I = (z) => {
    if (t) {
      !i && o && (i = !0, Tr(k, z), requestAnimationFrame(w));
      return;
    }
    Tr(k, z), S.detect(k.currentX, k.currentY) && (!S.isGesture() || !A()) && N();
  }, w = () => {
    t && (i = !1, u && u(k));
  }, A = () => m.capture() ? (t = !0, o = !1, k.startX = k.currentX, k.startY = k.currentY, k.startTime = k.currentTime, a ? a(k).then(y) : y(), !0) : !1, b = () => {
    if (typeof document < "u") {
      const z = document.activeElement;
      z != null && z.blur && z.blur();
    }
  }, y = () => {
    E && b(), l && l(k), o = !0;
  }, L = () => {
    t = !1, n = !1, i = !1, o = !0, m.release();
  }, C = (z) => {
    const oe = t, ke = o;
    if (L(), !!ke) {
      if (Tr(k, z), oe) {
        c && c(k);
        return;
      }
      d && d(k);
    }
  }, D = Uy(r.el, v, I, C, {
    capture: !1,
    passive: g
  }), N = () => {
    L(), D.stop(), d && d(k);
  };
  return {
    enable(z = !0) {
      z || (t && C(void 0), L()), D.enable(z);
    },
    destroy() {
      m.destroy(), D.destroy();
    }
  };
}, Tr = (e, t) => {
  if (!t)
    return;
  const n = e.currentX, o = e.currentY, i = e.currentTime;
  vf(t, e);
  const r = e.currentX, s = e.currentY, l = (e.currentTime = yf(t)) - i;
  if (l > 0 && l < 100) {
    const c = (r - n) / l, d = (s - o) / l;
    e.velocityX = c * 0.7 + e.velocityX * 0.3, e.velocityY = d * 0.7 + e.velocityY * 0.3;
  }
  e.deltaX = r - e.startX, e.deltaY = s - e.startY, e.event = t;
}, vf = (e, t) => {
  let n = 0, o = 0;
  if (e) {
    const i = e.changedTouches;
    if (i && i.length > 0) {
      const r = i[0];
      n = r.clientX, o = r.clientY;
    } else
      e.pageX !== void 0 && (n = e.pageX, o = e.pageY);
  }
  t.currentX = n, t.currentY = o;
}, yf = (e) => e.timeStamp || Date.now();
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const wf = (e, t) => {
  let n, o;
  const i = (a, l, c) => {
    if (typeof document > "u")
      return;
    const d = document.elementFromPoint(a, l);
    if (!d || !t(d)) {
      s();
      return;
    }
    d !== n && (s(), r(d, c));
  }, r = (a, l) => {
    n = a, o || (o = n);
    const c = n;
    Li(() => c.classList.add("ion-activated")), l();
  }, s = (a = !1) => {
    if (!n)
      return;
    const l = n;
    Li(() => l.classList.remove("ion-activated")), a && o !== n && n.click(), n = void 0;
  };
  return By({
    el: e,
    gestureName: "buttonActiveDrag",
    threshold: 0,
    onStart: (a) => i(a.currentX, a.currentY, pv),
    onMove: (a) => i(a.currentX, a.currentY, gv),
    onEnd: () => {
      s(!0), bv(), o = void 0;
    }
  });
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Wy = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(e.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(100%)", "translateY(0%)"), t.addElement(e).easing("cubic-bezier(.36,.66,.04,1)").duration(400).addAnimation([n, o]);
}, jy = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(e.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(0%)", "translateY(100%)"), t.addElement(e).easing("cubic-bezier(.36,.66,.04,1)").duration(450).addAnimation([n, o]);
}, Yy = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(e.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(100%)", "translateY(0%)"), t.addElement(e).easing("cubic-bezier(.36,.66,.04,1)").duration(400).addAnimation([n, o]);
}, Gy = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(e.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(0%)", "translateY(100%)"), t.addElement(e).easing("cubic-bezier(.36,.66,.04,1)").duration(450).addAnimation([n, o]);
}, qy = '.sc-ion-action-sheet-ios-h{--color:initial;--button-color-activated:var(--button-color);--button-color-focused:var(--button-color);--button-color-hover:var(--button-color);--button-color-selected:var(--button-color);--min-width:auto;--width:100%;--max-width:500px;--min-height:auto;--height:100%;--max-height:calc(100% - (var(--ion-safe-area-top) + var(--ion-safe-area-bottom)));-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:block;position:fixed;outline:none;font-family:var(--ion-font-family, inherit);-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-action-sheet-ios-h{display:none}.action-sheet-wrapper.sc-ion-action-sheet-ios{left:0;right:0;bottom:0;-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0);display:block;position:absolute;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);z-index:10;pointer-events:none}.action-sheet-button.sc-ion-action-sheet-ios{display:block;position:relative;width:100%;border:0;outline:none;background:var(--button-background);color:var(--button-color);font-family:inherit;overflow:hidden}.action-sheet-button-inner.sc-ion-action-sheet-ios{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none;width:100%;height:100%;z-index:1}.action-sheet-container.sc-ion-action-sheet-ios{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:end;justify-content:flex-end;height:100%;max-height:100%}.action-sheet-group.sc-ion-action-sheet-ios{-ms-flex-negative:2;flex-shrink:2;overscroll-behavior-y:contain;overflow-y:auto;-webkit-overflow-scrolling:touch;pointer-events:all;background:var(--background)}.action-sheet-group.sc-ion-action-sheet-ios::-webkit-scrollbar{display:none}.action-sheet-group-cancel.sc-ion-action-sheet-ios{-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.action-sheet-button.sc-ion-action-sheet-ios::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.action-sheet-selected.sc-ion-action-sheet-ios{color:var(--button-color-selected)}.action-sheet-selected.sc-ion-action-sheet-ios::after{background:var(--button-background-selected);opacity:var(--button-background-selected-opacity)}.action-sheet-button.ion-activated.sc-ion-action-sheet-ios{color:var(--button-color-activated)}.action-sheet-button.ion-activated.sc-ion-action-sheet-ios::after{background:var(--button-background-activated);opacity:var(--button-background-activated-opacity)}.action-sheet-button.ion-focused.sc-ion-action-sheet-ios{color:var(--button-color-focused)}.action-sheet-button.ion-focused.sc-ion-action-sheet-ios::after{background:var(--button-background-focused);opacity:var(--button-background-focused-opacity)}@media (any-hover: hover){.action-sheet-button.sc-ion-action-sheet-ios:hover{color:var(--button-color-hover)}.action-sheet-button.sc-ion-action-sheet-ios:hover::after{background:var(--button-background-hover);opacity:var(--button-background-hover-opacity)}}.sc-ion-action-sheet-ios-h{--background:var(--ion-overlay-background-color, var(--ion-color-step-100, #f9f9f9));--backdrop-opacity:var(--ion-backdrop-opacity, 0.4);--button-background:linear-gradient(0deg, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08), rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08) 50%, transparent 50%) bottom/100% 1px no-repeat transparent;--button-background-activated:var(--ion-text-color, #000);--button-background-activated-opacity:.08;--button-background-hover:currentColor;--button-background-hover-opacity:.04;--button-background-focused:currentColor;--button-background-focused-opacity:.12;--button-background-selected:var(--ion-color-step-150, var(--ion-background-color, #fff));--button-background-selected-opacity:1;--button-color:var(--ion-color-primary, #3880ff);--color:var(--ion-color-step-400, #999999);text-align:center}.action-sheet-wrapper.sc-ion-action-sheet-ios{margin-left:auto;margin-right:auto;margin-top:var(--ion-safe-area-top, 0);margin-bottom:var(--ion-safe-area-bottom, 0)}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-wrapper.sc-ion-action-sheet-ios{margin-left:unset;margin-right:unset;-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto}}.action-sheet-container.sc-ion-action-sheet-ios{padding-left:8px;padding-right:8px;padding-top:0;padding-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-container.sc-ion-action-sheet-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px}}.action-sheet-group.sc-ion-action-sheet-ios{border-radius:13px;margin-bottom:8px}.action-sheet-group.sc-ion-action-sheet-ios:first-child{margin-top:10px}.action-sheet-group.sc-ion-action-sheet-ios:last-child{margin-bottom:10px}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-group.sc-ion-action-sheet-ios{background-color:transparent;-webkit-backdrop-filter:saturate(280%) blur(20px);backdrop-filter:saturate(280%) blur(20px)}.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-title.sc-ion-action-sheet-ios,.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-button.sc-ion-action-sheet-ios{background-color:transparent;background-image:-webkit-gradient(linear, left bottom, left top, from(rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8)), to(rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8))), -webkit-gradient(linear, left bottom, left top, from(rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4)), color-stop(50%, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4)), color-stop(50%, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8)));background-image:linear-gradient(0deg, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8), rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8) 100%), linear-gradient(0deg, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4), rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4) 50%, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8) 50%);background-repeat:no-repeat;background-position:top, bottom;background-size:100% calc(100% - 1px), 100% 1px;-webkit-backdrop-filter:saturate(120%);backdrop-filter:saturate(120%)}.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-button.ion-activated.sc-ion-action-sheet-ios{background-color:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.7);background-image:none}.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-cancel.sc-ion-action-sheet-ios{background:var(--button-background-selected)}}.action-sheet-title.sc-ion-action-sheet-ios{background:-webkit-gradient(linear, left bottom, left top, from(rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08)), color-stop(50%, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08)), color-stop(50%, transparent)) bottom/100% 1px no-repeat transparent;background:linear-gradient(0deg, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08), rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08) 50%, transparent 50%) bottom/100% 1px no-repeat transparent}.action-sheet-title.sc-ion-action-sheet-ios{padding-left:10px;padding-right:10px;padding-top:14px;padding-bottom:13px;color:var(--color, var(--ion-color-step-400, #999999));font-size:13px;font-weight:400;text-align:center}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-title.sc-ion-action-sheet-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:10px;padding-inline-start:10px;-webkit-padding-end:10px;padding-inline-end:10px}}.action-sheet-title.action-sheet-has-sub-title.sc-ion-action-sheet-ios{font-weight:600}.action-sheet-sub-title.sc-ion-action-sheet-ios{padding-left:0;padding-right:0;padding-top:6px;padding-bottom:0;font-size:13px;font-weight:400}.action-sheet-button.sc-ion-action-sheet-ios{padding-left:18px;padding-right:18px;padding-top:18px;padding-bottom:18px;height:56px;font-size:20px;contain:strict}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-button.sc-ion-action-sheet-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:18px;padding-inline-start:18px;-webkit-padding-end:18px;padding-inline-end:18px}}.action-sheet-button.sc-ion-action-sheet-ios .action-sheet-icon.sc-ion-action-sheet-ios{margin-right:0.3em;font-size:28px;pointer-events:none}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-button.sc-ion-action-sheet-ios .action-sheet-icon.sc-ion-action-sheet-ios{margin-right:unset;-webkit-margin-end:0.3em;margin-inline-end:0.3em}}.action-sheet-button.sc-ion-action-sheet-ios:last-child{background-image:none}.action-sheet-selected.sc-ion-action-sheet-ios{font-weight:bold}.action-sheet-cancel.sc-ion-action-sheet-ios{font-weight:600}.action-sheet-cancel.sc-ion-action-sheet-ios::after{background:var(--button-background-selected);opacity:var(--button-background-selected-opacity)}.action-sheet-destructive.sc-ion-action-sheet-ios,.action-sheet-destructive.ion-activated.sc-ion-action-sheet-ios,.action-sheet-destructive.ion-focused.sc-ion-action-sheet-ios{color:var(--ion-color-danger, #eb445a)}@media (any-hover: hover){.action-sheet-destructive.sc-ion-action-sheet-ios:hover{color:var(--ion-color-danger, #eb445a)}}', Ky = '.sc-ion-action-sheet-md-h{--color:initial;--button-color-activated:var(--button-color);--button-color-focused:var(--button-color);--button-color-hover:var(--button-color);--button-color-selected:var(--button-color);--min-width:auto;--width:100%;--max-width:500px;--min-height:auto;--height:100%;--max-height:calc(100% - (var(--ion-safe-area-top) + var(--ion-safe-area-bottom)));-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:block;position:fixed;outline:none;font-family:var(--ion-font-family, inherit);-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-action-sheet-md-h{display:none}.action-sheet-wrapper.sc-ion-action-sheet-md{left:0;right:0;bottom:0;-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0);display:block;position:absolute;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);z-index:10;pointer-events:none}.action-sheet-button.sc-ion-action-sheet-md{display:block;position:relative;width:100%;border:0;outline:none;background:var(--button-background);color:var(--button-color);font-family:inherit;overflow:hidden}.action-sheet-button-inner.sc-ion-action-sheet-md{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none;width:100%;height:100%;z-index:1}.action-sheet-container.sc-ion-action-sheet-md{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:end;justify-content:flex-end;height:100%;max-height:100%}.action-sheet-group.sc-ion-action-sheet-md{-ms-flex-negative:2;flex-shrink:2;overscroll-behavior-y:contain;overflow-y:auto;-webkit-overflow-scrolling:touch;pointer-events:all;background:var(--background)}.action-sheet-group.sc-ion-action-sheet-md::-webkit-scrollbar{display:none}.action-sheet-group-cancel.sc-ion-action-sheet-md{-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.action-sheet-button.sc-ion-action-sheet-md::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.action-sheet-selected.sc-ion-action-sheet-md{color:var(--button-color-selected)}.action-sheet-selected.sc-ion-action-sheet-md::after{background:var(--button-background-selected);opacity:var(--button-background-selected-opacity)}.action-sheet-button.ion-activated.sc-ion-action-sheet-md{color:var(--button-color-activated)}.action-sheet-button.ion-activated.sc-ion-action-sheet-md::after{background:var(--button-background-activated);opacity:var(--button-background-activated-opacity)}.action-sheet-button.ion-focused.sc-ion-action-sheet-md{color:var(--button-color-focused)}.action-sheet-button.ion-focused.sc-ion-action-sheet-md::after{background:var(--button-background-focused);opacity:var(--button-background-focused-opacity)}@media (any-hover: hover){.action-sheet-button.sc-ion-action-sheet-md:hover{color:var(--button-color-hover)}.action-sheet-button.sc-ion-action-sheet-md:hover::after{background:var(--button-background-hover);opacity:var(--button-background-hover-opacity)}}.sc-ion-action-sheet-md-h{--background:var(--ion-overlay-background-color, var(--ion-background-color, #fff));--backdrop-opacity:var(--ion-backdrop-opacity, 0.32);--button-background:transparent;--button-background-selected:currentColor;--button-background-selected-opacity:0;--button-background-activated:transparent;--button-background-activated-opacity:0;--button-background-hover:currentColor;--button-background-hover-opacity:.04;--button-background-focused:currentColor;--button-background-focused-opacity:.12;--button-color:var(--ion-color-step-850, #262626);--color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54)}.action-sheet-wrapper.sc-ion-action-sheet-md{margin-left:auto;margin-right:auto;margin-top:var(--ion-safe-area-top, 0);margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-wrapper.sc-ion-action-sheet-md{margin-left:unset;margin-right:unset;-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto}}.action-sheet-title.sc-ion-action-sheet-md{padding-left:16px;padding-right:16px;padding-top:20px;padding-bottom:17px;min-height:60px;color:var(--color, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54));font-size:16px;text-align:start}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-title.sc-ion-action-sheet-md{padding-left:unset;padding-right:unset;-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px}}.action-sheet-sub-title.sc-ion-action-sheet-md{padding-left:0;padding-right:0;padding-top:16px;padding-bottom:0;font-size:14px}.action-sheet-group.sc-ion-action-sheet-md:first-child{padding-top:0}.action-sheet-group.sc-ion-action-sheet-md:last-child{padding-bottom:var(--ion-safe-area-bottom)}.action-sheet-button.sc-ion-action-sheet-md{padding-left:16px;padding-right:16px;padding-top:0;padding-bottom:0;position:relative;height:52px;font-size:16px;text-align:start;contain:strict;overflow:hidden}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-button.sc-ion-action-sheet-md{padding-left:unset;padding-right:unset;-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px}}.action-sheet-icon.sc-ion-action-sheet-md{margin-left:0;margin-right:32px;margin-top:0;margin-bottom:0;color:var(--color);font-size:24px}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.action-sheet-icon.sc-ion-action-sheet-md{margin-left:unset;margin-right:unset;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:32px;margin-inline-end:32px}}.action-sheet-button-inner.sc-ion-action-sheet-md{-ms-flex-pack:start;justify-content:flex-start}.action-sheet-selected.sc-ion-action-sheet-md{font-weight:bold}', Xy = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.didPresent = G(this, "ionActionSheetDidPresent", 7), this.willPresent = G(this, "ionActionSheetWillPresent", 7), this.willDismiss = G(this, "ionActionSheetWillDismiss", 7), this.didDismiss = G(this, "ionActionSheetDidDismiss", 7), this.presented = !1, this.keyboardClose = !0, this.buttons = [], this.backdropDismiss = !0, this.translucent = !1, this.animated = !0, this.onBackdropTap = () => {
      this.dismiss(void 0, lo);
    }, this.dispatchCancelHandler = (e) => {
      const t = e.detail.role;
      if (Mi(t)) {
        const n = this.getButtons().find((o) => o.role === "cancel");
        this.callButtonHandler(n);
      }
    };
  }
  /**
   * Present the action sheet overlay after it has been created.
   */
  present() {
    return ka(this, "actionSheetEnter", Wy, Yy);
  }
  connectedCallback() {
    wa(this.el);
  }
  /**
   * Dismiss the action sheet overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the action sheet.
   * This can be useful in a button handler for determining which button was
   * clicked to dismiss the action sheet.
   * Some examples include: ``"cancel"`, `"destructive"`, "selected"`, and `"backdrop"`.
   */
  dismiss(e, t) {
    return xa(this, e, t, "actionSheetLeave", jy, Gy);
  }
  /**
   * Returns a promise that resolves when the action sheet did dismiss.
   */
  onDidDismiss() {
    return ao(this.el, "ionActionSheetDidDismiss");
  }
  /**
   * Returns a promise that resolves when the action sheet will dismiss.
   *
   */
  onWillDismiss() {
    return ao(this.el, "ionActionSheetWillDismiss");
  }
  async buttonClick(e) {
    const t = e.role;
    return Mi(t) ? this.dismiss(e.data, t) : await this.callButtonHandler(e) ? this.dismiss(e.data, e.role) : Promise.resolve();
  }
  async callButtonHandler(e) {
    return !(e && await Ao(e.handler) === !1);
  }
  getButtons() {
    return this.buttons.map((e) => typeof e == "string" ? { text: e } : e);
  }
  disconnectedCallback() {
    this.gesture && (this.gesture.destroy(), this.gesture = void 0);
  }
  componentDidLoad() {
    const { groupEl: e, wrapperEl: t } = this;
    this.gesture || te(this) === "md" || !t || !e || ju(() => {
      e.scrollHeight > e.clientHeight || (this.gesture = wf(t, (o) => o.classList.contains("action-sheet-button")), this.gesture.enable(!0));
    });
  }
  render() {
    const { header: e, htmlAttributes: t, overlayIndex: n } = this, o = te(this), i = this.getButtons(), r = i.find((l) => l.role === "cancel"), s = i.filter((l) => l.role !== "cancel"), a = `action-sheet-${n}-header`;
    return x(ae, Object.assign({ role: "dialog", "aria-modal": "true", "aria-labelledby": e !== void 0 ? a : null, tabindex: "-1" }, t, { style: {
      zIndex: `${2e4 + this.overlayIndex}`
    }, class: Object.assign(Object.assign({ [o]: !0 }, Et(this.cssClass)), { "overlay-hidden": !0, "action-sheet-translucent": this.translucent }), onIonActionSheetWillDismiss: this.dispatchCancelHandler, onIonBackdropTap: this.onBackdropTap }), x("ion-backdrop", { tappable: this.backdropDismiss }), x("div", { tabindex: "0" }), x("div", { class: "action-sheet-wrapper ion-overlay-wrapper", ref: (l) => this.wrapperEl = l }, x("div", { class: "action-sheet-container" }, x("div", { class: "action-sheet-group", ref: (l) => this.groupEl = l }, e !== void 0 && x("div", { id: a, class: {
      "action-sheet-title": !0,
      "action-sheet-has-sub-title": this.subHeader !== void 0
    } }, e, this.subHeader && x("div", { class: "action-sheet-sub-title" }, this.subHeader)), s.map((l) => x("button", { type: "button", id: l.id, class: oc(l), onClick: () => this.buttonClick(l) }, x("span", { class: "action-sheet-button-inner" }, l.icon && x("ion-icon", { icon: l.icon, "aria-hidden": "true", lazy: !1, class: "action-sheet-icon" }), l.text), o === "md" && x("ion-ripple-effect", null)))), r && x("div", { class: "action-sheet-group action-sheet-group-cancel" }, x("button", { type: "button", class: oc(r), onClick: () => this.buttonClick(r) }, x("span", { class: "action-sheet-button-inner" }, r.icon && x("ion-icon", { icon: r.icon, "aria-hidden": "true", lazy: !1, class: "action-sheet-icon" }), r.text), o === "md" && x("ion-ripple-effect", null))))), x("div", { tabindex: "0" }));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: qy,
      md: Ky
    };
  }
}, [34, "ion-action-sheet", {
  overlayIndex: [2, "overlay-index"],
  keyboardClose: [4, "keyboard-close"],
  enterAnimation: [16],
  leaveAnimation: [16],
  buttons: [16],
  cssClass: [1, "css-class"],
  backdropDismiss: [4, "backdrop-dismiss"],
  header: [1],
  subHeader: [1, "sub-header"],
  translucent: [4],
  animated: [4],
  htmlAttributes: [16],
  present: [64],
  dismiss: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}]), oc = (e) => Object.assign({ "action-sheet-button": !0, "ion-activatable": !0, "ion-focusable": !0, [`action-sheet-${e.role}`]: e.role !== void 0 }, Et(e.cssClass));
function Zy() {
  if (typeof customElements > "u")
    return;
  ["ion-action-sheet", "ion-backdrop", "ion-icon", "ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-action-sheet":
        customElements.get(t) || customElements.define(t, Xy);
        break;
      case "ion-backdrop":
        customElements.get(t) || Qi();
        break;
      case "ion-icon":
        customElements.get(t) || Ji();
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Jy = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(e.querySelector(".alert-wrapper")).keyframes([
    { offset: 0, opacity: "0.01", transform: "scale(1.1)" },
    { offset: 1, opacity: "1", transform: "scale(1)" }
  ]), t.addElement(e).easing("ease-in-out").duration(200).addAnimation([n, o]);
}, Qy = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(e.querySelector(".alert-wrapper")).keyframes([
    { offset: 0, opacity: 0.99, transform: "scale(1)" },
    { offset: 1, opacity: 0, transform: "scale(0.9)" }
  ]), t.addElement(e).easing("ease-in-out").duration(200).addAnimation([n, o]);
}, ew = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(e.querySelector(".alert-wrapper")).keyframes([
    { offset: 0, opacity: "0.01", transform: "scale(0.9)" },
    { offset: 1, opacity: "1", transform: "scale(1)" }
  ]), t.addElement(e).easing("ease-in-out").duration(150).addAnimation([n, o]);
}, tw = (e) => {
  const t = Y(), n = Y(), o = Y();
  return n.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(e.querySelector(".alert-wrapper")).fromTo("opacity", 0.99, 0), t.addElement(e).easing("ease-in-out").duration(150).addAnimation([n, o]);
}, nw = ".sc-ion-alert-ios-h{--min-width:250px;--width:auto;--min-height:auto;--height:auto;--max-height:90%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;font-family:var(--ion-font-family, inherit);contain:strict;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-alert-ios-h{display:none}.alert-top.sc-ion-alert-ios-h{padding-top:50px;-ms-flex-align:start;align-items:flex-start}.alert-wrapper.sc-ion-alert-ios{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);contain:content;opacity:0;z-index:10}.alert-title.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}.alert-sub-title.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-weight:normal}.alert-message.sc-ion-alert-ios{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-overflow-scrolling:touch;overflow-y:auto;overscroll-behavior-y:contain}.alert-checkbox-group.sc-ion-alert-ios::-webkit-scrollbar,.alert-radio-group.sc-ion-alert-ios::-webkit-scrollbar,.alert-message.sc-ion-alert-ios::-webkit-scrollbar{display:none}.alert-input.sc-ion-alert-ios{padding-left:0;padding-right:0;padding-top:10px;padding-bottom:10px;width:100%;border:0;background:inherit;font:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}.alert-button-group.sc-ion-alert-ios{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;width:100%}.alert-button-group-vertical.sc-ion-alert-ios{-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.alert-button.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;border:0;font-size:14px;line-height:20px;z-index:0}.alert-button.ion-focused.sc-ion-alert-ios,.alert-tappable.ion-focused.sc-ion-alert-ios{background:var(--ion-color-step-100, #e6e6e6)}.alert-button-inner.sc-ion-alert-ios{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%}.alert-input-disabled.sc-ion-alert-ios,.alert-checkbox-button-disabled.sc-ion-alert-ios .alert-button-inner.sc-ion-alert-ios,.alert-radio-button-disabled.sc-ion-alert-ios .alert-button-inner.sc-ion-alert-ios{cursor:default;opacity:0.5;pointer-events:none}.alert-tappable.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;width:100%;border:0;background:transparent;font-size:inherit;line-height:initial;text-align:start;-webkit-appearance:none;-moz-appearance:none;appearance:none;contain:strict}.alert-button.sc-ion-alert-ios,.alert-checkbox.sc-ion-alert-ios,.alert-input.sc-ion-alert-ios,.alert-radio.sc-ion-alert-ios{outline:none}.alert-radio-icon.sc-ion-alert-ios,.alert-checkbox-icon.sc-ion-alert-ios,.alert-checkbox-inner.sc-ion-alert-ios{-webkit-box-sizing:border-box;box-sizing:border-box}textarea.alert-input.sc-ion-alert-ios{min-height:37px;resize:none}.sc-ion-alert-ios-h{--background:var(--ion-overlay-background-color, var(--ion-color-step-100, #f9f9f9));--max-width:270px;--backdrop-opacity:var(--ion-backdrop-opacity, 0.3);font-size:14px}.alert-wrapper.sc-ion-alert-ios{border-radius:13px;-webkit-box-shadow:none;box-shadow:none;overflow:hidden}.alert-button.sc-ion-alert-ios .alert-button-inner.sc-ion-alert-ios{pointer-events:none}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){.alert-translucent.sc-ion-alert-ios-h .alert-wrapper.sc-ion-alert-ios{background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.9);-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}}.alert-head.sc-ion-alert-ios{padding-left:16px;padding-right:16px;padding-top:12px;padding-bottom:7px;text-align:center}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-head.sc-ion-alert-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px}}.alert-title.sc-ion-alert-ios{margin-top:8px;color:var(--ion-text-color, #000);font-size:17px;font-weight:600}.alert-sub-title.sc-ion-alert-ios{color:var(--ion-color-step-600, #666666);font-size:14px}.alert-message.sc-ion-alert-ios,.alert-input-group.sc-ion-alert-ios{padding-left:16px;padding-right:16px;padding-top:0;padding-bottom:21px;color:var(--ion-text-color, #000);font-size:13px;text-align:center}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-message.sc-ion-alert-ios,.alert-input-group.sc-ion-alert-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px}}.alert-message.sc-ion-alert-ios{max-height:240px}.alert-message.sc-ion-alert-ios:empty{padding-left:0;padding-right:0;padding-top:0;padding-bottom:12px}.alert-input.sc-ion-alert-ios{border-radius:4px;margin-top:10px;padding-left:6px;padding-right:6px;padding-top:6px;padding-bottom:6px;border:0.55px solid var(--ion-color-step-250, #bfbfbf);background-color:var(--ion-background-color, #fff);-webkit-appearance:none;-moz-appearance:none;appearance:none}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-input.sc-ion-alert-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:6px;padding-inline-start:6px;-webkit-padding-end:6px;padding-inline-end:6px}}.alert-input.sc-ion-alert-ios::-webkit-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::-moz-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios:-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::-ms-clear{display:none}.alert-radio-group.sc-ion-alert-ios,.alert-checkbox-group.sc-ion-alert-ios{-ms-scroll-chaining:none;overscroll-behavior:contain;max-height:240px;border-top:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);overflow-y:auto;-webkit-overflow-scrolling:touch}.alert-tappable.sc-ion-alert-ios{height:44px}.alert-radio-label.sc-ion-alert-ios{padding-left:13px;padding-right:13px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;-ms-flex-order:0;order:0;color:var(--ion-text-color, #000);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-radio-label.sc-ion-alert-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:13px;padding-inline-start:13px;-webkit-padding-end:13px;padding-inline-end:13px}}[aria-checked=true].sc-ion-alert-ios .alert-radio-label.sc-ion-alert-ios{color:var(--ion-color-primary, #3880ff)}.alert-radio-icon.sc-ion-alert-ios{position:relative;-ms-flex-order:1;order:1;min-width:30px}[aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{left:7px;top:-7px;position:absolute;width:6px;height:12px;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:2px;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--ion-color-primary, #3880ff)}[dir=rtl].sc-ion-alert-ios [aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios,[dir=rtl].sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios,[dir=rtl] .sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{left:unset;right:unset;right:7px}.alert-checkbox-label.sc-ion-alert-ios{padding-left:13px;padding-right:13px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;color:var(--ion-text-color, #000);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-checkbox-label.sc-ion-alert-ios{padding-left:unset;padding-right:unset;-webkit-padding-start:13px;padding-inline-start:13px;-webkit-padding-end:13px;padding-inline-end:13px}}.alert-checkbox-icon.sc-ion-alert-ios{border-radius:50%;margin-left:16px;margin-right:6px;margin-top:10px;margin-bottom:10px;position:relative;width:24px;height:24px;border-width:1px;border-style:solid;border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-250, #c8c7cc)));background-color:var(--ion-item-background, var(--ion-background-color, #fff));contain:strict}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-checkbox-icon.sc-ion-alert-ios{margin-left:unset;margin-right:unset;-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:6px;margin-inline-end:6px}}[aria-checked=true].sc-ion-alert-ios .alert-checkbox-icon.sc-ion-alert-ios{border-color:var(--ion-color-primary, #3880ff);background-color:var(--ion-color-primary, #3880ff)}[aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{left:9px;top:4px;position:absolute;width:5px;height:12px;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:1px;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--ion-background-color, #fff)}[dir=rtl].sc-ion-alert-ios [aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios,[dir=rtl].sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios,[dir=rtl] .sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{left:unset;right:unset;right:9px}.alert-button-group.sc-ion-alert-ios{margin-right:-0.55px;-ms-flex-wrap:wrap;flex-wrap:wrap}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-button-group.sc-ion-alert-ios{margin-right:unset;-webkit-margin-end:-0.55px;margin-inline-end:-0.55px}}.alert-button.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;border-radius:0;-ms-flex:1 1 auto;flex:1 1 auto;min-width:50%;height:44px;border-top:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);border-right:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);background-color:transparent;color:var(--ion-color-primary, #3880ff);font-size:17px;overflow:hidden}[dir=rtl].sc-ion-alert-ios .alert-button.sc-ion-alert-ios:first-child,[dir=rtl].sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:first-child,[dir=rtl] .sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:first-child{border-right:0}.alert-button.sc-ion-alert-ios:last-child{border-right:0;font-weight:bold}[dir=rtl].sc-ion-alert-ios .alert-button.sc-ion-alert-ios:last-child,[dir=rtl].sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:last-child,[dir=rtl] .sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:last-child{border-right:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2)}.alert-button.ion-activated.sc-ion-alert-ios{background-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.1)}.alert-button-role-destructive.sc-ion-alert-ios,.alert-button-role-destructive.ion-activated.sc-ion-alert-ios,.alert-button-role-destructive.ion-focused.sc-ion-alert-ios{color:var(--ion-color-danger, #eb445a)}", ow = ".sc-ion-alert-md-h{--min-width:250px;--width:auto;--min-height:auto;--height:auto;--max-height:90%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;font-family:var(--ion-font-family, inherit);contain:strict;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-alert-md-h{display:none}.alert-top.sc-ion-alert-md-h{padding-top:50px;-ms-flex-align:start;align-items:flex-start}.alert-wrapper.sc-ion-alert-md{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);contain:content;opacity:0;z-index:10}.alert-title.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}.alert-sub-title.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-weight:normal}.alert-message.sc-ion-alert-md{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-overflow-scrolling:touch;overflow-y:auto;overscroll-behavior-y:contain}.alert-checkbox-group.sc-ion-alert-md::-webkit-scrollbar,.alert-radio-group.sc-ion-alert-md::-webkit-scrollbar,.alert-message.sc-ion-alert-md::-webkit-scrollbar{display:none}.alert-input.sc-ion-alert-md{padding-left:0;padding-right:0;padding-top:10px;padding-bottom:10px;width:100%;border:0;background:inherit;font:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}.alert-button-group.sc-ion-alert-md{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;width:100%}.alert-button-group-vertical.sc-ion-alert-md{-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.alert-button.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;border:0;font-size:14px;line-height:20px;z-index:0}.alert-button.ion-focused.sc-ion-alert-md,.alert-tappable.ion-focused.sc-ion-alert-md{background:var(--ion-color-step-100, #e6e6e6)}.alert-button-inner.sc-ion-alert-md{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%}.alert-input-disabled.sc-ion-alert-md,.alert-checkbox-button-disabled.sc-ion-alert-md .alert-button-inner.sc-ion-alert-md,.alert-radio-button-disabled.sc-ion-alert-md .alert-button-inner.sc-ion-alert-md{cursor:default;opacity:0.5;pointer-events:none}.alert-tappable.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;width:100%;border:0;background:transparent;font-size:inherit;line-height:initial;text-align:start;-webkit-appearance:none;-moz-appearance:none;appearance:none;contain:strict}.alert-button.sc-ion-alert-md,.alert-checkbox.sc-ion-alert-md,.alert-input.sc-ion-alert-md,.alert-radio.sc-ion-alert-md{outline:none}.alert-radio-icon.sc-ion-alert-md,.alert-checkbox-icon.sc-ion-alert-md,.alert-checkbox-inner.sc-ion-alert-md{-webkit-box-sizing:border-box;box-sizing:border-box}textarea.alert-input.sc-ion-alert-md{min-height:37px;resize:none}.sc-ion-alert-md-h{--background:var(--ion-overlay-background-color, var(--ion-background-color, #fff));--max-width:280px;--backdrop-opacity:var(--ion-backdrop-opacity, 0.32);font-size:14px}.alert-wrapper.sc-ion-alert-md{border-radius:4px;-webkit-box-shadow:0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);box-shadow:0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)}.alert-head.sc-ion-alert-md{padding-left:23px;padding-right:23px;padding-top:20px;padding-bottom:15px;text-align:start}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-head.sc-ion-alert-md{padding-left:unset;padding-right:unset;-webkit-padding-start:23px;padding-inline-start:23px;-webkit-padding-end:23px;padding-inline-end:23px}}.alert-title.sc-ion-alert-md{color:var(--ion-text-color, #000);font-size:20px;font-weight:500}.alert-sub-title.sc-ion-alert-md{color:var(--ion-text-color, #000);font-size:16px}.alert-message.sc-ion-alert-md,.alert-input-group.sc-ion-alert-md{padding-left:24px;padding-right:24px;padding-top:20px;padding-bottom:20px;color:var(--ion-color-step-550, #737373)}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-message.sc-ion-alert-md,.alert-input-group.sc-ion-alert-md{padding-left:unset;padding-right:unset;-webkit-padding-start:24px;padding-inline-start:24px;-webkit-padding-end:24px;padding-inline-end:24px}}.alert-message.sc-ion-alert-md{max-height:266px;font-size:16px}.alert-message.sc-ion-alert-md:empty{padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}.alert-head.sc-ion-alert-md+.alert-message.sc-ion-alert-md{padding-top:0}.alert-input.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:5px;border-bottom:1px solid var(--ion-color-step-150, #d9d9d9);color:var(--ion-text-color, #000)}.alert-input.sc-ion-alert-md::-webkit-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::-moz-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md:-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::-ms-clear{display:none}.alert-input.sc-ion-alert-md:focus{margin-bottom:4px;border-bottom:2px solid var(--ion-color-primary, #3880ff)}.alert-radio-group.sc-ion-alert-md,.alert-checkbox-group.sc-ion-alert-md{position:relative;max-height:266px;border-top:1px solid var(--ion-color-step-150, #d9d9d9);border-bottom:1px solid var(--ion-color-step-150, #d9d9d9);overflow:auto}.alert-tappable.sc-ion-alert-md{position:relative;height:48px;overflow:hidden}.alert-radio-label.sc-ion-alert-md{padding-left:52px;padding-right:26px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;color:var(--ion-color-step-850, #262626);font-size:16px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-radio-label.sc-ion-alert-md{padding-left:unset;padding-right:unset;-webkit-padding-start:52px;padding-inline-start:52px;-webkit-padding-end:26px;padding-inline-end:26px}}.alert-radio-icon.sc-ion-alert-md{left:26px;top:0;border-radius:50%;display:block;position:relative;width:20px;height:20px;border-width:2px;border-style:solid;border-color:var(--ion-color-step-550, #737373)}[dir=rtl].sc-ion-alert-md .alert-radio-icon.sc-ion-alert-md,[dir=rtl].sc-ion-alert-md-h .alert-radio-icon.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h .alert-radio-icon.sc-ion-alert-md{left:unset;right:unset;right:26px}.alert-radio-inner.sc-ion-alert-md{left:3px;top:3px;border-radius:50%;position:absolute;width:10px;height:10px;-webkit-transform:scale3d(0, 0, 0);transform:scale3d(0, 0, 0);-webkit-transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);background-color:var(--ion-color-primary, #3880ff)}[dir=rtl].sc-ion-alert-md .alert-radio-inner.sc-ion-alert-md,[dir=rtl].sc-ion-alert-md-h .alert-radio-inner.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h .alert-radio-inner.sc-ion-alert-md{left:unset;right:unset;right:3px}[aria-checked=true].sc-ion-alert-md .alert-radio-label.sc-ion-alert-md{color:var(--ion-color-step-850, #262626)}[aria-checked=true].sc-ion-alert-md .alert-radio-icon.sc-ion-alert-md{border-color:var(--ion-color-primary, #3880ff)}[aria-checked=true].sc-ion-alert-md .alert-radio-inner.sc-ion-alert-md{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}.alert-checkbox-label.sc-ion-alert-md{padding-left:53px;padding-right:26px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;color:var(--ion-color-step-850, #262626);font-size:16px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-checkbox-label.sc-ion-alert-md{padding-left:unset;padding-right:unset;-webkit-padding-start:53px;padding-inline-start:53px;-webkit-padding-end:26px;padding-inline-end:26px}}.alert-checkbox-icon.sc-ion-alert-md{left:26px;top:0;border-radius:2px;position:relative;width:16px;height:16px;border-width:2px;border-style:solid;border-color:var(--ion-color-step-550, #737373);contain:strict}[dir=rtl].sc-ion-alert-md .alert-checkbox-icon.sc-ion-alert-md,[dir=rtl].sc-ion-alert-md-h .alert-checkbox-icon.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h .alert-checkbox-icon.sc-ion-alert-md{left:unset;right:unset;right:26px}[aria-checked=true].sc-ion-alert-md .alert-checkbox-icon.sc-ion-alert-md{border-color:var(--ion-color-primary, #3880ff);background-color:var(--ion-color-primary, #3880ff)}[aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{left:3px;top:0;position:absolute;width:6px;height:10px;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:2px;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--ion-color-primary-contrast, #fff)}[dir=rtl].sc-ion-alert-md [aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md,[dir=rtl].sc-ion-alert-md-h [aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h [aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{left:unset;right:unset;right:3px}.alert-button-group.sc-ion-alert-md{padding-left:8px;padding-right:8px;padding-top:8px;padding-bottom:8px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;-ms-flex-pack:end;justify-content:flex-end}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-button-group.sc-ion-alert-md{padding-left:unset;padding-right:unset;-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px}}.alert-button.sc-ion-alert-md{border-radius:2px;margin-left:0;margin-right:8px;margin-top:0;margin-bottom:0;padding-left:10px;padding-right:10px;padding-top:10px;padding-bottom:10px;position:relative;background-color:transparent;color:var(--ion-color-primary, #3880ff);font-weight:500;text-align:end;text-transform:uppercase;overflow:hidden}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-button.sc-ion-alert-md{margin-left:unset;margin-right:unset;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px}}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.alert-button.sc-ion-alert-md{padding-left:unset;padding-right:unset;-webkit-padding-start:10px;padding-inline-start:10px;-webkit-padding-end:10px;padding-inline-end:10px}}.alert-button-inner.sc-ion-alert-md{-ms-flex-pack:end;justify-content:flex-end}", iw = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.didPresent = G(this, "ionAlertDidPresent", 7), this.willPresent = G(this, "ionAlertWillPresent", 7), this.willDismiss = G(this, "ionAlertWillDismiss", 7), this.didDismiss = G(this, "ionAlertDidDismiss", 7), this.customHTMLEnabled = go.get("innerHTMLTemplatesEnabled", Ey), this.processedInputs = [], this.processedButtons = [], this.presented = !1, this.keyboardClose = !0, this.buttons = [], this.inputs = [], this.backdropDismiss = !0, this.translucent = !1, this.animated = !0, this.onBackdropTap = () => {
      this.dismiss(void 0, lo);
    }, this.dispatchCancelHandler = (e) => {
      const t = e.detail.role;
      if (Mi(t)) {
        const n = this.processedButtons.find((o) => o.role === "cancel");
        this.callButtonHandler(n);
      }
    };
  }
  onKeydown(e) {
    if (!new Set(this.processedInputs.map((s) => s.type)).has("radio") || e.target && !this.el.contains(e.target) || e.target.classList.contains("alert-button"))
      return;
    const n = this.el.querySelectorAll(".alert-radio"), o = Array.from(n).filter((s) => !s.disabled), i = o.findIndex((s) => s.id === e.target.id);
    let r;
    if (["ArrowDown", "ArrowRight"].includes(e.key) && (r = i === o.length - 1 ? o[0] : o[i + 1]), ["ArrowUp", "ArrowLeft"].includes(e.key) && (r = i === 0 ? o[o.length - 1] : o[i - 1]), r && o.includes(r)) {
      const s = this.processedInputs.find((a) => a.id === (r == null ? void 0 : r.id));
      s && (this.rbClick(s), r.focus());
    }
  }
  buttonsChanged() {
    const e = this.buttons;
    this.processedButtons = e.map((t) => typeof t == "string" ? { text: t, role: t.toLowerCase() === "cancel" ? "cancel" : void 0 } : t);
  }
  inputsChanged() {
    const e = this.inputs, t = e.find((r) => !r.disabled), o = e.find((r) => r.checked && !r.disabled) || t, i = new Set(e.map((r) => r.type));
    i.has("checkbox") && i.has("radio") && console.warn(`Alert cannot mix input types: ${Array.from(i.values()).join("/")}. Please see alert docs for more info.`), this.inputType = i.values().next().value, this.processedInputs = e.map((r, s) => {
      var a;
      return {
        type: r.type || "text",
        name: r.name || `${s}`,
        placeholder: r.placeholder || "",
        value: r.value,
        label: r.label,
        checked: !!r.checked,
        disabled: !!r.disabled,
        id: r.id || `alert-input-${this.overlayIndex}-${s}`,
        handler: r.handler,
        min: r.min,
        max: r.max,
        cssClass: (a = r.cssClass) !== null && a !== void 0 ? a : "",
        attributes: r.attributes || {},
        tabindex: r.type === "radio" && r !== o ? -1 : 0
      };
    });
  }
  connectedCallback() {
    wa(this.el);
  }
  componentWillLoad() {
    this.inputsChanged(), this.buttonsChanged();
  }
  disconnectedCallback() {
    this.gesture && (this.gesture.destroy(), this.gesture = void 0);
  }
  componentDidLoad() {
    this.gesture || te(this) === "md" || !this.wrapperEl || (this.gesture = wf(this.wrapperEl, (e) => e.classList.contains("alert-button")), this.gesture.enable(!0));
  }
  /**
   * Present the alert overlay after it has been created.
   */
  present() {
    return ka(this, "alertEnter", Jy, ew);
  }
  /**
   * Dismiss the alert overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the alert.
   * This can be useful in a button handler for determining which button was
   * clicked to dismiss the alert.
   * Some examples include: ``"cancel"`, `"destructive"`, "selected"`, and `"backdrop"`.
   */
  dismiss(e, t) {
    return xa(this, e, t, "alertLeave", Qy, tw);
  }
  /**
   * Returns a promise that resolves when the alert did dismiss.
   */
  onDidDismiss() {
    return ao(this.el, "ionAlertDidDismiss");
  }
  /**
   * Returns a promise that resolves when the alert will dismiss.
   */
  onWillDismiss() {
    return ao(this.el, "ionAlertWillDismiss");
  }
  rbClick(e) {
    for (const t of this.processedInputs)
      t.checked = t === e, t.tabindex = t === e ? 0 : -1;
    this.activeId = e.id, Ao(e.handler, e), $i(this);
  }
  cbClick(e) {
    e.checked = !e.checked, Ao(e.handler, e), $i(this);
  }
  async buttonClick(e) {
    const t = e.role, n = this.getValues();
    if (Mi(t))
      return this.dismiss({ values: n }, t);
    const o = await this.callButtonHandler(e, n);
    return o !== !1 ? this.dismiss(Object.assign({ values: n }, o), e.role) : !1;
  }
  async callButtonHandler(e, t) {
    if (e != null && e.handler) {
      const n = await Ao(e.handler, t);
      if (n === !1)
        return !1;
      if (typeof n == "object")
        return n;
    }
    return {};
  }
  getValues() {
    if (this.processedInputs.length === 0)
      return;
    if (this.inputType === "radio") {
      const t = this.processedInputs.find((n) => !!n.checked);
      return t ? t.value : void 0;
    }
    if (this.inputType === "checkbox")
      return this.processedInputs.filter((t) => t.checked).map((t) => t.value);
    const e = {};
    return this.processedInputs.forEach((t) => {
      e[t.name] = t.value || "";
    }), e;
  }
  renderAlertInputs() {
    switch (this.inputType) {
      case "checkbox":
        return this.renderCheckbox();
      case "radio":
        return this.renderRadio();
      default:
        return this.renderInput();
    }
  }
  renderCheckbox() {
    const e = this.processedInputs, t = te(this);
    return e.length === 0 ? null : x("div", { class: "alert-checkbox-group" }, e.map((n) => x("button", { type: "button", onClick: () => this.cbClick(n), "aria-checked": `${n.checked}`, id: n.id, disabled: n.disabled, tabIndex: n.tabindex, role: "checkbox", class: Object.assign(Object.assign({}, Et(n.cssClass)), { "alert-tappable": !0, "alert-checkbox": !0, "alert-checkbox-button": !0, "ion-focusable": !0, "alert-checkbox-button-disabled": n.disabled || !1 }) }, x("div", { class: "alert-button-inner" }, x("div", { class: "alert-checkbox-icon" }, x("div", { class: "alert-checkbox-inner" })), x("div", { class: "alert-checkbox-label" }, n.label)), t === "md" && x("ion-ripple-effect", null))));
  }
  renderRadio() {
    const e = this.processedInputs;
    return e.length === 0 ? null : x("div", { class: "alert-radio-group", role: "radiogroup", "aria-activedescendant": this.activeId }, e.map((t) => x("button", { type: "button", onClick: () => this.rbClick(t), "aria-checked": `${t.checked}`, disabled: t.disabled, id: t.id, tabIndex: t.tabindex, class: Object.assign(Object.assign({}, Et(t.cssClass)), { "alert-radio-button": !0, "alert-tappable": !0, "alert-radio": !0, "ion-focusable": !0, "alert-radio-button-disabled": t.disabled || !1 }), role: "radio" }, x("div", { class: "alert-button-inner" }, x("div", { class: "alert-radio-icon" }, x("div", { class: "alert-radio-inner" })), x("div", { class: "alert-radio-label" }, t.label)))));
  }
  renderInput() {
    const e = this.processedInputs;
    return e.length === 0 ? null : x("div", { class: "alert-input-group" }, e.map((t) => {
      var n, o, i, r;
      return t.type === "textarea" ? x("div", { class: "alert-input-wrapper" }, x("textarea", Object.assign({ placeholder: t.placeholder, value: t.value, id: t.id, tabIndex: t.tabindex }, t.attributes, { disabled: (o = (n = t.attributes) === null || n === void 0 ? void 0 : n.disabled) !== null && o !== void 0 ? o : t.disabled, class: ic(t), onInput: (s) => {
        var a;
        t.value = s.target.value, !((a = t.attributes) === null || a === void 0) && a.onInput && t.attributes.onInput(s);
      } }))) : x("div", { class: "alert-input-wrapper" }, x("input", Object.assign({ placeholder: t.placeholder, type: t.type, min: t.min, max: t.max, value: t.value, id: t.id, tabIndex: t.tabindex }, t.attributes, { disabled: (r = (i = t.attributes) === null || i === void 0 ? void 0 : i.disabled) !== null && r !== void 0 ? r : t.disabled, class: ic(t), onInput: (s) => {
        var a;
        t.value = s.target.value, !((a = t.attributes) === null || a === void 0) && a.onInput && t.attributes.onInput(s);
      } })));
    }));
  }
  renderAlertButtons() {
    const e = this.processedButtons, t = te(this), n = {
      "alert-button-group": !0,
      "alert-button-group-vertical": e.length > 2
    };
    return x("div", { class: n }, e.map((o) => x("button", { type: "button", id: o.id, class: rw(o), tabIndex: 0, onClick: () => this.buttonClick(o) }, x("span", { class: "alert-button-inner" }, o.text), t === "md" && x("ion-ripple-effect", null))));
  }
  renderAlertMessage(e) {
    const { customHTMLEnabled: t, message: n } = this;
    return t ? x("div", { id: e, class: "alert-message", innerHTML: yy(n) }) : x("div", { id: e, class: "alert-message" }, n);
  }
  render() {
    const { overlayIndex: e, header: t, subHeader: n, message: o, htmlAttributes: i } = this, r = te(this), s = `alert-${e}-hdr`, a = `alert-${e}-sub-hdr`, l = `alert-${e}-msg`, c = this.inputs.length > 0 || this.buttons.length > 0 ? "alertdialog" : "alert";
    return x(ae, Object.assign({ role: c, "aria-modal": "true", "aria-labelledby": t ? s : n ? a : null, "aria-describedby": o !== void 0 ? l : null, tabindex: "-1" }, i, { style: {
      zIndex: `${2e4 + e}`
    }, class: Object.assign(Object.assign({}, Et(this.cssClass)), { [r]: !0, "overlay-hidden": !0, "alert-translucent": this.translucent }), onIonAlertWillDismiss: this.dispatchCancelHandler, onIonBackdropTap: this.onBackdropTap }), x("ion-backdrop", { tappable: this.backdropDismiss }), x("div", { tabindex: "0" }), x("div", { class: "alert-wrapper ion-overlay-wrapper", ref: (u) => this.wrapperEl = u }, x("div", { class: "alert-head" }, t && x("h2", { id: s, class: "alert-title" }, t), n && x("h2", { id: a, class: "alert-sub-title" }, n)), this.renderAlertMessage(l), this.renderAlertInputs(), this.renderAlertButtons()), x("div", { tabindex: "0" }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      buttons: ["buttonsChanged"],
      inputs: ["inputsChanged"]
    };
  }
  static get style() {
    return {
      ios: nw,
      md: ow
    };
  }
}, [34, "ion-alert", {
  overlayIndex: [2, "overlay-index"],
  keyboardClose: [4, "keyboard-close"],
  enterAnimation: [16],
  leaveAnimation: [16],
  cssClass: [1, "css-class"],
  header: [1],
  subHeader: [1, "sub-header"],
  message: [1],
  buttons: [16],
  inputs: [1040],
  backdropDismiss: [4, "backdrop-dismiss"],
  translucent: [4],
  animated: [4],
  htmlAttributes: [16],
  present: [64],
  dismiss: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}, [[4, "keydown", "onKeydown"]]]), ic = (e) => {
  var t, n, o;
  return Object.assign(Object.assign({ "alert-input": !0, "alert-input-disabled": ((n = (t = e.attributes) === null || t === void 0 ? void 0 : t.disabled) !== null && n !== void 0 ? n : e.disabled) || !1 }, Et(e.cssClass)), Et(e.attributes ? (o = e.attributes.class) === null || o === void 0 ? void 0 : o.toString() : ""));
}, rw = (e) => Object.assign({ "alert-button": !0, "ion-focusable": !0, "ion-activatable": !0, [`alert-button-role-${e.role}`]: e.role !== void 0 }, Et(e.cssClass));
function sw() {
  if (typeof customElements > "u")
    return;
  ["ion-alert", "ion-backdrop", "ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-alert":
        customElements.get(t) || customElements.define(t, iw);
        break;
      case "ion-backdrop":
        customElements.get(t) || Qi();
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const aw = ".sc-ion-select-popover-ios-h ion-list.sc-ion-select-popover-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list-header.sc-ion-select-popover-ios,ion-label.sc-ion-select-popover-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}", lw = ".sc-ion-select-popover-md-h ion-list.sc-ion-select-popover-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list-header.sc-ion-select-popover-md,ion-label.sc-ion-select-popover-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list.sc-ion-select-popover-md ion-radio.sc-ion-select-popover-md{opacity:0}ion-item.sc-ion-select-popover-md{--inner-border-width:0}.item-radio-checked.sc-ion-select-popover-md{--background:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);--background-focused:var(--ion-color-primary, #3880ff);--background-focused-opacity:0.2;--background-hover:var(--ion-color-primary, #3880ff);--background-hover-opacity:0.12}.item-checkbox-checked.sc-ion-select-popover-md{--background-activated:var(--ion-item-color, var(--ion-text-color, #000));--background-focused:var(--ion-item-color, var(--ion-text-color, #000));--background-hover:var(--ion-item-color, var(--ion-text-color, #000));--color:var(--ion-color-primary, #3880ff)}", cw = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.options = [];
  }
  onSelect(e) {
    this.setChecked(e), this.callOptionHandler(e);
  }
  findOptionFromEvent(e) {
    const { options: t } = this;
    return t.find((n) => n.value === e.target.value);
  }
  /**
   * When an option is selected we need to get the value(s)
   * of the selected option(s) and return it in the option
   * handler
   */
  callOptionHandler(e) {
    const t = this.findOptionFromEvent(e), n = this.getValues(e);
    t != null && t.handler && Ao(t.handler, n);
  }
  /**
   * This is required when selecting a radio that is already
   * selected because it will not trigger the ionChange event
   * but we still want to close the popover
   */
  rbClick(e) {
    this.callOptionHandler(e);
  }
  setChecked(e) {
    const { multiple: t } = this, n = this.findOptionFromEvent(e);
    t && n && (n.checked = e.detail.checked);
  }
  getValues(e) {
    const { multiple: t, options: n } = this;
    if (t)
      return n.filter((i) => i.checked).map((i) => i.value);
    const o = this.findOptionFromEvent(e);
    return o ? o.value : void 0;
  }
  renderOptions(e) {
    const { multiple: t } = this;
    switch (t) {
      case !0:
        return this.renderCheckboxOptions(e);
      default:
        return this.renderRadioOptions(e);
    }
  }
  renderCheckboxOptions(e) {
    return e.map((t) => x("ion-item", { class: Et(t.cssClass) }, x("ion-checkbox", { slot: "start", value: t.value, disabled: t.disabled, checked: t.checked }), x("ion-label", null, t.text)));
  }
  renderRadioOptions(e) {
    const t = e.filter((n) => n.checked).map((n) => n.value)[0];
    return x("ion-radio-group", { value: t }, e.map((n) => x("ion-item", { class: Et(n.cssClass) }, x("ion-label", null, n.text), x("ion-radio", { value: n.value, disabled: n.disabled, onClick: (o) => this.rbClick(o) }))));
  }
  render() {
    const { header: e, message: t, options: n, subHeader: o } = this, i = o !== void 0 || t !== void 0;
    return x(ae, { class: te(this) }, x("ion-list", null, e !== void 0 && x("ion-list-header", null, e), i && x("ion-item", null, x("ion-label", { class: "ion-text-wrap" }, o !== void 0 && x("h3", null, o), t !== void 0 && x("p", null, t))), this.renderOptions(n)));
  }
  static get style() {
    return {
      ios: aw,
      md: lw
    };
  }
}, [34, "ion-select-popover", {
  header: [1],
  subHeader: [1, "sub-header"],
  message: [1],
  multiple: [4],
  options: [16]
}, [[0, "ionChange", "onSelect"]]]);
function dw() {
  if (typeof customElements > "u")
    return;
  ["ion-select-popover", "ion-checkbox", "ion-icon", "ion-item", "ion-label", "ion-list", "ion-list-header", "ion-note", "ion-radio", "ion-radio-group", "ion-ripple-effect"].forEach((t) => {
    switch (t) {
      case "ion-select-popover":
        customElements.get(t) || customElements.define(t, cw);
        break;
      case "ion-checkbox":
        customElements.get(t) || rf();
        break;
      case "ion-icon":
        customElements.get(t) || Ji();
        break;
      case "ion-item":
        customElements.get(t) || ga();
        break;
      case "ion-label":
        customElements.get(t) || ba();
        break;
      case "ion-list":
        customElements.get(t) || mf();
        break;
      case "ion-list-header":
        customElements.get(t) || pf();
        break;
      case "ion-note":
        customElements.get(t) || pa();
        break;
      case "ion-radio":
        customElements.get(t) || gf();
        break;
      case "ion-radio-group":
        customElements.get(t) || bf();
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const uw = (e, t, n) => {
  if (typeof MutationObserver > "u")
    return;
  const o = new MutationObserver((i) => {
    n(fw(i, t));
  });
  return o.observe(e, {
    childList: !0,
    subtree: !0
  }), o;
}, fw = (e, t) => {
  let n;
  return e.forEach((o) => {
    for (let i = 0; i < o.addedNodes.length; i++)
      n = hw(o.addedNodes[i], t) || n;
  }), n;
}, hw = (e, t) => e.nodeType !== 1 ? void 0 : (e.tagName === t.toUpperCase() ? [e] : Array.from(e.querySelectorAll(t))).find((o) => o.value === e.value), mw = ":host{--placeholder-color:currentColor;--placeholder-opacity:0.33;padding-left:var(--padding-start);padding-right:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;font-family:var(--ion-font-family, inherit);white-space:nowrap;overflow:hidden;z-index:2}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end)}}:host(.in-item){position:static;max-width:45%}:host(.select-disabled){opacity:0.4;pointer-events:none}:host(.ion-focused) button{border:2px solid #5e9ed6}.select-placeholder{color:var(--placeholder-color);opacity:var(--placeholder-opacity)}label{left:0;top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}[dir=rtl] label,:host-context([dir=rtl]) label{left:unset;right:unset;right:0}label::-moz-focus-inner{border:0}button{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.select-icon{position:relative}.select-text{-ms-flex:1;flex:1;min-width:16px;font-size:inherit;text-overflow:ellipsis;white-space:inherit;overflow:hidden}.select-icon-inner{left:5px;top:50%;margin-top:-2px;position:absolute;width:0;height:0;border-top:5px solid;border-right:5px solid transparent;border-left:5px solid transparent;color:currentColor;pointer-events:none}[dir=rtl] .select-icon-inner,:host-context([dir=rtl]) .select-icon-inner{left:unset;right:unset;right:5px}:host{--padding-top:10px;--padding-end:10px;--padding-bottom:10px;--padding-start:20px}.select-icon{width:12px;height:18px;opacity:0.33}", pw = ":host{--placeholder-color:currentColor;--placeholder-opacity:0.33;padding-left:var(--padding-start);padding-right:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;font-family:var(--ion-font-family, inherit);white-space:nowrap;overflow:hidden;z-index:2}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end)}}:host(.in-item){position:static;max-width:45%}:host(.select-disabled){opacity:0.4;pointer-events:none}:host(.ion-focused) button{border:2px solid #5e9ed6}.select-placeholder{color:var(--placeholder-color);opacity:var(--placeholder-opacity)}label{left:0;top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}[dir=rtl] label,:host-context([dir=rtl]) label{left:unset;right:unset;right:0}label::-moz-focus-inner{border:0}button{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.select-icon{position:relative}.select-text{-ms-flex:1;flex:1;min-width:16px;font-size:inherit;text-overflow:ellipsis;white-space:inherit;overflow:hidden}.select-icon-inner{left:5px;top:50%;margin-top:-2px;position:absolute;width:0;height:0;border-top:5px solid;border-right:5px solid transparent;border-left:5px solid transparent;color:currentColor;pointer-events:none}[dir=rtl] .select-icon-inner,:host-context([dir=rtl]) .select-icon-inner{left:unset;right:unset;right:5px}:host{--padding-top:10px;--padding-end:0;--padding-bottom:10px;--padding-start:16px}.select-icon{width:19px;height:19px;-webkit-transition:-webkit-transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);transition:-webkit-transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);transition:transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);transition:transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);opacity:0.55}:host-context(.item-label-stacked) .select-icon,:host-context(.item-label-floating:not(.item-fill-outline)) .select-icon,:host-context(.item-label-floating.item-fill-outline){-webkit-transform:translate3d(0,  -9px,  0);transform:translate3d(0,  -9px,  0)}:host-context(.item-has-focus) .select-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host-context(.item-has-focus.item-label-stacked) .select-icon,:host-context(.item-has-focus.item-label-floating:not(.item-fill-outline)) .select-icon{-webkit-transform:translate3d(0,  -9px,  0) rotate(180deg);transform:translate3d(0,  -9px,  0) rotate(180deg)}:host-context(ion-item.ion-focused) .select-icon,:host-context(.item-has-focus) .select-icon{color:var(--highlight-color-focused);opacity:1}", gw = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionChange = G(this, "ionChange", 7), this.ionCancel = G(this, "ionCancel", 7), this.ionDismiss = G(this, "ionDismiss", 7), this.ionFocus = G(this, "ionFocus", 7), this.ionBlur = G(this, "ionBlur", 7), this.ionStyle = G(this, "ionStyle", 7), this.inputId = `ion-sel-${yw++}`, this.didInit = !1, this.isExpanded = !1, this.disabled = !1, this.cancelText = "Cancel", this.okText = "OK", this.name = this.inputId, this.multiple = !1, this.interface = "alert", this.interfaceOptions = {}, this.onClick = (e) => {
      this.setFocus(), this.open(e);
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    };
  }
  styleChanged() {
    this.emitStyle();
  }
  valueChanged() {
    this.emitStyle(), this.didInit && this.ionChange.emit({
      value: this.value
    });
  }
  async connectedCallback() {
    this.updateOverlayOptions(), this.emitStyle(), this.mutationO = uw(this.el, "ion-select-option", async () => {
      this.updateOverlayOptions(), $i(this);
    });
  }
  disconnectedCallback() {
    this.mutationO && (this.mutationO.disconnect(), this.mutationO = void 0);
  }
  componentDidLoad() {
    this.didInit = !0;
  }
  /**
   * Open the select overlay. The overlay is either an alert, action sheet, or popover,
   * depending on the `interface` property on the `ion-select`.
   *
   * @param event The user interface event that called the open.
   */
  async open(e) {
    if (this.disabled || this.isExpanded)
      return;
    this.isExpanded = !0;
    const t = this.overlay = await this.createOverlay(e);
    if (t.onDidDismiss().then(() => {
      this.overlay = void 0, this.isExpanded = !1, this.ionDismiss.emit(), this.setFocus();
    }), await t.present(), this.interface === "popover") {
      let n = this.childOpts.map((i) => i.value).indexOf(this.value);
      n = n > -1 ? n : 0;
      const o = t.querySelector(`.select-interface-option:nth-child(${n + 1})`);
      if (o) {
        Qu(o);
        const i = o.querySelector("ion-radio, ion-checkbox");
        i && i.focus();
      }
    }
    return t;
  }
  createOverlay(e) {
    let t = this.interface;
    return t === "action-sheet" && this.multiple && (console.warn(`Select interface cannot be "${t}" with a multi-value select. Using the "alert" interface instead.`), t = "alert"), t === "popover" && !e && (console.warn(`Select interface cannot be a "${t}" without passing an event. Using the "alert" interface instead.`), t = "alert"), t === "action-sheet" ? this.openActionSheet() : t === "popover" ? this.openPopover(e) : this.openAlert();
  }
  updateOverlayOptions() {
    const e = this.overlay;
    if (!e)
      return;
    const t = this.childOpts, n = this.value;
    switch (this.interface) {
      case "action-sheet":
        e.buttons = this.createActionSheetButtons(t, n);
        break;
      case "popover":
        const o = e.querySelector("ion-select-popover");
        o && (o.options = this.createPopoverOptions(t, n));
        break;
      case "alert":
        const i = this.multiple ? "checkbox" : "radio";
        e.inputs = this.createAlertInputs(t, i, n);
        break;
    }
  }
  createActionSheetButtons(e, t) {
    const n = e.map((o) => {
      const i = ki(o), r = Array.from(o.classList).filter((a) => a !== "hydrated").join(" "), s = `${Sr} ${r}`;
      return {
        role: Ir(t, i, this.compareWith) ? "selected" : "",
        text: o.textContent,
        cssClass: s,
        handler: () => {
          this.value = i;
        }
      };
    });
    return n.push({
      text: this.cancelText,
      role: "cancel",
      handler: () => {
        this.ionCancel.emit();
      }
    }), n;
  }
  createAlertInputs(e, t, n) {
    return e.map((i) => {
      const r = ki(i), s = Array.from(i.classList).filter((l) => l !== "hydrated").join(" "), a = `${Sr} ${s}`;
      return {
        type: t,
        cssClass: a,
        label: i.textContent || "",
        value: r,
        checked: Ir(n, r, this.compareWith),
        disabled: i.disabled
      };
    });
  }
  createPopoverOptions(e, t) {
    return e.map((o) => {
      const i = ki(o), r = Array.from(o.classList).filter((a) => a !== "hydrated").join(" "), s = `${Sr} ${r}`;
      return {
        text: o.textContent || "",
        cssClass: s,
        value: i,
        checked: Ir(t, i, this.compareWith),
        disabled: o.disabled,
        handler: (a) => {
          this.value = a, this.multiple || this.close();
        }
      };
    });
  }
  async openPopover(e) {
    const t = this.interfaceOptions, n = te(this), o = n !== "md", i = this.multiple, r = this.value;
    let s = e, a = "auto";
    const l = this.el.closest("ion-item");
    l && (l.classList.contains("item-label-floating") || l.classList.contains("item-label-stacked")) && (s = Object.assign(Object.assign({}, e), { detail: {
      ionShadowTarget: l
    } }), a = "cover");
    const c = Object.assign(Object.assign({
      mode: n,
      event: s,
      alignment: "center",
      size: a,
      showBackdrop: o
    }, t), { component: "ion-select-popover", cssClass: ["select-popover", t.cssClass], componentProps: {
      header: t.header,
      subHeader: t.subHeader,
      message: t.message,
      multiple: i,
      value: r,
      options: this.createPopoverOptions(this.childOpts, r)
    } });
    return Ev.create(c);
  }
  async openActionSheet() {
    const e = te(this), t = this.interfaceOptions, n = Object.assign(Object.assign({ mode: e }, t), { buttons: this.createActionSheetButtons(this.childOpts, this.value), cssClass: ["select-action-sheet", t.cssClass] });
    return _v.create(n);
  }
  async openAlert() {
    const e = this.getLabel(), t = e ? e.textContent : null, n = this.interfaceOptions, o = this.multiple ? "checkbox" : "radio", i = te(this), r = Object.assign(Object.assign({ mode: i }, n), { header: n.header ? n.header : t, inputs: this.createAlertInputs(this.childOpts, o, this.value), buttons: [
      {
        text: this.cancelText,
        role: "cancel",
        handler: () => {
          this.ionCancel.emit();
        }
      },
      {
        text: this.okText,
        handler: (s) => {
          this.value = s;
        }
      }
    ], cssClass: [
      "select-alert",
      n.cssClass,
      this.multiple ? "multiple-select-alert" : "single-select-alert"
    ] });
    return xv.create(r);
  }
  /**
   * Close the select interface.
   */
  close() {
    return this.overlay ? this.overlay.dismiss() : Promise.resolve(!1);
  }
  getLabel() {
    return Ju(this.el);
  }
  hasValue() {
    return this.getText() !== "";
  }
  get childOpts() {
    return Array.from(this.el.querySelectorAll("ion-select-option"));
  }
  getText() {
    const e = this.selectedText;
    return e != null && e !== "" ? e : vw(this.childOpts, this.value, this.compareWith);
  }
  setFocus() {
    this.focusEl && this.focusEl.focus();
  }
  emitStyle() {
    this.ionStyle.emit({
      interactive: !0,
      "interactive-disabled": this.disabled,
      select: !0,
      "select-disabled": this.disabled,
      "has-placeholder": this.placeholder !== void 0,
      "has-value": this.hasValue(),
      "has-focus": this.isExpanded
    });
  }
  render() {
    const { disabled: e, el: t, inputId: n, isExpanded: o, name: i, placeholder: r, value: s } = this, a = te(this), { labelText: l, labelId: c } = fa(t, n);
    ha(!0, t, i, bw(s), e);
    const d = this.getText();
    let u = !1, f = d;
    f === "" && r !== void 0 && (f = r, u = !0);
    const g = {
      "select-text": !0,
      "select-placeholder": u
    }, E = u ? "placeholder" : "text", k = l !== void 0 ? f !== "" ? `${f}, ${l}` : l : f;
    return x(ae, { onClick: this.onClick, role: "button", "aria-haspopup": "listbox", "aria-disabled": e ? "true" : null, "aria-label": k, class: {
      [a]: !0,
      "in-item": ln("ion-item", t),
      "select-disabled": e,
      "select-expanded": o
    } }, x("div", { "aria-hidden": "true", class: g, part: E }, f), x("div", { class: "select-icon", role: "presentation", part: "icon" }, x("div", { class: "select-icon-inner" })), x("label", { id: c }, k), x("button", { type: "button", disabled: e, id: n, "aria-labelledby": c, "aria-haspopup": "listbox", "aria-expanded": `${o}`, onFocus: this.onFocus, onBlur: this.onBlur, ref: (S) => this.focusEl = S }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      disabled: ["styleChanged"],
      placeholder: ["styleChanged"],
      isExpanded: ["styleChanged"],
      value: ["valueChanged"]
    };
  }
  static get style() {
    return {
      ios: mw,
      md: pw
    };
  }
}, [33, "ion-select", {
  disabled: [4],
  cancelText: [1, "cancel-text"],
  okText: [1, "ok-text"],
  placeholder: [1],
  name: [1],
  selectedText: [1, "selected-text"],
  multiple: [4],
  interface: [1],
  interfaceOptions: [8, "interface-options"],
  compareWith: [1, "compare-with"],
  value: [1032],
  isExpanded: [32],
  open: [64]
}]), Ir = (e, t, n) => e === void 0 ? !1 : Array.isArray(e) ? e.some((o) => vs(o, t, n)) : vs(e, t, n), ki = (e) => {
  const t = e.value;
  return t === void 0 ? e.textContent || "" : t;
}, bw = (e) => {
  if (e != null)
    return Array.isArray(e) ? e.join(",") : e.toString();
}, vs = (e, t, n) => typeof n == "function" ? n(e, t) : typeof n == "string" ? e[n] === t[n] : Array.isArray(t) ? t.includes(e) : e === t, vw = (e, t, n) => t === void 0 ? "" : Array.isArray(t) ? t.map((o) => rc(e, o, n)).filter((o) => o !== null).join(", ") : rc(e, t, n) || "", rc = (e, t, n) => {
  const o = e.find((i) => vs(t, ki(i), n));
  return o ? o.textContent : null;
};
let yw = 0;
const Sr = "select-interface-option";
function ww() {
  if (typeof customElements > "u")
    return;
  ["ion-select", "ion-action-sheet", "ion-alert", "ion-backdrop", "ion-checkbox", "ion-icon", "ion-item", "ion-label", "ion-list", "ion-list-header", "ion-note", "ion-popover", "ion-radio", "ion-radio-group", "ion-ripple-effect", "ion-select-popover"].forEach((t) => {
    switch (t) {
      case "ion-select":
        customElements.get(t) || customElements.define(t, gw);
        break;
      case "ion-action-sheet":
        customElements.get(t) || Zy();
        break;
      case "ion-alert":
        customElements.get(t) || sw();
        break;
      case "ion-backdrop":
        customElements.get(t) || Qi();
        break;
      case "ion-checkbox":
        customElements.get(t) || rf();
        break;
      case "ion-icon":
        customElements.get(t) || Ji();
        break;
      case "ion-item":
        customElements.get(t) || ga();
        break;
      case "ion-label":
        customElements.get(t) || ba();
        break;
      case "ion-list":
        customElements.get(t) || mf();
        break;
      case "ion-list-header":
        customElements.get(t) || pf();
        break;
      case "ion-note":
        customElements.get(t) || pa();
        break;
      case "ion-popover":
        customElements.get(t) || by();
        break;
      case "ion-radio":
        customElements.get(t) || gf();
        break;
      case "ion-radio-group":
        customElements.get(t) || bf();
        break;
      case "ion-ripple-effect":
        customElements.get(t) || Bn();
        break;
      case "ion-select-popover":
        customElements.get(t) || dw();
        break;
    }
  });
}
const kw = ww;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const xw = ":host{display:none}", _w = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inputId = `ion-selopt-${Ew++}`, this.disabled = !1;
  }
  render() {
    return x(ae, { role: "option", id: this.inputId, class: te(this) });
  }
  get el() {
    return this;
  }
  static get style() {
    return xw;
  }
}, [1, "ion-select-option", {
  disabled: [4],
  value: [8]
}]);
let Ew = 0;
function Tw() {
  if (typeof customElements > "u")
    return;
  ["ion-select-option"].forEach((t) => {
    switch (t) {
      case "ion-select-option":
        customElements.get(t) || customElements.define(t, _w);
        break;
    }
  });
}
const Iw = Tw;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var sc;
(function(e) {
  e.Dark = "DARK", e.Light = "LIGHT", e.Default = "DEFAULT";
})(sc || (sc = {}));
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const Sw = ":host{padding-left:var(--ion-safe-area-left);padding-right:var(--ion-safe-area-right);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-bottom:var(--ion-safe-area-bottom, 0);border-top:var(--border);background:var(--background);color:var(--color);text-align:center;contain:strict;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:10;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--ion-safe-area-left);padding-inline-start:var(--ion-safe-area-left);-webkit-padding-end:var(--ion-safe-area-right);padding-inline-end:var(--ion-safe-area-right)}}:host(.ion-color) ::slotted(ion-tab-button){--background-focused:var(--ion-color-shade);--color-selected:var(--ion-color-contrast)}:host(.ion-color) ::slotted(.tab-selected){color:var(--ion-color-contrast)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){color:rgba(var(--ion-color-contrast-rgb), 0.7)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){background:var(--ion-color-base)}:host(.ion-color) ::slotted(ion-tab-button.ion-focused),:host(.tab-bar-translucent) ::slotted(ion-tab-button.ion-focused){background:var(--background-focused)}:host(.tab-bar-translucent) ::slotted(ion-tab-button){background:transparent}:host([slot=top]){padding-top:var(--ion-safe-area-top, 0);padding-bottom:0;border-top:0;border-bottom:var(--border)}:host(.tab-bar-hidden){display:none !important}:host{--background:var(--ion-tab-bar-background, var(--ion-color-step-50, #f7f7f7));--background-focused:var(--ion-tab-bar-background-focused, #e0e0e0);--border:0.55px solid var(--ion-tab-bar-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.2))));--color:var(--ion-tab-bar-color, var(--ion-color-step-400, #999999));--color-selected:var(--ion-tab-bar-color-selected, var(--ion-color-primary, #3880ff));height:50px}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.tab-bar-translucent){--background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8);-webkit-backdrop-filter:saturate(210%) blur(20px);backdrop-filter:saturate(210%) blur(20px)}:host(.ion-color.tab-bar-translucent){background:rgba(var(--ion-color-base-rgb), 0.8)}:host(.tab-bar-translucent) ::slotted(ion-tab-button.ion-focused){background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.6)}}", Ow = ":host{padding-left:var(--ion-safe-area-left);padding-right:var(--ion-safe-area-right);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-bottom:var(--ion-safe-area-bottom, 0);border-top:var(--border);background:var(--background);color:var(--color);text-align:center;contain:strict;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:10;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host{padding-left:unset;padding-right:unset;-webkit-padding-start:var(--ion-safe-area-left);padding-inline-start:var(--ion-safe-area-left);-webkit-padding-end:var(--ion-safe-area-right);padding-inline-end:var(--ion-safe-area-right)}}:host(.ion-color) ::slotted(ion-tab-button){--background-focused:var(--ion-color-shade);--color-selected:var(--ion-color-contrast)}:host(.ion-color) ::slotted(.tab-selected){color:var(--ion-color-contrast)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){color:rgba(var(--ion-color-contrast-rgb), 0.7)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){background:var(--ion-color-base)}:host(.ion-color) ::slotted(ion-tab-button.ion-focused),:host(.tab-bar-translucent) ::slotted(ion-tab-button.ion-focused){background:var(--background-focused)}:host(.tab-bar-translucent) ::slotted(ion-tab-button){background:transparent}:host([slot=top]){padding-top:var(--ion-safe-area-top, 0);padding-bottom:0;border-top:0;border-bottom:var(--border)}:host(.tab-bar-hidden){display:none !important}:host{--background:var(--ion-tab-bar-background, var(--ion-background-color, #fff));--background-focused:var(--ion-tab-bar-background-focused, #e0e0e0);--border:1px solid var(--ion-tab-bar-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.07))));--color:var(--ion-tab-bar-color, var(--ion-color-step-600, #666666));--color-selected:var(--ion-tab-bar-color-selected, var(--ion-color-primary, #3880ff));height:56px}", Cw = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionTabBarChanged = G(this, "ionTabBarChanged", 7), this.keyboardCtrl = null, this.keyboardVisible = !1, this.translucent = !1;
  }
  selectedTabChanged() {
    this.selectedTab !== void 0 && this.ionTabBarChanged.emit({
      tab: this.selectedTab
    });
  }
  componentWillLoad() {
    this.selectedTabChanged();
  }
  connectedCallback() {
    this.keyboardCtrl = vy((e) => {
      this.keyboardVisible = e;
    });
  }
  disconnectedCallback() {
    this.keyboardCtrl && this.keyboardCtrl.destroy();
  }
  render() {
    const { color: e, translucent: t, keyboardVisible: n } = this, o = te(this), i = n && this.el.getAttribute("slot") !== "top";
    return x(ae, { role: "tablist", "aria-hidden": i ? "true" : null, class: dt(e, {
      [o]: !0,
      "tab-bar-translucent": t,
      "tab-bar-hidden": i
    }) }, x("slot", null));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      selectedTab: ["selectedTabChanged"]
    };
  }
  static get style() {
    return {
      ios: Sw,
      md: Ow
    };
  }
}, [33, "ion-tab-bar", {
  color: [513],
  selectedTab: [1, "selected-tab"],
  translucent: [4],
  keyboardVisible: [32]
}]);
function Aw() {
  if (typeof customElements > "u")
    return;
  ["ion-tab-bar"].forEach((t) => {
    switch (t) {
      case "ion-tab-bar":
        customElements.get(t) || customElements.define(t, Cw);
        break;
    }
  });
}
const Dw = Aw;
let Or;
const $w = () => {
  if (typeof window > "u")
    return /* @__PURE__ */ new Map();
  if (!Or) {
    const e = window;
    e.Ionicons = e.Ionicons || {}, Or = e.Ionicons.map = e.Ionicons.map || /* @__PURE__ */ new Map();
  }
  return Or;
}, Nw = (e) => {
  let t = Cr(e.src);
  return t || (t = kf(e.name, e.icon, e.mode, e.ios, e.md), t ? Lw(t) : e.icon && (t = Cr(e.icon), t || (t = Cr(e.icon[e.mode]), t)) ? t : null);
}, Lw = (e) => {
  const t = $w().get(e);
  return t || $u(`svg/${e}.svg`);
}, kf = (e, t, n, o, i) => (n = (n && hi(n)) === "ios" ? "ios" : "md", o && n === "ios" ? e = hi(o) : i && n === "md" ? e = hi(i) : (!e && t && !xf(t) && (e = t), Fi(e) && (e = hi(e))), !Fi(e) || e.trim() === "" || e.replace(/[a-z]|-|\d/gi, "") !== "" ? null : e), Cr = (e) => Fi(e) && (e = e.trim(), xf(e)) ? e : null, xf = (e) => e.length > 0 && /(\/|\.)/.test(e), Fi = (e) => typeof e == "string", hi = (e) => e.toLowerCase(), Pw = (e, t = []) => {
  const n = {};
  return t.forEach((o) => {
    e.hasAttribute(o) && (e.getAttribute(o) !== null && (n[o] = e.getAttribute(o)), e.removeAttribute(o));
  }), n;
}, Mw = (e) => e && e.dir !== "" ? e.dir.toLowerCase() === "rtl" : (document == null ? void 0 : document.dir.toLowerCase()) === "rtl", Fw = (e) => {
  const t = document.createElement("div");
  t.innerHTML = e;
  for (let o = t.childNodes.length - 1; o >= 0; o--)
    t.childNodes[o].nodeName.toLowerCase() !== "svg" && t.removeChild(t.childNodes[o]);
  const n = t.firstElementChild;
  if (n && n.nodeName.toLowerCase() === "svg") {
    const o = n.getAttribute("class") || "";
    if (n.setAttribute("class", (o + " s-ion-icon").trim()), _f(n))
      return t.innerHTML;
  }
  return "";
}, _f = (e) => {
  if (e.nodeType === 1) {
    if (e.nodeName.toLowerCase() === "script")
      return !1;
    for (let t = 0; t < e.attributes.length; t++) {
      const n = e.attributes[t].name;
      if (Fi(n) && n.toLowerCase().indexOf("on") === 0)
        return !1;
    }
    for (let t = 0; t < e.childNodes.length; t++)
      if (!_f(e.childNodes[t]))
        return !1;
  }
  return !0;
}, Rw = (e) => e.startsWith("data:image/svg+xml"), Vw = (e) => e.indexOf(";utf8,") !== -1, Tn = /* @__PURE__ */ new Map(), ac = /* @__PURE__ */ new Map();
let Ar;
const zw = (e, t) => {
  let n = ac.get(e);
  if (!n)
    if (typeof fetch < "u" && typeof document < "u")
      if (Rw(e) && Vw(e)) {
        Ar || (Ar = new DOMParser());
        const i = Ar.parseFromString(e, "text/html").querySelector("svg");
        return i && Tn.set(e, i.outerHTML), Promise.resolve();
      } else
        n = fetch(e).then((o) => {
          if (o.ok)
            return o.text().then((i) => {
              i && t !== !1 && (i = Fw(i)), Tn.set(e, i || "");
            });
          Tn.set(e, "");
        }), ac.set(e, n);
    else
      return Tn.set(e, ""), Promise.resolve();
  return n;
}, Uw = ":host{display:inline-block;width:1em;height:1em;contain:strict;fill:currentColor;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host .ionicon{stroke:currentColor}.ionicon-fill-none{fill:none}.ionicon-stroke-width{stroke-width:32px;stroke-width:var(--ionicon-stroke-width, 32px)}.icon-inner,.ionicon,svg{display:block;height:100%;width:100%}:host(.flip-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}:host(.icon-small){font-size:18px !important}:host(.icon-large){font-size:32px !important}:host(.ion-color){color:var(--ion-color-base) !important}:host(.ion-color-primary){--ion-color-base:var(--ion-color-primary, #3880ff)}:host(.ion-color-secondary){--ion-color-base:var(--ion-color-secondary, #0cd1e8)}:host(.ion-color-tertiary){--ion-color-base:var(--ion-color-tertiary, #f4a942)}:host(.ion-color-success){--ion-color-base:var(--ion-color-success, #10dc60)}:host(.ion-color-warning){--ion-color-base:var(--ion-color-warning, #ffce00)}:host(.ion-color-danger){--ion-color-base:var(--ion-color-danger, #f14141)}:host(.ion-color-light){--ion-color-base:var(--ion-color-light, #f4f5f8)}:host(.ion-color-medium){--ion-color-base:var(--ion-color-medium, #989aa2)}:host(.ion-color-dark){--ion-color-base:var(--ion-color-dark, #222428)}", Hw = /* @__PURE__ */ de(class extends ue {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.iconName = null, this.inheritedAttributes = {}, this.isVisible = !1, this.mode = Bw(), this.lazy = !1, this.sanitize = !0, this.hasAriaHidden = () => {
      const { el: e } = this;
      return e.hasAttribute("aria-hidden") && e.getAttribute("aria-hidden") === "true";
    };
  }
  componentWillLoad() {
    this.inheritedAttributes = Pw(this.el, ["aria-label"]);
  }
  connectedCallback() {
    this.waitUntilVisible(this.el, "50px", () => {
      this.isVisible = !0, this.loadIcon();
    });
  }
  disconnectedCallback() {
    this.io && (this.io.disconnect(), this.io = void 0);
  }
  waitUntilVisible(e, t, n) {
    if (this.lazy && typeof window < "u" && window.IntersectionObserver) {
      const o = this.io = new window.IntersectionObserver((i) => {
        i[0].isIntersecting && (o.disconnect(), this.io = void 0, n());
      }, { rootMargin: t });
      o.observe(e);
    } else
      n();
  }
  loadIcon() {
    if (this.isVisible) {
      const t = Nw(this);
      t && (Tn.has(t) ? this.svgContent = Tn.get(t) : zw(t, this.sanitize).then(() => this.svgContent = Tn.get(t)));
    }
    const e = this.iconName = kf(this.name, this.icon, this.mode, this.ios, this.md);
    e && (this.ariaLabel = e.replace(/\-/g, " "));
  }
  render() {
    const { iconName: e, ariaLabel: t, el: n, inheritedAttributes: o } = this, i = this.mode || "md", r = this.flipRtl || e && (e.indexOf("arrow") > -1 || e.indexOf("chevron") > -1) && this.flipRtl !== !1;
    return x(ae, Object.assign({ "aria-label": t !== void 0 && !this.hasAriaHidden() ? t : null, role: "img", class: Object.assign(Object.assign({ [i]: !0 }, Ww(this.color)), { [`icon-${this.size}`]: !!this.size, "flip-rtl": !!r && Mw(n) }) }, o), this.svgContent ? x("div", { class: "icon-inner", innerHTML: this.svgContent }) : x("div", { class: "icon-inner" }));
  }
  static get assetsDirs() {
    return ["svg"];
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      name: ["loadIcon"],
      src: ["loadIcon"],
      icon: ["loadIcon"],
      ios: ["loadIcon"],
      md: ["loadIcon"]
    };
  }
  static get style() {
    return Uw;
  }
}, [1, "ion-icon", {
  mode: [1025],
  color: [1],
  ios: [1],
  md: [1],
  flipRtl: [4, "flip-rtl"],
  name: [513],
  src: [1],
  icon: [8],
  size: [1],
  lazy: [4],
  sanitize: [4],
  svgContent: [32],
  isVisible: [32],
  ariaLabel: [32]
}]), Bw = () => typeof document < "u" && document.documentElement.getAttribute("mode") || "md", Ww = (e) => e ? {
  "ion-color": !0,
  [`ion-color-${e}`]: !0
} : null;
function jw() {
  if (typeof customElements > "u")
    return;
  ["ion-icon"].forEach((t) => {
    switch (t) {
      case "ion-icon":
        customElements.get(t) || customElements.define(t, Hw);
        break;
    }
  });
}
const Yw = jw, lc = "update:modelValue", Dr = "modelValue", Gw = "routerLink", cc = "navManager", qw = "router", Kw = "aria", Jn = Symbol(), $r = { default: Jn }, dc = (e) => (e == null ? void 0 : e.split(" ")) || [], Xw = (e, t, n = []) => {
  var o;
  return [...Array.from(((o = e.value) === null || o === void 0 ? void 0 : o.classList) || []), ...n].filter((i, r, s) => !t.has(i) && s.indexOf(i) === r);
}, Mt = (e, t, n = [], o, i, r) => {
  t !== void 0 && t();
  const s = It((a, { attrs: l, slots: c, emit: d }) => {
    var u;
    let f = a[o];
    const g = We(), E = new Set(dc(l.class)), k = (w) => {
      w.el && (Array.isArray(i) ? i : [i]).forEach((b) => {
        w.el.addEventListener(b.toLowerCase(), (y) => {
          f = (y == null ? void 0 : y.target)[o], d(lc, f), r && d(r, y);
        });
      });
    }, S = Zt(), v = ((u = S == null ? void 0 : S.appContext) === null || u === void 0 ? void 0 : u.provides[cc]) ? $o(cc) : void 0, I = (w) => {
      const { routerLink: A } = a;
      if (A !== Jn)
        if (v !== void 0) {
          let b = { event: w };
          for (const y in a) {
            const L = a[y];
            a.hasOwnProperty(y) && y.startsWith(qw) && L !== Jn && (b[y] = L);
          }
          v.navigate(b);
        } else
          console.warn("Tried to navigate, but no router was found. Make sure you have mounted Vue Router.");
    };
    return () => {
      f = a[o], dc(l.class).forEach((y) => {
        E.add(y);
      });
      const w = a.onClick, A = (y) => {
        w !== void 0 && w(y), y.defaultPrevented || I(y);
      };
      let b = {
        ref: g,
        class: Xw(g, E),
        onClick: A,
        onVnodeBeforeMount: i ? k : void 0
      };
      for (const y in a) {
        const L = a[y];
        (a.hasOwnProperty(y) && L !== Jn || y.startsWith(Kw)) && (b[y] = L);
      }
      return o && (a[Dr] !== Jn ? b = Object.assign(Object.assign({}, b), { [o]: a[Dr] }) : f !== Jn && (b = Object.assign(Object.assign({}, b), { [o]: f }))), Wo(e, b, c.default && c.default());
    };
  });
  return s.displayName = e, s.props = {
    [Gw]: $r
  }, n.forEach((a) => {
    s.props[a] = $r;
  }), o && (s.props[Dr] = $r, s.emits = [lc, r]), s;
}, Zw = /* @__PURE__ */ Mt("ion-button", A0, [
  "color",
  "buttonType",
  "disabled",
  "expand",
  "fill",
  "routerDirection",
  "routerAnimation",
  "download",
  "href",
  "rel",
  "shape",
  "size",
  "strong",
  "target",
  "type",
  "form",
  "ionFocus",
  "ionBlur"
]), Ea = /* @__PURE__ */ Mt("ion-card", P0, [
  "color",
  "button",
  "type",
  "disabled",
  "download",
  "href",
  "rel",
  "routerDirection",
  "routerAnimation",
  "target"
]), Ta = /* @__PURE__ */ Mt("ion-card-content", z0), Ia = /* @__PURE__ */ Mt("ion-card-header", j0, [
  "color",
  "translucent"
]), Jw = /* @__PURE__ */ Mt("ion-card-subtitle", X0, [
  "color"
]), Sa = /* @__PURE__ */ Mt("ion-card-title", tv, [
  "color"
]), ys = /* @__PURE__ */ Mt("ion-item", Ty, [
  "color",
  "button",
  "detail",
  "detailIcon",
  "disabled",
  "download",
  "fill",
  "shape",
  "href",
  "rel",
  "lines",
  "counter",
  "routerAnimation",
  "routerDirection",
  "target",
  "type",
  "counterFormatter"
]), ws = /* @__PURE__ */ Mt("ion-label", Iy, [
  "color",
  "position",
  "ionColor",
  "ionStyle"
]), ks = /* @__PURE__ */ Mt("ion-select", kw, [
  "disabled",
  "cancelText",
  "okText",
  "placeholder",
  "name",
  "selectedText",
  "multiple",
  "interface",
  "interfaceOptions",
  "compareWith",
  "value",
  "ionChange",
  "ionCancel",
  "ionDismiss",
  "ionFocus",
  "ionBlur",
  "ionStyle"
], "value", "v-ion-change", "ionChange"), xi = /* @__PURE__ */ Mt("ion-select-option", Iw, [
  "disabled",
  "value"
]);
var Nt;
(function(e) {
  e.WillEnter = "onIonViewWillEnter", e.DidEnter = "onIonViewDidEnter", e.WillLeave = "onIonViewWillLeave", e.DidLeave = "onIonViewDidLeave";
})(Nt || (Nt = {}));
Pv + "", Nt.WillEnter, Mv + "", Nt.DidEnter, Fv + "", Nt.WillLeave, Rv + "", Nt.DidLeave;
const Qw = () => {
  if (typeof window < "u") {
    const e = window.Ionic;
    if (e && e.config)
      return e.config;
  }
  return null;
}, ek = (e, t, n) => {
  if (n) {
    const o = n, i = o.proxy[e] || (o.proxy[e] = []);
    o.exposed && (o.exposed[e] = i);
    const r = (...s) => {
      if (!o.isUnmounted)
        return s ? t(...s) : t();
    };
    return i.push(r), r;
  } else
    console.warn("[@ionic/vue]: Ionic Lifecycle Hooks can only be used during execution of setup().");
}, tr = (e) => (t, n = Zt()) => ek(e, t, n);
tr(Nt.WillEnter);
tr(Nt.DidEnter);
tr(Nt.WillLeave);
tr(Nt.DidLeave);
const Ef = (e) => {
  var t;
  return ((t = e.type) === null || t === void 0 ? void 0 : t.name) === "IonTabButton";
}, Tf = (e) => {
  let t = [];
  return e.forEach((n) => {
    if (Ef(n))
      t.push(n);
    else if (Array.isArray(n.children) && n.children.length > 1) {
      const o = Tf(n.children);
      t = [...t, ...o];
    }
  }), t;
};
It({
  name: "IonTabBar",
  props: {
    /* eslint-disable @typescript-eslint/no-empty-function */
    _tabsWillChange: { type: Function, default: () => {
    } },
    _tabsDidChange: { type: Function, default: () => {
    } }
    /* eslint-enable @typescript-eslint/no-empty-function */
  },
  data() {
    return {
      tabState: {
        activeTab: void 0,
        tabs: {}
      },
      tabVnodes: []
    };
  },
  updated() {
    this.setupTabState($o("navManager"));
  },
  methods: {
    setupTabState(e) {
      const t = this.$data.tabState, n = Zt();
      (this.$data.tabVnodes = Tf(n.subTree.children || [])).forEach((i) => {
        t.tabs[i.props.tab] = {
          originalHref: i.props.href,
          currentHref: i.props.href,
          ref: i
        }, i.component.props._getTabState = () => t;
      }), this.checkActiveTab(e);
    },
    checkActiveTab(e) {
      const t = e.getCurrentRouteInfo(), n = this.$data.tabVnodes, { tabs: o, activeTab: i } = this.$data.tabState, r = this.$data.tabState, a = Object.keys(o).find((u) => {
        const f = o[u].originalHref;
        return t.pathname.startsWith(f);
      });
      if (n.forEach((u) => {
        const f = o[u.props.tab];
        (!f || f.originalHref !== u.props.href) && (o[u.props.tab] = {
          originalHref: u.props.href,
          currentHref: u.props.href,
          ref: u
        });
      }), a && i) {
        const u = this.$data.tabState.tabs[i].currentHref;
        if (a !== i || u !== t.pathname) {
          const f = t.search ? `?${t.search}` : "";
          o[a] = Object.assign(Object.assign({}, o[a]), { currentHref: t.pathname + f });
        }
        t.routerAction === "pop" && a !== i && (o[i] = Object.assign(Object.assign({}, o[i]), { currentHref: o[i].originalHref }));
      }
      const l = n.find((u) => {
        var f;
        return Ef(u) && ((f = u.props) === null || f === void 0 ? void 0 : f.tab) === a;
      }), c = this.$refs.ionTabBar, d = a !== i;
      c && (l ? (d && this.$props._tabsWillChange(a), e.handleSetCurrentTab(a), c.selectedTab = r.activeTab = a, d && this.$props._tabsDidChange(a)) : c.selectedTab = r.activeTab = "");
    }
  },
  mounted() {
    const e = $o("navManager");
    this.setupTabState(e), e.registerHistoryChangeListener(() => this.checkActiveTab(e));
  },
  setup(e, { slots: t }) {
    return Dw(), () => Wo("ion-tab-bar", { ref: "ionTabBar" }, t.default && t.default());
  }
});
bd([]);
const tk = /* @__PURE__ */ It({
  name: "IonIcon",
  props: {
    color: String,
    flipRtl: Boolean,
    icon: String,
    ios: String,
    lazy: String,
    md: String,
    mode: String,
    name: String,
    size: String,
    src: String
  },
  setup(e, { slots: t }) {
    return Yw(), () => {
      var n, o;
      const { icon: i, ios: r, md: s, mode: a } = e;
      let l;
      const c = Qw(), d = a || (c == null ? void 0 : c.get("mode"));
      return r || s ? d === "ios" ? l = (n = r ?? s) !== null && n !== void 0 ? n : i : l = (o = s ?? r) !== null && o !== void 0 ? o : i : l = i, Wo("ion-icon", Object.assign(Object.assign({}, e), { icon: l }), t);
    };
  }
}), nk = /* @__PURE__ */ It({
  __name: "ProductIdentifier",
  setup(e) {
    const t = Jm(), n = Ui.config.globalProperties.$store, o = Oe(() => n.getters["user/getCurrentEComStore"]), i = Oe(() => t.getProductIdentificationPref), r = t.getProductIdentificationOptions;
    Gs(() => {
      t.getIdentificationPref(o.value.productStoreId);
    });
    function s(a, l) {
      t.setProductIdentificationPref(l, a, o.value.productStoreId);
    }
    return (a, l) => ($t(), no(J(Ea), null, {
      default: re(() => [
        he(J(Ia), null, {
          default: re(() => [
            he(J(Sa), null, {
              default: re(() => [
                Ue(He("Product Identifier"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        he(J(Ta), null, {
          default: re(() => [
            Ue(He("Choosing a product identifier allows you to view products with your preferred identifiers."), 1)
          ]),
          _: 1
        }),
        he(J(ys), null, {
          default: re(() => [
            he(J(ws), null, {
              default: re(() => [
                Ue(He("Primary Product Identifier"))
              ]),
              _: 1
            }),
            he(J(ks), {
              interface: "popover",
              placeholder: "primary identifier",
              value: i.value.primaryId,
              onIonChange: l[0] || (l[0] = (c) => s(c.detail.value, "primaryId"))
            }, {
              default: re(() => [
                ($t(!0), _i(Lo, null, Jr(J(r), (c) => ($t(), no(J(xi), {
                  key: c,
                  value: c
                }, {
                  default: re(() => [
                    Ue(He(c), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        he(J(ys), null, {
          default: re(() => [
            he(J(ws), null, {
              default: re(() => [
                Ue(He("Secondary Product Identifier"))
              ]),
              _: 1
            }),
            he(J(ks), {
              interface: "popover",
              placeholder: "secondary identifier",
              value: i.value.secondaryId,
              onIonChange: l[1] || (l[1] = (c) => s(c.detail.value, "secondaryId"))
            }, {
              default: re(() => [
                ($t(!0), _i(Lo, null, Jr(J(r), (c) => ($t(), no(J(xi), {
                  key: c,
                  value: c
                }, {
                  default: re(() => [
                    Ue(He(c), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128)),
                he(J(xi), { value: "" }, {
                  default: re(() => [
                    Ue(He("None"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), If = Zs("user", {
  state: () => ({
    locale: "",
    localeOptions: process.env.VUE_APP_LOCALES ? JSON.parse(process.env.VUE_APP_LOCALES) : { en: "English" }
  }),
  getters: {
    getLocale: (e) => e.locale,
    getLocaleOptions: (e) => e.localeOptions
  },
  actions: {
    setLocale(e) {
      Io.global.locale = e, this.locale = e;
    }
  }
}), ok = /* @__PURE__ */ It({
  __name: "LanguageSwitcher",
  setup(e) {
    const t = If(), n = Oe(() => t.getLocaleOptions), o = Oe(() => t.getLocale), i = (r) => {
      t.setLocale(r);
    };
    return (r, s) => ($t(), no(J(Ea), null, {
      default: re(() => [
        he(J(Ia), null, {
          default: re(() => [
            he(J(Sa), null, {
              default: re(() => [
                Ue(He(r.$t("Language")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        he(J(Ta), null, {
          default: re(() => [
            Ue(He(r.$t("Select your preferred language.")), 1)
          ]),
          _: 1
        }),
        he(J(ys), { lines: "none" }, {
          default: re(() => [
            he(J(ws), null, {
              default: re(() => [
                Ue(He(r.$t("Choose language")), 1)
              ]),
              _: 1
            }),
            he(J(ks), {
              interface: "popover",
              value: o.value,
              onIonChange: s[0] || (s[0] = (a) => i(a.detail.value))
            }, {
              default: re(() => [
                ($t(!0), _i(Lo, null, Jr(Object.keys(n.value), (a) => ($t(), no(J(xi), {
                  key: a,
                  value: a
                }, {
                  default: re(() => [
                    Ue(He(n.value[a]), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), ik = (e, t) => {
  const n = (t.startsWith("http") ? t.replace(/api\/?/, "") : `https://${t}.hotwax.io/`) + `commerce/control/main?token=${e}`;
  window.open(n, "_blank", "noopener, noreferrer");
}, rk = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/></svg>", sk = /* @__PURE__ */ It({
  __name: "OmsInstanceNavigator",
  setup(e) {
    const t = Cu(), n = Oe(() => t.getToken), o = Oe(() => t.getOms);
    return (i, r) => ($t(), no(J(Ea), null, {
      default: re(() => [
        he(J(Ia), null, {
          default: re(() => [
            he(J(Jw), null, {
              default: re(() => [
                Ue(He(i.$t("OMS instance")), 1)
              ]),
              _: 1
            }),
            he(J(Sa), null, {
              default: re(() => [
                Ue(He(J(t).getOms), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        he(J(Ta), null, {
          default: re(() => [
            Ue(He(i.$t("This is the name of the OMS you are connected to right now. Make sure that you are connected to the right instance before proceeding.")), 1)
          ]),
          _: 1
        }),
        he(J(Zw), {
          onClick: r[0] || (r[0] = (s) => J(ik)(n.value.value, o.value)),
          fill: "clear"
        }, {
          default: re(() => [
            Ue(He(i.$t("Go to OMS")) + " ", 1),
            he(J(tk), {
              slot: "end",
              icon: J(rk)
            }, null, 8, ["icon"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), ak = ["src"], lk = /* @__PURE__ */ It({
  __name: "ShopifyImg",
  props: ["src", "size"],
  setup(e) {
    const t = e, n = We(Yh.defaultImgUrl), o = (s) => new Promise((a, l) => {
      const c = new Image();
      c.onload = () => a(!0), c.onerror = () => l(!1), c.src = s;
    }), i = (s, a) => a ? s.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".").replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(l) {
      return "_" + a + l;
    }) : s, r = () => {
      if (t.src) {
        const s = i(t.src, t.size);
        o(s).then(() => n.value = s);
      }
    };
    return Gs(() => {
      r();
    }), km(() => {
      r();
    }), (s, a) => ($t(), _i("img", { src: n.value }, null, 8, ak));
  }
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Sf = function(e) {
  const t = [];
  let n = 0;
  for (let o = 0; o < e.length; o++) {
    let i = e.charCodeAt(o);
    i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) === 55296 && o + 1 < e.length && (e.charCodeAt(o + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++o) & 1023), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
  }
  return t;
}, ck = function(e) {
  const t = [];
  let n = 0, o = 0;
  for (; n < e.length; ) {
    const i = e[n++];
    if (i < 128)
      t[o++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const r = e[n++];
      t[o++] = String.fromCharCode((i & 31) << 6 | r & 63);
    } else if (i > 239 && i < 365) {
      const r = e[n++], s = e[n++], a = e[n++], l = ((i & 7) << 18 | (r & 63) << 12 | (s & 63) << 6 | a & 63) - 65536;
      t[o++] = String.fromCharCode(55296 + (l >> 10)), t[o++] = String.fromCharCode(56320 + (l & 1023));
    } else {
      const r = e[n++], s = e[n++];
      t[o++] = String.fromCharCode((i & 15) << 12 | (r & 63) << 6 | s & 63);
    }
  }
  return t.join("");
}, Of = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(e, t) {
    if (!Array.isArray(e))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, o = [];
    for (let i = 0; i < e.length; i += 3) {
      const r = e[i], s = i + 1 < e.length, a = s ? e[i + 1] : 0, l = i + 2 < e.length, c = l ? e[i + 2] : 0, d = r >> 2, u = (r & 3) << 4 | a >> 4;
      let f = (a & 15) << 2 | c >> 6, g = c & 63;
      l || (g = 64, s || (f = 64)), o.push(n[d], n[u], n[f], n[g]);
    }
    return o.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(Sf(e), t);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : ck(this.decodeStringToByteArray(e, t));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(e, t) {
    this.init_();
    const n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, o = [];
    for (let i = 0; i < e.length; ) {
      const r = n[e.charAt(i++)], a = i < e.length ? n[e.charAt(i)] : 0;
      ++i;
      const c = i < e.length ? n[e.charAt(i)] : 64;
      ++i;
      const u = i < e.length ? n[e.charAt(i)] : 64;
      if (++i, r == null || a == null || c == null || u == null)
        throw new dk();
      const f = r << 2 | a >> 4;
      if (o.push(f), c !== 64) {
        const g = a << 4 & 240 | c >> 2;
        if (o.push(g), u !== 64) {
          const E = c << 6 & 192 | u;
          o.push(E);
        }
      }
    }
    return o;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let e = 0; e < this.ENCODED_VALS.length; e++)
        this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
    }
  }
};
class dk extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const uk = function(e) {
  const t = Sf(e);
  return Of.encodeByteArray(t, !0);
}, Cf = function(e) {
  return uk(e).replace(/\./g, "");
}, fk = function(e) {
  try {
    return Of.decodeString(e, !0);
  } catch (t) {
    console.error("base64Decode failed: ", t);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function hk() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const mk = () => hk().__FIREBASE_DEFAULTS__, pk = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const e = process.env.__FIREBASE_DEFAULTS__;
  if (e)
    return JSON.parse(e);
}, gk = () => {
  if (typeof document > "u")
    return;
  let e;
  try {
    e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const t = e && fk(e[1]);
  return t && JSON.parse(t);
}, bk = () => {
  try {
    return mk() || pk() || gk();
  } catch (e) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
}, Af = () => {
  var e;
  return (e = bk()) === null || e === void 0 ? void 0 : e.config;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class vk {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(t) {
    return (n, o) => {
      n ? this.reject(n) : this.resolve(o), typeof t == "function" && (this.promise.catch(() => {
      }), t.length === 1 ? t(n) : t(n, o));
    };
  }
}
function Df() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function $f() {
  return new Promise((e, t) => {
    try {
      let n = !0;
      const o = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(o);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(o), e(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var r;
        t(((r = i.error) === null || r === void 0 ? void 0 : r.message) || "");
      };
    } catch (n) {
      t(n);
    }
  });
}
function yk() {
  return !(typeof navigator > "u" || !navigator.cookieEnabled);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wk = "FirebaseError";
class bo extends Error {
  constructor(t, n, o) {
    super(n), this.code = t, this.customData = o, this.name = wk, Object.setPrototypeOf(this, bo.prototype), Error.captureStackTrace && Error.captureStackTrace(this, nr.prototype.create);
  }
}
class nr {
  constructor(t, n, o) {
    this.service = t, this.serviceName = n, this.errors = o;
  }
  create(t, ...n) {
    const o = n[0] || {}, i = `${this.service}/${t}`, r = this.errors[t], s = r ? kk(r, o) : "Error", a = `${this.serviceName}: ${s} (${i}).`;
    return new bo(i, a, o);
  }
}
function kk(e, t) {
  return e.replace(xk, (n, o) => {
    const i = t[o];
    return i != null ? String(i) : `<${o}?>`;
  });
}
const xk = /\{\$([^}]+)}/g;
function xs(e, t) {
  if (e === t)
    return !0;
  const n = Object.keys(e), o = Object.keys(t);
  for (const i of n) {
    if (!o.includes(i))
      return !1;
    const r = e[i], s = t[i];
    if (uc(r) && uc(s)) {
      if (!xs(r, s))
        return !1;
    } else if (r !== s)
      return !1;
  }
  for (const i of o)
    if (!n.includes(i))
      return !1;
  return !0;
}
function uc(e) {
  return e !== null && typeof e == "object";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Oa(e) {
  return e && e._delegate ? e._delegate : e;
}
class hn {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(t, n, o) {
    this.name = t, this.instanceFactory = n, this.type = o, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(t) {
    return this.instantiationMode = t, this;
  }
  setMultipleInstances(t) {
    return this.multipleInstances = t, this;
  }
  setServiceProps(t) {
    return this.serviceProps = t, this;
  }
  setInstanceCreatedCallback(t) {
    return this.onInstanceCreated = t, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const kn = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _k {
  constructor(t, n) {
    this.name = t, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(t) {
    const n = this.normalizeInstanceIdentifier(t);
    if (!this.instancesDeferred.has(n)) {
      const o = new vk();
      if (this.instancesDeferred.set(n, o), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: n
          });
          i && o.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(t) {
    var n;
    const o = this.normalizeInstanceIdentifier(t == null ? void 0 : t.identifier), i = (n = t == null ? void 0 : t.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(o) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: o
        });
      } catch (r) {
        if (i)
          return null;
        throw r;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(t) {
    if (t.name !== this.name)
      throw Error(`Mismatching Component ${t.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = t, !!this.shouldAutoInitialize()) {
      if (Tk(t))
        try {
          this.getOrInitializeService({ instanceIdentifier: kn });
        } catch {
        }
      for (const [n, o] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(n);
        try {
          const r = this.getOrInitializeService({
            instanceIdentifier: i
          });
          o.resolve(r);
        } catch {
        }
      }
    }
  }
  clearInstance(t = kn) {
    this.instancesDeferred.delete(t), this.instancesOptions.delete(t), this.instances.delete(t);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const t = Array.from(this.instances.values());
    await Promise.all([
      ...t.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...t.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(t = kn) {
    return this.instances.has(t);
  }
  getOptions(t = kn) {
    return this.instancesOptions.get(t) || {};
  }
  initialize(t = {}) {
    const { options: n = {} } = t, o = this.normalizeInstanceIdentifier(t.instanceIdentifier);
    if (this.isInitialized(o))
      throw Error(`${this.name}(${o}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: o,
      options: n
    });
    for (const [r, s] of this.instancesDeferred.entries()) {
      const a = this.normalizeInstanceIdentifier(r);
      o === a && s.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(t, n) {
    var o;
    const i = this.normalizeInstanceIdentifier(n), r = (o = this.onInitCallbacks.get(i)) !== null && o !== void 0 ? o : /* @__PURE__ */ new Set();
    r.add(t), this.onInitCallbacks.set(i, r);
    const s = this.instances.get(i);
    return s && t(s, i), () => {
      r.delete(t);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(t, n) {
    const o = this.onInitCallbacks.get(n);
    if (o)
      for (const i of o)
        try {
          i(t, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: t, options: n = {} }) {
    let o = this.instances.get(t);
    if (!o && this.component && (o = this.component.instanceFactory(this.container, {
      instanceIdentifier: Ek(t),
      options: n
    }), this.instances.set(t, o), this.instancesOptions.set(t, n), this.invokeOnInitCallbacks(o, t), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, t, o);
      } catch {
      }
    return o || null;
  }
  normalizeInstanceIdentifier(t = kn) {
    return this.component ? this.component.multipleInstances ? t : kn : t;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function Ek(e) {
  return e === kn ? void 0 : e;
}
function Tk(e) {
  return e.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ik {
  constructor(t) {
    this.name = t, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(t) {
    const n = this.getProvider(t.name);
    if (n.isComponentSet())
      throw new Error(`Component ${t.name} has already been registered with ${this.name}`);
    n.setComponent(t);
  }
  addOrOverwriteComponent(t) {
    this.getProvider(t.name).isComponentSet() && this.providers.delete(t.name), this.addComponent(t);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(t) {
    if (this.providers.has(t))
      return this.providers.get(t);
    const n = new _k(t, this);
    return this.providers.set(t, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var le;
(function(e) {
  e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(le || (le = {}));
const Sk = {
  debug: le.DEBUG,
  verbose: le.VERBOSE,
  info: le.INFO,
  warn: le.WARN,
  error: le.ERROR,
  silent: le.SILENT
}, Ok = le.INFO, Ck = {
  [le.DEBUG]: "log",
  [le.VERBOSE]: "log",
  [le.INFO]: "info",
  [le.WARN]: "warn",
  [le.ERROR]: "error"
}, Ak = (e, t, ...n) => {
  if (t < e.logLevel)
    return;
  const o = (/* @__PURE__ */ new Date()).toISOString(), i = Ck[t];
  if (i)
    console[i](`[${o}]  ${e.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);
};
class Dk {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(t) {
    this.name = t, this._logLevel = Ok, this._logHandler = Ak, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(t) {
    if (!(t in le))
      throw new TypeError(`Invalid value "${t}" assigned to \`logLevel\``);
    this._logLevel = t;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(t) {
    this._logLevel = typeof t == "string" ? Sk[t] : t;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(t) {
    if (typeof t != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = t;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(t) {
    this._userLogHandler = t;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...t) {
    this._userLogHandler && this._userLogHandler(this, le.DEBUG, ...t), this._logHandler(this, le.DEBUG, ...t);
  }
  log(...t) {
    this._userLogHandler && this._userLogHandler(this, le.VERBOSE, ...t), this._logHandler(this, le.VERBOSE, ...t);
  }
  info(...t) {
    this._userLogHandler && this._userLogHandler(this, le.INFO, ...t), this._logHandler(this, le.INFO, ...t);
  }
  warn(...t) {
    this._userLogHandler && this._userLogHandler(this, le.WARN, ...t), this._logHandler(this, le.WARN, ...t);
  }
  error(...t) {
    this._userLogHandler && this._userLogHandler(this, le.ERROR, ...t), this._logHandler(this, le.ERROR, ...t);
  }
}
const $k = (e, t) => t.some((n) => e instanceof n);
let fc, hc;
function Nk() {
  return fc || (fc = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Lk() {
  return hc || (hc = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const Nf = /* @__PURE__ */ new WeakMap(), _s = /* @__PURE__ */ new WeakMap(), Lf = /* @__PURE__ */ new WeakMap(), Nr = /* @__PURE__ */ new WeakMap(), Ca = /* @__PURE__ */ new WeakMap();
function Pk(e) {
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("success", r), e.removeEventListener("error", s);
    }, r = () => {
      n(cn(e.result)), i();
    }, s = () => {
      o(e.error), i();
    };
    e.addEventListener("success", r), e.addEventListener("error", s);
  });
  return t.then((n) => {
    n instanceof IDBCursor && Nf.set(n, e);
  }).catch(() => {
  }), Ca.set(t, e), t;
}
function Mk(e) {
  if (_s.has(e))
    return;
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("complete", r), e.removeEventListener("error", s), e.removeEventListener("abort", s);
    }, r = () => {
      n(), i();
    }, s = () => {
      o(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", r), e.addEventListener("error", s), e.addEventListener("abort", s);
  });
  _s.set(e, t);
}
let Es = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return _s.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || Lf.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return cn(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function Fk(e) {
  Es = e(Es);
}
function Rk(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const o = e.call(Lr(this), t, ...n);
    return Lf.set(o, t.sort ? t.sort() : [t]), cn(o);
  } : Lk().includes(e) ? function(...t) {
    return e.apply(Lr(this), t), cn(Nf.get(this));
  } : function(...t) {
    return cn(e.apply(Lr(this), t));
  };
}
function Vk(e) {
  return typeof e == "function" ? Rk(e) : (e instanceof IDBTransaction && Mk(e), $k(e, Nk()) ? new Proxy(e, Es) : e);
}
function cn(e) {
  if (e instanceof IDBRequest)
    return Pk(e);
  if (Nr.has(e))
    return Nr.get(e);
  const t = Vk(e);
  return t !== e && (Nr.set(e, t), Ca.set(t, e)), t;
}
const Lr = (e) => Ca.get(e);
function zk(e, t, { blocked: n, upgrade: o, blocking: i, terminated: r } = {}) {
  const s = indexedDB.open(e, t), a = cn(s);
  return o && s.addEventListener("upgradeneeded", (l) => {
    o(cn(s.result), l.oldVersion, l.newVersion, cn(s.transaction), l);
  }), n && s.addEventListener("blocked", (l) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    l.oldVersion,
    l.newVersion,
    l
  )), a.then((l) => {
    r && l.addEventListener("close", () => r()), i && l.addEventListener("versionchange", (c) => i(c.oldVersion, c.newVersion, c));
  }).catch(() => {
  }), a;
}
const Uk = ["get", "getKey", "getAll", "getAllKeys", "count"], Hk = ["put", "add", "delete", "clear"], Pr = /* @__PURE__ */ new Map();
function mc(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (Pr.get(t))
    return Pr.get(t);
  const n = t.replace(/FromIndex$/, ""), o = t !== n, i = Hk.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (o ? IDBIndex : IDBObjectStore).prototype) || !(i || Uk.includes(n))
  )
    return;
  const r = async function(s, ...a) {
    const l = this.transaction(s, i ? "readwrite" : "readonly");
    let c = l.store;
    return o && (c = c.index(a.shift())), (await Promise.all([
      c[n](...a),
      i && l.done
    ]))[0];
  };
  return Pr.set(t, r), r;
}
Fk((e) => ({
  ...e,
  get: (t, n, o) => mc(t, n) || e.get(t, n, o),
  has: (t, n) => !!mc(t, n) || e.has(t, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Bk {
  constructor(t) {
    this.container = t;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (Wk(n)) {
        const o = n.getImmediate();
        return `${o.library}/${o.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function Wk(e) {
  const t = e.getComponent();
  return (t == null ? void 0 : t.type) === "VERSION";
}
const Ts = "@firebase/app", pc = "0.9.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const $n = new Dk("@firebase/app"), jk = "@firebase/app-compat", Yk = "@firebase/analytics-compat", Gk = "@firebase/analytics", qk = "@firebase/app-check-compat", Kk = "@firebase/app-check", Xk = "@firebase/auth", Zk = "@firebase/auth-compat", Jk = "@firebase/database", Qk = "@firebase/database-compat", ex = "@firebase/functions", tx = "@firebase/functions-compat", nx = "@firebase/installations", ox = "@firebase/installations-compat", ix = "@firebase/messaging", rx = "@firebase/messaging-compat", sx = "@firebase/performance", ax = "@firebase/performance-compat", lx = "@firebase/remote-config", cx = "@firebase/remote-config-compat", dx = "@firebase/storage", ux = "@firebase/storage-compat", fx = "@firebase/firestore", hx = "@firebase/firestore-compat", mx = "firebase";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Is = "[DEFAULT]", px = {
  [Ts]: "fire-core",
  [jk]: "fire-core-compat",
  [Gk]: "fire-analytics",
  [Yk]: "fire-analytics-compat",
  [Kk]: "fire-app-check",
  [qk]: "fire-app-check-compat",
  [Xk]: "fire-auth",
  [Zk]: "fire-auth-compat",
  [Jk]: "fire-rtdb",
  [Qk]: "fire-rtdb-compat",
  [ex]: "fire-fn",
  [tx]: "fire-fn-compat",
  [nx]: "fire-iid",
  [ox]: "fire-iid-compat",
  [ix]: "fire-fcm",
  [rx]: "fire-fcm-compat",
  [sx]: "fire-perf",
  [ax]: "fire-perf-compat",
  [lx]: "fire-rc",
  [cx]: "fire-rc-compat",
  [dx]: "fire-gcs",
  [ux]: "fire-gcs-compat",
  [fx]: "fire-fst",
  [hx]: "fire-fst-compat",
  "fire-js": "fire-js",
  [mx]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ri = /* @__PURE__ */ new Map(), Ss = /* @__PURE__ */ new Map();
function gx(e, t) {
  try {
    e.container.addComponent(t);
  } catch (n) {
    $n.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
  }
}
function Nn(e) {
  const t = e.name;
  if (Ss.has(t))
    return $n.debug(`There were multiple attempts to register component ${t}.`), !1;
  Ss.set(t, e);
  for (const n of Ri.values())
    gx(n, e);
  return !0;
}
function Aa(e, t) {
  const n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const bx = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
}, dn = new nr("app", "Firebase", bx);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class vx {
  constructor(t, n, o) {
    this._isDeleted = !1, this._options = Object.assign({}, t), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = o, this.container.addComponent(new hn(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(t) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = t;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(t) {
    this._isDeleted = t;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw dn.create("app-deleted", { appName: this._name });
  }
}
function Pf(e, t = {}) {
  let n = e;
  typeof t != "object" && (t = { name: t });
  const o = Object.assign({ name: Is, automaticDataCollectionEnabled: !1 }, t), i = o.name;
  if (typeof i != "string" || !i)
    throw dn.create("bad-app-name", {
      appName: String(i)
    });
  if (n || (n = Af()), !n)
    throw dn.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const r = Ri.get(i);
  if (r) {
    if (xs(n, r.options) && xs(o, r.config))
      return r;
    throw dn.create("duplicate-app", { appName: i });
  }
  const s = new Ik(i);
  for (const l of Ss.values())
    s.addComponent(l);
  const a = new vx(n, o, s);
  return Ri.set(i, a), a;
}
function yx(e = Is) {
  const t = Ri.get(e);
  if (!t && e === Is && Af())
    return Pf();
  if (!t)
    throw dn.create("no-app", { appName: e });
  return t;
}
function un(e, t, n) {
  var o;
  let i = (o = px[e]) !== null && o !== void 0 ? o : e;
  n && (i += `-${n}`);
  const r = i.match(/\s|\//), s = t.match(/\s|\//);
  if (r || s) {
    const a = [
      `Unable to register library "${i}" with version "${t}":`
    ];
    r && a.push(`library name "${i}" contains illegal characters (whitespace or "/")`), r && s && a.push("and"), s && a.push(`version name "${t}" contains illegal characters (whitespace or "/")`), $n.warn(a.join(" "));
    return;
  }
  Nn(new hn(
    `${i}-version`,
    () => ({ library: i, version: t }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wx = "firebase-heartbeat-database", kx = 1, Vo = "firebase-heartbeat-store";
let Mr = null;
function Mf() {
  return Mr || (Mr = zk(wx, kx, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(Vo);
      }
    }
  }).catch((e) => {
    throw dn.create("idb-open", {
      originalErrorMessage: e.message
    });
  })), Mr;
}
async function xx(e) {
  try {
    return await (await Mf()).transaction(Vo).objectStore(Vo).get(Ff(e));
  } catch (t) {
    if (t instanceof bo)
      $n.warn(t.message);
    else {
      const n = dn.create("idb-get", {
        originalErrorMessage: t == null ? void 0 : t.message
      });
      $n.warn(n.message);
    }
  }
}
async function gc(e, t) {
  try {
    const o = (await Mf()).transaction(Vo, "readwrite");
    await o.objectStore(Vo).put(t, Ff(e)), await o.done;
  } catch (n) {
    if (n instanceof bo)
      $n.warn(n.message);
    else {
      const o = dn.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      $n.warn(o.message);
    }
  }
}
function Ff(e) {
  return `${e.name}!${e.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _x = 1024, Ex = 30 * 24 * 60 * 60 * 1e3;
class Tx {
  constructor(t) {
    this.container = t, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new Sx(n), this._heartbeatsCachePromise = this._storage.read().then((o) => (this._heartbeatsCache = o, o));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    const n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), o = bc();
    if (this._heartbeatsCache === null && (this._heartbeatsCache = await this._heartbeatsCachePromise), !(this._heartbeatsCache.lastSentHeartbeatDate === o || this._heartbeatsCache.heartbeats.some((i) => i.date === o)))
      return this._heartbeatsCache.heartbeats.push({ date: o, agent: n }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((i) => {
        const r = new Date(i.date).valueOf();
        return Date.now() - r <= Ex;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const t = bc(), { heartbeatsToSend: n, unsentEntries: o } = Ix(this._heartbeatsCache.heartbeats), i = Cf(JSON.stringify({ version: 2, heartbeats: n }));
    return this._heartbeatsCache.lastSentHeartbeatDate = t, o.length > 0 ? (this._heartbeatsCache.heartbeats = o, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), i;
  }
}
function bc() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function Ix(e, t = _x) {
  const n = [];
  let o = e.slice();
  for (const i of e) {
    const r = n.find((s) => s.agent === i.agent);
    if (r) {
      if (r.dates.push(i.date), vc(n) > t) {
        r.dates.pop();
        break;
      }
    } else if (n.push({
      agent: i.agent,
      dates: [i.date]
    }), vc(n) > t) {
      n.pop();
      break;
    }
    o = o.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: o
  };
}
class Sx {
  constructor(t) {
    this.app = t, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return Df() ? $f().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    return await this._canUseIndexedDBPromise ? await xx(this.app) || { heartbeats: [] } : { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return gc(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: t.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return gc(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...t.heartbeats
        ]
      });
    } else
      return;
  }
}
function vc(e) {
  return Cf(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: e })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ox(e) {
  Nn(new hn(
    "platform-logger",
    (t) => new Bk(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Nn(new hn(
    "heartbeat",
    (t) => new Tx(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), un(Ts, pc, e), un(Ts, pc, "esm2017"), un("fire-js", "");
}
Ox("");
var Cx = "firebase", Ax = "10.3.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
un(Cx, Ax, "app");
const Dx = (e, t) => t.some((n) => e instanceof n);
let yc, wc;
function $x() {
  return yc || (yc = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Nx() {
  return wc || (wc = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const Rf = /* @__PURE__ */ new WeakMap(), Os = /* @__PURE__ */ new WeakMap(), Vf = /* @__PURE__ */ new WeakMap(), Fr = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap();
function Lx(e) {
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("success", r), e.removeEventListener("error", s);
    }, r = () => {
      n(fn(e.result)), i();
    }, s = () => {
      o(e.error), i();
    };
    e.addEventListener("success", r), e.addEventListener("error", s);
  });
  return t.then((n) => {
    n instanceof IDBCursor && Rf.set(n, e);
  }).catch(() => {
  }), Da.set(t, e), t;
}
function Px(e) {
  if (Os.has(e))
    return;
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("complete", r), e.removeEventListener("error", s), e.removeEventListener("abort", s);
    }, r = () => {
      n(), i();
    }, s = () => {
      o(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", r), e.addEventListener("error", s), e.addEventListener("abort", s);
  });
  Os.set(e, t);
}
let Cs = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return Os.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || Vf.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return fn(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function Mx(e) {
  Cs = e(Cs);
}
function Fx(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const o = e.call(Rr(this), t, ...n);
    return Vf.set(o, t.sort ? t.sort() : [t]), fn(o);
  } : Nx().includes(e) ? function(...t) {
    return e.apply(Rr(this), t), fn(Rf.get(this));
  } : function(...t) {
    return fn(e.apply(Rr(this), t));
  };
}
function Rx(e) {
  return typeof e == "function" ? Fx(e) : (e instanceof IDBTransaction && Px(e), Dx(e, $x()) ? new Proxy(e, Cs) : e);
}
function fn(e) {
  if (e instanceof IDBRequest)
    return Lx(e);
  if (Fr.has(e))
    return Fr.get(e);
  const t = Rx(e);
  return t !== e && (Fr.set(e, t), Da.set(t, e)), t;
}
const Rr = (e) => Da.get(e);
function Vx(e, t, { blocked: n, upgrade: o, blocking: i, terminated: r } = {}) {
  const s = indexedDB.open(e, t), a = fn(s);
  return o && s.addEventListener("upgradeneeded", (l) => {
    o(fn(s.result), l.oldVersion, l.newVersion, fn(s.transaction));
  }), n && s.addEventListener("blocked", () => n()), a.then((l) => {
    r && l.addEventListener("close", () => r()), i && l.addEventListener("versionchange", () => i());
  }).catch(() => {
  }), a;
}
const zx = ["get", "getKey", "getAll", "getAllKeys", "count"], Ux = ["put", "add", "delete", "clear"], Vr = /* @__PURE__ */ new Map();
function kc(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (Vr.get(t))
    return Vr.get(t);
  const n = t.replace(/FromIndex$/, ""), o = t !== n, i = Ux.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (o ? IDBIndex : IDBObjectStore).prototype) || !(i || zx.includes(n))
  )
    return;
  const r = async function(s, ...a) {
    const l = this.transaction(s, i ? "readwrite" : "readonly");
    let c = l.store;
    return o && (c = c.index(a.shift())), (await Promise.all([
      c[n](...a),
      i && l.done
    ]))[0];
  };
  return Vr.set(t, r), r;
}
Mx((e) => ({
  ...e,
  get: (t, n, o) => kc(t, n) || e.get(t, n, o),
  has: (t, n) => !!kc(t, n) || e.has(t, n)
}));
const zf = "@firebase/installations", $a = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Uf = 1e4, Hf = `w:${$a}`, Bf = "FIS_v2", Hx = "https://firebaseinstallations.googleapis.com/v1", Bx = 60 * 60 * 1e3, Wx = "installations", jx = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Yx = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "not-registered": "Firebase Installation is not registered.",
  "installation-not-found": "Firebase Installation not found.",
  "request-failed": '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  "app-offline": "Could not process request. Application offline.",
  "delete-pending-registration": "Can't delete installation while there is a pending registration request."
}, Ln = new nr(Wx, jx, Yx);
function Wf(e) {
  return e instanceof bo && e.code.includes(
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jf({ projectId: e }) {
  return `${Hx}/projects/${e}/installations`;
}
function Yf(e) {
  return {
    token: e.token,
    requestStatus: 2,
    expiresIn: qx(e.expiresIn),
    creationTime: Date.now()
  };
}
async function Gf(e, t) {
  const o = (await t.json()).error;
  return Ln.create("request-failed", {
    requestName: e,
    serverCode: o.code,
    serverMessage: o.message,
    serverStatus: o.status
  });
}
function qf({ apiKey: e }) {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
function Gx(e, { refreshToken: t }) {
  const n = qf(e);
  return n.append("Authorization", Kx(t)), n;
}
async function Kf(e) {
  const t = await e();
  return t.status >= 500 && t.status < 600 ? e() : t;
}
function qx(e) {
  return Number(e.replace("s", "000"));
}
function Kx(e) {
  return `${Bf} ${e}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Xx({ appConfig: e, heartbeatServiceProvider: t }, { fid: n }) {
  const o = jf(e), i = qf(e), r = t.getImmediate({
    optional: !0
  });
  if (r) {
    const c = await r.getHeartbeatsHeader();
    c && i.append("x-firebase-client", c);
  }
  const s = {
    fid: n,
    authVersion: Bf,
    appId: e.appId,
    sdkVersion: Hf
  }, a = {
    method: "POST",
    headers: i,
    body: JSON.stringify(s)
  }, l = await Kf(() => fetch(o, a));
  if (l.ok) {
    const c = await l.json();
    return {
      fid: c.fid || n,
      registrationStatus: 2,
      refreshToken: c.refreshToken,
      authToken: Yf(c.authToken)
    };
  } else
    throw await Gf("Create Installation", l);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Xf(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Zx(e) {
  return btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Jx = /^[cdef][\w-]{21}$/, As = "";
function Qx() {
  try {
    const e = new Uint8Array(17);
    (self.crypto || self.msCrypto).getRandomValues(e), e[0] = 112 + e[0] % 16;
    const n = e_(e);
    return Jx.test(n) ? n : As;
  } catch {
    return As;
  }
}
function e_(e) {
  return Zx(e).substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function or(e) {
  return `${e.appName}!${e.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Zf = /* @__PURE__ */ new Map();
function Jf(e, t) {
  const n = or(e);
  Qf(n, t), t_(n, t);
}
function Qf(e, t) {
  const n = Zf.get(e);
  if (n)
    for (const o of n)
      o(t);
}
function t_(e, t) {
  const n = n_();
  n && n.postMessage({ key: e, fid: t }), o_();
}
let In = null;
function n_() {
  return !In && "BroadcastChannel" in self && (In = new BroadcastChannel("[Firebase] FID Change"), In.onmessage = (e) => {
    Qf(e.data.key, e.data.fid);
  }), In;
}
function o_() {
  Zf.size === 0 && In && (In.close(), In = null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const i_ = "firebase-installations-database", r_ = 1, Pn = "firebase-installations-store";
let zr = null;
function Na() {
  return zr || (zr = Vx(i_, r_, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(Pn);
      }
    }
  })), zr;
}
async function Vi(e, t) {
  const n = or(e), i = (await Na()).transaction(Pn, "readwrite"), r = i.objectStore(Pn), s = await r.get(n);
  return await r.put(t, n), await i.done, (!s || s.fid !== t.fid) && Jf(e, t.fid), t;
}
async function eh(e) {
  const t = or(e), o = (await Na()).transaction(Pn, "readwrite");
  await o.objectStore(Pn).delete(t), await o.done;
}
async function ir(e, t) {
  const n = or(e), i = (await Na()).transaction(Pn, "readwrite"), r = i.objectStore(Pn), s = await r.get(n), a = t(s);
  return a === void 0 ? await r.delete(n) : await r.put(a, n), await i.done, a && (!s || s.fid !== a.fid) && Jf(e, a.fid), a;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function La(e) {
  let t;
  const n = await ir(e.appConfig, (o) => {
    const i = s_(o), r = a_(e, i);
    return t = r.registrationPromise, r.installationEntry;
  });
  return n.fid === As ? { installationEntry: await t } : {
    installationEntry: n,
    registrationPromise: t
  };
}
function s_(e) {
  const t = e || {
    fid: Qx(),
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  };
  return th(t);
}
function a_(e, t) {
  if (t.registrationStatus === 0) {
    if (!navigator.onLine) {
      const i = Promise.reject(Ln.create(
        "app-offline"
        /* ErrorCode.APP_OFFLINE */
      ));
      return {
        installationEntry: t,
        registrationPromise: i
      };
    }
    const n = {
      fid: t.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    }, o = l_(e, n);
    return { installationEntry: n, registrationPromise: o };
  } else
    return t.registrationStatus === 1 ? {
      installationEntry: t,
      registrationPromise: c_(e)
    } : { installationEntry: t };
}
async function l_(e, t) {
  try {
    const n = await Xx(e, t);
    return Vi(e.appConfig, n);
  } catch (n) {
    throw Wf(n) && n.customData.serverCode === 409 ? await eh(e.appConfig) : await Vi(e.appConfig, {
      fid: t.fid,
      registrationStatus: 0
      /* RequestStatus.NOT_STARTED */
    }), n;
  }
}
async function c_(e) {
  let t = await xc(e.appConfig);
  for (; t.registrationStatus === 1; )
    await Xf(100), t = await xc(e.appConfig);
  if (t.registrationStatus === 0) {
    const { installationEntry: n, registrationPromise: o } = await La(e);
    return o || n;
  }
  return t;
}
function xc(e) {
  return ir(e, (t) => {
    if (!t)
      throw Ln.create(
        "installation-not-found"
        /* ErrorCode.INSTALLATION_NOT_FOUND */
      );
    return th(t);
  });
}
function th(e) {
  return d_(e) ? {
    fid: e.fid,
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  } : e;
}
function d_(e) {
  return e.registrationStatus === 1 && e.registrationTime + Uf < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function u_({ appConfig: e, heartbeatServiceProvider: t }, n) {
  const o = f_(e, n), i = Gx(e, n), r = t.getImmediate({
    optional: !0
  });
  if (r) {
    const c = await r.getHeartbeatsHeader();
    c && i.append("x-firebase-client", c);
  }
  const s = {
    installation: {
      sdkVersion: Hf,
      appId: e.appId
    }
  }, a = {
    method: "POST",
    headers: i,
    body: JSON.stringify(s)
  }, l = await Kf(() => fetch(o, a));
  if (l.ok) {
    const c = await l.json();
    return Yf(c);
  } else
    throw await Gf("Generate Auth Token", l);
}
function f_(e, { fid: t }) {
  return `${jf(e)}/${t}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Pa(e, t = !1) {
  let n;
  const o = await ir(e.appConfig, (r) => {
    if (!nh(r))
      throw Ln.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const s = r.authToken;
    if (!t && p_(s))
      return r;
    if (s.requestStatus === 1)
      return n = h_(e, t), r;
    {
      if (!navigator.onLine)
        throw Ln.create(
          "app-offline"
          /* ErrorCode.APP_OFFLINE */
        );
      const a = b_(r);
      return n = m_(e, a), a;
    }
  });
  return n ? await n : o.authToken;
}
async function h_(e, t) {
  let n = await _c(e.appConfig);
  for (; n.authToken.requestStatus === 1; )
    await Xf(100), n = await _c(e.appConfig);
  const o = n.authToken;
  return o.requestStatus === 0 ? Pa(e, t) : o;
}
function _c(e) {
  return ir(e, (t) => {
    if (!nh(t))
      throw Ln.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const n = t.authToken;
    return v_(n) ? Object.assign(Object.assign({}, t), { authToken: {
      requestStatus: 0
      /* RequestStatus.NOT_STARTED */
    } }) : t;
  });
}
async function m_(e, t) {
  try {
    const n = await u_(e, t), o = Object.assign(Object.assign({}, t), { authToken: n });
    return await Vi(e.appConfig, o), n;
  } catch (n) {
    if (Wf(n) && (n.customData.serverCode === 401 || n.customData.serverCode === 404))
      await eh(e.appConfig);
    else {
      const o = Object.assign(Object.assign({}, t), { authToken: {
        requestStatus: 0
        /* RequestStatus.NOT_STARTED */
      } });
      await Vi(e.appConfig, o);
    }
    throw n;
  }
}
function nh(e) {
  return e !== void 0 && e.registrationStatus === 2;
}
function p_(e) {
  return e.requestStatus === 2 && !g_(e);
}
function g_(e) {
  const t = Date.now();
  return t < e.creationTime || e.creationTime + e.expiresIn < t + Bx;
}
function b_(e) {
  const t = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, e), { authToken: t });
}
function v_(e) {
  return e.requestStatus === 1 && e.requestTime + Uf < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function y_(e) {
  const t = e, { installationEntry: n, registrationPromise: o } = await La(t);
  return o ? o.catch(console.error) : Pa(t).catch(console.error), n.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function w_(e, t = !1) {
  const n = e;
  return await k_(n), (await Pa(n, t)).token;
}
async function k_(e) {
  const { registrationPromise: t } = await La(e);
  t && await t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function x_(e) {
  if (!e || !e.options)
    throw Ur("App Configuration");
  if (!e.name)
    throw Ur("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId"
  ];
  for (const n of t)
    if (!e.options[n])
      throw Ur(n);
  return {
    appName: e.name,
    projectId: e.options.projectId,
    apiKey: e.options.apiKey,
    appId: e.options.appId
  };
}
function Ur(e) {
  return Ln.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const oh = "installations", __ = "installations-internal", E_ = (e) => {
  const t = e.getProvider("app").getImmediate(), n = x_(t), o = Aa(t, "heartbeat");
  return {
    app: t,
    appConfig: n,
    heartbeatServiceProvider: o,
    _delete: () => Promise.resolve()
  };
}, T_ = (e) => {
  const t = e.getProvider("app").getImmediate(), n = Aa(t, oh).getImmediate();
  return {
    getId: () => y_(n),
    getToken: (i) => w_(n, i)
  };
};
function I_() {
  Nn(new hn(
    oh,
    E_,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), Nn(new hn(
    __,
    T_,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ));
}
I_();
un(zf, $a);
un(zf, $a, "esm2017");
const S_ = (e, t) => t.some((n) => e instanceof n);
let Ec, Tc;
function O_() {
  return Ec || (Ec = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function C_() {
  return Tc || (Tc = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const ih = /* @__PURE__ */ new WeakMap(), Ds = /* @__PURE__ */ new WeakMap(), rh = /* @__PURE__ */ new WeakMap(), Hr = /* @__PURE__ */ new WeakMap(), Ma = /* @__PURE__ */ new WeakMap();
function A_(e) {
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("success", r), e.removeEventListener("error", s);
    }, r = () => {
      n(Xt(e.result)), i();
    }, s = () => {
      o(e.error), i();
    };
    e.addEventListener("success", r), e.addEventListener("error", s);
  });
  return t.then((n) => {
    n instanceof IDBCursor && ih.set(n, e);
  }).catch(() => {
  }), Ma.set(t, e), t;
}
function D_(e) {
  if (Ds.has(e))
    return;
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("complete", r), e.removeEventListener("error", s), e.removeEventListener("abort", s);
    }, r = () => {
      n(), i();
    }, s = () => {
      o(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", r), e.addEventListener("error", s), e.addEventListener("abort", s);
  });
  Ds.set(e, t);
}
let $s = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return Ds.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || rh.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Xt(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function $_(e) {
  $s = e($s);
}
function N_(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const o = e.call(Br(this), t, ...n);
    return rh.set(o, t.sort ? t.sort() : [t]), Xt(o);
  } : C_().includes(e) ? function(...t) {
    return e.apply(Br(this), t), Xt(ih.get(this));
  } : function(...t) {
    return Xt(e.apply(Br(this), t));
  };
}
function L_(e) {
  return typeof e == "function" ? N_(e) : (e instanceof IDBTransaction && D_(e), S_(e, O_()) ? new Proxy(e, $s) : e);
}
function Xt(e) {
  if (e instanceof IDBRequest)
    return A_(e);
  if (Hr.has(e))
    return Hr.get(e);
  const t = L_(e);
  return t !== e && (Hr.set(e, t), Ma.set(t, e)), t;
}
const Br = (e) => Ma.get(e);
function sh(e, t, { blocked: n, upgrade: o, blocking: i, terminated: r } = {}) {
  const s = indexedDB.open(e, t), a = Xt(s);
  return o && s.addEventListener("upgradeneeded", (l) => {
    o(Xt(s.result), l.oldVersion, l.newVersion, Xt(s.transaction));
  }), n && s.addEventListener("blocked", () => n()), a.then((l) => {
    r && l.addEventListener("close", () => r()), i && l.addEventListener("versionchange", () => i());
  }).catch(() => {
  }), a;
}
function Wr(e, { blocked: t } = {}) {
  const n = indexedDB.deleteDatabase(e);
  return t && n.addEventListener("blocked", () => t()), Xt(n).then(() => {
  });
}
const P_ = ["get", "getKey", "getAll", "getAllKeys", "count"], M_ = ["put", "add", "delete", "clear"], jr = /* @__PURE__ */ new Map();
function Ic(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (jr.get(t))
    return jr.get(t);
  const n = t.replace(/FromIndex$/, ""), o = t !== n, i = M_.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (o ? IDBIndex : IDBObjectStore).prototype) || !(i || P_.includes(n))
  )
    return;
  const r = async function(s, ...a) {
    const l = this.transaction(s, i ? "readwrite" : "readonly");
    let c = l.store;
    return o && (c = c.index(a.shift())), (await Promise.all([
      c[n](...a),
      i && l.done
    ]))[0];
  };
  return jr.set(t, r), r;
}
$_((e) => ({
  ...e,
  get: (t, n, o) => Ic(t, n) || e.get(t, n, o),
  has: (t, n) => !!Ic(t, n) || e.has(t, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const F_ = "/firebase-messaging-sw.js", R_ = "/firebase-cloud-messaging-push-scope", ah = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4", V_ = "https://fcmregistrations.googleapis.com/v1", lh = "google.c.a.c_id", z_ = "google.c.a.c_l", U_ = "google.c.a.ts", H_ = "google.c.a.e";
var Sc;
(function(e) {
  e[e.DATA_MESSAGE = 1] = "DATA_MESSAGE", e[e.DISPLAY_NOTIFICATION = 3] = "DISPLAY_NOTIFICATION";
})(Sc || (Sc = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var zo;
(function(e) {
  e.PUSH_RECEIVED = "push-received", e.NOTIFICATION_CLICKED = "notification-clicked";
})(zo || (zo = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jt(e) {
  const t = new Uint8Array(e);
  return btoa(String.fromCharCode(...t)).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function B_(e) {
  const t = "=".repeat((4 - e.length % 4) % 4), n = (e + t).replace(/\-/g, "+").replace(/_/g, "/"), o = atob(n), i = new Uint8Array(o.length);
  for (let r = 0; r < o.length; ++r)
    i[r] = o.charCodeAt(r);
  return i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Yr = "fcm_token_details_db", W_ = 5, Oc = "fcm_token_object_Store";
async function j_(e) {
  if ("databases" in indexedDB && !(await indexedDB.databases()).map((r) => r.name).includes(Yr))
    return null;
  let t = null;
  return (await sh(Yr, W_, {
    upgrade: async (o, i, r, s) => {
      var a;
      if (i < 2 || !o.objectStoreNames.contains(Oc))
        return;
      const l = s.objectStore(Oc), c = await l.index("fcmSenderId").get(e);
      if (await l.clear(), !!c) {
        if (i === 2) {
          const d = c;
          if (!d.auth || !d.p256dh || !d.endpoint)
            return;
          t = {
            token: d.fcmToken,
            createTime: (a = d.createTime) !== null && a !== void 0 ? a : Date.now(),
            subscriptionOptions: {
              auth: d.auth,
              p256dh: d.p256dh,
              endpoint: d.endpoint,
              swScope: d.swScope,
              vapidKey: typeof d.vapidKey == "string" ? d.vapidKey : jt(d.vapidKey)
            }
          };
        } else if (i === 3) {
          const d = c;
          t = {
            token: d.fcmToken,
            createTime: d.createTime,
            subscriptionOptions: {
              auth: jt(d.auth),
              p256dh: jt(d.p256dh),
              endpoint: d.endpoint,
              swScope: d.swScope,
              vapidKey: jt(d.vapidKey)
            }
          };
        } else if (i === 4) {
          const d = c;
          t = {
            token: d.fcmToken,
            createTime: d.createTime,
            subscriptionOptions: {
              auth: jt(d.auth),
              p256dh: jt(d.p256dh),
              endpoint: d.endpoint,
              swScope: d.swScope,
              vapidKey: jt(d.vapidKey)
            }
          };
        }
      }
    }
  })).close(), await Wr(Yr), await Wr("fcm_vapid_details_db"), await Wr("undefined"), Y_(t) ? t : null;
}
function Y_(e) {
  if (!e || !e.subscriptionOptions)
    return !1;
  const { subscriptionOptions: t } = e;
  return typeof e.createTime == "number" && e.createTime > 0 && typeof e.token == "string" && e.token.length > 0 && typeof t.auth == "string" && t.auth.length > 0 && typeof t.p256dh == "string" && t.p256dh.length > 0 && typeof t.endpoint == "string" && t.endpoint.length > 0 && typeof t.swScope == "string" && t.swScope.length > 0 && typeof t.vapidKey == "string" && t.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const G_ = "firebase-messaging-database", q_ = 1, Mn = "firebase-messaging-store";
let Gr = null;
function Fa() {
  return Gr || (Gr = sh(G_, q_, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(Mn);
      }
    }
  })), Gr;
}
async function ch(e) {
  const t = Va(e), o = await (await Fa()).transaction(Mn).objectStore(Mn).get(t);
  if (o)
    return o;
  {
    const i = await j_(e.appConfig.senderId);
    if (i)
      return await Ra(e, i), i;
  }
}
async function Ra(e, t) {
  const n = Va(e), i = (await Fa()).transaction(Mn, "readwrite");
  return await i.objectStore(Mn).put(t, n), await i.done, t;
}
async function K_(e) {
  const t = Va(e), o = (await Fa()).transaction(Mn, "readwrite");
  await o.objectStore(Mn).delete(t), await o.done;
}
function Va({ appConfig: e }) {
  return e.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const X_ = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "only-available-in-window": "This method is available in a Window context.",
  "only-available-in-sw": "This method is available in a service worker context.",
  "permission-default": "The notification permission was not granted and dismissed instead.",
  "permission-blocked": "The notification permission was not granted and blocked instead.",
  "unsupported-browser": "This browser doesn't support the API's required to use the Firebase SDK.",
  "indexed-db-unsupported": "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
  "failed-service-worker-registration": "We are unable to register the default service worker. {$browserErrorMessage}",
  "token-subscribe-failed": "A problem occurred while subscribing the user to FCM: {$errorInfo}",
  "token-subscribe-no-token": "FCM returned no token when subscribing the user to push.",
  "token-unsubscribe-failed": "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
  "token-update-failed": "A problem occurred while updating the user from FCM: {$errorInfo}",
  "token-update-no-token": "FCM returned no token when updating the user to push.",
  "use-sw-after-get-token": "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
  "invalid-sw-registration": "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
  "invalid-bg-handler": "The input to setBackgroundMessageHandler() must be a function.",
  "invalid-vapid-key": "The public VAPID key must be a string.",
  "use-vapid-key-after-get-token": "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
}, Ve = new nr("messaging", "Messaging", X_);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Z_(e, t) {
  const n = await Ua(e), o = uh(t), i = {
    method: "POST",
    headers: n,
    body: JSON.stringify(o)
  };
  let r;
  try {
    r = await (await fetch(za(e.appConfig), i)).json();
  } catch (s) {
    throw Ve.create("token-subscribe-failed", {
      errorInfo: s == null ? void 0 : s.toString()
    });
  }
  if (r.error) {
    const s = r.error.message;
    throw Ve.create("token-subscribe-failed", {
      errorInfo: s
    });
  }
  if (!r.token)
    throw Ve.create(
      "token-subscribe-no-token"
      /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */
    );
  return r.token;
}
async function J_(e, t) {
  const n = await Ua(e), o = uh(t.subscriptionOptions), i = {
    method: "PATCH",
    headers: n,
    body: JSON.stringify(o)
  };
  let r;
  try {
    r = await (await fetch(`${za(e.appConfig)}/${t.token}`, i)).json();
  } catch (s) {
    throw Ve.create("token-update-failed", {
      errorInfo: s == null ? void 0 : s.toString()
    });
  }
  if (r.error) {
    const s = r.error.message;
    throw Ve.create("token-update-failed", {
      errorInfo: s
    });
  }
  if (!r.token)
    throw Ve.create(
      "token-update-no-token"
      /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */
    );
  return r.token;
}
async function dh(e, t) {
  const o = {
    method: "DELETE",
    headers: await Ua(e)
  };
  try {
    const r = await (await fetch(`${za(e.appConfig)}/${t}`, o)).json();
    if (r.error) {
      const s = r.error.message;
      throw Ve.create("token-unsubscribe-failed", {
        errorInfo: s
      });
    }
  } catch (i) {
    throw Ve.create("token-unsubscribe-failed", {
      errorInfo: i == null ? void 0 : i.toString()
    });
  }
}
function za({ projectId: e }) {
  return `${V_}/projects/${e}/registrations`;
}
async function Ua({ appConfig: e, installations: t }) {
  const n = await t.getToken();
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e.apiKey,
    "x-goog-firebase-installations-auth": `FIS ${n}`
  });
}
function uh({ p256dh: e, auth: t, endpoint: n, vapidKey: o }) {
  const i = {
    web: {
      endpoint: n,
      auth: t,
      p256dh: e
    }
  };
  return o !== ah && (i.web.applicationPubKey = o), i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Q_ = 7 * 24 * 60 * 60 * 1e3;
async function eE(e) {
  const t = await oE(e.swRegistration, e.vapidKey), n = {
    vapidKey: e.vapidKey,
    swScope: e.swRegistration.scope,
    endpoint: t.endpoint,
    auth: jt(t.getKey("auth")),
    p256dh: jt(t.getKey("p256dh"))
  }, o = await ch(e.firebaseDependencies);
  if (o) {
    if (iE(o.subscriptionOptions, n))
      return Date.now() >= o.createTime + Q_ ? nE(e, {
        token: o.token,
        createTime: Date.now(),
        subscriptionOptions: n
      }) : o.token;
    try {
      await dh(e.firebaseDependencies, o.token);
    } catch (i) {
      console.warn(i);
    }
    return Cc(e.firebaseDependencies, n);
  } else
    return Cc(e.firebaseDependencies, n);
}
async function tE(e) {
  const t = await ch(e.firebaseDependencies);
  t && (await dh(e.firebaseDependencies, t.token), await K_(e.firebaseDependencies));
  const n = await e.swRegistration.pushManager.getSubscription();
  return n ? n.unsubscribe() : !0;
}
async function nE(e, t) {
  try {
    const n = await J_(e.firebaseDependencies, t), o = Object.assign(Object.assign({}, t), { token: n, createTime: Date.now() });
    return await Ra(e.firebaseDependencies, o), n;
  } catch (n) {
    throw await tE(e), n;
  }
}
async function Cc(e, t) {
  const o = {
    token: await Z_(e, t),
    createTime: Date.now(),
    subscriptionOptions: t
  };
  return await Ra(e, o), o.token;
}
async function oE(e, t) {
  const n = await e.pushManager.getSubscription();
  return n || e.pushManager.subscribe({
    userVisibleOnly: !0,
    // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
    // submitted to pushManager#subscribe must be of type Uint8Array.
    applicationServerKey: B_(t)
  });
}
function iE(e, t) {
  const n = t.vapidKey === e.vapidKey, o = t.endpoint === e.endpoint, i = t.auth === e.auth, r = t.p256dh === e.p256dh;
  return n && o && i && r;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ac(e) {
  const t = {
    from: e.from,
    // eslint-disable-next-line camelcase
    collapseKey: e.collapse_key,
    // eslint-disable-next-line camelcase
    messageId: e.fcmMessageId
  };
  return rE(t, e), sE(t, e), aE(t, e), t;
}
function rE(e, t) {
  if (!t.notification)
    return;
  e.notification = {};
  const n = t.notification.title;
  n && (e.notification.title = n);
  const o = t.notification.body;
  o && (e.notification.body = o);
  const i = t.notification.image;
  i && (e.notification.image = i);
  const r = t.notification.icon;
  r && (e.notification.icon = r);
}
function sE(e, t) {
  t.data && (e.data = t.data);
}
function aE(e, t) {
  var n, o, i, r, s;
  if (!t.fcmOptions && !(!((n = t.notification) === null || n === void 0) && n.click_action))
    return;
  e.fcmOptions = {};
  const a = (i = (o = t.fcmOptions) === null || o === void 0 ? void 0 : o.link) !== null && i !== void 0 ? i : (r = t.notification) === null || r === void 0 ? void 0 : r.click_action;
  a && (e.fcmOptions.link = a);
  const l = (s = t.fcmOptions) === null || s === void 0 ? void 0 : s.analytics_label;
  l && (e.fcmOptions.analyticsLabel = l);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function lE(e) {
  return typeof e == "object" && !!e && lh in e;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
fh("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
fh("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
function fh(e, t) {
  const n = [];
  for (let o = 0; o < e.length; o++)
    n.push(e.charAt(o)), o < t.length && n.push(t.charAt(o));
  return n.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function cE(e) {
  if (!e || !e.options)
    throw qr("App Configuration Object");
  if (!e.name)
    throw qr("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId",
    "messagingSenderId"
  ], { options: n } = e;
  for (const o of t)
    if (!n[o])
      throw qr(o);
  return {
    appName: e.name,
    projectId: n.projectId,
    apiKey: n.apiKey,
    appId: n.appId,
    senderId: n.messagingSenderId
  };
}
function qr(e) {
  return Ve.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class dE {
  constructor(t, n, o) {
    this.deliveryMetricsExportedToBigQueryEnabled = !1, this.onBackgroundMessageHandler = null, this.onMessageHandler = null, this.logEvents = [], this.isLogServiceStarted = !1;
    const i = cE(t);
    this.firebaseDependencies = {
      app: t,
      appConfig: i,
      installations: n,
      analyticsProvider: o
    };
  }
  _delete() {
    return Promise.resolve();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function uE(e) {
  try {
    e.swRegistration = await navigator.serviceWorker.register(F_, {
      scope: R_
    }), e.swRegistration.update().catch(() => {
    });
  } catch (t) {
    throw Ve.create("failed-service-worker-registration", {
      browserErrorMessage: t == null ? void 0 : t.message
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function fE(e, t) {
  if (!t && !e.swRegistration && await uE(e), !(!t && e.swRegistration)) {
    if (!(t instanceof ServiceWorkerRegistration))
      throw Ve.create(
        "invalid-sw-registration"
        /* ErrorCode.INVALID_SW_REGISTRATION */
      );
    e.swRegistration = t;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function hE(e, t) {
  t ? e.vapidKey = t : e.vapidKey || (e.vapidKey = ah);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function hh(e, t) {
  if (!navigator)
    throw Ve.create(
      "only-available-in-window"
      /* ErrorCode.AVAILABLE_IN_WINDOW */
    );
  if (Notification.permission === "default" && await Notification.requestPermission(), Notification.permission !== "granted")
    throw Ve.create(
      "permission-blocked"
      /* ErrorCode.PERMISSION_BLOCKED */
    );
  return await hE(e, t == null ? void 0 : t.vapidKey), await fE(e, t == null ? void 0 : t.serviceWorkerRegistration), eE(e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function mE(e, t, n) {
  const o = pE(t);
  (await e.firebaseDependencies.analyticsProvider.get()).logEvent(o, {
    /* eslint-disable camelcase */
    message_id: n[lh],
    message_name: n[z_],
    message_time: n[U_],
    message_device_time: Math.floor(Date.now() / 1e3)
    /* eslint-enable camelcase */
  });
}
function pE(e) {
  switch (e) {
    case zo.NOTIFICATION_CLICKED:
      return "notification_open";
    case zo.PUSH_RECEIVED:
      return "notification_foreground";
    default:
      throw new Error();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function gE(e, t) {
  const n = t.data;
  if (!n.isFirebaseMessaging)
    return;
  e.onMessageHandler && n.messageType === zo.PUSH_RECEIVED && (typeof e.onMessageHandler == "function" ? e.onMessageHandler(Ac(n)) : e.onMessageHandler.next(Ac(n)));
  const o = n.data;
  lE(o) && o[H_] === "1" && await mE(e, n.messageType, o);
}
const Dc = "@firebase/messaging", $c = "0.12.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const bE = (e) => {
  const t = new dE(e.getProvider("app").getImmediate(), e.getProvider("installations-internal").getImmediate(), e.getProvider("analytics-internal"));
  return navigator.serviceWorker.addEventListener("message", (n) => gE(t, n)), t;
}, vE = (e) => {
  const t = e.getProvider("messaging").getImmediate();
  return {
    getToken: (o) => hh(t, o)
  };
};
function yE() {
  Nn(new hn(
    "messaging",
    bE,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), Nn(new hn(
    "messaging-internal",
    vE,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), un(Dc, $c), un(Dc, $c, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function wE() {
  try {
    await $f();
  } catch {
    return !1;
  }
  return typeof window < "u" && Df() && yk() && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function kE(e, t) {
  if (!navigator)
    throw Ve.create(
      "only-available-in-window"
      /* ErrorCode.AVAILABLE_IN_WINDOW */
    );
  return e.onMessageHandler = t, () => {
    e.onMessageHandler = null;
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function xE(e = yx()) {
  return wE().then((t) => {
    if (!t)
      throw Ve.create(
        "unsupported-browser"
        /* ErrorCode.UNSUPPORTED_BROWSER */
      );
  }, (t) => {
    throw Ve.create(
      "indexed-db-unsupported"
      /* ErrorCode.INDEXED_DB_UNSUPPORTED */
    );
  }), Aa(Oa(e), "messaging").getImmediate();
}
async function _E(e, t) {
  return e = Oa(e), hh(e, t);
}
function EE(e, t) {
  return e = Oa(e), kE(e, t);
}
yE();
const TE = async (e, t, n, o) => {
  const r = Pf(e), s = xE(r);
  if (await Notification.requestPermission() === "granted") {
    const l = await _E(s, {
      vapidKey: t
    });
    await n(l), EE(s, (d) => {
      o({ notification: d, isForeground: !0 });
    });
    const c = new BroadcastChannel("FB_BG_MESSAGES");
    c.onmessage = (d) => {
      o({ notification: d.data, isForeground: !1 });
    };
  } else
    alert("You denied notifications.");
}, IE = It({
  template: `
            <div style='position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);'>
              <h4 v-if='errorMsg.length'> 
                {{ errorMsg }}
              </h4>
            </div>
            `,
  data() {
    return {
      errorMsg: "",
      authStore: {},
      router: {},
      route: {}
    };
  },
  async mounted() {
    if (this.authStore = Cu(), this.router = Ui.config.globalProperties.$router, this.route = Ui.config.globalProperties.$route, !Object.keys(this.route.query).length) {
      window.location.href = Ke.appLoginUrl;
      return;
    }
    const { token: e, oms: t, expirationTime: n } = this.route.query;
    this.handleUserFlow(e, t, n);
  },
  methods: {
    async handleUserFlow(e, t, n) {
      const o = Ke.getConfig();
      if (await Ke.logout({ isUserUnauthorised: !0 }), await Ke.initialise(o), +n < W.now().toMillis()) {
        console.error("User token has expired, redirecting to launchpad."), this.errorMsg = "User token has expired, redirecting to launchpad.";
        const i = window.location.origin + "/login";
        window.location.href = `${Ke.appLoginUrl}?isLoggedOut=true&redirectUrl=${i}`;
        return;
      }
      this.authStore.$patch({
        token: { value: e, expiration: n },
        oms: t
      }), Ke.loader.present("Logging in");
      try {
        await Ke.login({ token: e, oms: t }), qt.appFirebaseConfig && await TE(qt.appFirebaseConfig, qt.appFirebaseVapidKey, qt.storeClientRegistrationToken, qt.addNotification), this.router.push("/");
      } catch (i) {
        console.error(i), this.errorMsg = "Unable to login. Please contact the administrator";
      } finally {
        Ke.loader.dismiss();
      }
    }
  }
});
function SE(e) {
  return typeof e == "object" && e !== null;
}
function Nc(e, t) {
  return e = SE(e) ? e : /* @__PURE__ */ Object.create(null), new Proxy(e, {
    get(n, o, i) {
      return o === "key" ? Reflect.get(n, o, i) : Reflect.get(n, o, i) || Reflect.get(t, o, i);
    }
  });
}
function OE(e, t) {
  return t.reduce((n, o) => n == null ? void 0 : n[o], e);
}
function CE(e, t, n) {
  return t.slice(0, -1).reduce((o, i) => /^(__proto__)$/.test(i) ? {} : o[i] = o[i] || {}, e)[t[t.length - 1]] = n, e;
}
function AE(e, t) {
  return t.reduce((n, o) => {
    const i = o.split(".");
    return CE(n, i, OE(e, i));
  }, {});
}
function Lc(e, { storage: t, serializer: n, key: o, debug: i }) {
  try {
    const r = t == null ? void 0 : t.getItem(o);
    r && e.$patch(n == null ? void 0 : n.deserialize(r));
  } catch (r) {
    i && console.error(r);
  }
}
function Pc(e, { storage: t, serializer: n, key: o, paths: i, debug: r }) {
  try {
    const s = Array.isArray(i) ? AE(e, i) : e;
    t.setItem(o, n.serialize(s));
  } catch (s) {
    r && console.error(s);
  }
}
function DE(e = {}) {
  return (t) => {
    const { auto: n = !1 } = e, {
      options: { persist: o = n },
      store: i,
      pinia: r
    } = t;
    if (!o)
      return;
    if (!(i.$id in r.state.value)) {
      const a = r._s.get(i.$id.replace("__hot:", ""));
      a && Promise.resolve().then(() => a.$persist());
      return;
    }
    const s = (Array.isArray(o) ? o.map((a) => Nc(a, e)) : [Nc(o, e)]).map(
      ({
        storage: a = localStorage,
        beforeRestore: l = null,
        afterRestore: c = null,
        serializer: d = {
          serialize: JSON.stringify,
          deserialize: JSON.parse
        },
        key: u = i.$id,
        paths: f = null,
        debug: g = !1
      }) => {
        var E;
        return {
          storage: a,
          beforeRestore: l,
          afterRestore: c,
          serializer: d,
          key: ((E = e.key) != null ? E : (k) => k)(typeof u == "string" ? u : u(i.$id)),
          paths: f,
          debug: g
        };
      }
    );
    i.$persist = () => {
      s.forEach((a) => {
        Pc(i.$state, a);
      });
    }, i.$hydrate = ({ runHooks: a = !0 } = {}) => {
      s.forEach((l) => {
        const { beforeRestore: c, afterRestore: d } = l;
        a && (c == null || c(t)), Lc(i, l), a && (d == null || d(t));
      });
    }, s.forEach((a) => {
      const { beforeRestore: l, afterRestore: c } = a;
      l == null || l(t), Lc(i, a), c == null || c(t), i.$subscribe(
        (d, u) => {
          Pc(u, a);
        },
        {
          detached: !0
        }
      );
    });
  };
}
var $E = DE();
/*!
  * shared v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const Pt = typeof window < "u";
let Je, Fn;
if (process.env.NODE_ENV !== "production") {
  const e = Pt && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Je = (t) => {
    e.mark(t);
  }, Fn = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const NE = /\{([0-9a-zA-Z]+)\}/g;
function Ha(e, ...t) {
  return t.length === 1 && ne(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(NE, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const Ft = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), LE = (e, t, n) => PE({ l: e, k: t, s: n }), PE = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ee = (e) => typeof e == "number" && isFinite(e), ME = (e) => ph(e) === "[object Date]", mn = (e) => ph(e) === "[object RegExp]", rr = (e) => B(e) && Object.keys(e).length === 0, $e = Object.assign;
let Mc;
const Gt = () => Mc || (Mc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Fc(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const FE = Object.prototype.hasOwnProperty;
function Ba(e, t) {
  return FE.call(e, t);
}
const se = Array.isArray, be = (e) => typeof e == "function", M = (e) => typeof e == "string", j = (e) => typeof e == "boolean", ne = (e) => e !== null && typeof e == "object", mh = Object.prototype.toString, ph = (e) => mh.call(e), B = (e) => {
  if (!ne(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, RE = (e) => e == null ? "" : se(e) || B(e) && e.toString === mh ? JSON.stringify(e, null, 2) : String(e);
function VE(e, t = "") {
  return e.reduce((n, o, i) => i === 0 ? n + o : n + t + o, "");
}
const Rc = 2;
function zE(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let i = 0;
  const r = [];
  for (let s = 0; s < o.length; s++)
    if (i += o[s].length + 1, i >= t) {
      for (let a = s - Rc; a <= s + Rc || n > i; a++) {
        if (a < 0 || a >= o.length)
          continue;
        const l = a + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[a]}`);
        const c = o[a].length;
        if (a === s) {
          const d = t - (i - c) + 1, u = Math.max(1, n > i ? c - d : n - t);
          r.push("   |  " + " ".repeat(d) + "^".repeat(u));
        } else if (a > s) {
          if (n > i) {
            const d = Math.max(Math.min(n - i, c), 1);
            r.push("   |  " + "^".repeat(d));
          }
          i += c + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function Wa(e) {
  let t = e;
  return () => ++t;
}
function Ce(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Vc = {};
function UE(e) {
  Vc[e] || (Vc[e] = !0, Ce(e));
}
function ja() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const i = e.get(n);
      i && i.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const i = e.get(n);
      i && i.splice(i.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((i) => i(o)), (e.get("*") || []).slice().map((i) => i(n, o));
    }
  };
}
/*!
  * message-compiler v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function HE(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Ns(e, t, n) {
  const o = { start: e, end: t };
  return n != null && (o.source = n), o;
}
const BE = /\{([0-9a-zA-Z]+)\}/g;
function WE(e, ...t) {
  return t.length === 1 && jE(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(BE, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const gh = Object.assign, zc = (e) => typeof e == "string", jE = (e) => e !== null && typeof e == "object";
function bh(e, t = "") {
  return e.reduce((n, o, i) => i === 0 ? n + o : n + t + o, "");
}
const U = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, YE = {
  // tokenizer error messages
  [U.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [U.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [U.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [U.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [U.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [U.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [U.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [U.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [U.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [U.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [U.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [U.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [U.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [U.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [U.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [U.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function vo(e, t, n = {}) {
  const { domain: o, messages: i, args: r } = n, s = WE((i || YE)[e] || "", ...r || []), a = new SyntaxError(String(s));
  return a.code = e, t && (a.location = t), a.domain = o, a;
}
function GE(e) {
  throw e;
}
const qE = /<\/?[\w\s="/.':;#-\/]+>/, KE = (e) => qE.test(e), Wt = " ", XE = "\r", ze = `
`, ZE = String.fromCharCode(8232), JE = String.fromCharCode(8233);
function QE(e) {
  const t = e;
  let n = 0, o = 1, i = 1, r = 0;
  const s = (y) => t[y] === XE && t[y + 1] === ze, a = (y) => t[y] === ze, l = (y) => t[y] === JE, c = (y) => t[y] === ZE, d = (y) => s(y) || a(y) || l(y) || c(y), u = () => n, f = () => o, g = () => i, E = () => r, k = (y) => s(y) || l(y) || c(y) ? ze : t[y], S = () => k(n), m = () => k(n + r);
  function v() {
    return r = 0, d(n) && (o++, i = 0), s(n) && n++, n++, i++, t[n];
  }
  function I() {
    return s(n + r) && r++, r++, t[n + r];
  }
  function w() {
    n = 0, o = 1, i = 1, r = 0;
  }
  function A(y = 0) {
    r = y;
  }
  function b() {
    const y = n + r;
    for (; y !== n; )
      v();
    r = 0;
  }
  return {
    index: u,
    line: f,
    column: g,
    peekOffset: E,
    charAt: k,
    currentChar: S,
    currentPeek: m,
    next: v,
    peek: I,
    reset: w,
    resetPeek: A,
    skipToPeek: b
  };
}
const on = void 0, e1 = ".", Uc = "'", t1 = "tokenizer";
function n1(e, t = {}) {
  const n = t.location !== !1, o = QE(e), i = () => o.index(), r = () => HE(o.line(), o.column(), o.index()), s = r(), a = i(), l = {
    currentType: 14,
    offset: a,
    startLoc: s,
    endLoc: s,
    lastType: 14,
    lastOffset: a,
    lastStartLoc: s,
    lastEndLoc: s,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: d } = t;
  function u(p, h, T, ...R) {
    const H = c();
    if (h.column += T, h.offset += T, d) {
      const Q = n ? Ns(H.startLoc, h) : null, nt = vo(p, Q, {
        domain: t1,
        args: R
      });
      d(nt);
    }
  }
  function f(p, h, T) {
    p.endLoc = r(), p.currentType = h;
    const R = { type: h };
    return n && (R.loc = Ns(p.startLoc, p.endLoc)), T != null && (R.value = T), R;
  }
  const g = (p) => f(
    p,
    14
    /* TokenTypes.EOF */
  );
  function E(p, h) {
    return p.currentChar() === h ? (p.next(), h) : (u(U.EXPECTED_TOKEN, r(), 0, h), "");
  }
  function k(p) {
    let h = "";
    for (; p.currentPeek() === Wt || p.currentPeek() === ze; )
      h += p.currentPeek(), p.peek();
    return h;
  }
  function S(p) {
    const h = k(p);
    return p.skipToPeek(), h;
  }
  function m(p) {
    if (p === on)
      return !1;
    const h = p.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h === 95;
  }
  function v(p) {
    if (p === on)
      return !1;
    const h = p.charCodeAt(0);
    return h >= 48 && h <= 57;
  }
  function I(p, h) {
    const { currentType: T } = h;
    if (T !== 2)
      return !1;
    k(p);
    const R = m(p.currentPeek());
    return p.resetPeek(), R;
  }
  function w(p, h) {
    const { currentType: T } = h;
    if (T !== 2)
      return !1;
    k(p);
    const R = p.currentPeek() === "-" ? p.peek() : p.currentPeek(), H = v(R);
    return p.resetPeek(), H;
  }
  function A(p, h) {
    const { currentType: T } = h;
    if (T !== 2)
      return !1;
    k(p);
    const R = p.currentPeek() === Uc;
    return p.resetPeek(), R;
  }
  function b(p, h) {
    const { currentType: T } = h;
    if (T !== 8)
      return !1;
    k(p);
    const R = p.currentPeek() === ".";
    return p.resetPeek(), R;
  }
  function y(p, h) {
    const { currentType: T } = h;
    if (T !== 9)
      return !1;
    k(p);
    const R = m(p.currentPeek());
    return p.resetPeek(), R;
  }
  function L(p, h) {
    const { currentType: T } = h;
    if (!(T === 8 || T === 12))
      return !1;
    k(p);
    const R = p.currentPeek() === ":";
    return p.resetPeek(), R;
  }
  function C(p, h) {
    const { currentType: T } = h;
    if (T !== 10)
      return !1;
    const R = () => {
      const Q = p.currentPeek();
      return Q === "{" ? m(p.peek()) : Q === "@" || Q === "%" || Q === "|" || Q === ":" || Q === "." || Q === Wt || !Q ? !1 : Q === ze ? (p.peek(), R()) : m(Q);
    }, H = R();
    return p.resetPeek(), H;
  }
  function D(p) {
    k(p);
    const h = p.currentPeek() === "|";
    return p.resetPeek(), h;
  }
  function N(p) {
    const h = k(p), T = p.currentPeek() === "%" && p.peek() === "{";
    return p.resetPeek(), {
      isModulo: T,
      hasSpace: h.length > 0
    };
  }
  function z(p, h = !0) {
    const T = (H = !1, Q = "", nt = !1) => {
      const ht = p.currentPeek();
      return ht === "{" ? Q === "%" ? !1 : H : ht === "@" || !ht ? Q === "%" ? !0 : H : ht === "%" ? (p.peek(), T(H, "%", !0)) : ht === "|" ? Q === "%" || nt ? !0 : !(Q === Wt || Q === ze) : ht === Wt ? (p.peek(), T(!0, Wt, nt)) : ht === ze ? (p.peek(), T(!0, ze, nt)) : !0;
    }, R = T();
    return h && p.resetPeek(), R;
  }
  function oe(p, h) {
    const T = p.currentChar();
    return T === on ? on : h(T) ? (p.next(), T) : null;
  }
  function ke(p) {
    return oe(p, (T) => {
      const R = T.charCodeAt(0);
      return R >= 97 && R <= 122 || // a-z
      R >= 65 && R <= 90 || // A-Z
      R >= 48 && R <= 57 || // 0-9
      R === 95 || // _
      R === 36;
    });
  }
  function Ye(p) {
    return oe(p, (T) => {
      const R = T.charCodeAt(0);
      return R >= 48 && R <= 57;
    });
  }
  function q(p) {
    return oe(p, (T) => {
      const R = T.charCodeAt(0);
      return R >= 48 && R <= 57 || // 0-9
      R >= 65 && R <= 70 || // A-F
      R >= 97 && R <= 102;
    });
  }
  function K(p) {
    let h = "", T = "";
    for (; h = Ye(p); )
      T += h;
    return T;
  }
  function ut(p) {
    S(p);
    const h = p.currentChar();
    return h !== "%" && u(U.EXPECTED_TOKEN, r(), 0, h), p.next(), "%";
  }
  function Le(p) {
    let h = "";
    for (; ; ) {
      const T = p.currentChar();
      if (T === "{" || T === "}" || T === "@" || T === "|" || !T)
        break;
      if (T === "%")
        if (z(p))
          h += T, p.next();
        else
          break;
      else if (T === Wt || T === ze)
        if (z(p))
          h += T, p.next();
        else {
          if (D(p))
            break;
          h += T, p.next();
        }
      else
        h += T, p.next();
    }
    return h;
  }
  function et(p) {
    S(p);
    let h = "", T = "";
    for (; h = ke(p); )
      T += h;
    return p.currentChar() === on && u(U.UNTERMINATED_CLOSING_BRACE, r(), 0), T;
  }
  function ft(p) {
    S(p);
    let h = "";
    return p.currentChar() === "-" ? (p.next(), h += `-${K(p)}`) : h += K(p), p.currentChar() === on && u(U.UNTERMINATED_CLOSING_BRACE, r(), 0), h;
  }
  function St(p) {
    S(p), E(p, "'");
    let h = "", T = "";
    const R = (Q) => Q !== Uc && Q !== ze;
    for (; h = oe(p, R); )
      h === "\\" ? T += Te(p) : T += h;
    const H = p.currentChar();
    return H === ze || H === on ? (u(U.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), H === ze && (p.next(), E(p, "'")), T) : (E(p, "'"), T);
  }
  function Te(p) {
    const h = p.currentChar();
    switch (h) {
      case "\\":
      case "'":
        return p.next(), `\\${h}`;
      case "u":
        return tt(p, h, 4);
      case "U":
        return tt(p, h, 6);
      default:
        return u(U.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, h), "";
    }
  }
  function tt(p, h, T) {
    E(p, h);
    let R = "";
    for (let H = 0; H < T; H++) {
      const Q = q(p);
      if (!Q) {
        u(U.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${h}${R}${p.currentChar()}`);
        break;
      }
      R += Q;
    }
    return `\\${h}${R}`;
  }
  function Ie(p) {
    S(p);
    let h = "", T = "";
    const R = (H) => H !== "{" && H !== "}" && H !== Wt && H !== ze;
    for (; h = oe(p, R); )
      T += h;
    return T;
  }
  function Qt(p) {
    let h = "", T = "";
    for (; h = ke(p); )
      T += h;
    return T;
  }
  function en(p) {
    const h = (T = !1, R) => {
      const H = p.currentChar();
      return H === "{" || H === "%" || H === "@" || H === "|" || H === "(" || H === ")" || !H || H === Wt ? R : H === ze || H === e1 ? (R += H, p.next(), h(T, R)) : (R += H, p.next(), h(!0, R));
    };
    return h(!1, "");
  }
  function Rt(p) {
    S(p);
    const h = E(
      p,
      "|"
      /* TokenChars.Pipe */
    );
    return S(p), h;
  }
  function Vt(p, h) {
    let T = null;
    switch (p.currentChar()) {
      case "{":
        return h.braceNest >= 1 && u(U.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), p.next(), T = f(
          h,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(p), h.braceNest++, T;
      case "}":
        return h.braceNest > 0 && h.currentType === 2 && u(U.EMPTY_PLACEHOLDER, r(), 0), p.next(), T = f(
          h,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), h.braceNest--, h.braceNest > 0 && S(p), h.inLinked && h.braceNest === 0 && (h.inLinked = !1), T;
      case "@":
        return h.braceNest > 0 && u(U.UNTERMINATED_CLOSING_BRACE, r(), 0), T = Ot(p, h) || g(h), h.braceNest = 0, T;
      default:
        let H = !0, Q = !0, nt = !0;
        if (D(p))
          return h.braceNest > 0 && u(U.UNTERMINATED_CLOSING_BRACE, r(), 0), T = f(h, 1, Rt(p)), h.braceNest = 0, h.inLinked = !1, T;
        if (h.braceNest > 0 && (h.currentType === 5 || h.currentType === 6 || h.currentType === 7))
          return u(U.UNTERMINATED_CLOSING_BRACE, r(), 0), h.braceNest = 0, zt(p, h);
        if (H = I(p, h))
          return T = f(h, 5, et(p)), S(p), T;
        if (Q = w(p, h))
          return T = f(h, 6, ft(p)), S(p), T;
        if (nt = A(p, h))
          return T = f(h, 7, St(p)), S(p), T;
        if (!H && !Q && !nt)
          return T = f(h, 13, Ie(p)), u(U.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, T.value), S(p), T;
        break;
    }
    return T;
  }
  function Ot(p, h) {
    const { currentType: T } = h;
    let R = null;
    const H = p.currentChar();
    switch ((T === 8 || T === 9 || T === 12 || T === 10) && (H === ze || H === Wt) && u(U.INVALID_LINKED_FORMAT, r(), 0), H) {
      case "@":
        return p.next(), R = f(
          h,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), h.inLinked = !0, R;
      case ".":
        return S(p), p.next(), f(
          h,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(p), p.next(), f(
          h,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return D(p) ? (R = f(h, 1, Rt(p)), h.braceNest = 0, h.inLinked = !1, R) : b(p, h) || L(p, h) ? (S(p), Ot(p, h)) : y(p, h) ? (S(p), f(h, 12, Qt(p))) : C(p, h) ? (S(p), H === "{" ? Vt(p, h) || R : f(h, 11, en(p))) : (T === 8 && u(U.INVALID_LINKED_FORMAT, r(), 0), h.braceNest = 0, h.inLinked = !1, zt(p, h));
    }
  }
  function zt(p, h) {
    let T = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (h.braceNest > 0)
      return Vt(p, h) || g(h);
    if (h.inLinked)
      return Ot(p, h) || g(h);
    switch (p.currentChar()) {
      case "{":
        return Vt(p, h) || g(h);
      case "}":
        return u(U.UNBALANCED_CLOSING_BRACE, r(), 0), p.next(), f(
          h,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ot(p, h) || g(h);
      default:
        if (D(p))
          return T = f(h, 1, Rt(p)), h.braceNest = 0, h.inLinked = !1, T;
        const { isModulo: H, hasSpace: Q } = N(p);
        if (H)
          return Q ? f(h, 0, Le(p)) : f(h, 4, ut(p));
        if (z(p))
          return f(h, 0, Le(p));
        break;
    }
    return T;
  }
  function Ct() {
    const { currentType: p, offset: h, startLoc: T, endLoc: R } = l;
    return l.lastType = p, l.lastOffset = h, l.lastStartLoc = T, l.lastEndLoc = R, l.offset = i(), l.startLoc = r(), o.currentChar() === on ? f(
      l,
      14
      /* TokenTypes.EOF */
    ) : zt(o, l);
  }
  return {
    nextToken: Ct,
    currentOffset: i,
    currentPosition: r,
    context: c
  };
}
const o1 = "parser", i1 = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function r1(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function s1(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(m, v, I, w, ...A) {
    const b = m.currentPosition();
    if (b.offset += w, b.column += w, n) {
      const y = t ? Ns(I, b) : null, L = vo(v, y, {
        domain: o1,
        args: A
      });
      n(L);
    }
  }
  function i(m, v, I) {
    const w = { type: m };
    return t && (w.start = v, w.end = v, w.loc = { start: I, end: I }), w;
  }
  function r(m, v, I, w) {
    w && (m.type = w), t && (m.end = v, m.loc && (m.loc.end = I));
  }
  function s(m, v) {
    const I = m.context(), w = i(3, I.offset, I.startLoc);
    return w.value = v, r(w, m.currentOffset(), m.currentPosition()), w;
  }
  function a(m, v) {
    const I = m.context(), { lastOffset: w, lastStartLoc: A } = I, b = i(5, w, A);
    return b.index = parseInt(v, 10), m.nextToken(), r(b, m.currentOffset(), m.currentPosition()), b;
  }
  function l(m, v) {
    const I = m.context(), { lastOffset: w, lastStartLoc: A } = I, b = i(4, w, A);
    return b.key = v, m.nextToken(), r(b, m.currentOffset(), m.currentPosition()), b;
  }
  function c(m, v) {
    const I = m.context(), { lastOffset: w, lastStartLoc: A } = I, b = i(9, w, A);
    return b.value = v.replace(i1, r1), m.nextToken(), r(b, m.currentOffset(), m.currentPosition()), b;
  }
  function d(m) {
    const v = m.nextToken(), I = m.context(), { lastOffset: w, lastStartLoc: A } = I, b = i(8, w, A);
    return v.type !== 12 ? (o(m, U.UNEXPECTED_EMPTY_LINKED_MODIFIER, I.lastStartLoc, 0), b.value = "", r(b, w, A), {
      nextConsumeToken: v,
      node: b
    }) : (v.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, I.lastStartLoc, 0, Dt(v)), b.value = v.value || "", r(b, m.currentOffset(), m.currentPosition()), {
      node: b
    });
  }
  function u(m, v) {
    const I = m.context(), w = i(7, I.offset, I.startLoc);
    return w.value = v, r(w, m.currentOffset(), m.currentPosition()), w;
  }
  function f(m) {
    const v = m.context(), I = i(6, v.offset, v.startLoc);
    let w = m.nextToken();
    if (w.type === 9) {
      const A = d(m);
      I.modifier = A.node, w = A.nextConsumeToken || m.nextToken();
    }
    switch (w.type !== 10 && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(w)), w = m.nextToken(), w.type === 2 && (w = m.nextToken()), w.type) {
      case 11:
        w.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(w)), I.key = u(m, w.value || "");
        break;
      case 5:
        w.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(w)), I.key = l(m, w.value || "");
        break;
      case 6:
        w.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(w)), I.key = a(m, w.value || "");
        break;
      case 7:
        w.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(w)), I.key = c(m, w.value || "");
        break;
      default:
        o(m, U.UNEXPECTED_EMPTY_LINKED_KEY, v.lastStartLoc, 0);
        const A = m.context(), b = i(7, A.offset, A.startLoc);
        return b.value = "", r(b, A.offset, A.startLoc), I.key = b, r(I, A.offset, A.startLoc), {
          nextConsumeToken: w,
          node: I
        };
    }
    return r(I, m.currentOffset(), m.currentPosition()), {
      node: I
    };
  }
  function g(m) {
    const v = m.context(), I = v.currentType === 1 ? m.currentOffset() : v.offset, w = v.currentType === 1 ? v.endLoc : v.startLoc, A = i(2, I, w);
    A.items = [];
    let b = null;
    do {
      const C = b || m.nextToken();
      switch (b = null, C.type) {
        case 0:
          C.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(C)), A.items.push(s(m, C.value || ""));
          break;
        case 6:
          C.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(C)), A.items.push(a(m, C.value || ""));
          break;
        case 5:
          C.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(C)), A.items.push(l(m, C.value || ""));
          break;
        case 7:
          C.value == null && o(m, U.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Dt(C)), A.items.push(c(m, C.value || ""));
          break;
        case 8:
          const D = f(m);
          A.items.push(D.node), b = D.nextConsumeToken || null;
          break;
      }
    } while (v.currentType !== 14 && v.currentType !== 1);
    const y = v.currentType === 1 ? v.lastOffset : m.currentOffset(), L = v.currentType === 1 ? v.lastEndLoc : m.currentPosition();
    return r(A, y, L), A;
  }
  function E(m, v, I, w) {
    const A = m.context();
    let b = w.items.length === 0;
    const y = i(1, v, I);
    y.cases = [], y.cases.push(w);
    do {
      const L = g(m);
      b || (b = L.items.length === 0), y.cases.push(L);
    } while (A.currentType !== 14);
    return b && o(m, U.MUST_HAVE_MESSAGES_IN_PLURAL, I, 0), r(y, m.currentOffset(), m.currentPosition()), y;
  }
  function k(m) {
    const v = m.context(), { offset: I, startLoc: w } = v, A = g(m);
    return v.currentType === 14 ? A : E(m, I, w, A);
  }
  function S(m) {
    const v = n1(m, gh({}, e)), I = v.context(), w = i(0, I.offset, I.startLoc);
    return t && w.loc && (w.loc.source = m), w.body = k(v), e.onCacheKey && (w.cacheKey = e.onCacheKey(m)), I.currentType !== 14 && o(v, U.UNEXPECTED_LEXICAL_ANALYSIS, I.lastStartLoc, 0, m[I.offset] || ""), r(w, v.currentOffset(), v.currentPosition()), w;
  }
  return { parse: S };
}
function Dt(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function a1(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function Hc(e, t) {
  for (let n = 0; n < e.length; n++)
    Ya(e[n], t);
}
function Ya(e, t) {
  switch (e.type) {
    case 1:
      Hc(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Hc(e.items, t);
      break;
    case 6:
      Ya(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function l1(e, t = {}) {
  const n = a1(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Ya(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function c1(e) {
  const t = e.body;
  return t.type === 2 ? Bc(t) : t.cases.forEach((n) => Bc(n)), e;
}
function Bc(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = bh(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const d1 = "minifier";
function Qn(e) {
  switch (e.t = e.type, e.type) {
    case 0:
      const t = e;
      Qn(t.body), t.b = t.body, delete t.body;
      break;
    case 1:
      const n = e, o = n.cases;
      for (let d = 0; d < o.length; d++)
        Qn(o[d]);
      n.c = o, delete n.cases;
      break;
    case 2:
      const i = e, r = i.items;
      for (let d = 0; d < r.length; d++)
        Qn(r[d]);
      i.i = r, delete i.items, i.static && (i.s = i.static, delete i.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const s = e;
      s.value && (s.v = s.value, delete s.value);
      break;
    case 6:
      const a = e;
      Qn(a.key), a.k = a.key, delete a.key, a.modifier && (Qn(a.modifier), a.m = a.modifier, delete a.modifier);
      break;
    case 5:
      const l = e;
      l.i = l.index, delete l.index;
      break;
    case 4:
      const c = e;
      c.k = c.key, delete c.key;
      break;
    default:
      throw vo(U.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: d1,
        args: [e.type]
      });
  }
  delete e.type;
}
const u1 = "parser";
function f1(e, t) {
  const { sourceMap: n, filename: o, breakLineCode: i, needIndent: r } = t, s = t.location !== !1, a = {
    filename: o,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: i,
    needIndent: r,
    indentLevel: 0
  };
  s && e.loc && (a.source = e.loc.source);
  const l = () => a;
  function c(S, m) {
    a.code += S;
  }
  function d(S, m = !0) {
    const v = m ? i : "";
    c(r ? v + "  ".repeat(S) : v);
  }
  function u(S = !0) {
    const m = ++a.indentLevel;
    S && d(m);
  }
  function f(S = !0) {
    const m = --a.indentLevel;
    S && d(m);
  }
  function g() {
    d(a.indentLevel);
  }
  return {
    context: l,
    push: c,
    indent: u,
    deindent: f,
    newline: g,
    helper: (S) => `_${S}`,
    needIndent: () => a.needIndent
  };
}
function h1(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), co(e, t.key), t.modifier ? (e.push(", "), co(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function m1(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const i = t.items.length;
  for (let r = 0; r < i && (co(e, t.items[r]), r !== i - 1); r++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function p1(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const i = t.cases.length;
    for (let r = 0; r < i && (co(e, t.cases[r]), r !== i - 1); r++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function g1(e, t) {
  t.body ? co(e, t.body) : e.push("null");
}
function co(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      g1(e, t);
      break;
    case 1:
      p1(e, t);
      break;
    case 2:
      m1(e, t);
      break;
    case 6:
      h1(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw vo(U.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: u1,
        args: [t.type]
      });
  }
}
const b1 = (e, t = {}) => {
  const n = zc(t.mode) ? t.mode : "normal", o = zc(t.filename) ? t.filename : "message.intl", i = !!t.sourceMap, r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], l = f1(e, {
    mode: n,
    filename: o,
    sourceMap: i,
    breakLineCode: r,
    needIndent: s
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(s), a.length > 0 && (l.push(`const { ${bh(a.map((u) => `${u}: _${u}`), ", ")} } = ctx`), l.newline()), l.push("return "), co(l, e), l.deindent(s), l.push("}"), delete e.helpers;
  const { code: c, map: d } = l.context();
  return {
    ast: e,
    code: c,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function v1(e, t = {}) {
  const n = gh({}, t), o = !!n.jit, i = !!n.minify, r = n.optimize == null ? !0 : n.optimize, a = s1(n).parse(e);
  return o ? (r && c1(a), i && Qn(a), { ast: a, code: "" }) : (l1(a, n), b1(a, n));
}
/*!
  * core-base v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function y1() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Gt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Gt().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Gt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const pn = [];
pn[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pn[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pn[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
pn[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
pn[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
pn[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
pn[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const w1 = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function k1(e) {
  return w1.test(e);
}
function x1(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function _1(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function E1(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : k1(t) ? x1(t) : "*" + t;
}
function T1(e) {
  const t = [];
  let n = -1, o = 0, i = 0, r, s, a, l, c, d, u;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    s === void 0 ? s = a : s += a;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    s !== void 0 && (t.push(s), s = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), i++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, o = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (i = 0, s === void 0 || (s = E1(s), s === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function g() {
    const E = e[n + 1];
    if (o === 5 && E === "'" || o === 6 && E === '"')
      return n++, a = "\\" + E, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = e[n], !(r === "\\" && g())) {
      if (l = _1(r), u = pn[o], c = u[l] || u.l || 8, c === 8 || (o = c[0], c[1] !== void 0 && (d = f[c[1]], d && (a = r, d() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const Wc = /* @__PURE__ */ new Map();
function I1(e, t) {
  return ne(e) ? e[t] : null;
}
function S1(e, t) {
  if (!ne(e))
    return null;
  let n = Wc.get(t);
  if (n || (n = T1(t), n && Wc.set(t, n)), !n)
    return null;
  const o = n.length;
  let i = e, r = 0;
  for (; r < o; ) {
    const s = i[n[r]];
    if (s === void 0)
      return null;
    i = s, r++;
  }
  return i;
}
const O1 = (e) => e, C1 = (e) => "", A1 = "text", D1 = (e) => e.length === 0 ? "" : VE(e), $1 = RE;
function jc(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function N1(e) {
  const t = Ee(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Ee(e.named.count) || Ee(e.named.n)) ? Ee(e.named.count) ? e.named.count : Ee(e.named.n) ? e.named.n : t : t;
}
function L1(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function P1(e = {}) {
  const t = e.locale, n = N1(e), o = ne(e.pluralRules) && M(t) && be(e.pluralRules[t]) ? e.pluralRules[t] : jc, i = ne(e.pluralRules) && M(t) && be(e.pluralRules[t]) ? jc : void 0, r = (m) => m[o(n, m.length, i)], s = e.list || [], a = (m) => s[m], l = e.named || {};
  Ee(e.pluralIndex) && L1(n, l);
  const c = (m) => l[m];
  function d(m) {
    const v = be(e.messages) ? e.messages(m) : ne(e.messages) ? e.messages[m] : !1;
    return v || (e.parent ? e.parent.message(m) : C1);
  }
  const u = (m) => e.modifiers ? e.modifiers[m] : O1, f = B(e.processor) && be(e.processor.normalize) ? e.processor.normalize : D1, g = B(e.processor) && be(e.processor.interpolate) ? e.processor.interpolate : $1, E = B(e.processor) && M(e.processor.type) ? e.processor.type : A1, S = {
    list: a,
    named: c,
    plural: r,
    linked: (m, ...v) => {
      const [I, w] = v;
      let A = "text", b = "";
      v.length === 1 ? ne(I) ? (b = I.modifier || b, A = I.type || A) : M(I) && (b = I || b) : v.length === 2 && (M(I) && (b = I || b), M(w) && (A = w || A));
      const y = d(m)(S), L = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        A === "vnode" && se(y) && b ? y[0] : y
      );
      return b ? u(b)(L, A) : L;
    },
    message: d,
    type: E,
    interpolate: g,
    normalize: f,
    values: $e({}, s, l)
  };
  return S;
}
let Uo = null;
function M1(e) {
  Uo = e;
}
function F1(e, t, n) {
  Uo && Uo.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const R1 = /* @__PURE__ */ V1(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function V1(e) {
  return (t) => Uo && Uo.emit(e, t);
}
const Be = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, z1 = {
  [Be.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Be.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Be.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Be.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Be.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Be.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Be.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Rn(e, ...t) {
  return Ha(z1[e], ...t);
}
function U1(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...se(t) ? t : ne(t) ? Object.keys(t) : M(t) ? [t] : [n]
  ])];
}
function vh(e, t, n) {
  const o = M(n) ? n : Zo, i = e;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let r = i.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let s = [n];
    for (; se(s); )
      s = Yc(r, s, t);
    const a = se(t) || !B(t) ? t : t.default ? t.default : null;
    s = M(a) ? [a] : a, se(s) && Yc(r, s, !1), i.__localeChainCache.set(o, r);
  }
  return r;
}
function Yc(e, t, n) {
  let o = !0;
  for (let i = 0; i < t.length && j(o); i++) {
    const r = t[i];
    M(r) && (o = H1(e, t[i], n));
  }
  return o;
}
function H1(e, t, n) {
  let o;
  const i = t.split("-");
  do {
    const r = i.join("-");
    o = B1(e, r, n), i.splice(-1, 1);
  } while (i.length && o === !0);
  return o;
}
function B1(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const i = t.replace(/!/g, "");
    e.push(i), (se(n) || B(n)) && n[i] && (o = n[i]);
  }
  return o;
}
const W1 = "9.4.1", sr = -1, Zo = "en-US", zi = "", Gc = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function j1() {
  return {
    upper: (e, t) => t === "text" && M(e) ? e.toUpperCase() : t === "vnode" && ne(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && M(e) ? e.toLowerCase() : t === "vnode" && ne(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && M(e) ? Gc(e) : t === "vnode" && ne(e) && "__v_isVNode" in e ? Gc(e.children) : e
  };
}
let yh;
function qc(e) {
  yh = e;
}
let wh;
function Y1(e) {
  wh = e;
}
let kh;
function G1(e) {
  kh = e;
}
let xh = null;
const Kc = (e) => {
  xh = e;
}, q1 = () => xh;
let _h = null;
const Xc = (e) => {
  _h = e;
}, K1 = () => _h;
let Zc = 0;
function X1(e = {}) {
  const t = be(e.onWarn) ? e.onWarn : Ce, n = M(e.version) ? e.version : W1, o = M(e.locale) ? e.locale : Zo, i = se(e.fallbackLocale) || B(e.fallbackLocale) || M(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, r = B(e.messages) ? e.messages : { [o]: {} }, s = B(e.datetimeFormats) ? e.datetimeFormats : { [o]: {} }, a = B(e.numberFormats) ? e.numberFormats : { [o]: {} }, l = $e({}, e.modifiers || {}, j1()), c = e.pluralRules || {}, d = be(e.missing) ? e.missing : null, u = j(e.missingWarn) || mn(e.missingWarn) ? e.missingWarn : !0, f = j(e.fallbackWarn) || mn(e.fallbackWarn) ? e.fallbackWarn : !0, g = !!e.fallbackFormat, E = !!e.unresolving, k = be(e.postTranslation) ? e.postTranslation : null, S = B(e.processor) ? e.processor : null, m = j(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter, I = be(e.messageCompiler) ? e.messageCompiler : yh;
  process.env.NODE_ENV !== "production" && be(e.messageCompiler) && UE(Rn(Be.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const w = be(e.messageResolver) ? e.messageResolver : wh || I1, A = be(e.localeFallbacker) ? e.localeFallbacker : kh || U1, b = ne(e.fallbackContext) ? e.fallbackContext : void 0, y = e, L = ne(y.__datetimeFormatters) ? y.__datetimeFormatters : /* @__PURE__ */ new Map(), C = ne(y.__numberFormatters) ? y.__numberFormatters : /* @__PURE__ */ new Map(), D = ne(y.__meta) ? y.__meta : {};
  Zc++;
  const N = {
    version: n,
    cid: Zc,
    locale: o,
    fallbackLocale: i,
    messages: r,
    modifiers: l,
    pluralRules: c,
    missing: d,
    missingWarn: u,
    fallbackWarn: f,
    fallbackFormat: g,
    unresolving: E,
    postTranslation: k,
    processor: S,
    warnHtmlMessage: m,
    escapeParameter: v,
    messageCompiler: I,
    messageResolver: w,
    localeFallbacker: A,
    fallbackContext: b,
    onWarn: t,
    __meta: D
  };
  return N.datetimeFormats = s, N.numberFormats = a, N.__datetimeFormatters = L, N.__numberFormatters = C, process.env.NODE_ENV !== "production" && (N.__v_emitter = y.__v_emitter != null ? y.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && F1(N, n, D), N;
}
function ar(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Eh(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Ga(e, t, n, o, i) {
  const { missing: r, onWarn: s } = e;
  if (process.env.NODE_ENV !== "production") {
    const a = e.__v_emitter;
    a && a.emit("missing", {
      locale: n,
      key: t,
      type: i,
      groupId: `${i}:${t}`
    });
  }
  if (r !== null) {
    const a = r(e, n, t, i);
    return M(a) ? a : t;
  } else
    return process.env.NODE_ENV !== "production" && Eh(o, t) && s(Rn(Be.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function xo(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Kr(e) {
  return (n) => Z1(n, e);
}
function Z1(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const o = n, i = o.c || o.cases;
    return e.plural(i.reduce((r, s) => [
      ...r,
      Jc(e, s)
    ], []));
  } else
    return Jc(e, n);
}
function Jc(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = (t.i || t.items).reduce((i, r) => [...i, Ls(e, r)], []);
    return e.normalize(o);
  }
}
function Ls(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3:
      const o = t;
      return o.v || o.value;
    case 9:
      const i = t;
      return i.v || i.value;
    case 4:
      const r = t;
      return e.interpolate(e.named(r.k || r.key));
    case 5:
      const s = t;
      return e.interpolate(e.list(s.i || s.index));
    case 6:
      const a = t, l = a.m || a.modifier;
      return e.linked(Ls(e, a.k || a.key), l ? Ls(e, l) : void 0, e.type);
    case 7:
      const c = t;
      return c.v || c.value;
    case 8:
      const d = t;
      return d.v || d.value;
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const Th = U.__EXTEND_POINT__, mi = Wa(Th), ct = {
  INVALID_ARGUMENT: Th,
  INVALID_DATE_ARGUMENT: mi(),
  INVALID_ISO_DATE_ARGUMENT: mi(),
  NOT_SUPPORT_NON_STRING_MESSAGE: mi(),
  __EXTEND_POINT__: mi()
  // 22
};
function Sn(e) {
  return vo(e, null, process.env.NODE_ENV !== "production" ? { messages: J1 } : void 0);
}
const J1 = {
  [ct.INVALID_ARGUMENT]: "Invalid arguments",
  [ct.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [ct.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [ct.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message"
}, Q1 = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Ih(e, t) {
  t && KE(e) && Ce(Ha(Q1, { source: e }));
}
const Sh = (e) => e;
let to = /* @__PURE__ */ Object.create(null);
const Vn = (e) => ne(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function Oh(e, t = {}) {
  let n = !1;
  const o = t.onError || GE;
  return t.onError = (i) => {
    n = !0, o(i);
  }, { ...v1(e, t), detectError: n };
}
const eT = (e, t) => {
  if (!M(e))
    throw Sn(ct.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const n = j(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Ih(e, n);
    const i = (t.onCacheKey || Sh)(e), r = to[i];
    if (r)
      return r;
    const { code: s, detectError: a } = Oh(e, t), l = new Function(`return ${s}`)();
    return a ? l : to[i] = l;
  }
};
function tT(e, t) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && M(e)) {
    const n = j(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Ih(e, n);
    const i = (t.onCacheKey || Sh)(e), r = to[i];
    if (r)
      return r;
    const { ast: s, detectError: a } = Oh(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Kr(s);
    return a ? l : to[i] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Vn(e))
      return Ce(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = to[n];
      return o || (to[n] = Kr(e));
    } else
      return Kr(e);
  }
}
const Qc = () => "", kt = (e) => be(e);
function ed(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: i, messageCompiler: r, fallbackLocale: s, messages: a } = e, [l, c] = Ps(...t), d = j(c.missingWarn) ? c.missingWarn : e.missingWarn, u = j(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, f = j(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, g = !!c.resolvedMessage, E = M(c.default) || j(c.default) ? j(c.default) ? r ? l : () => l : c.default : n ? r ? l : () => l : "", k = n || E !== "", S = M(c.locale) ? c.locale : e.locale;
  f && nT(c);
  let [m, v, I] = g ? [
    l,
    S,
    a[S] || {}
  ] : Ch(e, l, S, s, u, d), w = m, A = l;
  if (!g && !(M(w) || Vn(w) || kt(w)) && k && (w = E, A = w), !g && (!(M(w) || Vn(w) || kt(w)) || !M(v)))
    return i ? sr : l;
  if (process.env.NODE_ENV !== "production" && M(w) && e.messageCompiler == null)
    return Ce(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let b = !1;
  const y = () => {
    b = !0;
  }, L = kt(w) ? w : Ah(e, l, v, w, A, y);
  if (b)
    return w;
  const C = sT(e, v, I, c), D = P1(C), N = oT(e, L, D), z = o ? o(N, l) : N;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const oe = {
      timestamp: Date.now(),
      key: M(l) ? l : kt(w) ? w.key : "",
      locale: v || (kt(w) ? w.locale : ""),
      format: M(w) ? w : kt(w) ? w.source : "",
      message: z
    };
    oe.meta = $e({}, e.__meta, q1() || {}), R1(oe);
  }
  return z;
}
function nT(e) {
  se(e.list) ? e.list = e.list.map((t) => M(t) ? Fc(t) : t) : ne(e.named) && Object.keys(e.named).forEach((t) => {
    M(e.named[t]) && (e.named[t] = Fc(e.named[t]));
  });
}
function Ch(e, t, n, o, i, r) {
  const { messages: s, onWarn: a, messageResolver: l, localeFallbacker: c } = e, d = c(e, o, n);
  let u = {}, f, g = null, E = n, k = null;
  const S = "translate";
  for (let m = 0; m < d.length; m++) {
    if (f = k = d[m], process.env.NODE_ENV !== "production" && n !== f && ar(i, t) && a(Rn(Be.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: f
    })), process.env.NODE_ENV !== "production" && n !== f) {
      const b = e.__v_emitter;
      b && b.emit("fallback", {
        type: S,
        key: t,
        from: E,
        to: k,
        groupId: `${S}:${t}`
      });
    }
    u = s[f] || {};
    let v = null, I, w;
    if (process.env.NODE_ENV !== "production" && Pt && (v = window.performance.now(), I = "intlify-message-resolve-start", w = "intlify-message-resolve-end", Je && Je(I)), (g = l(u, t)) === null && (g = u[t]), process.env.NODE_ENV !== "production" && Pt) {
      const b = window.performance.now(), y = e.__v_emitter;
      y && v && g && y.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: g,
        time: b - v,
        groupId: `${S}:${t}`
      }), I && w && Je && Fn && (Je(w), Fn("intlify message resolve", I, w));
    }
    if (M(g) || Vn(g) || kt(g))
      break;
    const A = Ga(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      t,
      f,
      r,
      S
    );
    A !== t && (g = A), E = k;
  }
  return [g, f, u];
}
function Ah(e, t, n, o, i, r) {
  const { messageCompiler: s, warnHtmlMessage: a } = e;
  if (kt(o)) {
    const f = o;
    return f.locale = f.locale || n, f.key = f.key || t, f;
  }
  if (s == null) {
    const f = () => o;
    return f.locale = n, f.key = t, f;
  }
  let l = null, c, d;
  process.env.NODE_ENV !== "production" && Pt && (l = window.performance.now(), c = "intlify-message-compilation-start", d = "intlify-message-compilation-end", Je && Je(c));
  const u = s(o, iT(e, n, i, o, a, r));
  if (process.env.NODE_ENV !== "production" && Pt) {
    const f = window.performance.now(), g = e.__v_emitter;
    g && l && g.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: f - l,
      groupId: `translate:${t}`
    }), c && d && Je && Fn && (Je(d), Fn("intlify message compilation", c, d));
  }
  return u.locale = n, u.key = t, u.source = o, u;
}
function oT(e, t, n) {
  let o = null, i, r;
  process.env.NODE_ENV !== "production" && Pt && (o = window.performance.now(), i = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", Je && Je(i));
  const s = t(n);
  if (process.env.NODE_ENV !== "production" && Pt) {
    const a = window.performance.now(), l = e.__v_emitter;
    l && o && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: s,
      time: a - o,
      groupId: `translate:${t.key}`
    }), i && r && Je && Fn && (Je(r), Fn("intlify message evaluation", i, r));
  }
  return s;
}
function Ps(...e) {
  const [t, n, o] = e, i = {};
  if (!M(t) && !Ee(t) && !kt(t) && !Vn(t))
    throw Sn(ct.INVALID_ARGUMENT);
  const r = Ee(t) ? String(t) : (kt(t), t);
  return Ee(n) ? i.plural = n : M(n) ? i.default = n : B(n) && !rr(n) ? i.named = n : se(n) && (i.list = n), Ee(o) ? i.plural = o : M(o) ? i.default = o : B(o) && $e(i, o), [r, i];
}
function iT(e, t, n, o, i, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: i,
    onError: (s) => {
      if (r && r(s), process.env.NODE_ENV !== "production") {
        const a = rT(o), l = `Message compilation error: ${s.message}`, c = s.location && a && zE(a, s.location.start.offset, s.location.end.offset), d = e.__v_emitter;
        d && a && d.emit("compile-error", {
          message: a,
          error: s.message,
          start: s.location && s.location.start.offset,
          end: s.location && s.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw s;
    },
    onCacheKey: (s) => LE(t, n, s)
  };
}
function rT(e) {
  var t;
  if (!M(e)) {
    if ((t = e.loc) != null && t.source)
      return e.loc.source;
  }
}
function sT(e, t, n, o) {
  const { modifiers: i, pluralRules: r, messageResolver: s, fallbackLocale: a, fallbackWarn: l, missingWarn: c, fallbackContext: d } = e, f = {
    locale: t,
    modifiers: i,
    pluralRules: r,
    messages: (g) => {
      let E = s(n, g);
      if (E == null && d) {
        const [, , k] = Ch(d, g, t, a, l, c);
        E = s(k, g);
      }
      if (M(E) || Vn(E)) {
        let k = !1;
        const m = Ah(e, g, t, E, g, () => {
          k = !0;
        });
        return k ? Qc : m;
      } else
        return kt(E) ? E : Qc;
    }
  };
  return e.processor && (f.processor = e.processor), o.list && (f.list = o.list), o.named && (f.named = o.named), Ee(o.plural) && (f.pluralIndex = o.plural), f;
}
const td = typeof Intl < "u", Dh = {
  dateTimeFormat: td && typeof Intl.DateTimeFormat < "u",
  numberFormat: td && typeof Intl.NumberFormat < "u"
};
function nd(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: s } = e, { __datetimeFormatters: a } = e;
  if (process.env.NODE_ENV !== "production" && !Dh.dateTimeFormat)
    return r(Rn(Be.CANNOT_FORMAT_DATE)), zi;
  const [l, c, d, u] = Ms(...t), f = j(d.missingWarn) ? d.missingWarn : e.missingWarn, g = j(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, E = !!d.part, k = M(d.locale) ? d.locale : e.locale, S = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    k
  );
  if (!M(l) || l === "")
    return new Intl.DateTimeFormat(k, u).format(c);
  let m = {}, v, I = null, w = k, A = null;
  const b = "datetime format";
  for (let C = 0; C < S.length; C++) {
    if (v = A = S[C], process.env.NODE_ENV !== "production" && k !== v && ar(g, l) && r(Rn(Be.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: v
    })), process.env.NODE_ENV !== "production" && k !== v) {
      const D = e.__v_emitter;
      D && D.emit("fallback", {
        type: b,
        key: l,
        from: w,
        to: A,
        groupId: `${b}:${l}`
      });
    }
    if (m = n[v] || {}, I = m[l], B(I))
      break;
    Ga(e, l, v, f, b), w = A;
  }
  if (!B(I) || !M(v))
    return o ? sr : l;
  let y = `${v}__${l}`;
  rr(u) || (y = `${y}__${JSON.stringify(u)}`);
  let L = a.get(y);
  return L || (L = new Intl.DateTimeFormat(v, $e({}, I, u)), a.set(y, L)), E ? L.formatToParts(c) : L.format(c);
}
const $h = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Ms(...e) {
  const [t, n, o, i] = e, r = {};
  let s = {}, a;
  if (M(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Sn(ct.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    a = new Date(c);
    try {
      a.toISOString();
    } catch {
      throw Sn(ct.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ME(t)) {
    if (isNaN(t.getTime()))
      throw Sn(ct.INVALID_DATE_ARGUMENT);
    a = t;
  } else if (Ee(t))
    a = t;
  else
    throw Sn(ct.INVALID_ARGUMENT);
  return M(n) ? r.key = n : B(n) && Object.keys(n).forEach((l) => {
    $h.includes(l) ? s[l] = n[l] : r[l] = n[l];
  }), M(o) ? r.locale = o : B(o) && (s = o), B(i) && (s = i), [r.key || "", a, r, s];
}
function od(e, t, n) {
  const o = e;
  for (const i in n) {
    const r = `${t}__${i}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function id(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: s } = e, { __numberFormatters: a } = e;
  if (process.env.NODE_ENV !== "production" && !Dh.numberFormat)
    return r(Rn(Be.CANNOT_FORMAT_NUMBER)), zi;
  const [l, c, d, u] = Fs(...t), f = j(d.missingWarn) ? d.missingWarn : e.missingWarn, g = j(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, E = !!d.part, k = M(d.locale) ? d.locale : e.locale, S = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    k
  );
  if (!M(l) || l === "")
    return new Intl.NumberFormat(k, u).format(c);
  let m = {}, v, I = null, w = k, A = null;
  const b = "number format";
  for (let C = 0; C < S.length; C++) {
    if (v = A = S[C], process.env.NODE_ENV !== "production" && k !== v && ar(g, l) && r(Rn(Be.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: v
    })), process.env.NODE_ENV !== "production" && k !== v) {
      const D = e.__v_emitter;
      D && D.emit("fallback", {
        type: b,
        key: l,
        from: w,
        to: A,
        groupId: `${b}:${l}`
      });
    }
    if (m = n[v] || {}, I = m[l], B(I))
      break;
    Ga(e, l, v, f, b), w = A;
  }
  if (!B(I) || !M(v))
    return o ? sr : l;
  let y = `${v}__${l}`;
  rr(u) || (y = `${y}__${JSON.stringify(u)}`);
  let L = a.get(y);
  return L || (L = new Intl.NumberFormat(v, $e({}, I, u)), a.set(y, L)), E ? L.formatToParts(c) : L.format(c);
}
const Nh = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Fs(...e) {
  const [t, n, o, i] = e, r = {};
  let s = {};
  if (!Ee(t))
    throw Sn(ct.INVALID_ARGUMENT);
  const a = t;
  return M(n) ? r.key = n : B(n) && Object.keys(n).forEach((l) => {
    Nh.includes(l) ? s[l] = n[l] : r[l] = n[l];
  }), M(o) ? r.locale = o : B(o) && (s = o), B(i) && (s = i), [r.key || "", a, r, s];
}
function rd(e, t, n) {
  const o = e;
  for (const i in n) {
    const r = `${t}__${i}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
y1();
/*!
  * vue-i18n v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const aT = "9.4.1";
function lT() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Gt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Gt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Gt().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Gt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Gt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Lh = Be.__EXTEND_POINT__, rn = Wa(Lh), ge = {
  FALLBACK_TO_ROOT: Lh,
  NOT_SUPPORTED_PRESERVE: rn(),
  NOT_SUPPORTED_FORMATTER: rn(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: rn(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: rn(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: rn(),
  NOT_FOUND_PARENT_SCOPE: rn(),
  IGNORE_OBJ_FLATTEN: rn(),
  NOTICE_DROP_ALLOW_COMPOSITION: rn()
  // 17
}, cT = {
  [ge.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [ge.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [ge.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [ge.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [ge.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [ge.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [ge.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [ge.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [ge.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function Ze(e, ...t) {
  return Ha(cT[e], ...t);
}
const Ph = ct.__EXTEND_POINT__, Ge = Wa(Ph), Z = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Ph,
  // legacy module errors
  INVALID_ARGUMENT: Ge(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Ge(),
  NOT_INSTALLED: Ge(),
  NOT_AVAILABLE_IN_LEGACY_MODE: Ge(),
  // directive module errors
  REQUIRED_VALUE: Ge(),
  INVALID_VALUE: Ge(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Ge(),
  NOT_INSTALLED_WITH_PROVIDE: Ge(),
  // unexpected error
  UNEXPECTED_ERROR: Ge(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Ge(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Ge(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Ge(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Ge(),
  // for enhancement
  __EXTEND_POINT__: Ge()
  // 37
};
function we(e, ...t) {
  return vo(e, null, process.env.NODE_ENV !== "production" ? { messages: dT, args: t } : void 0);
}
const dT = {
  [Z.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Z.INVALID_ARGUMENT]: "Invalid argument",
  [Z.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Z.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Z.UNEXPECTED_ERROR]: "Unexpected error",
  [Z.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [Z.REQUIRED_VALUE]: "Required in value: {0}",
  [Z.INVALID_VALUE]: "Invalid value",
  [Z.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Z.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Z.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Z.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [Z.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [Z.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Rs = /* @__PURE__ */ Ft("__translateVNode"), Vs = /* @__PURE__ */ Ft("__datetimeParts"), zs = /* @__PURE__ */ Ft("__numberParts"), zn = /* @__PURE__ */ Ft("__enableEmitter"), Ho = /* @__PURE__ */ Ft("__disableEmitter"), Mh = Ft("__setPluralRules"), Fh = /* @__PURE__ */ Ft("__injectWithOption"), Us = /* @__PURE__ */ Ft("__dispose");
function Hs(e) {
  if (!ne(e))
    return e;
  for (const t in e)
    if (Ba(e, t))
      if (!t.includes("."))
        ne(e[t]) && Hs(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let i = e, r = !1;
        for (let s = 0; s < o; s++) {
          if (n[s] in i || (i[n[s]] = {}), !ne(i[n[s]])) {
            process.env.NODE_ENV !== "production" && Ce(Ze(ge.IGNORE_OBJ_FLATTEN, {
              key: n[s]
            })), r = !0;
            break;
          }
          i = i[n[s]];
        }
        r || (i[n[o]] = e[t], delete e[t]), ne(i[n[o]]) && Hs(i[n[o]]);
      }
  return e;
}
function lr(e, t) {
  const { messages: n, __i18n: o, messageResolver: i, flatJson: r } = t, s = B(n) ? n : se(o) ? {} : { [e]: {} };
  if (se(o) && o.forEach((a) => {
    if ("locale" in a && "resource" in a) {
      const { locale: l, resource: c } = a;
      l ? (s[l] = s[l] || {}, Do(c, s[l])) : Do(c, s);
    } else
      M(a) && Do(JSON.parse(a), s);
  }), i == null && r)
    for (const a in s)
      Ba(s, a) && Hs(s[a]);
  return s;
}
const pi = (e) => !ne(e) || se(e);
function Do(e, t) {
  if (pi(e) || pi(t))
    throw we(Z.INVALID_VALUE);
  for (const n in e)
    Ba(e, n) && (pi(e[n]) || pi(t[n]) ? t[n] = e[n] : Do(e[n], t[n]));
}
function Rh(e) {
  return e.type;
}
function Vh(e, t, n) {
  let o = ne(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (o = lr(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const i = Object.keys(o);
  i.length && i.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (ne(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((s) => {
        e.mergeDateTimeFormat(s, t.datetimeFormats[s]);
      });
    }
    if (ne(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((s) => {
        e.mergeNumberFormat(s, t.numberFormats[s]);
      });
    }
  }
}
function sd(e) {
  return he(Em, null, e, 0);
}
const ad = "__INTLIFY_META__";
let ld = 0;
function cd(e) {
  return (t, n, o, i) => e(n, o, Zt() || void 0, i);
}
const uT = () => {
  const e = Zt();
  let t = null;
  return e && (t = Rh(e)[ad]) ? { [ad]: t } : null;
};
function qa(e = {}, t) {
  const { __root: n, __injectWithOption: o } = e, i = n === void 0;
  let r = j(e.inheritLocale) ? e.inheritLocale : !0;
  const s = We(
    // prettier-ignore
    n && r ? n.locale.value : M(e.locale) ? e.locale : Zo
  ), a = We(
    // prettier-ignore
    n && r ? n.fallbackLocale.value : M(e.fallbackLocale) || se(e.fallbackLocale) || B(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s.value
  ), l = We(lr(s.value, e)), c = We(B(e.datetimeFormats) ? e.datetimeFormats : { [s.value]: {} }), d = We(B(e.numberFormats) ? e.numberFormats : { [s.value]: {} });
  let u = n ? n.missingWarn : j(e.missingWarn) || mn(e.missingWarn) ? e.missingWarn : !0, f = n ? n.fallbackWarn : j(e.fallbackWarn) || mn(e.fallbackWarn) ? e.fallbackWarn : !0, g = n ? n.fallbackRoot : j(e.fallbackRoot) ? e.fallbackRoot : !0, E = !!e.fallbackFormat, k = be(e.missing) ? e.missing : null, S = be(e.missing) ? cd(e.missing) : null, m = be(e.postTranslation) ? e.postTranslation : null, v = n ? n.warnHtmlMessage : j(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, I = !!e.escapeParameter;
  const w = n ? n.modifiers : B(e.modifiers) ? e.modifiers : {};
  let A = e.pluralRules || n && n.pluralRules, b;
  b = (() => {
    i && Xc(null);
    const O = {
      version: aT,
      locale: s.value,
      fallbackLocale: a.value,
      messages: l.value,
      modifiers: w,
      pluralRules: A,
      missing: S === null ? void 0 : S,
      missingWarn: u,
      fallbackWarn: f,
      fallbackFormat: E,
      unresolving: !0,
      postTranslation: m === null ? void 0 : m,
      warnHtmlMessage: v,
      escapeParameter: I,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    O.datetimeFormats = c.value, O.numberFormats = d.value, O.__datetimeFormatters = B(b) ? b.__datetimeFormatters : void 0, O.__numberFormatters = B(b) ? b.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (O.__v_emitter = B(b) ? b.__v_emitter : void 0);
    const $ = X1(O);
    return i && Xc($), $;
  })(), xo(b, s.value, a.value);
  function L() {
    return [
      s.value,
      a.value,
      l.value,
      c.value,
      d.value
    ];
  }
  const C = Oe({
    get: () => s.value,
    set: (O) => {
      s.value = O, b.locale = s.value;
    }
  }), D = Oe({
    get: () => a.value,
    set: (O) => {
      a.value = O, b.fallbackLocale = a.value, xo(b, s.value, O);
    }
  }), N = Oe(() => l.value), z = /* @__PURE__ */ Oe(() => c.value), oe = /* @__PURE__ */ Oe(() => d.value);
  function ke() {
    return be(m) ? m : null;
  }
  function Ye(O) {
    m = O, b.postTranslation = O;
  }
  function q() {
    return k;
  }
  function K(O) {
    O !== null && (S = cd(O)), k = O, b.missing = S;
  }
  function ut(O, $) {
    return O !== "translate" || !$.resolvedMessage;
  }
  const Le = (O, $, Pe, Ae, Ut, mt) => {
    L();
    let pt;
    try {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Kc(uT()), i || (b.fallbackContext = n ? K1() : void 0), pt = O(b);
    } finally {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Kc(null), i || (b.fallbackContext = void 0);
    }
    if (Ee(pt) && pt === sr) {
      const [xe, At] = $();
      if (process.env.NODE_ENV !== "production" && n && M(xe) && ut(Pe, At) && (g && (ar(f, xe) || Eh(u, xe)) && Ce(Ze(ge.FALLBACK_TO_ROOT, {
        key: xe,
        type: Pe
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Ht } = b;
        Ht && g && Ht.emit("fallback", {
          type: Pe,
          key: xe,
          to: "global",
          groupId: `${Pe}:${xe}`
        });
      }
      return n && g ? Ae(n) : Ut(xe);
    } else {
      if (mt(pt))
        return pt;
      throw we(Z.UNEXPECTED_RETURN_TYPE);
    }
  };
  function et(...O) {
    return Le(($) => Reflect.apply(ed, null, [$, ...O]), () => Ps(...O), "translate", ($) => Reflect.apply($.t, $, [...O]), ($) => $, ($) => M($));
  }
  function ft(...O) {
    const [$, Pe, Ae] = O;
    if (Ae && !ne(Ae))
      throw we(Z.INVALID_ARGUMENT);
    return et($, Pe, $e({ resolvedMessage: !0 }, Ae || {}));
  }
  function St(...O) {
    return Le(($) => Reflect.apply(nd, null, [$, ...O]), () => Ms(...O), "datetime format", ($) => Reflect.apply($.d, $, [...O]), () => zi, ($) => M($));
  }
  function Te(...O) {
    return Le(($) => Reflect.apply(id, null, [$, ...O]), () => Fs(...O), "number format", ($) => Reflect.apply($.n, $, [...O]), () => zi, ($) => M($));
  }
  function tt(O) {
    return O.map(($) => M($) || Ee($) || j($) ? sd(String($)) : $);
  }
  const Qt = {
    normalize: tt,
    interpolate: (O) => O,
    type: "vnode"
  };
  function en(...O) {
    return Le(
      ($) => {
        let Pe;
        const Ae = $;
        try {
          Ae.processor = Qt, Pe = Reflect.apply(ed, null, [Ae, ...O]);
        } finally {
          Ae.processor = null;
        }
        return Pe;
      },
      () => Ps(...O),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ($) => $[Rs](...O),
      ($) => [sd($)],
      ($) => se($)
    );
  }
  function Rt(...O) {
    return Le(
      ($) => Reflect.apply(id, null, [$, ...O]),
      () => Fs(...O),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ($) => $[zs](...O),
      () => [],
      ($) => M($) || se($)
    );
  }
  function Vt(...O) {
    return Le(
      ($) => Reflect.apply(nd, null, [$, ...O]),
      () => Ms(...O),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ($) => $[Vs](...O),
      () => [],
      ($) => M($) || se($)
    );
  }
  function Ot(O) {
    A = O, b.pluralRules = A;
  }
  function zt(O, $) {
    const Pe = M($) ? $ : s.value, Ae = h(Pe);
    return b.messageResolver(Ae, O) !== null;
  }
  function Ct(O) {
    let $ = null;
    const Pe = vh(b, a.value, s.value);
    for (let Ae = 0; Ae < Pe.length; Ae++) {
      const Ut = l.value[Pe[Ae]] || {}, mt = b.messageResolver(Ut, O);
      if (mt != null) {
        $ = mt;
        break;
      }
    }
    return $;
  }
  function p(O) {
    const $ = Ct(O);
    return $ ?? (n ? n.tm(O) || {} : {});
  }
  function h(O) {
    return l.value[O] || {};
  }
  function T(O, $) {
    l.value[O] = $, b.messages = l.value;
  }
  function R(O, $) {
    l.value[O] = l.value[O] || {}, Do($, l.value[O]), b.messages = l.value;
  }
  function H(O) {
    return c.value[O] || {};
  }
  function Q(O, $) {
    c.value[O] = $, b.datetimeFormats = c.value, od(b, O, $);
  }
  function nt(O, $) {
    c.value[O] = $e(c.value[O] || {}, $), b.datetimeFormats = c.value, od(b, O, $);
  }
  function ht(O) {
    return d.value[O] || {};
  }
  function cr(O, $) {
    d.value[O] = $, b.numberFormats = d.value, rd(b, O, $);
  }
  function dr(O, $) {
    d.value[O] = $e(d.value[O] || {}, $), b.numberFormats = d.value, rd(b, O, $);
  }
  ld++, n && Pt && (No(n.locale, (O) => {
    r && (s.value = O, b.locale = O, xo(b, s.value, a.value));
  }), No(n.fallbackLocale, (O) => {
    r && (a.value = O, b.fallbackLocale = O, xo(b, s.value, a.value));
  }));
  const me = {
    id: ld,
    locale: C,
    fallbackLocale: D,
    get inheritLocale() {
      return r;
    },
    set inheritLocale(O) {
      r = O, O && n && (s.value = n.locale.value, a.value = n.fallbackLocale.value, xo(b, s.value, a.value));
    },
    get availableLocales() {
      return Object.keys(l.value).sort();
    },
    messages: N,
    get modifiers() {
      return w;
    },
    get pluralRules() {
      return A || {};
    },
    get isGlobal() {
      return i;
    },
    get missingWarn() {
      return u;
    },
    set missingWarn(O) {
      u = O, b.missingWarn = u;
    },
    get fallbackWarn() {
      return f;
    },
    set fallbackWarn(O) {
      f = O, b.fallbackWarn = f;
    },
    get fallbackRoot() {
      return g;
    },
    set fallbackRoot(O) {
      g = O;
    },
    get fallbackFormat() {
      return E;
    },
    set fallbackFormat(O) {
      E = O, b.fallbackFormat = E;
    },
    get warnHtmlMessage() {
      return v;
    },
    set warnHtmlMessage(O) {
      v = O, b.warnHtmlMessage = O;
    },
    get escapeParameter() {
      return I;
    },
    set escapeParameter(O) {
      I = O, b.escapeParameter = O;
    },
    t: et,
    getLocaleMessage: h,
    setLocaleMessage: T,
    mergeLocaleMessage: R,
    getPostTranslationHandler: ke,
    setPostTranslationHandler: Ye,
    getMissingHandler: q,
    setMissingHandler: K,
    [Mh]: Ot
  };
  return me.datetimeFormats = z, me.numberFormats = oe, me.rt = ft, me.te = zt, me.tm = p, me.d = St, me.n = Te, me.getDateTimeFormat = H, me.setDateTimeFormat = Q, me.mergeDateTimeFormat = nt, me.getNumberFormat = ht, me.setNumberFormat = cr, me.mergeNumberFormat = dr, me[Fh] = o, me[Rs] = en, me[Vs] = Vt, me[zs] = Rt, process.env.NODE_ENV !== "production" && (me[zn] = (O) => {
    b.__v_emitter = O;
  }, me[Ho] = () => {
    b.__v_emitter = void 0;
  }), me;
}
function fT(e) {
  const t = M(e.locale) ? e.locale : Zo, n = M(e.fallbackLocale) || se(e.fallbackLocale) || B(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, o = be(e.missing) ? e.missing : void 0, i = j(e.silentTranslationWarn) || mn(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, r = j(e.silentFallbackWarn) || mn(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, s = j(e.fallbackRoot) ? e.fallbackRoot : !0, a = !!e.formatFallbackMessages, l = B(e.modifiers) ? e.modifiers : {}, c = e.pluralizationRules, d = be(e.postTranslation) ? e.postTranslation : void 0, u = M(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, f = !!e.escapeParameterHtml, g = j(e.sync) ? e.sync : !0;
  process.env.NODE_ENV !== "production" && e.formatter && Ce(Ze(ge.NOT_SUPPORTED_FORMATTER)), process.env.NODE_ENV !== "production" && e.preserveDirectiveContent && Ce(Ze(ge.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
  let E = e.messages;
  if (B(e.sharedMessages)) {
    const A = e.sharedMessages;
    E = Object.keys(A).reduce((y, L) => {
      const C = y[L] || (y[L] = {});
      return $e(C, A[L]), y;
    }, E || {});
  }
  const { __i18n: k, __root: S, __injectWithOption: m } = e, v = e.datetimeFormats, I = e.numberFormats, w = e.flatJson;
  return {
    locale: t,
    fallbackLocale: n,
    messages: E,
    flatJson: w,
    datetimeFormats: v,
    numberFormats: I,
    missing: o,
    missingWarn: i,
    fallbackWarn: r,
    fallbackRoot: s,
    fallbackFormat: a,
    modifiers: l,
    pluralRules: c,
    postTranslation: d,
    warnHtmlMessage: u,
    escapeParameter: f,
    messageResolver: e.messageResolver,
    inheritLocale: g,
    __i18n: k,
    __root: S,
    __injectWithOption: m
  };
}
function Bs(e = {}, t) {
  {
    const n = qa(fT(e)), { __extender: o } = e, i = {
      // id
      id: n.id,
      // locale
      get locale() {
        return n.locale.value;
      },
      set locale(r) {
        n.locale.value = r;
      },
      // fallbackLocale
      get fallbackLocale() {
        return n.fallbackLocale.value;
      },
      set fallbackLocale(r) {
        n.fallbackLocale.value = r;
      },
      // messages
      get messages() {
        return n.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return n.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return n.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return n.availableLocales;
      },
      // formatter
      get formatter() {
        return process.env.NODE_ENV !== "production" && Ce(Ze(ge.NOT_SUPPORTED_FORMATTER)), {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(r) {
        process.env.NODE_ENV !== "production" && Ce(Ze(ge.NOT_SUPPORTED_FORMATTER));
      },
      // missing
      get missing() {
        return n.getMissingHandler();
      },
      set missing(r) {
        n.setMissingHandler(r);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return j(n.missingWarn) ? !n.missingWarn : n.missingWarn;
      },
      set silentTranslationWarn(r) {
        n.missingWarn = j(r) ? !r : r;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return j(n.fallbackWarn) ? !n.fallbackWarn : n.fallbackWarn;
      },
      set silentFallbackWarn(r) {
        n.fallbackWarn = j(r) ? !r : r;
      },
      // modifiers
      get modifiers() {
        return n.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return n.fallbackFormat;
      },
      set formatFallbackMessages(r) {
        n.fallbackFormat = r;
      },
      // postTranslation
      get postTranslation() {
        return n.getPostTranslationHandler();
      },
      set postTranslation(r) {
        n.setPostTranslationHandler(r);
      },
      // sync
      get sync() {
        return n.inheritLocale;
      },
      set sync(r) {
        n.inheritLocale = r;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return n.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(r) {
        n.warnHtmlMessage = r !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return n.escapeParameter;
      },
      set escapeParameterHtml(r) {
        n.escapeParameter = r;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return process.env.NODE_ENV !== "production" && Ce(Ze(ge.NOT_SUPPORTED_PRESERVE_DIRECTIVE)), !0;
      },
      set preserveDirectiveContent(r) {
        process.env.NODE_ENV !== "production" && Ce(Ze(ge.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
      },
      // pluralizationRules
      get pluralizationRules() {
        return n.pluralRules || {};
      },
      // for internal
      __composer: n,
      // t
      t(...r) {
        const [s, a, l] = r, c = {};
        let d = null, u = null;
        if (!M(s))
          throw we(Z.INVALID_ARGUMENT);
        const f = s;
        return M(a) ? c.locale = a : se(a) ? d = a : B(a) && (u = a), se(l) ? d = l : B(l) && (u = l), Reflect.apply(n.t, n, [
          f,
          d || u || {},
          c
        ]);
      },
      rt(...r) {
        return Reflect.apply(n.rt, n, [...r]);
      },
      // tc
      tc(...r) {
        const [s, a, l] = r, c = { plural: 1 };
        let d = null, u = null;
        if (!M(s))
          throw we(Z.INVALID_ARGUMENT);
        const f = s;
        return M(a) ? c.locale = a : Ee(a) ? c.plural = a : se(a) ? d = a : B(a) && (u = a), M(l) ? c.locale = l : se(l) ? d = l : B(l) && (u = l), Reflect.apply(n.t, n, [
          f,
          d || u || {},
          c
        ]);
      },
      // te
      te(r, s) {
        return n.te(r, s);
      },
      // tm
      tm(r) {
        return n.tm(r);
      },
      // getLocaleMessage
      getLocaleMessage(r) {
        return n.getLocaleMessage(r);
      },
      // setLocaleMessage
      setLocaleMessage(r, s) {
        n.setLocaleMessage(r, s);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(r, s) {
        n.mergeLocaleMessage(r, s);
      },
      // d
      d(...r) {
        return Reflect.apply(n.d, n, [...r]);
      },
      // getDateTimeFormat
      getDateTimeFormat(r) {
        return n.getDateTimeFormat(r);
      },
      // setDateTimeFormat
      setDateTimeFormat(r, s) {
        n.setDateTimeFormat(r, s);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(r, s) {
        n.mergeDateTimeFormat(r, s);
      },
      // n
      n(...r) {
        return Reflect.apply(n.n, n, [...r]);
      },
      // getNumberFormat
      getNumberFormat(r) {
        return n.getNumberFormat(r);
      },
      // setNumberFormat
      setNumberFormat(r, s) {
        n.setNumberFormat(r, s);
      },
      // mergeNumberFormat
      mergeNumberFormat(r, s) {
        n.mergeNumberFormat(r, s);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(r, s) {
        return process.env.NODE_ENV !== "production" && Ce(Ze(ge.NOT_SUPPORTED_GET_CHOICE_INDEX)), -1;
      }
    };
    return i.__extender = o, process.env.NODE_ENV !== "production" && (i.__enableEmitter = (r) => {
      const s = n;
      s[zn] && s[zn](r);
    }, i.__disableEmitter = () => {
      const r = n;
      r[Ho] && r[Ho]();
    }), i;
  }
}
const Ka = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function hT({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, i) => [
    ...o,
    // prettier-ignore
    ...i.type === Lo ? i.children : [i]
  ], []) : t.reduce((n, o) => {
    const i = e[o];
    return i && (n[o] = i()), n;
  }, {});
}
function zh(e) {
  return Lo;
}
const mT = /* @__PURE__ */ It({
  /* eslint-disable */
  name: "i18n-t",
  props: $e({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => Ee(e) || !isNaN(e)
    }
  }, Ka),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: o } = t, i = e.i18n || Za({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const r = Object.keys(n).filter((u) => u !== "_"), s = {};
      e.locale && (s.locale = e.locale), e.plural !== void 0 && (s.plural = M(e.plural) ? +e.plural : e.plural);
      const a = hT(t, r), l = i[Rs](e.keypath, a, s), c = $e({}, o), d = M(e.tag) || ne(e.tag) ? e.tag : zh();
      return Wo(d, c, l);
    };
  }
}), Xr = mT;
function pT(e) {
  return se(e) && !M(e[0]);
}
function Uh(e, t, n, o) {
  const { slots: i, attrs: r } = t;
  return () => {
    const s = { part: !0 };
    let a = {};
    e.locale && (s.locale = e.locale), M(e.format) ? s.key = e.format : ne(e.format) && (M(e.format.key) && (s.key = e.format.key), a = Object.keys(e.format).reduce((f, g) => n.includes(g) ? $e({}, f, { [g]: e.format[g] }) : f, {}));
    const l = o(e.value, s, a);
    let c = [s.key];
    se(l) ? c = l.map((f, g) => {
      const E = i[f.type], k = E ? E({ [f.type]: f.value, index: g, parts: l }) : [f.value];
      return pT(k) && (k[0].key = `${f.type}-${g}`), k;
    }) : M(l) && (c = [l]);
    const d = $e({}, r), u = M(e.tag) || ne(e.tag) ? e.tag : zh();
    return Wo(u, d, c);
  };
}
const gT = /* @__PURE__ */ It({
  /* eslint-disable */
  name: "i18n-n",
  props: $e({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Ka),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || Za({
      useScope: "parent",
      __useComponent: !0
    });
    return Uh(e, t, Nh, (...o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[zs](...o)
    ));
  }
}), dd = gT, bT = /* @__PURE__ */ It({
  /* eslint-disable */
  name: "i18n-d",
  props: $e({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Ka),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || Za({
      useScope: "parent",
      __useComponent: !0
    });
    return Uh(e, t, $h, (...o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[Vs](...o)
    ));
  }
}), ud = bT;
function vT(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const o = n.__getInstance(t);
    return o != null ? o.__composer : e.global.__composer;
  }
}
function yT(e) {
  const t = (s) => {
    const { instance: a, modifiers: l, value: c } = s;
    if (!a || !a.$)
      throw we(Z.UNEXPECTED_ERROR);
    const d = vT(e, a.$);
    process.env.NODE_ENV !== "production" && l.preserve && Ce(Ze(ge.NOT_SUPPORTED_PRESERVE));
    const u = fd(c);
    return [
      Reflect.apply(d.t, d, [...hd(u)]),
      d
    ];
  };
  return {
    created: (s, a) => {
      const [l, c] = t(a);
      Pt && e.global === c && (s.__i18nWatcher = No(c.locale, () => {
        a.instance && a.instance.$forceUpdate();
      })), s.__composer = c, s.textContent = l;
    },
    unmounted: (s) => {
      Pt && s.__i18nWatcher && (s.__i18nWatcher(), s.__i18nWatcher = void 0, delete s.__i18nWatcher), s.__composer && (s.__composer = void 0, delete s.__composer);
    },
    beforeUpdate: (s, { value: a }) => {
      if (s.__composer) {
        const l = s.__composer, c = fd(a);
        s.textContent = Reflect.apply(l.t, l, [
          ...hd(c)
        ]);
      }
    },
    getSSRProps: (s) => {
      const [a] = t(s);
      return { textContent: a };
    }
  };
}
function fd(e) {
  if (M(e))
    return { path: e };
  if (B(e)) {
    if (!("path" in e))
      throw we(Z.REQUIRED_VALUE, "path");
    return e;
  } else
    throw we(Z.INVALID_VALUE);
}
function hd(e) {
  const { path: t, locale: n, args: o, choice: i, plural: r } = e, s = {}, a = o || {};
  return M(n) && (s.locale = n), Ee(i) && (s.plural = i), Ee(r) && (s.plural = r), [t, a, s];
}
function wT(e, t, ...n) {
  const o = B(n[0]) ? n[0] : {}, i = !!o.useI18nComponentName, r = j(o.globalInstall) ? o.globalInstall : !0;
  process.env.NODE_ENV !== "production" && r && i && Ce(Ze(ge.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: Xr.name
  })), r && ([i ? "i18n" : Xr.name, "I18nT"].forEach((s) => e.component(s, Xr)), [dd.name, "I18nN"].forEach((s) => e.component(s, dd)), [ud.name, "I18nD"].forEach((s) => e.component(s, ud))), e.directive("t", yT(t));
}
const Zr = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, kT = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, xT = {
  "vue-i18n-timeline": 16764185
}, Hh = "vue-i18n: composer properties";
let Ws;
async function _T(e, t) {
  return new Promise((n, o) => {
    try {
      qs({
        id: "vue-devtools-plugin-vue-i18n",
        label: Zr[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [Hh],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (i) => {
        Ws = i, i.on.visitComponentTree(({ componentInstance: s, treeNode: a }) => {
          ET(s, a, t);
        }), i.on.inspectComponent(({ componentInstance: s, instanceData: a }) => {
          s.vnode.el && s.vnode.el.__VUE_I18N__ && a && (t.mode === "legacy" ? s.vnode.el.__VUE_I18N__ !== t.global.__composer && md(a, s.vnode.el.__VUE_I18N__) : md(a, s.vnode.el.__VUE_I18N__));
        }), i.addInspector({
          id: "vue-i18n-resource-inspector",
          label: Zr[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: kT[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), i.on.getInspectorTree((s) => {
          s.app === e && s.inspectorId === "vue-i18n-resource-inspector" && CT(s, t);
        });
        const r = /* @__PURE__ */ new Map();
        i.on.getInspectorState(async (s) => {
          if (s.app === e && s.inspectorId === "vue-i18n-resource-inspector")
            if (i.unhighlightElement(), DT(s, t), s.nodeId === "global") {
              if (!r.has(s.app)) {
                const [a] = await i.getComponentInstances(s.app);
                r.set(s.app, a);
              }
              i.highlightElement(r.get(s.app));
            } else {
              const a = AT(s.nodeId, t);
              a && i.highlightElement(a);
            }
        }), i.on.editInspectorState((s) => {
          s.app === e && s.inspectorId === "vue-i18n-resource-inspector" && NT(s, t);
        }), i.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: Zr[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: xT[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), n(!0);
      });
    } catch (i) {
      console.error(i), o(!1);
    }
  });
}
function Bh(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function ET(e, t, n) {
  const o = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== o) {
    const i = {
      label: `i18n (${Bh(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(i);
  }
}
function md(e, t) {
  const n = Hh;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: Xa(t.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function Xa(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const o = e[n];
    be(o) && "source" in o ? t[n] = OT(o) : Vn(o) && o.loc && o.loc.source ? t[n] = o.loc.source : ne(o) ? t[n] = Xa(o) : t[n] = o;
  }), t;
}
const TT = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function IT(e) {
  return e.replace(/[<>"&]/g, ST);
}
function ST(e) {
  return TT[e] || e;
}
function OT(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${IT(e.source)}")` : "(?)"}`
    }
  };
}
function CT(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [o, i] of t.__instances) {
    const r = t.mode === "composition" ? i : i.__composer;
    n !== r && e.rootNodes.push({
      id: r.id.toString(),
      label: `${Bh(o)} Scope`
    });
  }
}
function AT(e, t) {
  let n = null;
  if (e !== "global") {
    for (const [o, i] of t.__instances.entries())
      if (i.id.toString() === e) {
        n = o;
        break;
      }
  }
  return n;
}
function Wh(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const n = Array.from(t.__instances.values()).find((o) => o.id.toString() === e);
    return n ? t.mode === "composition" ? n : n.__composer : null;
  }
}
function DT(e, t) {
  const n = Wh(e.nodeId, t);
  return n && (e.state = $T(n)), null;
}
function $T(e) {
  const t = {}, n = "Locale related info", o = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[n] = o;
  const i = "Locale messages info", r = [
    {
      type: i,
      key: "messages",
      editable: !1,
      value: Xa(e.messages.value)
    }
  ];
  t[i] = r;
  {
    const s = "Datetime formats info", a = [
      {
        type: s,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[s] = a;
    const l = "Datetime formats info", c = [
      {
        type: l,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[l] = c;
  }
  return t;
}
function Bo(e, t) {
  if (Ws) {
    let n;
    t && "groupId" in t && (n = t.groupId, delete t.groupId), Ws.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function NT(e, t) {
  const n = Wh(e.nodeId, t);
  if (n) {
    const [o] = e.path;
    o === "locale" && M(e.state.value) ? n.locale.value = e.state.value : o === "fallbackLocale" && (M(e.state.value) || se(e.state.value) || ne(e.state.value)) ? n.fallbackLocale.value = e.state.value : o === "inheritLocale" && j(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
function LT(e, t, n) {
  return {
    beforeCreate() {
      const o = Zt();
      if (!o)
        throw we(Z.UNEXPECTED_ERROR);
      const i = this.$options;
      if (i.i18n) {
        const r = i.i18n;
        if (i.__i18n && (r.__i18n = i.__i18n), r.__root = t, this === this.$root)
          this.$i18n = pd(e, r);
        else {
          r.__injectWithOption = !0, r.__extender = n.__vueI18nExtend, this.$i18n = Bs(r);
          const s = this.$i18n;
          s.__extender && (s.__disposer = s.__extender(this.$i18n));
        }
      } else if (i.__i18n)
        if (this === this.$root)
          this.$i18n = pd(e, i);
        else {
          this.$i18n = Bs({
            __i18n: i.__i18n,
            __injectWithOption: !0,
            __extender: n.__vueI18nExtend,
            __root: t
          });
          const r = this.$i18n;
          r.__extender && (r.__disposer = r.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      i.__i18nGlobal && Vh(t, i, i), this.$t = (...r) => this.$i18n.t(...r), this.$rt = (...r) => this.$i18n.rt(...r), this.$tc = (...r) => this.$i18n.tc(...r), this.$te = (r, s) => this.$i18n.te(r, s), this.$d = (...r) => this.$i18n.d(...r), this.$n = (...r) => this.$i18n.n(...r), this.$tm = (r) => this.$i18n.tm(r), n.__setInstance(o, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const o = this.$i18n;
        this.$el.__VUE_I18N__ = o.__composer;
        const i = this.__v_emitter = ja();
        o.__enableEmitter && o.__enableEmitter(i), i.on("*", Bo);
      }
    },
    unmounted() {
      const o = Zt();
      if (!o)
        throw we(Z.UNEXPECTED_ERROR);
      const i = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", Bo), delete this.__v_emitter), this.$i18n && (i.__disableEmitter && i.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, i.__disposer && (i.__disposer(), delete i.__disposer, delete i.__extender), n.__deleteInstance(o), delete this.$i18n;
    }
  };
}
function pd(e, t) {
  e.locale = t.locale || e.locale, e.fallbackLocale = t.fallbackLocale || e.fallbackLocale, e.missing = t.missing || e.missing, e.silentTranslationWarn = t.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = t.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = t.postTranslation || e.postTranslation, e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml, e.sync = t.sync || e.sync, e.__composer[Mh](t.pluralizationRules || e.pluralizationRules);
  const n = lr(e.locale, {
    messages: t.messages,
    __i18n: t.__i18n
  });
  return Object.keys(n).forEach((o) => e.mergeLocaleMessage(o, n[o])), t.datetimeFormats && Object.keys(t.datetimeFormats).forEach((o) => e.mergeDateTimeFormat(o, t.datetimeFormats[o])), t.numberFormats && Object.keys(t.numberFormats).forEach((o) => e.mergeNumberFormat(o, t.numberFormats[o])), e;
}
const PT = /* @__PURE__ */ Ft("global-vue-i18n");
function MT(e = {}, t) {
  const n = __VUE_I18N_LEGACY_API__ && j(e.legacy) ? e.legacy : __VUE_I18N_LEGACY_API__, o = j(e.globalInjection) ? e.globalInjection : !0, i = __VUE_I18N_LEGACY_API__ && n ? !!e.allowComposition : !0, r = /* @__PURE__ */ new Map(), [s, a] = FT(e, n), l = /* @__PURE__ */ Ft(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV !== "production" && n && i && Ce(Ze(ge.NOTICE_DROP_ALLOW_COMPOSITION));
  function c(f) {
    return r.get(f) || null;
  }
  function d(f, g) {
    r.set(f, g);
  }
  function u(f) {
    r.delete(f);
  }
  {
    const f = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && n ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return i;
      },
      // install plugin
      async install(g, ...E) {
        if (process.env.NODE_ENV !== "production" && (g.__VUE_I18N__ = f), g.__VUE_I18N_SYMBOL__ = l, g.provide(g.__VUE_I18N_SYMBOL__, f), B(E[0])) {
          const m = E[0];
          f.__composerExtend = m.__composerExtend, f.__vueI18nExtend = m.__vueI18nExtend;
        }
        let k = null;
        !n && o && (k = YT(g, f.global)), __VUE_I18N_FULL_INSTALL__ && wT(g, f, ...E), __VUE_I18N_LEGACY_API__ && n && g.mixin(LT(a, a.__composer, f));
        const S = g.unmount;
        if (g.unmount = () => {
          k && k(), f.dispose(), S();
        }, process.env.NODE_ENV !== "production") {
          if (!await _T(g, f))
            throw we(Z.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const v = ja();
          if (n) {
            const I = a;
            I.__enableEmitter && I.__enableEmitter(v);
          } else {
            const I = a;
            I[zn] && I[zn](v);
          }
          v.on("*", Bo);
        }
      },
      // global accessor
      get global() {
        return a;
      },
      dispose() {
        s.stop();
      },
      // @internal
      __instances: r,
      // @internal
      __getInstance: c,
      // @internal
      __setInstance: d,
      // @internal
      __deleteInstance: u
    };
    return f;
  }
}
function Za(e = {}) {
  const t = Zt();
  if (t == null)
    throw we(Z.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw we(Z.NOT_INSTALLED);
  const n = RT(t), o = zT(n), i = Rh(t), r = VT(e, i);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw we(Z.NOT_AVAILABLE_IN_LEGACY_MODE);
    return WT(t, r, o, e);
  }
  if (r === "global")
    return Vh(o, e, i), o;
  if (r === "parent") {
    let l = UT(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Ce(Ze(ge.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  const s = n;
  let a = s.__getInstance(t);
  if (a == null) {
    const l = $e({}, e);
    "__i18n" in i && (l.__i18n = i.__i18n), o && (l.__root = o), a = qa(l), s.__composerExtend && (a[Us] = s.__composerExtend(a)), BT(s, t, a), s.__setInstance(t, a);
  }
  return a;
}
function FT(e, t, n) {
  const o = js();
  {
    const i = __VUE_I18N_LEGACY_API__ && t ? o.run(() => Bs(e)) : o.run(() => qa(e));
    if (i == null)
      throw we(Z.UNEXPECTED_ERROR);
    return [o, i];
  }
}
function RT(e) {
  {
    const t = $o(e.isCE ? PT : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw we(e.isCE ? Z.NOT_INSTALLED_WITH_PROVIDE : Z.UNEXPECTED_ERROR);
    return t;
  }
}
function VT(e, t) {
  return rr(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function zT(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function UT(e, t, n = !1) {
  let o = null;
  const i = t.root;
  let r = HT(t, n);
  for (; r != null; ) {
    const s = e;
    if (e.mode === "composition")
      o = s.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const a = s.__getInstance(r);
      a != null && (o = a.__composer, n && o && !o[Fh] && (o = null));
    }
    if (o != null || i === r)
      break;
    r = r.parent;
  }
  return o;
}
function HT(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function BT(e, t, n) {
  let o = null;
  Gs(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, o = ja();
      const i = n;
      i[zn] && i[zn](o), o.on("*", Bo);
    }
  }, t), xm(() => {
    const i = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (o && o.off("*", Bo), i[Ho] && i[Ho](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const r = i[Us];
    r && (r(), delete i[Us]);
  }, t);
}
function WT(e, t, n, o = {}) {
  const i = t === "local", r = bd(null);
  if (i && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw we(Z.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const s = j(o.inheritLocale) ? o.inheritLocale : !M(o.locale), a = We(
    // prettier-ignore
    !i || s ? n.locale.value : M(o.locale) ? o.locale : Zo
  ), l = We(
    // prettier-ignore
    !i || s ? n.fallbackLocale.value : M(o.fallbackLocale) || se(o.fallbackLocale) || B(o.fallbackLocale) || o.fallbackLocale === !1 ? o.fallbackLocale : a.value
  ), c = We(lr(a.value, o)), d = We(B(o.datetimeFormats) ? o.datetimeFormats : { [a.value]: {} }), u = We(B(o.numberFormats) ? o.numberFormats : { [a.value]: {} }), f = i ? n.missingWarn : j(o.missingWarn) || mn(o.missingWarn) ? o.missingWarn : !0, g = i ? n.fallbackWarn : j(o.fallbackWarn) || mn(o.fallbackWarn) ? o.fallbackWarn : !0, E = i ? n.fallbackRoot : j(o.fallbackRoot) ? o.fallbackRoot : !0, k = !!o.fallbackFormat, S = be(o.missing) ? o.missing : null, m = be(o.postTranslation) ? o.postTranslation : null, v = i ? n.warnHtmlMessage : j(o.warnHtmlMessage) ? o.warnHtmlMessage : !0, I = !!o.escapeParameter, w = i ? n.modifiers : B(o.modifiers) ? o.modifiers : {}, A = o.pluralRules || i && n.pluralRules;
  function b() {
    return [
      a.value,
      l.value,
      c.value,
      d.value,
      u.value
    ];
  }
  const y = Oe({
    get: () => r.value ? r.value.locale.value : a.value,
    set: (h) => {
      r.value && (r.value.locale.value = h), a.value = h;
    }
  }), L = Oe({
    get: () => r.value ? r.value.fallbackLocale.value : l.value,
    set: (h) => {
      r.value && (r.value.fallbackLocale.value = h), l.value = h;
    }
  }), C = Oe(() => r.value ? r.value.messages.value : c.value), D = Oe(() => d.value), N = Oe(() => u.value);
  function z() {
    return r.value ? r.value.getPostTranslationHandler() : m;
  }
  function oe(h) {
    r.value && r.value.setPostTranslationHandler(h);
  }
  function ke() {
    return r.value ? r.value.getMissingHandler() : S;
  }
  function Ye(h) {
    r.value && r.value.setMissingHandler(h);
  }
  function q(h) {
    return b(), h();
  }
  function K(...h) {
    return r.value ? q(() => Reflect.apply(r.value.t, null, [...h])) : q(() => "");
  }
  function ut(...h) {
    return r.value ? Reflect.apply(r.value.rt, null, [...h]) : "";
  }
  function Le(...h) {
    return r.value ? q(() => Reflect.apply(r.value.d, null, [...h])) : q(() => "");
  }
  function et(...h) {
    return r.value ? q(() => Reflect.apply(r.value.n, null, [...h])) : q(() => "");
  }
  function ft(h) {
    return r.value ? r.value.tm(h) : {};
  }
  function St(h, T) {
    return r.value ? r.value.te(h, T) : !1;
  }
  function Te(h) {
    return r.value ? r.value.getLocaleMessage(h) : {};
  }
  function tt(h, T) {
    r.value && (r.value.setLocaleMessage(h, T), c.value[h] = T);
  }
  function Ie(h, T) {
    r.value && r.value.mergeLocaleMessage(h, T);
  }
  function Qt(h) {
    return r.value ? r.value.getDateTimeFormat(h) : {};
  }
  function en(h, T) {
    r.value && (r.value.setDateTimeFormat(h, T), d.value[h] = T);
  }
  function Rt(h, T) {
    r.value && r.value.mergeDateTimeFormat(h, T);
  }
  function Vt(h) {
    return r.value ? r.value.getNumberFormat(h) : {};
  }
  function Ot(h, T) {
    r.value && (r.value.setNumberFormat(h, T), u.value[h] = T);
  }
  function zt(h, T) {
    r.value && r.value.mergeNumberFormat(h, T);
  }
  const Ct = {
    get id() {
      return r.value ? r.value.id : -1;
    },
    locale: y,
    fallbackLocale: L,
    messages: C,
    datetimeFormats: D,
    numberFormats: N,
    get inheritLocale() {
      return r.value ? r.value.inheritLocale : s;
    },
    set inheritLocale(h) {
      r.value && (r.value.inheritLocale = h);
    },
    get availableLocales() {
      return r.value ? r.value.availableLocales : Object.keys(c.value);
    },
    get modifiers() {
      return r.value ? r.value.modifiers : w;
    },
    get pluralRules() {
      return r.value ? r.value.pluralRules : A;
    },
    get isGlobal() {
      return r.value ? r.value.isGlobal : !1;
    },
    get missingWarn() {
      return r.value ? r.value.missingWarn : f;
    },
    set missingWarn(h) {
      r.value && (r.value.missingWarn = h);
    },
    get fallbackWarn() {
      return r.value ? r.value.fallbackWarn : g;
    },
    set fallbackWarn(h) {
      r.value && (r.value.missingWarn = h);
    },
    get fallbackRoot() {
      return r.value ? r.value.fallbackRoot : E;
    },
    set fallbackRoot(h) {
      r.value && (r.value.fallbackRoot = h);
    },
    get fallbackFormat() {
      return r.value ? r.value.fallbackFormat : k;
    },
    set fallbackFormat(h) {
      r.value && (r.value.fallbackFormat = h);
    },
    get warnHtmlMessage() {
      return r.value ? r.value.warnHtmlMessage : v;
    },
    set warnHtmlMessage(h) {
      r.value && (r.value.warnHtmlMessage = h);
    },
    get escapeParameter() {
      return r.value ? r.value.escapeParameter : I;
    },
    set escapeParameter(h) {
      r.value && (r.value.escapeParameter = h);
    },
    t: K,
    getPostTranslationHandler: z,
    setPostTranslationHandler: oe,
    getMissingHandler: ke,
    setMissingHandler: Ye,
    rt: ut,
    d: Le,
    n: et,
    tm: ft,
    te: St,
    getLocaleMessage: Te,
    setLocaleMessage: tt,
    mergeLocaleMessage: Ie,
    getDateTimeFormat: Qt,
    setDateTimeFormat: en,
    mergeDateTimeFormat: Rt,
    getNumberFormat: Vt,
    setNumberFormat: Ot,
    mergeNumberFormat: zt
  };
  function p(h) {
    h.locale.value = a.value, h.fallbackLocale.value = l.value, Object.keys(c.value).forEach((T) => {
      h.mergeLocaleMessage(T, c.value[T]);
    }), Object.keys(d.value).forEach((T) => {
      h.mergeDateTimeFormat(T, d.value[T]);
    }), Object.keys(u.value).forEach((T) => {
      h.mergeNumberFormat(T, u.value[T]);
    }), h.escapeParameter = I, h.fallbackFormat = k, h.fallbackRoot = E, h.fallbackWarn = g, h.missingWarn = f, h.warnHtmlMessage = v;
  }
  return _m(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw we(Z.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const h = r.value = e.proxy.$i18n.__composer;
    t === "global" ? (a.value = h.locale.value, l.value = h.fallbackLocale.value, c.value = h.messages.value, d.value = h.datetimeFormats.value, u.value = h.numberFormats.value) : i && p(h);
  }), Ct;
}
const jT = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], gd = ["t", "rt", "d", "n", "tm", "te"];
function YT(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return jT.forEach((i) => {
    const r = Object.getOwnPropertyDescriptor(t, i);
    if (!r)
      throw we(Z.UNEXPECTED_ERROR);
    const s = ro(r.value) ? {
      get() {
        return r.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(a) {
        r.value.value = a;
      }
    } : {
      get() {
        return r.get && r.get();
      }
    };
    Object.defineProperty(n, i, s);
  }), e.config.globalProperties.$i18n = n, gd.forEach((i) => {
    const r = Object.getOwnPropertyDescriptor(t, i);
    if (!r || !r.value)
      throw we(Z.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${i}`, r);
  }), () => {
    delete e.config.globalProperties.$i18n, gd.forEach((i) => {
      delete e.config.globalProperties[`$${i}`];
    });
  };
}
lT();
__INTLIFY_JIT_COMPILATION__ ? qc(tT) : qc(eT);
Y1(S1);
G1(vh);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Gt();
  e.__INTLIFY__ = !0, M1(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const jh = Km();
jh.use($E);
let Io, GT, Ke = {}, Yh = {}, Ui = {}, Hi = {}, qt = {}, QT = {
  install(e, t) {
    Ui = e, Io = MT({
      legacy: !1,
      locale: process.env.VUE_APP_I18N_LOCALE || "en",
      fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
      messages: t.localeMessages
    }), e.use(jh), e.use(Io), e.component("LanguageSwitcher", ok), e.component("Login", IE), e.component("OmsInstanceNavigator", sk), e.component("ProductIdentifier", nk), e.component("ShopifyImg", lk), Ke.login = t.login, Ke.logout = t.logout, Ke.loader = t.loader, Ke.appLoginUrl = t.appLoginUrl, Yh.defaultImgUrl = t.defaultImgUrl, Hi.getProductIdentificationPref = t.getProductIdentificationPref, Hi.setProductIdentificationPref = t.setProductIdentificationPref, qt.addNotification = t.addNotification, qt.appFirebaseConfig = t.appFirebaseConfig, qt.appFirebaseVapidKey = t.appFirebaseVapidKey, qt.storeClientRegistrationToken = t.storeClientRegistrationToken, Ke.getConfig = t.getConfig, Ke.initialise = t.initialise, If().setLocale(Io.global.locale), GT = Io.global.t;
  }
};
export {
  IE as Login,
  sk as OmsInstanceNavigator,
  nk as ProductIdentifier,
  lk as ShopifyImg,
  Ui as appContext,
  QT as dxpComponents,
  ik as goToOms,
  Io as i18n,
  TE as initialiseFirebaseApp,
  Ke as loginContext,
  qt as noitificationContext,
  Hi as productIdentificationContext,
  Yh as shopifyImgContext,
  GT as translate,
  Cu as useAuthStore,
  Jm as useProductIdentificationStore,
  If as useUserStore
};
